import { jsx as t, jsxs as u, Fragment as O } from "react/jsx-runtime";
import ue, { forwardRef as $o, createElement as So, useState as D, useRef as de, useEffect as Q, useMemo as le, useCallback as ge, useLayoutEffect as pn, createContext as gn, useContext as mn } from "react";
import Le from "react-dom";
import { useQueryClient as Yo, useQuery as un } from "@tanstack/react-query";
function Fs(e) {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}
function Is(e) {
  return new Date(e).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
function Ps(e) {
  const o = new Date(e), n = (/* @__PURE__ */ new Date()).getTime() - o.getTime(), i = Math.floor(n / (1e3 * 60 * 60 * 24));
  return i === 0 ? "Today" : i === 1 ? "Yesterday" : i < 7 ? `${i} days ago` : o.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
}
function Ts(e, o) {
  return o > 0 ? Math.round(e * 100 / o) : 0;
}
function Ms(e) {
  return e.toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/--+/g, "-").substring(0, 50);
}
function Es(e) {
  return {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }[e] || 400;
}
function Ws(e, o) {
  return e.length <= o ? e : e.slice(0, o - 3) + "...";
}
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hn = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), yn = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (o, r, n) => n ? n.toUpperCase() : r.toLowerCase()
), tt = (e) => {
  const o = yn(e);
  return o.charAt(0).toUpperCase() + o.slice(1);
}, Fr = (...e) => e.filter((o, r, n) => !!o && o.trim() !== "" && n.indexOf(o) === r).join(" ").trim(), bn = (e) => {
  for (const o in e)
    if (o.startsWith("aria-") || o === "role" || o === "title")
      return !0;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var fn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xn = $o(
  ({
    color: e = "currentColor",
    size: o = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: i = "",
    children: l,
    iconNode: s,
    ...p
  }, g) => So(
    "svg",
    {
      ref: g,
      ...fn,
      width: o,
      height: o,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(o) : r,
      className: Fr("lucide", i),
      ...!l && !bn(p) && { "aria-hidden": "true" },
      ...p
    },
    [
      ...s.map(([y, c]) => So(y, c)),
      ...Array.isArray(l) ? l : [l]
    ]
  )
);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ce = (e, o) => {
  const r = $o(
    ({ className: n, ...i }, l) => So(xn, {
      ref: l,
      iconNode: o,
      className: Fr(
        `lucide-${hn(tt(e))}`,
        `lucide-${e}`,
        n
      ),
      ...i
    })
  );
  return r.displayName = tt(e), r;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cn = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], qe = ce("check", Cn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kn = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], vn = ce("chevron-down", kn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sn = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], co = ce("chevron-right", Sn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wn = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], Bn = ce("circle-check-big", wn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zn = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], Fn = ce("circle-x", zn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const In = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], Pn = ce("ellipsis-vertical", In);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tn = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Mn = ce("eye", Tn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const En = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], Qo = ce("info", En);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wn = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], Rn = ce("loader", Wn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const An = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], bo = ce("log-out", An);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ln = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], Hn = ce("maximize-2", Ln);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nn = [
  [
    "path",
    {
      d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
      key: "1sd12s"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], Dn = ce("message-circle-plus", Nn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const On = [
  ["path", { d: "m14 10 7-7", key: "oa77jy" }],
  ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
], jn = ce("minimize-2", On);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gn = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], Ir = ce("monitor", Gn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $n = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], rt = ce("palette", $n);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yn = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], Pr = ce("pencil", Yn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qn = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], Xo = ce("plus", Qn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xn = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], Tr = ce("rotate-ccw", Xn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jn = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], po = ce("search", Jn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zn = [
  [
    "path",
    {
      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
      key: "1i5ecw"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], wo = ce("settings", Zn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Un = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], Mr = ce("smartphone", Un);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _n = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
], Er = ce("upload", _n);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vn = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Ne = ce("x", Vn), d = {
  // Primary colors
  primary: "#031425",
  white: "#fff",
  // Grays
  gray_light: "#e8e8ed",
  gray_medium: "#7e8fa8",
  gray_dark: "#3a3a3a",
  gray_border: "#bec7d3",
  // Blues
  blue: "#5572b7",
  blue_dark: "#181d56",
  blue_light: "#f6f8fa",
  // Greens
  green: "#71c285",
  green_light: "#9ee0d0",
  // Reds
  red: "#ff534a",
  red_light: "#ffeeed",
  // Yellows
  yellow: "#ffbd32",
  yellow_light: "#fff8ea",
  // Background colors
  bg_light: "#f7f8f9",
  bg_white: "#ffffff",
  // Glassmorphism & Modern UI
  glass_bg: "rgba(255, 255, 255, 0.85)",
  glass_bg_strong: "rgba(255, 255, 255, 0.95)",
  border_subtle: "rgba(255, 255, 255, 0.6)",
  border_glass: "rgba(0, 0, 0, 0.06)",
  shadow_soft: "rgba(0, 0, 0, 0.04)",
  shadow_medium: "rgba(0, 0, 0, 0.08)",
  overlay_light: "rgba(255, 255, 255, 0.5)"
}, Wr = () => typeof window > "u" ? !1 : window.self !== window.top, go = () => {
  var e, o;
  return typeof window > "u" ? document.body : window.self !== window.top && ((o = (e = window.parent) == null ? void 0 : e.document) != null && o.body) ? window.parent.document.body : document.body;
}, Bo = () => {
  var e;
  return typeof window > "u" ? document : window.self !== window.top && ((e = window.parent) != null && e.document) ? window.parent.document : document;
}, qn = async () => {
  if (typeof window > "u") return !0;
  try {
    const o = (await fetch(window.location.href, { method: "HEAD" })).headers.get("Content-Security-Policy");
    return !(o != null && o.includes("frame-ancestors 'none'"));
  } catch {
    return !0;
  }
}, Kn = () => {
  const [e, o] = D({ x: 0, y: 0 }), [r, n] = D(!1), i = de({ x: 0, y: 0 }), l = (s) => {
    n(!0), i.current = {
      x: s.clientX - e.x,
      y: s.clientY - e.y
    };
  };
  return Q(() => {
    const s = (g) => {
      r && o({
        x: g.clientX - i.current.x,
        y: g.clientY - i.current.y
      });
    }, p = () => {
      n(!1);
    };
    if (r) {
      const g = Bo();
      return g.addEventListener("mousemove", s), g.addEventListener("mouseup", p), () => {
        g.removeEventListener("mousemove", s), g.removeEventListener("mouseup", p);
      };
    }
  }, [r]), { dragOffset: e, isDragging: r, handleMouseDown: l };
};
function nt(e, o) {
  if (!e) return !0;
  if (typeof e == "string")
    return !!o[e];
  const { field: r, value: n, operator: i } = e, l = o[r];
  return i === "includes" && n !== void 0 ? typeof l == "string" && l.includes(n) : i === "not_equals" && n !== void 0 ? l !== n : i === "equals" || n !== void 0 ? l === n : !!l;
}
const ei = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  h6: "H6",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell",
  carousel: "Carousel",
  "Card Container": "Card Container",
  title: "Title",
  price: "Price",
  "Retailer Icons": "Retailer Icons",
  image: "Image"
};
function Rr(e) {
  return ei[e] || e;
}
function oi(e, o) {
  const [r, n] = D("desktop"), [i, l] = D(""), [s, p] = D(null), [g, y] = D(
    /* @__PURE__ */ new Set()
  ), c = le(
    () => e.some((z) => z.responsive),
    [e]
  ), h = le(() => r === "mobile" && c ? e.filter((z) => z.responsive).map(
    (z) => ({
      ...z,
      key: `mobile_${z.key}`,
      label: z.label
    })
  ).filter((z) => nt(z.condition, o)) : e.filter((z) => !z.key.startsWith("mobile_")).filter((z) => nt(z.condition, o)), [e, r, c, o]), x = le(() => {
    const z = [], w = {};
    return h.forEach((v) => {
      if (v.group)
        w[v.group] || (w[v.group] = []), w[v.group].push(v);
      else {
        const P = v.key.match(/^elementStyles\.([^.]+)\./);
        if (P) {
          const W = P[1];
          w[W] || (w[W] = []), w[W].push(v);
        } else
          z.push(v);
      }
    }), { baseFields: z, groups: w };
  }, [h]), B = le(() => {
    const z = [];
    return z.push({
      name: "All",
      key: "__all__",
      count: h.length
    }), x.baseFields.length > 0 && z.push({
      name: "General",
      key: "__general__",
      count: x.baseFields.length
    }), Object.entries(x.groups).forEach(([w, v]) => {
      z.push({
        name: Rr(w),
        key: w,
        count: v.length
      });
    }), z;
  }, [h, x]), k = B.length > 3, b = k || h.length >= 8, C = ge(
    (z, w) => w ? z.label.toLowerCase().includes(w) || (z.group ? z.group.toLowerCase().includes(w) : !1) || z.key.toLowerCase().includes(w) : !0,
    []
  ), S = le(() => {
    const z = i.toLowerCase().trim();
    let w = x.baseFields, v = { ...x.groups };
    if (z) {
      w = w.filter((W) => C(W, z));
      const P = {};
      Object.entries(v).forEach(([W, F]) => {
        const L = F.filter((I) => C(I, z));
        L.length > 0 && (P[W] = L);
      }), v = P;
    }
    return s && s !== "__all__" && (s === "__general__" ? v = {} : (w = [], v = v[s] ? { [s]: v[s] } : {})), { baseFields: w, groups: v };
  }, [x, i, s, C]), T = le(() => {
    const z = i.toLowerCase().trim();
    if (!z) return null;
    const w = {};
    return w.__general__ = x.baseFields.filter(
      (v) => C(v, z)
    ).length, Object.entries(x.groups).forEach(([v, P]) => {
      w[v] = P.filter((W) => C(W, z)).length;
    }), w.__all__ = Object.values(w).reduce((v, P) => v + P, 0), w;
  }, [i, x, C]), m = S.baseFields.length + Object.values(S.groups).reduce(
    (z, w) => z + w.length,
    0
  ), A = !s || s === "__all__", f = ge((z) => {
    y((w) => {
      const v = new Set(w);
      return v.has(z) ? v.delete(z) : v.add(z), v;
    });
  }, []);
  return {
    activeTab: r,
    setActiveTab: n,
    hasResponsiveFields: c,
    searchQuery: i,
    setSearchQuery: l,
    activeCategory: s,
    setActiveCategory: p,
    categoryList: B,
    hasSidebar: k,
    hasSearchBar: b,
    displayedGroupedFields: S,
    totalDisplayedFields: m,
    isShowingAllCategories: A,
    searchMatchCounts: T,
    collapsedGroups: g,
    toggleGroupCollapse: f
  };
}
function ti(e) {
  return `
    @keyframes edit-panel-slideIn {
      from {
        opacity: 0;
        transform: translateY(-8px) scale(0.98);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    .edit-panel-close {
      transition: all 0.15s ease;
    }

    .edit-panel-close:hover {
      background-color: ${d.overlay_light};
      color: ${d.primary};
      transform: scale(1.1);
    }

    .edit-panel-input:focus,
    .edit-panel-select:focus {
      border-color: ${d.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
    }

    .edit-panel-input:hover:not(:focus),
    .edit-panel-select:hover:not(:focus) {
      border-color: ${d.gray_border};
    }

    .edit-panel-color-text:focus {
      border-color: ${d.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
      background: ${d.white};
    }

    .edit-panel-color-swatch:hover {
      border-color: ${d.gray_border};
      transform: scale(1.05);
    }

    .edit-panel-reset-field:hover {
      opacity: 1 !important;
      color: ${d.blue} !important;
    }

    .drag-handle {
      cursor: ${e ? "grabbing" : "grab"};
      transition: background-color 0.15s ease;
    }

    .drag-handle:hover {
      background-color: ${d.overlay_light};
    }

    .edit-panel-save-button {
      background: linear-gradient(135deg, ${d.blue} 0%, ${d.blue_dark} 100%);
      color: ${d.white};
      border: none;
      padding: 10px 18px;
      border-radius: 10px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.15s ease;
      box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
      letter-spacing: 0.3px;
    }

    .edit-panel-save-button:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 16px rgba(85, 114, 183, 0.35);
    }

    .edit-panel-save-button:active:not(:disabled) {
      transform: translateY(0);
    }

    .edit-panel-save-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }

    /* Custom scrollbar for fields area */
    .edit-panel-content::-webkit-scrollbar {
      width: 6px;
    }

    .edit-panel-content::-webkit-scrollbar-track {
      background: transparent;
    }

    .edit-panel-content::-webkit-scrollbar-thumb {
      background: ${d.gray_border};
      border-radius: 3px;
    }

    .edit-panel-content::-webkit-scrollbar-thumb:hover {
      background: ${d.gray_medium};
    }

    /* Custom scrollbar for sidebar */
    .edit-panel-sidebar::-webkit-scrollbar {
      width: 4px;
    }

    .edit-panel-sidebar::-webkit-scrollbar-track {
      background: transparent;
    }

    .edit-panel-sidebar::-webkit-scrollbar-thumb {
      background: ${d.gray_border};
      border-radius: 2px;
    }

    .edit-panel-sidebar-item {
      transition: all 0.12s ease;
    }

    .edit-panel-sidebar-item:hover {
      background-color: rgba(85, 114, 183, 0.08) !important;
    }

    .edit-panel-search:focus {
      border-color: ${d.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.08);
    }

    .edit-panel-group-header {
      cursor: pointer;
      transition: color 0.12s ease;
      user-select: none;
    }

    .edit-panel-group-header:hover {
      color: ${d.blue} !important;
    }
  `;
}
const ri = {
  sm: {
    padding: "6px 14px",
    fontSize: "12px",
    borderRadius: "8px",
    gap: "5px"
  },
  md: {
    padding: "10px 18px",
    fontSize: "13px",
    borderRadius: "10px",
    gap: "6px"
  },
  lg: {
    padding: "12px 24px",
    fontSize: "14px",
    borderRadius: "12px",
    gap: "8px"
  }
}, ni = {
  sm: {
    padding: "6px",
    fontSize: "12px",
    borderRadius: "8px",
    width: "28px",
    height: "28px"
  },
  md: {
    padding: "8px",
    fontSize: "13px",
    borderRadius: "10px",
    width: "34px",
    height: "34px"
  },
  lg: {
    padding: "10px",
    fontSize: "14px",
    borderRadius: "12px",
    width: "42px",
    height: "42px"
  }
}, ii = (e, o, r) => {
  switch (e) {
    case "primary":
      return {
        background: r ? d.blue_dark : o ? `linear-gradient(135deg, ${d.blue_dark} 0%, #252b6e 100%)` : `linear-gradient(135deg, ${d.blue_dark} 0%, #1f2463 100%)`,
        color: d.white,
        border: "none",
        boxShadow: o ? "0 4px 14px rgba(24, 29, 86, 0.35)" : "0 2px 8px rgba(24, 29, 86, 0.2)",
        transform: o && !r ? "translateY(-1px)" : "none"
      };
    case "secondary":
      return {
        background: r ? d.gray_border : d.gray_light,
        color: d.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "danger":
      return {
        background: r ? "linear-gradient(135deg, #e63e37 0%, #d13530 100%)" : o ? `linear-gradient(135deg, ${d.red} 0%, #e63e37 100%)` : `linear-gradient(135deg, ${d.red} 0%, #e63e37 100%)`,
        color: d.white,
        border: "none",
        boxShadow: o ? "0 4px 12px rgba(255, 83, 74, 0.35)" : "0 2px 6px rgba(255, 83, 74, 0.25)",
        transform: o && !r ? "translateY(-1px)" : "none"
      };
    case "ghost":
      return {
        background: r ? "rgba(0, 0, 0, 0.08)" : o ? "rgba(0, 0, 0, 0.04)" : "transparent",
        color: d.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "outline":
      return {
        background: r ? d.blue_light : o ? "rgba(24, 29, 86, 0.04)" : d.white,
        color: d.blue_dark,
        border: `2px solid ${d.blue_dark}`,
        boxShadow: "none",
        transform: o && !r ? "translateY(-1px)" : "none"
      };
    case "icon":
      return {
        background: r ? "rgba(0, 0, 0, 0.1)" : o ? "rgba(0, 0, 0, 0.05)" : "transparent",
        color: d.gray_medium,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    default:
      return {};
  }
}, te = $o(
  ({
    variant: e = "primary",
    size: o = "md",
    leftIcon: r,
    rightIcon: n,
    isLoading: i = !1,
    pill: l = !1,
    disabled: s,
    children: p,
    style: g,
    ...y
  }, c) => {
    const [h, x] = D(!1), [B, k] = D(!1), b = s || i, C = e === "icon" ? ni[o] : ri[o], S = l ? "200px" : C.borderRadius, T = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      cursor: b ? "not-allowed" : "pointer",
      opacity: b ? 0.5 : 1,
      transition: "all 0.2s ease",
      outline: "none",
      whiteSpace: "nowrap",
      fontFamily: "inherit",
      ...C,
      borderRadius: S,
      ...ii(
        e,
        !b && h,
        !b && B
      ),
      ...g
    };
    return /* @__PURE__ */ t(
      "button",
      {
        ref: c,
        disabled: b,
        style: T,
        onMouseEnter: () => x(!0),
        onMouseLeave: () => {
          x(!1), k(!1);
        },
        onMouseDown: () => k(!0),
        onMouseUp: () => k(!1),
        ...y,
        children: i ? /* @__PURE__ */ t(ai, { size: o }) : /* @__PURE__ */ u(O, { children: [
          r && /* @__PURE__ */ t(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: r
            }
          ),
          p,
          n && /* @__PURE__ */ t(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: n
            }
          )
        ] })
      }
    );
  }
);
te.displayName = "Button";
const ai = ({ size: e }) => {
  const o = e === "sm" ? 12 : e === "md" ? 14 : 16;
  return /* @__PURE__ */ u(
    "svg",
    {
      width: o,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        animation: "bc-button-spin 1s linear infinite"
      },
      children: [
        /* @__PURE__ */ t("style", { children: `
          @keyframes bc-button-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        ` }),
        /* @__PURE__ */ t(
          "circle",
          {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeDasharray: "32",
            strokeDashoffset: "12"
          }
        )
      ]
    }
  );
}, Ke = ({
  title: e,
  message: o,
  confirmLabel: r = "Save",
  cancelLabel: n = "Discard",
  dismissLabel: i = "Cancel",
  onConfirm: l,
  onCancel: s,
  onDismiss: p,
  isLoading: g = !1
}) => {
  const y = /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: `
        .confirm-dialog-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000010;
        }

        .confirm-dialog-container {
          background: ${d.white};
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          max-width: 400px;
          width: 90%;
          padding: 24px;
        }

        .confirm-dialog-title {
          margin: 0 0 12px;
          font-size: 18px;
          font-weight: 600;
          color: ${d.primary};
        }

        .confirm-dialog-message {
          margin: 0 0 24px;
          font-size: 14px;
          color: ${d.gray_medium};
          line-height: 1.5;
        }

        .confirm-dialog-actions {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .confirm-dialog-actions-right {
          display: flex;
          gap: 12px;
        }
      ` }),
    /* @__PURE__ */ t("div", { className: "confirm-dialog-overlay", onClick: s, children: /* @__PURE__ */ u(
      "div",
      {
        className: "confirm-dialog-container",
        onClick: (c) => c.stopPropagation(),
        children: [
          /* @__PURE__ */ t("h3", { className: "confirm-dialog-title", children: e }),
          /* @__PURE__ */ t("p", { className: "confirm-dialog-message", children: o }),
          /* @__PURE__ */ u("div", { className: "confirm-dialog-actions", children: [
            /* @__PURE__ */ t("div", { children: p && /* @__PURE__ */ t(
              te,
              {
                variant: "ghost",
                size: "sm",
                onClick: p,
                disabled: g,
                children: i
              }
            ) }),
            /* @__PURE__ */ u("div", { className: "confirm-dialog-actions-right", children: [
              /* @__PURE__ */ t(
                te,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: s,
                  disabled: g,
                  children: n
                }
              ),
              /* @__PURE__ */ t(
                te,
                {
                  variant: "primary",
                  size: "sm",
                  onClick: l,
                  isLoading: g,
                  disabled: g,
                  children: r
                }
              )
            ] })
          ] })
        ]
      }
    ) })
  ] });
  return Le.createPortal(y, go());
}, li = ({
  displayName: e,
  isDirty: o,
  isSaving: r,
  onReset: n,
  onSave: i,
  onClose: l,
  handleMouseDown: s
}) => /* @__PURE__ */ u(
  "div",
  {
    className: "drag-handle",
    onMouseDown: s,
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 20px",
      borderBottom: `1px solid ${d.border_glass}`,
      borderRadius: "20px 20px 0 0",
      userSelect: "none"
    },
    children: [
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flex: 1
          },
          children: [
            /* @__PURE__ */ t(
              "div",
              {
                style: {
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "3px",
                  opacity: 0.3
                },
                children: [...Array(6)].map((p, g) => /* @__PURE__ */ t(
                  "div",
                  {
                    style: {
                      width: "4px",
                      height: "4px",
                      background: d.gray_medium,
                      borderRadius: "1px"
                    }
                  },
                  g
                ))
              }
            ),
            /* @__PURE__ */ t(
              "h3",
              {
                style: {
                  fontSize: "13px",
                  fontWeight: 600,
                  color: d.primary,
                  margin: 0,
                  letterSpacing: "0.2px"
                },
                children: e || "Edit Properties"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ u("div", { style: { display: "flex", gap: "8px", alignItems: "center" }, children: [
        o && n && /* @__PURE__ */ t(
          te,
          {
            variant: "ghost",
            size: "sm",
            onClick: n,
            disabled: r,
            "aria-label": "Reset changes",
            leftIcon: /* @__PURE__ */ t(Tr, { size: 14 }),
            children: "Reset"
          }
        ),
        o && i && /* @__PURE__ */ t(
          te,
          {
            variant: "primary",
            size: "sm",
            onClick: i,
            disabled: r,
            isLoading: r,
            "aria-label": "Save changes",
            type: "submit",
            children: "Save"
          }
        ),
        /* @__PURE__ */ t(te, { variant: "icon", size: "md", onClick: l, "aria-label": "Close", children: /* @__PURE__ */ t(Ne, { size: 18 }) })
      ] })
    ]
  }
), si = ({
  searchQuery: e,
  setSearchQuery: o,
  searchInputRef: r
}) => /* @__PURE__ */ t(
  "div",
  {
    style: {
      padding: "12px 20px",
      borderBottom: `1px solid ${d.border_glass}`
    },
    children: /* @__PURE__ */ u("div", { style: { position: "relative" }, children: [
      /* @__PURE__ */ t(
        po,
        {
          size: 14,
          style: {
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            color: d.gray_medium,
            pointerEvents: "none"
          }
        }
      ),
      /* @__PURE__ */ t(
        "input",
        {
          ref: r,
          type: "text",
          value: e,
          onChange: (n) => o(n.target.value),
          onKeyDown: (n) => {
            var i;
            n.key === "Escape" && (o(""), (i = r.current) == null || i.blur());
          },
          placeholder: "Search properties...",
          className: "edit-panel-search",
          style: {
            width: "100%",
            padding: "8px 30px 8px 32px",
            fontSize: "12px",
            border: `1px solid ${d.border_glass}`,
            borderRadius: "10px",
            background: d.bg_light,
            color: d.primary,
            outline: "none",
            transition: "border-color 0.15s, box-shadow 0.15s",
            fontFamily: "inherit",
            boxSizing: "border-box"
          }
        }
      ),
      e && /* @__PURE__ */ t(
        "button",
        {
          onClick: () => {
            var n;
            o(""), (n = r.current) == null || n.focus();
          },
          style: {
            position: "absolute",
            right: "6px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "2px",
            display: "inline-flex",
            alignItems: "center",
            color: d.gray_medium
          },
          children: /* @__PURE__ */ t(Ne, { size: 12 })
        }
      )
    ] })
  }
), di = ({
  activeTab: e,
  setActiveTab: o
}) => /* @__PURE__ */ u(
  "div",
  {
    style: {
      display: "flex",
      gap: "0",
      padding: "0 20px",
      borderBottom: `1px solid ${d.border_glass}`
    },
    children: [
      /* @__PURE__ */ u(
        "button",
        {
          onClick: () => o("desktop"),
          style: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "10px 16px",
            background: "none",
            border: "none",
            borderBottom: e === "desktop" ? `2px solid ${d.blue}` : "2px solid transparent",
            color: e === "desktop" ? d.blue : d.gray_medium,
            fontSize: "12px",
            fontWeight: e === "desktop" ? 600 : 500,
            cursor: "pointer",
            transition: "all 0.15s ease"
          },
          children: [
            /* @__PURE__ */ t(Ir, { size: 14 }),
            "Desktop"
          ]
        }
      ),
      /* @__PURE__ */ u(
        "button",
        {
          onClick: () => o("mobile"),
          style: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "10px 16px",
            background: "none",
            border: "none",
            borderBottom: e === "mobile" ? `2px solid ${d.blue}` : "2px solid transparent",
            color: e === "mobile" ? d.blue : d.gray_medium,
            fontSize: "12px",
            fontWeight: e === "mobile" ? 600 : 500,
            cursor: "pointer",
            transition: "all 0.15s ease"
          },
          children: [
            /* @__PURE__ */ t(Mr, { size: 14 }),
            "Mobile"
          ]
        }
      )
    ]
  }
), ci = ({
  categoryList: e,
  activeCategory: o,
  setActiveCategory: r,
  searchMatchCounts: n
}) => /* @__PURE__ */ t(
  "div",
  {
    className: "edit-panel-sidebar",
    style: {
      width: "160px",
      minWidth: "160px",
      borderRight: `1px solid ${d.border_glass}`,
      overflowY: "auto",
      padding: "8px 0"
    },
    children: e.map((i) => {
      const l = o === i.key || !o && i.key === "__all__", s = n ? n[i.key] ?? 0 : i.count, p = n !== null && s === 0;
      return /* @__PURE__ */ u(
        "button",
        {
          className: "edit-panel-sidebar-item",
          onClick: () => r(
            l && i.key !== "__all__" ? null : i.key
          ),
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "7px 16px 7px 20px",
            background: l ? "rgba(85, 114, 183, 0.1)" : "none",
            border: "none",
            borderLeft: l ? `3px solid ${d.blue}` : "3px solid transparent",
            cursor: "pointer",
            fontSize: "11px",
            fontWeight: l ? 600 : 500,
            color: l ? d.blue : d.gray_medium,
            textAlign: "left",
            opacity: p ? 0.35 : 1,
            fontFamily: "inherit"
          },
          children: [
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                },
                children: i.name
              }
            ),
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: "10px",
                  fontWeight: 500,
                  color: l ? d.blue : d.gray_border,
                  marginLeft: "6px",
                  flexShrink: 0
                },
                children: n ? s : i.count
              }
            )
          ]
        },
        i.key
      );
    })
  }
), pi = ({ value: e, onChange: o }) => {
  const [r, n] = D(e || "");
  return Q(() => {
    n(e || "");
  }, [e]), /* @__PURE__ */ t(
    "input",
    {
      type: "text",
      value: r,
      onChange: (l) => {
        const s = l.target.value;
        n(s), o(s);
      },
      className: "edit-panel-input",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${d.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: d.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: d.white,
        outline: "none"
      }
    }
  );
}, gi = ({
  value: e,
  onChange: o,
  field: r
}) => {
  var n, i;
  return /* @__PURE__ */ t(
    "select",
    {
      value: e ?? ((i = (n = r.options) == null ? void 0 : n[0]) == null ? void 0 : i.value) ?? "",
      onChange: (l) => o(l.target.value),
      className: "edit-panel-select",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${d.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: d.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: d.white,
        cursor: "pointer",
        outline: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 12px center",
        paddingRight: "36px"
      },
      children: (r.options ?? []).map((l) => /* @__PURE__ */ t("option", { value: l.value, children: l.label }, l.value))
    }
  );
};
function mo() {
  return (mo = Object.assign || function(e) {
    for (var o = 1; o < arguments.length; o++) {
      var r = arguments[o];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }).apply(this, arguments);
}
function Ar(e, o) {
  if (e == null) return {};
  var r, n, i = {}, l = Object.keys(e);
  for (n = 0; n < l.length; n++) o.indexOf(r = l[n]) >= 0 || (i[r] = e[r]);
  return i;
}
function zo(e) {
  var o = de(e), r = de(function(n) {
    o.current && o.current(n);
  });
  return o.current = e, r.current;
}
var eo = function(e, o, r) {
  return o === void 0 && (o = 0), r === void 0 && (r = 1), e > r ? r : e < o ? o : e;
}, Ve = function(e) {
  return "touches" in e;
}, Fo = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, it = function(e, o, r) {
  var n = e.getBoundingClientRect(), i = Ve(o) ? function(l, s) {
    for (var p = 0; p < l.length; p++) if (l[p].identifier === s) return l[p];
    return l[0];
  }(o.touches, r) : o;
  return { left: eo((i.pageX - (n.left + Fo(e).pageXOffset)) / n.width), top: eo((i.pageY - (n.top + Fo(e).pageYOffset)) / n.height) };
}, at = function(e) {
  !Ve(e) && e.preventDefault();
}, Lr = ue.memo(function(e) {
  var o = e.onMove, r = e.onKey, n = Ar(e, ["onMove", "onKey"]), i = de(null), l = zo(o), s = zo(r), p = de(null), g = de(!1), y = le(function() {
    var B = function(C) {
      at(C), (Ve(C) ? C.touches.length > 0 : C.buttons > 0) && i.current ? l(it(i.current, C, p.current)) : b(!1);
    }, k = function() {
      return b(!1);
    };
    function b(C) {
      var S = g.current, T = Fo(i.current), m = C ? T.addEventListener : T.removeEventListener;
      m(S ? "touchmove" : "mousemove", B), m(S ? "touchend" : "mouseup", k);
    }
    return [function(C) {
      var S = C.nativeEvent, T = i.current;
      if (T && (at(S), !function(A, f) {
        return f && !Ve(A);
      }(S, g.current) && T)) {
        if (Ve(S)) {
          g.current = !0;
          var m = S.changedTouches || [];
          m.length && (p.current = m[0].identifier);
        }
        T.focus(), l(it(T, S, p.current)), b(!0);
      }
    }, function(C) {
      var S = C.which || C.keyCode;
      S < 37 || S > 40 || (C.preventDefault(), s({ left: S === 39 ? 0.05 : S === 37 ? -0.05 : 0, top: S === 40 ? 0.05 : S === 38 ? -0.05 : 0 }));
    }, b];
  }, [s, l]), c = y[0], h = y[1], x = y[2];
  return Q(function() {
    return x;
  }, [x]), ue.createElement("div", mo({}, n, { onTouchStart: c, onMouseDown: c, className: "react-colorful__interactive", ref: i, onKeyDown: h, tabIndex: 0, role: "slider" }));
}), Jo = function(e) {
  return e.filter(Boolean).join(" ");
}, Hr = function(e) {
  var o = e.color, r = e.left, n = e.top, i = n === void 0 ? 0.5 : n, l = Jo(["react-colorful__pointer", e.className]);
  return ue.createElement("div", { className: l, style: { top: 100 * i + "%", left: 100 * r + "%" } }, ue.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: o } }));
}, he = function(e, o, r) {
  return o === void 0 && (o = 0), r === void 0 && (r = Math.pow(10, o)), Math.round(r * e) / r;
}, mi = function(e) {
  return fi(Io(e));
}, Io = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? he(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? he(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, ui = function(e) {
  return bi(yi(e));
}, hi = function(e) {
  var o = e.s, r = e.v, n = e.a, i = (200 - o) * r / 100;
  return { h: he(e.h), s: he(i > 0 && i < 200 ? o * r / 100 / (i <= 100 ? i : 200 - i) * 100 : 0), l: he(i / 2), a: he(n, 2) };
}, Po = function(e) {
  var o = hi(e);
  return "hsl(" + o.h + ", " + o.s + "%, " + o.l + "%)";
}, yi = function(e) {
  var o = e.h, r = e.s, n = e.v, i = e.a;
  o = o / 360 * 6, r /= 100, n /= 100;
  var l = Math.floor(o), s = n * (1 - r), p = n * (1 - (o - l) * r), g = n * (1 - (1 - o + l) * r), y = l % 6;
  return { r: he(255 * [n, p, s, s, g, n][y]), g: he(255 * [g, n, n, p, s, s][y]), b: he(255 * [s, s, g, n, n, p][y]), a: he(i, 2) };
}, oo = function(e) {
  var o = e.toString(16);
  return o.length < 2 ? "0" + o : o;
}, bi = function(e) {
  var o = e.r, r = e.g, n = e.b, i = e.a, l = i < 1 ? oo(he(255 * i)) : "";
  return "#" + oo(o) + oo(r) + oo(n) + l;
}, fi = function(e) {
  var o = e.r, r = e.g, n = e.b, i = e.a, l = Math.max(o, r, n), s = l - Math.min(o, r, n), p = s ? l === o ? (r - n) / s : l === r ? 2 + (n - o) / s : 4 + (o - r) / s : 0;
  return { h: he(60 * (p < 0 ? p + 6 : p)), s: he(l ? s / l * 100 : 0), v: he(l / 255 * 100), a: i };
}, xi = ue.memo(function(e) {
  var o = e.hue, r = e.onChange, n = Jo(["react-colorful__hue", e.className]);
  return ue.createElement("div", { className: n }, ue.createElement(Lr, { onMove: function(i) {
    r({ h: 360 * i.left });
  }, onKey: function(i) {
    r({ h: eo(o + 360 * i.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": he(o), "aria-valuemax": "360", "aria-valuemin": "0" }, ue.createElement(Hr, { className: "react-colorful__hue-pointer", left: o / 360, color: Po({ h: o, s: 100, v: 100, a: 1 }) })));
}), Ci = ue.memo(function(e) {
  var o = e.hsva, r = e.onChange, n = { backgroundColor: Po({ h: o.h, s: 100, v: 100, a: 1 }) };
  return ue.createElement("div", { className: "react-colorful__saturation", style: n }, ue.createElement(Lr, { onMove: function(i) {
    r({ s: 100 * i.left, v: 100 - 100 * i.top });
  }, onKey: function(i) {
    r({ s: eo(o.s + 100 * i.left, 0, 100), v: eo(o.v - 100 * i.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + he(o.s) + "%, Brightness " + he(o.v) + "%" }, ue.createElement(Hr, { className: "react-colorful__saturation-pointer", top: 1 - o.v / 100, left: o.s / 100, color: Po(o) })));
}), Nr = function(e, o) {
  if (e === o) return !0;
  for (var r in e) if (e[r] !== o[r]) return !1;
  return !0;
}, ki = function(e, o) {
  return e.toLowerCase() === o.toLowerCase() || Nr(Io(e), Io(o));
};
function vi(e, o, r) {
  var n = zo(r), i = D(function() {
    return e.toHsva(o);
  }), l = i[0], s = i[1], p = de({ color: o, hsva: l });
  Q(function() {
    if (!e.equal(o, p.current.color)) {
      var y = e.toHsva(o);
      p.current = { hsva: y, color: o }, s(y);
    }
  }, [o, e]), Q(function() {
    var y;
    Nr(l, p.current.hsva) || e.equal(y = e.fromHsva(l), p.current.color) || (p.current = { hsva: l, color: y }, n(y));
  }, [l, e, n]);
  var g = ge(function(y) {
    s(function(c) {
      return Object.assign({}, c, y);
    });
  }, []);
  return [l, g];
}
var Si = typeof window < "u" ? pn : Q, wi = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, lt = /* @__PURE__ */ new Map(), Bi = function(e) {
  Si(function() {
    var o = e.current ? e.current.ownerDocument : document;
    if (o !== void 0 && !lt.has(o)) {
      var r = o.createElement("style");
      r.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, lt.set(o, r);
      var n = wi();
      n && r.setAttribute("nonce", n), o.head.appendChild(r);
    }
  }, []);
}, zi = function(e) {
  var o = e.className, r = e.colorModel, n = e.color, i = n === void 0 ? r.defaultColor : n, l = e.onChange, s = Ar(e, ["className", "colorModel", "color", "onChange"]), p = de(null);
  Bi(p);
  var g = vi(r, i, l), y = g[0], c = g[1], h = Jo(["react-colorful", o]);
  return ue.createElement("div", mo({}, s, { ref: p, className: h }), ue.createElement(Ci, { hsva: y, onChange: c }), ue.createElement(xi, { hue: y.h, onChange: c, className: "react-colorful__last-control" }));
}, Fi = { defaultColor: "000", toHsva: mi, fromHsva: function(e) {
  return ui({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: ki }, Ii = function(e) {
  return ue.createElement(zi, mo({}, e, { colorModel: Fi }));
};
const st = (e) => {
  const o = e.startsWith("#") ? e : `#${e}`, r = o.slice(0, 7).padEnd(7, "0"), n = o.slice(7, 9) || "ff", i = parseInt(n, 16), l = Math.round(i / 255 * 100);
  return { hex: r, opacity: l };
}, Oe = (e, o) => {
  const r = Math.round(o / 100 * 255).toString(16).padStart(2, "0");
  return `${(e.startsWith("#") ? e : `#${e}`).slice(0, 7)}${r}`;
}, dt = (e) => {
  const o = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(o) ? `#${o.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(o) ? `#${o.toLowerCase()}` : null;
}, Dr = ({
  value: e,
  onChange: o,
  className: r
}) => {
  const { hex: n, opacity: i } = st(
    e || "#000000ff"
  ), [l, s] = D(n), [p, g] = D(i), [y, c] = D(
    i < 100 ? e || "#000000ff" : n
  );
  Q(() => {
    const { hex: b, opacity: C } = st(
      e || "#000000ff"
    );
    s(b), g(C), c(C < 100 ? e || "#000000ff" : b);
  }, [e]);
  const h = (b) => {
    s(b), c(p < 100 ? Oe(b, p) : b), o(Oe(b, p));
  }, x = (b) => {
    const C = b.target.value;
    c(C);
    const S = dt(C);
    if (S)
      if (S.length === 9) {
        const T = S.slice(0, 7), m = S.slice(7, 9), A = parseInt(m, 16), f = Math.round(A / 255 * 100);
        s(T), g(f), o(S);
      } else
        s(S), o(Oe(S, p));
  }, B = () => {
    const b = dt(y);
    if (b)
      if (b.length === 9)
        c(b);
      else {
        const C = Oe(b, p);
        c(p < 100 ? C : b);
      }
    else {
      const C = Oe(l, p);
      c(p < 100 ? C : l);
    }
  }, k = (b) => {
    const C = parseInt(b.target.value, 10);
    g(C);
    const S = Oe(l, C);
    o(S), c(C < 100 ? S : l);
  };
  return /* @__PURE__ */ u("div", { className: `bc-color-picker ${r || ""}`, children: [
    /* @__PURE__ */ t("style", { children: `
        .bc-color-picker {
          width: 200px;
        }

        .bc-color-picker .react-colorful {
          width: 100%;
          height: auto;
        }

        .bc-color-picker .react-colorful__saturation {
          border-radius: 8px;
          height: 150px;
        }

        .bc-color-picker .react-colorful__hue {
          height: 14px;
          border-radius: 7px;
          margin-top: 16px;
        }

        .bc-color-picker .react-colorful__pointer {
          width: 20px;
          height: 20px;
        }

        .bc-color-picker-hex-input {
          width: 100%;
          margin-top: 16px;
          padding: 8px 10px;
          border: 1px solid ${d.border_glass};
          border-radius: 8px;
          font-size: 13px;
          color: ${d.primary};
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          background: ${d.bg_light};
          outline: none;
          box-sizing: border-box;
          text-align: center;
          transition: all 0.15s ease;
        }

        .bc-color-picker-hex-input:focus {
          border-color: ${d.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${d.white};
        }

        .bc-color-picker-opacity-container {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 12px;
        }

        .bc-color-picker-opacity-slider {
          flex: 1;
          height: 14px;
          -webkit-appearance: none;
          appearance: none;
          background: linear-gradient(to right, white 0%, ${l} 100%);
          border-radius: 7px;
          outline: none;
          cursor: pointer;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${d.white};
          border: 2px solid ${d.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: transform 0.1s ease;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }

        .bc-color-picker-opacity-slider::-moz-range-thumb {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${d.white};
          border: 2px solid ${d.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }

        .bc-color-picker-opacity-value {
          min-width: 36px;
          font-size: 12px;
          font-weight: 500;
          color: ${d.gray_medium};
          text-align: right;
          user-select: none;
        }
      ` }),
    /* @__PURE__ */ t(Ii, { color: l, onChange: h }),
    /* @__PURE__ */ t(
      "input",
      {
        type: "text",
        value: y,
        onChange: x,
        onBlur: B,
        placeholder: "#000000 or #000000ff",
        className: "bc-color-picker-hex-input",
        maxLength: 9
      }
    ),
    /* @__PURE__ */ u("div", { className: "bc-color-picker-opacity-container", children: [
      /* @__PURE__ */ t(
        "input",
        {
          type: "range",
          min: "0",
          max: "100",
          value: p,
          onChange: k,
          className: "bc-color-picker-opacity-slider",
          style: {
            background: `linear-gradient(to right, white 0%, ${l} 100%)`
          }
        }
      ),
      /* @__PURE__ */ t("span", { className: "bc-color-picker-opacity-value", children: p })
    ] })
  ] });
}, Pi = "data:image/png;base64,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", To = ({
  color: e,
  size: o = 32,
  borderRadius: r = 4,
  className: n,
  style: i
}) => /* @__PURE__ */ u(
  "div",
  {
    className: n,
    style: {
      position: "relative",
      width: o,
      height: o,
      borderRadius: r,
      overflow: "hidden",
      ...i
    },
    children: [
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${Pi})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "repeat",
            borderRadius: "inherit"
          }
        }
      ),
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundColor: e,
            display: "block",
            borderRadius: "inherit"
          }
        }
      )
    ]
  }
), Ti = (e) => typeof e == "object" && e !== null && "type" in e && "value" in e && (e.type === "theme" || e.type === "custom"), a = (e) => ({
  type: "theme",
  value: e
}), oe = (e) => ({
  type: "custom",
  value: e
}), je = (e) => {
  if (!e) return "#000000ff";
  const o = e.startsWith("#") ? e : `#${e}`;
  return o.length === 9 ? o : o.length === 7 ? `${o}ff` : o.padEnd(9, "f").slice(0, 9);
}, ct = (e) => {
  const o = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(o) ? `#${o.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(o) ? `#${o.toLowerCase()}` : null;
}, Mi = ({
  value: e,
  onChange: o,
  field: r,
  themeColors: n,
  openColorPicker: i,
  setOpenColorPicker: l
}) => {
  const p = Ti(e) && e.type === "theme" ? e.value : "", g = le(() => {
    if (!e) return "#000000ff";
    if (typeof e == "string")
      return je(e);
    if (e.type === "custom")
      return je(e.value);
    if (e.type === "theme") {
      const v = n[e.value];
      return v ? je(v) : "#000000ff";
    }
    return "#000000ff";
  }, [e, n]), y = () => "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0"), c = (v) => {
    if (v === "") {
      const P = y();
      o({ type: "custom", value: P });
    } else
      o({ type: "theme", value: v });
  }, h = (v) => {
    o({ type: "custom", value: v });
  }, x = i === r.key, B = g, k = de(null), b = de(null), [C, S] = ue.useState(!1), T = (v) => {
    const P = je(v);
    return P.length === 9 && P.slice(7, 9).toLowerCase() === "ff" ? P.slice(0, 7) : P;
  }, [m, A] = D(() => T(B));
  Q(() => {
    A(T(g));
  }, [g]);
  const f = (v) => {
    const P = v.target.value;
    A(P);
    const W = ct(P);
    if (W) {
      const F = je(W);
      h(F);
    }
  }, z = () => {
    const v = ct(m);
    if (!v)
      A(T(B));
    else {
      const P = je(v);
      A(T(P));
    }
  }, w = 300;
  return Q(() => {
    if (x && b.current) {
      const v = b.current.getBoundingClientRect(), W = window.innerHeight - v.bottom, F = v.top;
      S(W < w && F > W);
    }
  }, [x]), Q(() => {
    if (!x) return;
    const v = (P) => {
      k.current && !k.current.contains(P.target) && l(null);
    };
    return document.addEventListener("mousedown", v, !0), () => {
      document.removeEventListener("mousedown", v, !0);
    };
  }, [x, l]), /* @__PURE__ */ u(
    "div",
    {
      style: {
        display: "flex",
        gap: "10px",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ u(
          "select",
          {
            value: p,
            onChange: (v) => c(v.target.value),
            className: "edit-panel-select",
            style: {
              flex: 1,
              padding: "12px 14px",
              border: `1px solid ${d.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: d.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: d.white,
              cursor: "pointer",
              maxWidth: "110px",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              paddingRight: "30px"
            },
            children: [
              /* @__PURE__ */ t("option", { value: "", children: "Custom" }),
              Object.keys(n).map((v) => /* @__PURE__ */ t("option", { value: v, children: v }, v))
            ]
          }
        ),
        /* @__PURE__ */ u("div", { ref: k, style: { position: "relative" }, children: [
          /* @__PURE__ */ t(
            "button",
            {
              ref: b,
              type: "button",
              onClick: () => l(x ? null : r.key),
              className: "edit-panel-color-swatch",
              style: {
                width: "42px",
                height: "42px",
                border: `2px solid ${d.border_glass}`,
                borderRadius: "10px",
                cursor: "pointer",
                padding: "3px",
                transition: "all 0.15s ease",
                backgroundColor: d.white,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              },
              "aria-label": "Open color picker",
              children: /* @__PURE__ */ t(
                To,
                {
                  color: B,
                  style: { width: "100%", height: "100%" },
                  borderRadius: 6
                }
              )
            }
          ),
          x && /* @__PURE__ */ t(
            "div",
            {
              className: "edit-panel-color-popover",
              style: {
                position: "absolute",
                ...C ? { bottom: "calc(100% + 8px)" } : { top: "calc(100% + 8px)" },
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10,
                backgroundColor: d.white,
                borderRadius: "12px",
                padding: "12px",
                boxShadow: `0 8px 24px ${d.shadow_medium}, 0 0 0 1px ${d.border_glass}`
              },
              onClick: (v) => v.stopPropagation(),
              children: /* @__PURE__ */ t(
                Dr,
                {
                  value: B,
                  onChange: h
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ t(
          "input",
          {
            type: "text",
            value: m,
            onChange: f,
            onBlur: z,
            className: "edit-panel-color-text",
            placeholder: "#000000 or #000000ff",
            maxLength: 9,
            style: {
              width: "100px",
              padding: "12px 10px",
              border: `1px solid ${d.border_glass}`,
              borderRadius: "10px",
              fontSize: "12px",
              color: d.primary,
              fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace",
              background: d.white,
              outline: "none",
              transition: "all 0.15s ease",
              cursor: "text"
            },
            onFocus: (v) => v.target.select()
          }
        )
      ]
    }
  );
}, Ei = ({
  value: e,
  onChange: o,
  field: r
}) => /* @__PURE__ */ t(
  "input",
  {
    type: "number",
    value: e || 0,
    min: r.min,
    max: r.max,
    step: r.step || 1,
    onChange: (n) => o(parseFloat(n.target.value)),
    className: "edit-panel-input",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${d.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: d.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: d.white,
      outline: "none"
    }
  }
), Wi = ({ value: e, onChange: o }) => {
  const r = !!e;
  return /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": r,
      onClick: () => o(!r),
      className: "edit-panel-toggle",
      style: {
        width: "48px",
        height: "28px",
        borderRadius: "14px",
        border: "none",
        padding: "2px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        background: r ? d.blue : d.gray_light,
        display: "flex",
        alignItems: "center",
        justifyContent: r ? "flex-end" : "flex-start"
      },
      children: /* @__PURE__ */ t(
        "span",
        {
          style: {
            width: "24px",
            height: "24px",
            borderRadius: "12px",
            background: d.white,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
            transition: "all 0.2s ease"
          }
        }
      )
    }
  );
}, Ri = ({
  value: e,
  onChange: o,
  themeFonts: r
}) => /* @__PURE__ */ u(
  "select",
  {
    value: e || "inherit",
    onChange: (n) => o(n.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${d.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: d.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: d.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ t("option", { value: "inherit", children: "Inherit (System Font)" }),
      Object.entries(r).map(([n, i]) => /* @__PURE__ */ t("option", { value: n, children: i.name }, n))
    ]
  }
), Mo = "bc-widget-panel-opened", Eo = "bc-widget-upload-icon-request", Or = (e) => {
  const o = new CustomEvent(Mo, {
    detail: { widgetId: e },
    bubbles: !0
  });
  document.dispatchEvent(o);
}, jr = (e) => {
  const o = (r) => {
    e(r.detail.widgetId);
  };
  return document.addEventListener(Mo, o), () => {
    document.removeEventListener(Mo, o);
  };
}, Ai = () => {
  const e = new CustomEvent(Eo, { bubbles: !0 });
  document.dispatchEvent(e);
}, Li = (e) => {
  const o = () => {
    e();
  };
  return document.addEventListener(Eo, o), () => {
    document.removeEventListener(Eo, o);
  };
}, pt = "__upload_new__", Hi = ({
  value: e,
  onChange: o,
  themeIcons: r
}) => /* @__PURE__ */ u(
  "select",
  {
    value: e || "default",
    onChange: (i) => {
      const l = i.target.value;
      if (l === pt) {
        Ai();
        return;
      }
      o(l);
    },
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${d.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: d.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: d.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ t("option", { value: "default", children: "Default" }),
      Object.entries(r).map(([i, l]) => /* @__PURE__ */ t("option", { value: i, children: l.name }, i)),
      /* @__PURE__ */ t("option", { value: pt, children: "Upload new..." })
    ]
  }
);
function Ni(e, o) {
  const r = o.values[e.key];
  switch (e.type) {
    case "text":
      return /* @__PURE__ */ t(
        pi,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e
        }
      );
    case "options":
      return /* @__PURE__ */ t(
        gi,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e
        }
      );
    case "color":
      return /* @__PURE__ */ t(
        Mi,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e,
          themeColors: o.themeColors,
          openColorPicker: o.openColorPicker,
          setOpenColorPicker: o.setOpenColorPicker
        }
      );
    case "number":
      return /* @__PURE__ */ t(
        Ei,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e
        }
      );
    case "toggle":
      return /* @__PURE__ */ t(
        Wi,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e
        }
      );
    case "font":
      return /* @__PURE__ */ t(
        Ri,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e,
          themeFonts: o.themeFonts
        }
      );
    case "icon":
      return /* @__PURE__ */ t(
        Hi,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e,
          themeIcons: o.themeIcons
        }
      );
    default:
      return null;
  }
}
const Di = (e) => {
  const { field: o, savedKeys: r, studioLockedKeys: n, onResetField: i } = e, l = r == null ? void 0 : r.has(o.key), s = n == null ? void 0 : n.has(o.key);
  return /* @__PURE__ */ u(
    "div",
    {
      style: {
        minWidth: 0,
        opacity: s ? 0.5 : 1,
        pointerEvents: s ? "none" : void 0
      },
      children: [
        /* @__PURE__ */ u(
          "label",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "11px",
              fontWeight: 600,
              color: d.gray_medium,
              marginBottom: "8px",
              textTransform: "uppercase",
              letterSpacing: "0.5px"
            },
            children: [
              o.label,
              s && /* @__PURE__ */ t(
                "span",
                {
                  title: "Edit this property from Concierge Studio",
                  style: {
                    display: "inline-flex",
                    alignItems: "center",
                    color: d.blue,
                    marginLeft: "2px",
                    flexShrink: 0,
                    cursor: "help",
                    pointerEvents: "auto"
                  },
                  children: /* @__PURE__ */ t(Qo, { size: 10 })
                }
              ),
              !s && l && i && /* @__PURE__ */ t(
                "button",
                {
                  onClick: () => i(o.key),
                  title: "Reset to default",
                  className: "edit-panel-reset-field",
                  style: {
                    background: "none",
                    border: "none",
                    padding: "1px",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    color: d.gray_medium,
                    opacity: 0.5,
                    transition: "opacity 0.15s, color 0.15s",
                    marginLeft: "2px",
                    flexShrink: 0
                  },
                  children: /* @__PURE__ */ t(Tr, { size: 10 })
                }
              )
            ]
          }
        ),
        Ni(o, e)
      ]
    }
  );
}, gt = ({ label: e, count: o, isCollapsed: r, onClick: n, marginBottom: i }) => /* @__PURE__ */ u(
  "button",
  {
    className: "edit-panel-group-header",
    onClick: n,
    style: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "12px",
      fontWeight: 700,
      color: d.primary,
      margin: 0,
      padding: 0,
      paddingBottom: "8px",
      marginBottom: i ?? 0,
      borderTop: "none",
      borderRight: "none",
      borderLeft: "none",
      borderBottom: `2px solid ${d.border_glass}`,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      background: "none",
      width: "100%",
      textAlign: "left",
      fontFamily: "inherit"
    },
    children: [
      r ? /* @__PURE__ */ t(co, { size: 14 }) : /* @__PURE__ */ t(vn, { size: 14 }),
      e,
      /* @__PURE__ */ t(
        "span",
        {
          style: {
            fontSize: "10px",
            fontWeight: 500,
            color: d.gray_medium,
            marginLeft: "auto"
          },
          children: o
        }
      )
    ]
  }
), mt = ({
  fields: e,
  itemProps: o
}) => /* @__PURE__ */ t(
  "div",
  {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "16px"
    },
    children: e.map((r) => /* @__PURE__ */ t(Di, { field: r, ...o }, r.key))
  }
), Oi = ({
  displayedGroupedFields: e,
  totalDisplayedFields: o,
  isShowingAllCategories: r,
  collapsedGroups: n,
  toggleGroupCollapse: i,
  searchQuery: l,
  setSearchQuery: s,
  fieldItemProps: p
}) => {
  if (o === 0)
    return /* @__PURE__ */ t(
      "div",
      {
        className: "edit-panel-content",
        style: {
          padding: "16px 20px 20px",
          overflowY: "auto",
          overflowX: "hidden",
          flex: 1
        },
        children: /* @__PURE__ */ u(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px 20px",
              color: d.gray_medium,
              gap: "8px"
            },
            children: [
              /* @__PURE__ */ t(po, { size: 24, style: { opacity: 0.3 } }),
              /* @__PURE__ */ t("span", { style: { fontSize: "12px", fontWeight: 500 }, children: "No matching properties" }),
              l && /* @__PURE__ */ t(
                "button",
                {
                  onClick: () => s(""),
                  style: {
                    background: "none",
                    border: `1px solid ${d.border_glass}`,
                    borderRadius: "8px",
                    padding: "6px 12px",
                    fontSize: "11px",
                    color: d.blue,
                    cursor: "pointer",
                    fontFamily: "inherit",
                    marginTop: "4px"
                  },
                  children: "Clear search"
                }
              )
            ]
          }
        )
      }
    );
  const g = Object.keys(e.groups).length > 0;
  return /* @__PURE__ */ t(
    "div",
    {
      className: "edit-panel-content",
      style: {
        padding: "16px 20px 20px",
        overflowY: "auto",
        overflowX: "hidden",
        flex: 1
      },
      children: /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "20px"
          },
          children: [
            e.baseFields.length > 0 && /* @__PURE__ */ u(O, { children: [
              r && g && /* @__PURE__ */ t(
                gt,
                {
                  label: "General",
                  count: e.baseFields.length,
                  isCollapsed: n.has("__general__"),
                  onClick: () => i("__general__")
                }
              ),
              (!r || !n.has("__general__") || !g) && /* @__PURE__ */ t(
                mt,
                {
                  fields: e.baseFields,
                  itemProps: p
                }
              )
            ] }),
            Object.entries(e.groups).map(
              ([y, c]) => {
                const h = r && n.has(y);
                return /* @__PURE__ */ u("div", { children: [
                  r && /* @__PURE__ */ t(
                    gt,
                    {
                      label: Rr(y),
                      count: c.length,
                      isCollapsed: h,
                      onClick: () => i(y),
                      marginBottom: h ? 0 : "16px"
                    }
                  ),
                  !h && /* @__PURE__ */ t(mt, { fields: c, itemProps: p })
                ] }, y);
              }
            )
          ]
        }
      )
    }
  );
}, Gr = ({
  displayName: e,
  fields: o,
  values: r,
  initialValues: n,
  onChange: i,
  onClose: l,
  onReset: s,
  screenPosition: p,
  onSave: g,
  isSaving: y = !1,
  savedKeys: c,
  studioLockedKeys: h,
  onResetField: x,
  themeColors: B = {},
  themeFonts: k = {},
  themeIcons: b = {}
}) => {
  const { dragOffset: C, isDragging: S, handleMouseDown: T } = Kn(), m = de(null), A = de(null), [f, z] = D(null), [w, v] = D(!1), {
    activeTab: P,
    setActiveTab: W,
    hasResponsiveFields: F,
    searchQuery: L,
    setSearchQuery: I,
    activeCategory: R,
    setActiveCategory: j,
    categoryList: X,
    hasSidebar: M,
    hasSearchBar: N,
    displayedGroupedFields: G,
    totalDisplayedFields: H,
    isShowingAllCategories: $,
    searchMatchCounts: Y,
    collapsedGroups: q,
    toggleGroupCollapse: J
  } = oi(o, r), V = le(() => n ? JSON.stringify(r) !== JSON.stringify(n) : !1, [r, n]), ne = () => {
    V ? v(!0) : l();
  }, K = () => {
    v(!1), s && s(), l();
  }, re = () => {
    v(!1), l();
  }, ee = async () => {
    g && g(), v(!1);
  };
  Q(() => {
    if (!f) return;
    const be = Bo(), ze = (ve) => {
      const Pe = ve.target;
      !Pe.closest(".edit-panel-color-popover") && !Pe.closest(".edit-panel-color-swatch") && z(null);
    };
    return be.addEventListener("mousedown", ze, !0), () => {
      be.removeEventListener("mousedown", ze, !0);
    };
  }, [f]), Q(() => {
    if (!Wr()) return;
    const be = Bo(), ze = "edit-panel-styles";
    if (!be.getElementById(ze)) {
      const ve = be.createElement("style");
      ve.id = ze, ve.textContent = `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `, be.head.appendChild(ve);
    }
    return () => {
      const ve = be.getElementById(ze);
      ve && ve.remove();
    };
  }, []);
  const ye = {
    values: r,
    onChange: i,
    savedKeys: c,
    studioLockedKeys: h,
    onResetField: x,
    themeColors: B,
    themeFonts: k,
    themeIcons: b,
    openColorPicker: f,
    setOpenColorPicker: z
  }, Re = /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: ti(S) }),
    /* @__PURE__ */ u(
      "div",
      {
        ref: m,
        style: {
          position: "fixed",
          top: p.y + C.y,
          left: p.x + C.x,
          background: d.glass_bg_strong,
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: `1px solid ${d.border_subtle}`,
          borderRadius: "20px",
          boxShadow: `
            0 8px 40px ${d.shadow_medium},
            0 20px 60px ${d.shadow_soft},
            0 0 0 1px ${d.border_glass}
          `,
          zIndex: 999999,
          width: M ? "800px" : "620px",
          maxWidth: M ? "800px" : "620px",
          maxHeight: "450px",
          display: "flex",
          flexDirection: "column",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          animation: "edit-panel-slideIn 0.2s ease-out"
        },
        onClick: (be) => be.stopPropagation(),
        onMouseDown: (be) => be.stopPropagation(),
        children: [
          /* @__PURE__ */ t(
            li,
            {
              displayName: e,
              isDirty: V,
              isSaving: y,
              onReset: s,
              onSave: g,
              onClose: ne,
              handleMouseDown: T
            }
          ),
          N && /* @__PURE__ */ t(
            si,
            {
              searchQuery: L,
              setSearchQuery: I,
              searchInputRef: A
            }
          ),
          F && /* @__PURE__ */ t(di, { activeTab: P, setActiveTab: W }),
          /* @__PURE__ */ u("div", { style: { display: "flex", flex: 1, overflow: "hidden" }, children: [
            M && /* @__PURE__ */ t(
              ci,
              {
                categoryList: X,
                activeCategory: R,
                setActiveCategory: j,
                searchMatchCounts: Y
              }
            ),
            /* @__PURE__ */ t(
              Oi,
              {
                displayedGroupedFields: G,
                totalDisplayedFields: H,
                isShowingAllCategories: $,
                collapsedGroups: q,
                toggleGroupCollapse: J,
                searchQuery: L,
                setSearchQuery: I,
                fieldItemProps: ye
              }
            )
          ] })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ u(O, { children: [
    Le.createPortal(Re, go()),
    w && /* @__PURE__ */ t(
      Ke,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: ee,
        onCancel: K,
        onDismiss: re,
        isLoading: y
      }
    )
  ] });
}, Ce = {
  THEME_ID: "bc_themeId",
  EDIT_MODE: "bc_editMode",
  EDIT_THEME_TOKEN: "bc_editThemeToken",
  PREVIEW_MODE: "bc_previewMode"
}, ji = (e, o, r, n) => {
  try {
    e ? localStorage.setItem(Ce.THEME_ID, e) : localStorage.removeItem(Ce.THEME_ID), localStorage.setItem(Ce.EDIT_MODE, String(o)), r ? localStorage.setItem(Ce.EDIT_THEME_TOKEN, r) : localStorage.removeItem(Ce.EDIT_THEME_TOKEN), localStorage.setItem(Ce.PREVIEW_MODE, String(!!n));
  } catch (i) {
    console.error("Failed to save theme params to localStorage:", i);
  }
}, Gi = () => {
  try {
    return {
      themeId: localStorage.getItem(Ce.THEME_ID),
      editMode: localStorage.getItem(Ce.EDIT_MODE) === "true",
      editThemeToken: localStorage.getItem(Ce.EDIT_THEME_TOKEN),
      previewMode: localStorage.getItem(Ce.PREVIEW_MODE) === "true"
    };
  } catch (e) {
    return console.error("Failed to read theme params from localStorage:", e), {
      themeId: null,
      editMode: !1,
      editThemeToken: null,
      previewMode: !1
    };
  }
}, fo = () => {
  try {
    localStorage.removeItem(Ce.THEME_ID), localStorage.removeItem(Ce.EDIT_MODE), localStorage.removeItem(Ce.EDIT_THEME_TOKEN), localStorage.removeItem(Ce.PREVIEW_MODE);
  } catch (e) {
    console.error("Failed to clear theme params from localStorage:", e);
  }
}, $i = () => {
  try {
    const e = new URLSearchParams(window.location.search), o = e.get("themeId"), r = e.get("editMode") === "true", n = e.get("editThemeToken"), i = e.get("previewMode") === "true";
    o && ji(o, r, n, i);
  } catch (e) {
    console.error("Failed to sync URL to storage:", e);
  }
}, xo = () => {
  try {
    const e = new URL(window.location.href);
    e.searchParams.delete("themeId"), e.searchParams.delete("editMode"), e.searchParams.delete("editThemeToken"), e.searchParams.delete("previewMode"), e.searchParams.delete("origin"), window.history.replaceState({}, "", e.toString());
  } catch (e) {
    console.error("Failed to clear URL params:", e);
  }
}, Rs = (e, o, r) => {
  try {
    const n = new URL(window.location.href);
    e ? (n.searchParams.set("themeId", e), n.searchParams.set("editMode", String(o)), r ? n.searchParams.set("editThemeToken", r) : n.searchParams.delete("editThemeToken")) : (n.searchParams.delete("themeId"), n.searchParams.delete("editMode"), n.searchParams.delete("editThemeToken")), window.history.replaceState({}, "", n.toString());
  } catch (n) {
    console.error("Failed to update URL params:", n);
  }
}, ut = () => {
  const e = new URLSearchParams(window.location.search), o = e.get("themeId"), r = e.get("editMode"), n = e.get("editThemeToken"), i = e.get("origin"), l = e.get("previewMode"), s = Gi(), p = l === "true" || l === null && s.previewMode;
  return {
    themeId: o || s.themeId,
    editMode: !p && (r === "true" || r === null && s.editMode),
    editThemeToken: n || s.editThemeToken,
    origin: i,
    previewMode: p
  };
}, $e = () => {
  const [e, o] = D(ut);
  return Q(() => {
    const r = setTimeout(() => {
      const n = ut();
      o((i) => i.themeId !== n.themeId || i.editMode !== n.editMode || i.editThemeToken !== n.editThemeToken || i.origin !== n.origin || i.previewMode !== n.previewMode ? n : i);
    }, 0);
    return () => clearTimeout(r);
  }, []), e;
}, Zo = () => $e().editMode, Uo = gn(!1), Yi = ({ children: e }) => /* @__PURE__ */ t(Uo.Provider, { value: !0, children: e }), As = ({ children: e }) => /* @__PURE__ */ t(Uo.Provider, { value: !1, children: e }), Qi = () => mn(Uo), Xi = () => {
  const o = Array.from(document.getElementsByTagName("script")).find(
    (r) => {
      var n, i;
      return ((n = r.src) == null ? void 0 : n.includes("brandclub-checkout-shop-app")) || ((i = r.src) == null ? void 0 : i.includes("bc-checkout-shop-app"));
    }
  );
  if (o)
    try {
      return new URL(o.src).origin;
    } catch {
    }
  return window.location.origin;
}, $r = Xi(), Se = `${$r}/api-rewards`;
$r.replace(/^https?:\/\//, "");
const Yr = {
  // Core colors
  primary: "#181d56",
  secondary: "#ffffff",
  tertiary: "#7e8fa8",
  accent: "#ffffff",
  background: "#ffffff",
  transparent: "#00000000",
  // Text colors
  textPrimary: "#181d56",
  textSecondary: "#181d56",
  textTertiary: "#7e8fa8",
  // UI colors
  borderColor: "#DCDCDC",
  buttonText: "#ffffff",
  // Semantic colors
  link: "#5572b7",
  success: "#71c285",
  error: "#ff534a",
  warning: "#ffbd32",
  info: "#5572b7"
}, Ji = Object.keys(Yr), io = (e) => {
  if (!e) return "#000000ff";
  const o = e.startsWith("#") ? e : `#${e}`;
  return o.length === 9 ? o : o.length === 7 ? `${o}ff` : o.padEnd(9, "f").slice(0, 9);
}, ht = (e) => {
  const o = io(e);
  return o.length === 9 && o.slice(7, 9).toLowerCase() === "ff" ? o.slice(0, 7) : o;
}, yt = (e) => {
  const o = io(e || "#000000");
  return o.length === 9 && o.slice(7, 9).toLowerCase() === "ff" ? o.slice(0, 7) : o;
}, bt = ({
  themeColors: e,
  isExpanded: o,
  onToggle: r,
  isLoading: n,
  isAddingColor: i,
  setIsAddingColor: l,
  newColorKey: s,
  setNewColorKey: p,
  newColorValue: g,
  setNewColorValue: y,
  onAddColor: c,
  onUpdateColor: h,
  onRenameColor: x,
  onDeleteColor: B,
  studioLockedColorKeys: k
}) => {
  const [b, C] = D(null), S = de({}), [T, m] = D({
    top: 0,
    left: 0,
    openAbove: !1
  }), [A, f] = D(null), [z, w] = D(null), [v, P] = D(null), W = de({}), [F, L] = D({
    top: 0,
    left: 0
  }), I = 300;
  Q(() => {
    if (b && S.current[b]) {
      const H = S.current[b].getBoundingClientRect(), Y = window.innerHeight - H.bottom, q = H.top, J = Y < I && q > Y;
      m({
        top: J ? H.top - 8 : H.bottom + 8,
        left: H.left + H.width / 2,
        openAbove: J
      });
    }
  }, [b]), Q(() => {
    if (!b) return;
    const H = ($) => {
      const Y = $.target;
      !Y.closest(".bc-theme-color-popover") && !Y.closest(".bc-theme-color-swatch") && C(null);
    };
    return document.addEventListener("mousedown", H), () => {
      document.removeEventListener("mousedown", H);
    };
  }, [b]), Q(() => {
    if (v && W.current[v]) {
      const H = W.current[v].getBoundingClientRect();
      L({
        top: H.bottom + 4,
        left: H.right
      });
    }
  }, [v]), Q(() => {
    if (!v) return;
    const H = ($) => {
      const Y = $.target;
      !Y.closest(".bc-theme-color-dropdown") && !Y.closest(".bc-theme-color-menu-btn") && P(null);
    };
    return document.addEventListener("mousedown", H), () => {
      document.removeEventListener("mousedown", H);
    };
  }, [v]);
  const R = (H, $) => {
    f(H), w({ name: H, value: io($) }), P(null), C(null);
  }, j = () => {
    f(null), w(null), C(null);
  }, X = async (H) => {
    if (!z) return;
    const { name: $, value: Y } = z, q = ht(Y);
    if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(q))
      return;
    $.trim() && $.trim() !== H && x && await x(H, $.trim());
    const V = ht(e[H]);
    if (q !== V) {
      const ne = $.trim() || H;
      await h(ne, q);
    }
    f(null), w(null), C(null);
  }, M = (H) => {
    z && w({ ...z, value: H });
  }, N = (H) => {
    z && w({ ...z, name: H });
  }, G = (H, $, Y, q) => {
    const J = b === H, V = io($), ne = q && !n;
    return /* @__PURE__ */ u(O, { children: [
      ne ? /* @__PURE__ */ t(
        "button",
        {
          ref: (K) => {
            S.current[H] = K;
          },
          type: "button",
          onClick: () => C(J ? null : H),
          className: "bc-theme-color-swatch",
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${d.border_glass}`,
            borderRadius: "6px",
            cursor: "pointer",
            padding: "2px",
            transition: "all 0.15s ease",
            backgroundColor: d.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          "aria-label": "Open color picker",
          children: /* @__PURE__ */ t(
            To,
            {
              color: V,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ) : /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${d.border_glass}`,
            borderRadius: "6px",
            padding: "2px",
            backgroundColor: d.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: /* @__PURE__ */ t(
            To,
            {
              color: V,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ),
      J && ne && Le.createPortal(
        /* @__PURE__ */ t(
          "div",
          {
            className: "bc-theme-color-popover",
            style: {
              position: "fixed",
              top: T.top,
              left: T.left,
              transform: T.openAbove ? "translate(-50%, -100%)" : "translateX(-50%)",
              zIndex: 1000002,
              backgroundColor: d.white,
              borderRadius: "12px",
              padding: "12px",
              boxShadow: `0 8px 24px ${d.shadow_medium}, 0 0 0 1px ${d.border_glass}`
            },
            onClick: (K) => K.stopPropagation(),
            children: /* @__PURE__ */ t(Dr, { value: V, onChange: Y })
          }
        ),
        document.body
      )
    ] });
  };
  return /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ t("style", { children: `
        .bc-theme-color-swatch:hover:not(:disabled) {
          border-color: ${d.gray_border};
          transform: scale(1.05);
        }
        .bc-theme-color-menu-btn:hover:not(:disabled) {
          background: ${d.gray_light} !important;
        }
        .bc-theme-editor-row-container {
          display: flex;
          flex-direction: column;
        }
      ` }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: r, children: [
      /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
        "Colors",
        /* @__PURE__ */ t("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ t(
        co,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${o ? "expanded" : ""}`
        }
      )
    ] }),
    o && /* @__PURE__ */ t("div", { className: "bc-theme-editor-section-content", children: n && Object.keys(e).length === 0 ? /* @__PURE__ */ t("div", { className: "bc-theme-editor-loading", children: "Loading colors..." }) : /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([H, $]) => {
        const Y = A === H, q = Ji.includes(H), J = (k == null ? void 0 : k.has(H)) ?? !1, V = v === H, ne = Y && z ? z.name : H, K = yt(Y && z ? z.value : $), re = Y && z ? z.value : $;
        return /* @__PURE__ */ u("div", { className: "bc-theme-editor-row-container", children: [
          /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
            /* @__PURE__ */ t(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: ne,
                onChange: (ee) => Y && N(ee.target.value),
                readOnly: !Y,
                disabled: n,
                style: { cursor: Y ? "text" : "default" }
              }
            ),
            G(
              H,
              re,
              M,
              Y
              // only editable when in edit mode
            ),
            Y ? /* @__PURE__ */ t(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: K,
                onChange: (ee) => {
                  const ye = ee.target.value;
                  z && w({ ...z, value: ye });
                },
                disabled: n,
                placeholder: "#000000 or #000000ff",
                maxLength: 9,
                style: {
                  width: "85px",
                  textAlign: "right",
                  fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace"
                }
              }
            ) : /* @__PURE__ */ t(
              "span",
              {
                className: "bc-theme-editor-color-value",
                style: { cursor: "default" },
                children: K
              }
            ),
            J && !Y && /* @__PURE__ */ t(
              "span",
              {
                title: "Edit this color from Concierge Studio",
                style: {
                  display: "inline-flex",
                  alignItems: "center",
                  color: d.blue,
                  padding: "4px",
                  cursor: "help"
                },
                children: /* @__PURE__ */ t(Qo, { size: 14 })
              }
            ),
            !Y && !J && /* @__PURE__ */ t(
              "button",
              {
                ref: (ee) => {
                  W.current[H] = ee;
                },
                className: "bc-theme-color-menu-btn",
                onClick: () => P(V ? null : H),
                disabled: n,
                "aria-label": "Color options",
                style: {
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: d.gray_medium,
                  transition: "all 0.15s ease"
                },
                children: /* @__PURE__ */ t(Pn, { size: 16 })
              }
            ),
            V && Le.createPortal(
              /* @__PURE__ */ u(
                "div",
                {
                  className: "bc-theme-color-dropdown",
                  style: {
                    position: "fixed",
                    top: F.top,
                    left: F.left,
                    transform: "translateX(-100%)",
                    zIndex: 1000003,
                    backgroundColor: d.white,
                    borderRadius: "8px",
                    padding: "4px",
                    boxShadow: `0 4px 12px ${d.shadow_medium}, 0 0 0 1px ${d.border_glass}`,
                    minWidth: "100px"
                  },
                  onClick: (ee) => ee.stopPropagation(),
                  children: [
                    /* @__PURE__ */ t(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => R(H, $),
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: d.primary,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (ee) => ee.currentTarget.style.background = d.gray_light,
                        onMouseLeave: (ee) => ee.currentTarget.style.background = "transparent",
                        children: "Edit"
                      }
                    ),
                    /* @__PURE__ */ t(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => {
                          P(null), B(H);
                        },
                        disabled: q,
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: q ? "not-allowed" : "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: q ? d.gray_medium : d.red,
                          opacity: q ? 0.5 : 1,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (ee) => {
                          q || (ee.currentTarget.style.background = d.gray_light);
                        },
                        onMouseLeave: (ee) => ee.currentTarget.style.background = "transparent",
                        children: "Delete"
                      }
                    )
                  ]
                }
              ),
              document.body
            )
          ] }),
          Y && /* @__PURE__ */ u(
            "div",
            {
              className: "bc-theme-editor-row-actions",
              style: {
                display: "flex",
                gap: "8px",
                marginTop: "8px",
                marginLeft: "auto",
                justifyContent: "flex-end"
              },
              children: [
                /* @__PURE__ */ t(
                  te,
                  {
                    variant: "primary",
                    size: "sm",
                    leftIcon: /* @__PURE__ */ t(qe, { size: 12 }),
                    onClick: () => X(H),
                    disabled: n,
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ t(
                  te,
                  {
                    variant: "secondary",
                    size: "sm",
                    onClick: j,
                    disabled: n,
                    children: "Cancel"
                  }
                )
              ]
            }
          )
        ] }, H);
      }),
      i ? /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
        /* @__PURE__ */ t(
          "input",
          {
            type: "text",
            className: "bc-theme-editor-input",
            placeholder: "Color name",
            value: s,
            onChange: (H) => p(H.target.value),
            disabled: n,
            autoFocus: !0
          }
        ),
        G(
          "__new_color__",
          g,
          y,
          !0
          // new color is editable
        ),
        /* @__PURE__ */ t(
          te,
          {
            variant: "primary",
            size: "sm",
            leftIcon: /* @__PURE__ */ t(qe, { size: 12 }),
            onClick: c,
            disabled: n || !s.trim(),
            children: "Save"
          }
        ),
        /* @__PURE__ */ t(
          te,
          {
            variant: "secondary",
            size: "sm",
            onClick: () => {
              l(!1), p(""), y("#000000ff");
            },
            disabled: n,
            children: "Cancel"
          }
        )
      ] }) : /* @__PURE__ */ t(
        te,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ t(Xo, { size: 12 }),
          onClick: () => l(!0),
          disabled: n,
          children: "Add Color"
        }
      )
    ] }) })
  ] });
}, Zi = (e) => {
  const o = {};
  let r = !1;
  for (const [n, i] of Object.entries(e))
    typeof i == "string" && i.startsWith("#") ? (o[n] = { type: "custom", value: i }, r = !0) : o[n] = i;
  return { migrated: o, needsMigration: r };
}, Ui = (e) => {
  const o = {};
  for (const [r, n] of Object.entries(Yr))
    r in e || (o[r] = n);
  return o;
}, Qr = (e) => {
  if (!e) return { processedTheme: e, needsUpdate: !1 };
  let o = !1;
  const r = { ...e };
  r.config || (r.config = {});
  const n = r.config.colors || {}, i = Ui(n);
  if (Object.keys(i).length > 0 && (r.config.colors = { ...n, ...i }, o = !0), r.config.widgetConfig) {
    const l = {};
    for (const [s, p] of Object.entries(
      r.config.widgetConfig
    )) {
      const { migrated: g, needsMigration: y } = Zi(
        p
      );
      l[s] = g, y && (o = !0);
    }
    r.config.widgetConfig = l;
  }
  return { processedTheme: r, needsUpdate: o };
}, Xr = async (e, o) => {
  try {
    console.log(
      `Theme ${e} needs migration. Will be migrated on next save.`
    );
  } catch (r) {
    console.error(`Failed to migrate theme ${e}:`, r);
  }
}, _i = async (e) => {
  const o = await fetch(
    `${Se}/brand-app-widget-theme/by-theme-id?appThemeId=${e}`
  );
  if (!o.ok)
    throw new Error("Failed to fetch widget theme");
  const r = await o.json(), { processedTheme: n, needsUpdate: i } = Qr(r);
  return i && Xr(e, n.config), n;
}, Vi = async (e) => {
  const o = await fetch(
    `${Se}/brand-app-widget-theme/published-by-app-id?appId=${e}`
  );
  if (!o.ok)
    throw new Error("Failed to fetch published widget theme");
  const r = await o.json(), { processedTheme: n, needsUpdate: i } = Qr(r);
  return i && (n != null && n.appThemeId) && Xr(
    n.appThemeId,
    n.config
  ), n;
}, qi = async ({
  themeId: e,
  editThemeToken: o
}) => {
  try {
    const r = await fetch(
      `${Se}/brand-app-widget-theme/validate-edit-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          appThemeId: e,
          editThemeToken: o
        })
      }
    );
    return r.ok ? (await r.json()).valid === !0 : !1;
  } catch {
    return !1;
  }
}, Jr = async ({
  themeId: e,
  widgetId: o,
  widgetState: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${Se}/brand-app-widget-theme/update-widget-config`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        widgetId: o,
        widgetState: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to update widget config";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, ft = async ({
  themeId: e,
  colorKey: o,
  colorValue: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${Se}/brand-app-widget-theme/set-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: o,
        colorValue: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to set theme color";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, Ki = async ({
  themeId: e,
  colorKey: o,
  editThemeToken: r
}) => {
  const n = await fetch(
    `${Se}/brand-app-widget-theme/delete-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: o,
        editThemeToken: r
      })
    }
  );
  if (!n.ok) {
    let i = "Failed to delete theme color";
    try {
      i = (await n.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return n.json();
}, ea = async ({
  themeId: e,
  oldColorKey: o,
  newColorKey: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${Se}/brand-app-widget-theme/rename-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        oldColorKey: o,
        newColorKey: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to rename theme color";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, xt = async ({
  themeId: e,
  fileName: o,
  contentType: r,
  assetType: n,
  editThemeToken: i
}) => {
  const l = await fetch(
    `${Se}/brand-app-widget-theme/generate-asset-upload-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fileName: o,
        contentType: r,
        assetType: n,
        editThemeToken: i
      })
    }
  );
  if (!l.ok) {
    let p = "Failed to generate upload URL";
    try {
      const g = await l.json();
      p = g.errorMessage || g.message || p;
    } catch {
    }
    throw new Error(p);
  }
  const s = await l.json();
  if (s.status === "failed")
    throw new Error(s.errorMessage || "Failed to generate upload URL");
  return {
    signedUploadUrl: s.signedUploadUrl,
    objectPublicUrl: s.objectPublicUrl
  };
}, Ct = async ({
  file: e,
  signedUploadUrl: o
}) => {
  if (!(await fetch(o, {
    method: "PUT",
    body: e,
    headers: {
      "Content-Type": e.type
    }
  })).ok)
    throw new Error("Failed to upload file to S3");
}, oa = async ({
  themeId: e,
  fontKey: o,
  fontValue: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${Se}/brand-app-widget-theme/set-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: o,
        fontValue: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to set theme font";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, ta = async ({
  themeId: e,
  fontKey: o,
  editThemeToken: r
}) => {
  const n = await fetch(
    `${Se}/brand-app-widget-theme/delete-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: o,
        editThemeToken: r
      })
    }
  );
  if (!n.ok) {
    let i = "Failed to delete theme font";
    try {
      i = (await n.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return n.json();
}, ra = async ({
  themeId: e,
  iconKey: o,
  iconValue: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${Se}/brand-app-widget-theme/set-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: o,
        iconValue: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to set theme icon";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, na = async ({
  themeId: e,
  iconKey: o,
  editThemeToken: r
}) => {
  const n = await fetch(
    `${Se}/brand-app-widget-theme/delete-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: o,
        editThemeToken: r
      })
    }
  );
  if (!n.ok) {
    let i = "Failed to delete theme icon";
    try {
      i = (await n.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return n.json();
}, Ae = ["bc-widget-theme"], Zr = "bc-theme-updated";
let Co = null, kt = !1;
const ia = (e) => {
  Co = e, Q(() => {
    if (kt) return;
    kt = !0;
    const o = (r) => {
      var i;
      if (r.origin !== window.location.origin || ((i = r.data) == null ? void 0 : i.type) !== Zr || !Co) return;
      const { themeId: n } = r.data.payload;
      Co.refetchQueries({
        queryKey: [...Ae, n]
      });
    };
    window.addEventListener("message", o);
  }, []);
}, Fe = () => {
  const e = $e(), o = Yo();
  return ia(o), un({
    queryKey: [...Ae, e.themeId],
    queryFn: async () => {
      if (e.themeId)
        return _i(e.themeId);
      const r = window.location.hostname;
      return Vi(r);
    },
    staleTime: 5 * 60 * 1e3
    // 5 minutes
  });
}, _o = () => {
  var n;
  const { data: e, isLoading: o, refetch: r } = Fe();
  return {
    themeColors: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.colors) || {},
    isLoading: o,
    refreshThemeColors: async () => {
      await r();
    }
  };
}, Ur = () => {
  var n;
  const { data: e, isLoading: o, refetch: r } = Fe();
  return {
    themeFonts: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.fonts) || {},
    isLoading: o,
    refreshThemeFonts: async () => {
      await r();
    }
  };
}, _r = () => {
  var n;
  const { data: e, isLoading: o, refetch: r } = Fe();
  return {
    themeIcons: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.icons) || {},
    isLoading: o,
    refreshThemeIcons: async () => {
      await r();
    }
  };
}, aa = (e, o) => {
  var l, s;
  const { data: r, isLoading: n } = Fe(), i = e ? (s = (l = r == null ? void 0 : r.config) == null ? void 0 : l.widgetConfig) == null ? void 0 : s[e] : void 0;
  return {
    ...o,
    ...i,
    isLoading: n,
    savedKeys: new Set(i ? Object.keys(i) : [])
  };
}, Wo = (e) => {
  const o = Yo(), r = $e();
  return { updateWidgetConfig: (s, p) => {
    e && o.setQueryData(
      [...Ae, r.themeId],
      (g) => {
        var y, c, h;
        return g ? {
          ...g,
          config: {
            ...g == null ? void 0 : g.config,
            widgetConfig: {
              ...(y = g == null ? void 0 : g.config) == null ? void 0 : y.widgetConfig,
              [e]: {
                ...(h = (c = g == null ? void 0 : g.config) == null ? void 0 : c.widgetConfig) == null ? void 0 : h[e],
                [s]: p
              }
            }
          }
        } : {
          config: {
            widgetConfig: {
              [e]: {
                [s]: p
              }
            }
          }
        };
      }
    );
  }, removeWidgetConfigKey: (s) => {
    e && o.setQueryData(
      [...Ae, r.themeId],
      (p) => {
        var c, h;
        if (!((h = (c = p == null ? void 0 : p.config) == null ? void 0 : c.widgetConfig) != null && h[e])) return p;
        const { [s]: g, ...y } = p.config.widgetConfig[e];
        return {
          ...p,
          config: {
            ...p.config,
            widgetConfig: {
              ...p.config.widgetConfig,
              [e]: y
            }
          }
        };
      }
    );
  }, getWidgetState: () => {
    var p, g;
    if (!e) return;
    const s = o.getQueryData([
      ...Ae,
      r.themeId
    ]);
    return (g = (p = s == null ? void 0 : s.config) == null ? void 0 : p.widgetConfig) == null ? void 0 : g[e];
  } };
}, Ls = () => {
  const { data: e } = Fe();
  return e == null ? void 0 : e.studioAvailability;
}, Hs = () => {
  const { data: e } = Fe();
  return e == null ? void 0 : e.studioAgentName;
}, la = (e, o = 32, r = 4) => {
  const n = window.innerWidth, i = window.innerHeight, l = n < 768, s = e.left, p = n - e.right, g = e.top, y = i - e.bottom, c = o + r, h = s >= c, x = p >= c, B = g >= c, k = y >= c;
  let b = "top-left", C = {};
  return l ? x && B ? (b = "top-right", C = {
    top: e.top - r,
    left: e.right - o + r
  }) : x && k ? (b = "bottom-right", C = {
    top: e.bottom - o + r,
    left: e.right - o + r
  }) : h && B ? (b = "top-left", C = {
    top: e.top - r,
    left: e.left - r
  }) : h && k ? (b = "bottom-left", C = {
    top: e.bottom - o + r,
    left: e.left - r
  }) : (b = "top-right", C = {
    top: e.top + r,
    left: e.right - o - r
  }) : h && B ? (b = "top-left", C = {
    top: e.top - r,
    left: e.left - r
  }) : x && B ? (b = "top-right", C = {
    top: e.top - r,
    left: e.right - o + r
  }) : h && k ? (b = "bottom-left", C = {
    top: e.bottom - o + r,
    left: e.left - r
  }) : x && k ? (b = "bottom-right", C = {
    top: e.bottom - o + r,
    left: e.right - o + r
  }) : (b = "top-left", C = {
    top: e.top + r,
    left: e.left + r
  }), { position: b, style: C };
}, Z = ({
  children: e,
  widgetId: o,
  displayName: r,
  editFields: n,
  editValues: i,
  onEditChange: l,
  onSave: s,
  isSaving: p = !1,
  savedKeys: g,
  studioLockedKeys: y,
  onResetField: c,
  themeColors: h = {},
  themeFonts: x = {},
  themeIcons: B = {},
  triggerMode: k = "hover",
  triggerIcon: b = "pencil",
  triggerPosition: C = "bottom-right",
  triggerLabel: S,
  wrapperStyle: T,
  containerClassName: m,
  iconOffset: A
}) => {
  const { data: f } = Fe(), z = le(() => {
    var fe;
    if (y) return y;
    const _ = (fe = f == null ? void 0 : f.studioControlledKeys) == null ? void 0 : fe.widgetConfig;
    if (!_ || !o) return;
    const pe = _[o];
    return pe != null && pe.length ? new Set(pe) : void 0;
  }, [y, f, o]), [w, v] = D(!1), [P, W] = D({ x: 0, y: 0 }), [F, L] = D(null), [I, R] = D(!1), [j, X] = D(null), [M, N] = D(!1), [G, H] = D(!1), $ = de(null), Y = de(null), q = de(null), J = Zo(), V = Qi(), ne = (k === "persistent" || M || G) && !w, K = ge(() => {
    if (q.current) {
      const _ = q.current.getBoundingClientRect();
      if (k === "persistent") {
        const xe = S ? 160 : 28, se = {};
        C.includes("top") ? se.top = _.top + 12 : se.top = _.bottom - 32 - 12, C.includes("right") ? se.left = _.right - xe - 12 : se.left = _.left + 12, X(se);
      } else {
        const { style: pe } = la(_);
        A && (A.top && (pe.top = (pe.top ?? 0) + A.top), A.left && (pe.left = (pe.left ?? 0) + A.left)), X(pe);
      }
    }
  }, [k, C, A]);
  Q(() => {
    if (!J || !ne) {
      X(null);
      return;
    }
    K();
    const _ = () => K();
    return window.addEventListener("scroll", _, !0), window.addEventListener("resize", _), () => {
      window.removeEventListener("scroll", _, !0), window.removeEventListener("resize", _);
    };
  }, [J, ne, K]);
  const re = ge(() => F ? JSON.stringify(i) !== JSON.stringify(F) : !1, [i, F]);
  if (Q(() => o ? jr((pe) => {
    pe !== o && w && (re() ? R(!0) : v(!1));
  }) : void 0, [o, w, re]), Q(() => () => {
    $.current && clearTimeout($.current);
  }, []), !J || V)
    return /* @__PURE__ */ t(O, { children: e });
  const ee = () => {
    if (Y.current) {
      const _ = Y.current.getBoundingClientRect(), pe = window.innerWidth, fe = window.innerHeight, xe = 620, se = 450, me = 10, De = fe - _.bottom, Ye = _.top, Qe = pe - _.left, uo = _.right;
      let Ie;
      De >= se + me ? Ie = _.bottom + me : Ye >= se + me ? Ie = _.top - se - me : De >= Ye ? Ie = Math.max(me, fe - se - me) : Ie = Math.max(me, _.top - se - me);
      let ke;
      Qe >= xe ? ke = _.left : uo >= xe ? ke = _.right - xe : ke = Math.max(me, Math.min(pe - xe - me, _.left)), ke = Math.max(me, Math.min(ke, pe - xe - me)), Ie = Math.max(me, Math.min(Ie, fe - se - me)), W({ x: ke, y: Ie });
    }
    (!F || JSON.stringify(i) === JSON.stringify(F)) && L({ ...i }), v(!0), o && Or(o);
  }, ye = () => {
    F && Object.keys(F).forEach((_) => {
      l(_, F[_]);
    });
  }, Re = () => {
    s && s(), L({ ...i });
  }, be = () => {
    ye(), R(!1), v(!1);
  }, ze = () => {
    Re(), R(!1), v(!1);
  }, ve = () => {
    R(!1), v(!1);
  }, Pe = () => {
    if (!j) return null;
    const _ = k === "persistent", pe = b === "gear" ? wo : Pr, xe = _ && S ? (
      // Labeled button for persistent mode (more discoverable)
      /* @__PURE__ */ u(
        "button",
        {
          ref: Y,
          style: {
            position: "fixed",
            top: j.top,
            left: j.left,
            height: 32,
            background: G ? d.blue_light : "rgba(255, 255, 255, 0.92)",
            border: `1px solid ${G ? d.blue : "rgba(0,0,0,0.12)"}`,
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "0 12px 0 8px",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
            transition: "all 0.2s ease",
            transform: G ? "scale(1.03)" : "scale(1)",
            opacity: G ? 1 : 0.85,
            zIndex: 999998,
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            whiteSpace: "nowrap"
          },
          onMouseDown: (se) => se.stopPropagation(),
          onClick: (se) => {
            se.stopPropagation(), se.preventDefault(), ee();
          },
          onMouseEnter: () => {
            $.current && (clearTimeout($.current), $.current = null), H(!0);
          },
          onMouseLeave: () => H(!1),
          "aria-label": S,
          children: [
            /* @__PURE__ */ t(pe, { size: 14, color: G ? d.blue : d.gray_dark }),
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: "11px",
                  fontWeight: 600,
                  color: G ? d.blue : d.gray_dark,
                  letterSpacing: "0.2px"
                },
                children: S
              }
            )
          ]
        }
      )
    ) : (
      // Icon-only button (standard for hover mode, compact for persistent without label)
      /* @__PURE__ */ t(
        "button",
        {
          ref: Y,
          style: {
            position: "fixed",
            top: j.top,
            left: j.left,
            width: _ ? 28 : 32,
            height: _ ? 28 : 32,
            background: G ? d.blue_light : _ ? "rgba(255, 255, 255, 0.85)" : d.white,
            border: `1px solid ${G ? d.blue : _ ? "rgba(0,0,0,0.1)" : d.gray_border}`,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: _ ? "0 1px 4px rgba(0, 0, 0, 0.1)" : "0 2px 8px rgba(0, 0, 0, 0.15)",
            transition: "background 0.2s, border-color 0.2s, transform 0.2s, opacity 0.2s",
            transform: G ? "scale(1.05)" : "scale(1)",
            opacity: _ && !G ? 0.7 : 1,
            zIndex: 999998,
            padding: 0,
            minWidth: 0
          },
          onMouseDown: (se) => se.stopPropagation(),
          onClick: (se) => {
            se.stopPropagation(), se.preventDefault(), ee();
          },
          onMouseEnter: () => {
            $.current && (clearTimeout($.current), $.current = null), H(!0);
          },
          onMouseLeave: () => H(!1),
          "aria-label": b === "gear" ? "Edit layout" : "Edit widget",
          children: /* @__PURE__ */ t(pe, { size: _ ? 14 : 16, color: d.gray_dark })
        }
      )
    );
    return Le.createPortal(xe, document.body);
  };
  return /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: `
        .widget-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
        
        }

        .widget-wrapper.widget-fill-container,
        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-hovered {
          outline: 1px dashed ${d.blue};
        }

        .widget-wrapper.widget-editing {
          outline: 2px dashed ${d.blue};
        }
      ` }),
    /* @__PURE__ */ u(
      "div",
      {
        ref: q,
        className: `widget-wrapper${k === "persistent" ? " widget-fill-container" : ""}${m ? ` ${m}` : ""}${w ? " widget-editing" : ne ? " widget-hovered" : ""}`,
        style: T,
        onMouseEnter: () => {
          $.current && (clearTimeout($.current), $.current = null), N(!0);
        },
        onMouseLeave: () => {
          $.current = setTimeout(() => {
            N(!1);
          }, 200);
        },
        children: [
          e,
          w && /* @__PURE__ */ t(
            Gr,
            {
              widgetId: o,
              displayName: r,
              fields: n,
              values: i,
              initialValues: F || void 0,
              onChange: l,
              onClose: () => v(!1),
              onReset: ye,
              screenPosition: P,
              onSave: Re,
              isSaving: p,
              savedKeys: g,
              studioLockedKeys: z,
              onResetField: c,
              themeColors: h,
              themeFonts: x,
              themeIcons: B
            }
          ),
          I && /* @__PURE__ */ t(
            Ke,
            {
              title: "Unsaved Changes",
              message: "You have unsaved changes. Would you like to save them before closing?",
              confirmLabel: "Save",
              cancelLabel: "Discard",
              onConfirm: ze,
              onCancel: be,
              onDismiss: ve,
              isLoading: p
            }
          )
        ]
      }
    ),
    ne && Pe()
  ] });
}, Vr = (e, o, r = "#000000") => e ? typeof e == "string" ? e : e.type === "custom" ? e.value : o[e.value] ?? r : r, sa = (e) => (o, r = "#000000") => Vr(o, e, r), Ns = () => {
  const { themeColors: e } = _o();
  return ge(
    (r, n = "#000000") => Vr(r, e, n),
    [e]
  );
};
function U(e, o, r) {
  const { isLoading: n, savedKeys: i, ...l } = aa(
    e,
    o
  ), s = l, [p, g] = D(!1), { themeColors: y } = _o(), { themeFonts: c } = Ur(), { themeIcons: h } = _r(), x = le(
    () => sa(y),
    [y]
  ), { data: B } = Fe(), k = le(() => {
    var W;
    const P = (W = B == null ? void 0 : B.studioControlledKeys) == null ? void 0 : W.widgetConfig;
    return !P || !e ? /* @__PURE__ */ new Set() : new Set(P[e] || []);
  }, [B, e]), b = $e(), {
    updateWidgetConfig: C,
    removeWidgetConfigKey: S,
    getWidgetState: T
  } = Wo(e), m = ge(
    (P) => {
      S(P);
    },
    [S]
  ), A = le(() => {
    const P = {};
    return r.forEach((W) => {
      P[W.key] = W.type, W.responsive && (P[`mobile_${W.key}`] = W.type);
    }), P;
  }, [r]), f = ge(
    (P, W) => {
      if (k.has(P)) return;
      const F = A[P];
      let L = W;
      switch (F) {
        case "toggle":
          typeof W == "string" && (L = W === "true");
          break;
        case "number":
          if (typeof W == "string" && W !== "") {
            const I = parseFloat(W);
            isNaN(I) || (L = I);
          }
          break;
        case "options":
          typeof W == "string" && (W === "true" ? L = !0 : W === "false" ? L = !1 : /^\d+$/.test(W) && (L = parseInt(W, 10)));
          break;
      }
      C(P, L);
    },
    [A, C]
  ), z = !!(b.themeId && b.editThemeToken && e), w = ge(async () => {
    if (!b.themeId || !b.editThemeToken || !e) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    g(!0);
    try {
      const P = T() || s;
      await Jr({
        themeId: b.themeId,
        widgetId: e,
        widgetState: P,
        editThemeToken: b.editThemeToken
      });
    } catch (P) {
      console.error("Failed to save widget config:", P), alert(`Failed to save: ${P.message}`);
    } finally {
      g(!1);
    }
  }, [b, e, T, s]), v = ge(() => {
    const P = { ...s };
    return r.forEach((W) => {
      const F = P[W.key];
      W.type === "options" && (typeof F == "boolean" ? P[W.key] = F ? "true" : "false" : typeof F == "number" && (P[W.key] = String(F)));
    }), P;
  }, [s, r]);
  return {
    state: s,
    isLoading: n,
    isSaving: p,
    handleEditChange: f,
    handleSave: w,
    resetField: m,
    savedKeys: i,
    studioLockedKeys: k,
    themeColors: y,
    themeFonts: c,
    themeIcons: h,
    resolveColor: x,
    canSave: z,
    getEditValues: v
  };
}
const He = [
  { label: "Normal", value: "400" },
  { label: "Medium", value: "500" },
  { label: "Semibold", value: "600" },
  { label: "Bold", value: "700" },
  { label: "Extra Bold", value: "800" },
  { label: "Black", value: "900" }
], ae = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" },
  { label: "Extra Bold", value: "800" },
  // CSS doesn't have keyword for 800, use numeric
  { label: "Black", value: "900" }
  // CSS doesn't have keyword for 900, use numeric
];
He.slice(
  0,
  4
);
const vt = He.slice(1, 4), da = He.slice(0, 3), ca = {
  expanded: {
    fontSize: 14,
    iconSize: 20,
    iconGap: 4,
    shadowEnabled: !0,
    shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
    borderColor: oe("#F3F3F3"),
    borderColorFocus: a("borderColor"),
    borderRadiusSingleLine: 15,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    paddingX: 12,
    paddingY: 12,
    minHeight: 116,
    mobile_paddingX: 12,
    mobile_paddingY: 12,
    mobile_minHeight: 116
  },
  compact: {
    fontSize: 14,
    iconSize: 20,
    iconGap: 4,
    shadowEnabled: !0,
    shadow: "8px 8px 14px 0px rgba(0, 0, 0, 0.03)",
    borderColor: oe("#F3F3F3"),
    borderColorFocus: a("borderColor"),
    borderRadiusSingleLine: 28,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    paddingX: 12,
    paddingY: 12,
    minHeight: 56,
    submitButtonSize: 24,
    mobile_fontSize: 12,
    mobile_paddingX: 16,
    mobile_paddingY: 12,
    mobile_minHeight: 46,
    mobile_iconGap: 4,
    mobile_iconSize: 20,
    mobile_submitButtonSize: 20
  }
}, pa = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Xe = {
  preset: "compact",
  // Background
  backgroundColor: a("secondary"),
  shadowEnabled: !0,
  shadow: "8px 8px 14px 0px rgba(0, 0, 0, 0.03)",
  // Border styling
  borderColor: oe("#F3F3F3"),
  borderColorFocus: a("borderColor"),
  borderRadiusSingleLine: 28,
  borderRadiusMultiLine: 15,
  borderWidth: 1,
  // Submit button
  submitButtonBgColor: a("textPrimary"),
  submitButtonBgColorHover: a("textPrimary"),
  submitButtonIconColor: a("secondary"),
  submitButtonSize: 24,
  submitButtonBorderRadius: 12,
  // Action icons (attachment, mic) — 20px, 6px gap per panel mock
  iconColor: a("textPrimary"),
  iconColorHover: a("tertiary"),
  iconSize: 20,
  iconGap: 4,
  micActiveColor: a("error"),
  microphoneIcon: "default",
  // Textarea typography — 14px per panel mock
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  textColor: a("textPrimary"),
  placeholderColor: oe("#4f4b4780"),
  // Layout — 12px padding per panel mock
  paddingX: 12,
  paddingY: 12,
  maxWidth: 768,
  minHeight: 56,
  // Visibility toggles
  showAttachmentButton: !0,
  showMicrophoneButton: !0,
  // Mobile overrides
  mobile_fontSize: 12,
  mobile_paddingX: 12,
  mobile_paddingY: 12,
  mobile_minHeight: 46,
  mobile_iconGap: 4,
  mobile_iconSize: 20,
  mobile_submitButtonSize: 20
}, St = [
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: [
      { label: "Expanded", value: "expanded" },
      { label: "Compact", value: "compact" },
      { label: "Custom", value: "custom" }
    ]
  },
  // Background
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "shadowEnabled", label: "Shadow", type: "toggle" },
  { key: "shadow", label: "Shadow Value (CSS)", type: "text" },
  // Border styling group
  { key: "borderColor", label: "Border Color", type: "color" },
  { key: "borderColorFocus", label: "Border Color (Focus)", type: "color" },
  {
    key: "borderRadiusSingleLine",
    label: "Border Radius (Single Line)",
    type: "number",
    min: 0,
    max: 100,
    step: 1
  },
  {
    key: "borderRadiusMultiLine",
    label: "Border Radius (Multi Line)",
    type: "number",
    min: 0,
    max: 50,
    step: 1
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 1
  },
  // Submit button group
  { key: "submitButtonBgColor", label: "Submit Button Color", type: "color" },
  {
    key: "submitButtonBgColorHover",
    label: "Submit Button Hover Color",
    type: "color"
  },
  {
    key: "submitButtonIconColor",
    label: "Submit Button Icon Color",
    type: "color"
  },
  {
    key: "submitButtonSize",
    label: "Submit Button Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "submitButtonBorderRadius",
    label: "Submit Button Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  // Action icons group
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "iconColorHover", label: "Icon Hover Color", type: "color" },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "iconGap",
    label: "Icon Gap",
    type: "number",
    min: 4,
    max: 32,
    step: 2
  },
  { key: "micActiveColor", label: "Mic Active Color", type: "color" },
  { key: "microphoneIcon", label: "Microphone Icon", type: "icon" },
  // Typography group
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: ae
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "placeholderColor", label: "Placeholder Color", type: "color" },
  // Layout group
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2,
    responsive: !0
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2,
    responsive: !0
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 1200,
    step: 50
  },
  {
    key: "minHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 300,
    step: 10,
    responsive: !0
  },
  // Visibility toggles
  {
    key: "showAttachmentButton",
    label: "Show Attachment Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  },
  {
    key: "showMicrophoneButton",
    label: "Show Microphone Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  }
], Ds = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    resetField: y,
    savedKeys: c,
    themeColors: h,
    themeFonts: x,
    themeIcons: B,
    resolveColor: k,
    canSave: b,
    getEditValues: C
  } = U(
    o,
    { ...Xe, ...e },
    St
  ), S = ge(
    (F, L) => {
      if (F === "preset" && L !== "custom") {
        const R = ca[L];
        if (R) {
          p("preset", L), Object.entries(R).forEach(([j, X]) => {
            p(j, X);
          });
          return;
        }
      }
      F !== "preset" && p("preset", "custom"), p(F, L);
    },
    [p]
  ), T = i.fontFamily, m = T && T !== "inherit" ? x[T] : null, A = m && m.format === "google" ? m.url : null;
  if (Q(() => {
    A && pa(A);
  }, [A]), Q(() => {
    !l && !c.has("iconGap") && (c.has("iconSize") && i.iconSize !== Xe.iconSize && S("iconSize", Xe.iconSize), c.has("submitButtonSize") && i.submitButtonSize !== Xe.submitButtonSize && S("submitButtonSize", Xe.submitButtonSize));
  }, [l]), l)
    return /* @__PURE__ */ t(O, {});
  const f = m ? m.format === "system" ? m.url : `"${m.name}", sans-serif` : "inherit", z = m && m.format !== "system" && m.format !== "google", w = `chat-input-${o || "default"}`, v = `
    ${z ? `
      @font-face {
        font-family: "${m.name}";
        src: url("${m.url}") format("${m.format}");
        font-display: swap;
      }
    ` : ""}
    ${f !== "inherit" ? `.${w} { font-family: ${f} !important; }` : ""}
  `.trim(), P = {
    ...i,
    fontFamilyCss: f
  }, W = /* @__PURE__ */ u(O, { children: [
    v && /* @__PURE__ */ t("style", { children: v }),
    n(P, B, k)
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: St,
      editValues: C(),
      onEditChange: S,
      onSave: b ? g : void 0,
      isSaving: s,
      savedKeys: c,
      onResetField: y,
      themeColors: h,
      themeFonts: x,
      themeIcons: B,
      children: W
    }
  );
}, wt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, ga = {
  // Headings - decreasing sizes with bold weight
  h1: {
    fontSize: 28,
    fontWeight: "700",
    lineHeight: 1.3,
    marginTop: 16,
    marginBottom: 12,
    color: a("textPrimary")
  },
  h2: {
    fontSize: 24,
    fontWeight: "700",
    lineHeight: 1.35,
    marginTop: 14,
    marginBottom: 10,
    color: a("textPrimary")
  },
  h3: {
    fontSize: 20,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 12,
    marginBottom: 8,
    color: a("textPrimary")
  },
  h4: {
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 10,
    marginBottom: 6
  },
  h5: {
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 8,
    marginBottom: 4
  },
  // Text elements
  p: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 12,
    color: a("textPrimary")
  },
  strong: { fontWeight: "600" },
  em: { fontWeight: "500" },
  code: { fontSize: 14, fontWeight: "500", lineHeight: 1.4 },
  blockquote: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 8,
    marginBottom: 8,
    color: a("textPrimary")
  },
  // Lists
  ul: { marginTop: 8, marginBottom: 12 },
  ol: { marginTop: 8, marginBottom: 12 },
  li: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginBottom: 4,
    color: a("textPrimary")
  },
  // Tables
  table: { fontSize: 14, marginTop: 8, marginBottom: 12 },
  thead: {
    fontWeight: "600",
    backgroundColor: a("primary"),
    color: a("primaryForeground")
  },
  tbody: { fontWeight: "500" },
  tr: {},
  th: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 1.4,
    color: a("primaryForeground")
  },
  td: {
    fontSize: 14,
    fontWeight: "500",
    lineHeight: 1.4,
    color: a("textPrimary")
  }
}, ma = {
  // Background & Colors (defaults for user message, assistant can override via widgetId)
  bgColor: a("background"),
  // blueWhite-like for user
  textColor: a("textPrimary"),
  // Border radius
  borderRadius: 23,
  borderRadiusShort: 100,
  // pill shape for short messages
  // Typography
  fontSize: 16,
  fontWeight: "500",
  fontFamily: "inherit",
  lineHeight: 1.5,
  // Padding
  paddingX: 16,
  paddingY: 12,
  // Single-line height
  singleLineHeight: 46,
  // Layout
  maxWidth: "70%",
  alignment: "left",
  // Short message threshold
  shortMessageThreshold: 50,
  // Element styles with defaults
  elementStyles: ga
}, Je = (e, o, r) => {
  const n = `elementStyles.${e}`, i = [
    {
      key: `${n}.fontFamily`,
      label: `${o} Font`,
      type: "font"
    },
    {
      key: `${n}.fontSize`,
      label: `${o} Font Size`,
      type: "number",
      min: 10,
      max: 48,
      step: 1
    },
    {
      key: `${n}.fontWeight`,
      label: `${o} Font Weight`,
      type: "options",
      options: He
    },
    {
      key: `${n}.color`,
      label: `${o} Color`,
      type: "color"
    }
  ];
  return r != null && r.includeBackgroundColor && i.push({
    key: `${n}.backgroundColor`,
    label: `${o} Background`,
    type: "color"
  }), i.push(
    {
      key: `${n}.lineHeight`,
      label: `${o} Line Height`,
      type: "number",
      min: 1,
      max: 2.5,
      step: 0.1
    },
    {
      key: `${n}.marginTop`,
      label: `${o} Margin Top`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    },
    {
      key: `${n}.marginBottom`,
      label: `${o} Margin Bottom`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    }
  ), i;
}, Ze = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell"
}, qr = [
  { key: "bgColor", label: "Background Color", type: "color" },
  { key: "textColor", label: "Text Color", type: "color" },
  {
    key: "borderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "borderRadiusShort",
    label: "Short Msg Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "fontSize",
    label: "Base Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Base Font Weight",
    type: "options",
    options: da
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  {
    key: "lineHeight",
    label: "Base Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "paddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "singleLineHeight",
    label: "Single Line Height (px)",
    type: "number",
    min: 0,
    max: 80,
    step: 1
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "alignment",
    label: "Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Right", value: "right" },
      { label: "Center", value: "center" }
    ]
  }
], ua = ["h1", "h2", "h3"], ha = ["p", "blockquote"], ya = ["li"], ba = ["th", "td"], fa = ["thead"], xa = [
  ...ua.flatMap(
    (e) => Je(e, Ze[e])
  ),
  ...ha.flatMap(
    (e) => Je(e, Ze[e])
  ),
  ...ya.flatMap(
    (e) => Je(e, Ze[e])
  ),
  ...fa.flatMap(
    (e) => Je(e, Ze[e], {
      includeBackgroundColor: !0
    })
  ),
  ...ba.flatMap(
    (e) => Je(e, Ze[e])
  )
], Ca = [...qr, ...xa], ka = (e, o, r, n) => {
  if (!o) return "";
  const i = [], l = [], s = /* @__PURE__ */ new Set();
  for (const [p, g] of Object.entries(o)) {
    if (!g) continue;
    const y = [];
    if (g.fontSize !== void 0 && y.push(`font-size: ${g.fontSize}px`), g.fontWeight !== void 0 && y.push(`font-weight: ${g.fontWeight}`), g.color && g.color !== "inherit") {
      const c = n(g.color);
      y.push(`color: ${c}`);
    }
    if (g.backgroundColor && g.backgroundColor !== "inherit" && g.backgroundColor !== "transparent") {
      const c = n(g.backgroundColor);
      y.push(`background-color: ${c}`);
    }
    if (g.lineHeight !== void 0 && y.push(`line-height: ${g.lineHeight}`), g.marginTop !== void 0 && y.push(`margin-top: ${g.marginTop}px`), g.marginBottom !== void 0 && y.push(`margin-bottom: ${g.marginBottom}px`), g.fontFamily && g.fontFamily !== "inherit") {
      const c = r[g.fontFamily];
      c && (c.format === "system" ? y.push(`font-family: ${c.url}`) : (y.push(`font-family: "${c.name}", sans-serif`), c.format !== "google" && !s.has(c.name) && (l.push(`
              @font-face {
                font-family: "${c.name}";
                src: url("${c.url}") format("${c.format}");
                font-display: swap;
              }
            `), s.add(c.name))));
    }
    y.length > 0 && i.push(`#concierge-mount .${e} .message-content ${p},
#concierge-mount .${e} .message-content .message-markdown ${p},
.${e} .message-content ${p},
.${e} .message-content .message-markdown ${p} {
  ${y.join(`;
  `)};
}`);
  }
  return [...l, ...i].join(`

`);
}, va = (e, o, r) => {
  const n = o.split("."), i = { ...e };
  let l = i;
  for (let s = 0; s < n.length - 1; s++) {
    const p = n[s];
    l[p] = { ...l[p] }, l = l[p];
  }
  return l[n[n.length - 1]] = r, i;
}, Sa = (e) => {
  const o = {};
  for (const [r, n] of Object.entries(e))
    if (r === "elementStyles" && typeof n == "object" && n !== null) {
      for (const [i, l] of Object.entries(
        n
      ))
        if (l && typeof l == "object")
          for (const [s, p] of Object.entries(l))
            o[`elementStyles.${i}.${s}`] = p;
    } else
      o[r] = n;
  return o;
}, Os = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeFonts: c,
    resolveColor: h,
    canSave: x
  } = U(
    o,
    { ...ma, ...e },
    qr
    // Only use base fields for type transformations
  ), B = (F, L) => {
    if (F.includes(".")) {
      const I = va(i, F, L), R = F.split(".")[0];
      p(R, I[R]);
    } else
      p(F, L);
  }, k = le(() => Sa(i), [i]), b = i.fontFamily, C = b && b !== "inherit" ? c[b] : null, S = C && C.format === "google" ? C.url : null, T = le(() => {
    const F = [];
    if (i.elementStyles) {
      for (const L of Object.values(i.elementStyles))
        if (L != null && L.fontFamily && L.fontFamily !== "inherit") {
          const I = c[L.fontFamily];
          (I == null ? void 0 : I.format) === "google" && I.url && !F.includes(I.url) && F.push(I.url);
        }
    }
    return F;
  }, [i.elementStyles, c]);
  Q(() => {
    S && wt(S);
    for (const F of T)
      wt(F);
  }, [S, T]);
  const m = `message-bubble-${o || "default"}`, A = le(
    () => ka(
      m,
      i.elementStyles,
      c,
      h
    ),
    [m, i.elementStyles, c, h]
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const f = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", v = [`
    ${C && C.format !== "system" && C.format !== "google" ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${f !== "inherit" ? `.${m} { font-family: ${f} !important; }` : ""}
  `.trim(), A].filter(Boolean).join(`

`), P = {
    ...i,
    fontFamilyCss: f
  }, W = /* @__PURE__ */ u("div", { className: m, children: [
    v && /* @__PURE__ */ t("style", { children: v }),
    n(P, h)
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Ca,
      editValues: k,
      onEditChange: B,
      onSave: x ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeFonts: c,
      children: W
    }
  );
}, js = {
  headings: ["h1", "h2", "h3", "h4", "h5"],
  text: ["p", "strong", "em", "code", "blockquote"],
  lists: ["ul", "ol", "li"],
  tables: ["table", "thead", "tbody", "tr", "th", "td"]
}, wa = {
  // Container
  containerBgColor: a("background"),
  containerPaddingX: 16,
  containerPaddingY: 12,
  containerBorderRadius: 18,
  containerBorderRadiusBottomLeft: 5,
  // Dots
  dotColor: a("textPrimary"),
  dotSize: 8,
  dotSpacing: 2,
  // Animation
  animationDuration: 1.4,
  // Status text
  statusTextColor: a("textPrimary"),
  statusFontSize: 12,
  statusMarginTop: 8
}, Bt = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "containerBorderRadiusBottomLeft",
    label: "Bottom Left Radius",
    type: "number",
    min: 0,
    max: 20,
    step: 1
  },
  // Dots
  { key: "dotColor", label: "Dot Color", type: "color" },
  {
    key: "dotSize",
    label: "Dot Size",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  },
  {
    key: "dotSpacing",
    label: "Dot Spacing",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  },
  // Animation
  {
    key: "animationDuration",
    label: "Animation Duration (s)",
    type: "number",
    min: 0.5,
    max: 3,
    step: 0.1
  },
  // Status text
  { key: "statusTextColor", label: "Status Text Color", type: "color" },
  {
    key: "statusFontSize",
    label: "Status Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "statusMarginTop",
    label: "Status Margin Top",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  }
], Gs = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    resolveColor: c,
    canSave: h
  } = U(
    o,
    { ...wa, ...e },
    Bt
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const x = n(i, c);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Bt,
      editValues: i,
      onEditChange: p,
      onSave: h ? g : void 0,
      isSaving: s,
      themeColors: y,
      children: x
    }
  );
}, zt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, to = ({ width: e }) => /* @__PURE__ */ t(
  "div",
  {
    style: {
      width: `${e}px`,
      height: "32px",
      borderRadius: "9999px",
      backgroundColor: "#e5e7eb",
      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), Ba = {
  // Preset
  preset: "inline",
  // Title
  showTitle: !0,
  titleText: "Get expert advice on this product",
  titleFontSize: 20,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  titleColor: a("textPrimary"),
  // Title icon & behavior
  showSparkleIcon: !0,
  collapsible: !1,
  // Container
  containerGap: 16,
  containerMarginTop: 16,
  containerMarginBottom: 16,
  containerBgColor: a("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Suggestion pills
  pillPaddingX: 12,
  pillPaddingY: 4,
  pillBorderRadius: 50,
  pillBorderColor: a("primary"),
  pillBorderWidth: 1.5,
  pillBgColor: a("secondary"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillFontSize: 16,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, za = {
  inline: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  highlighted: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("background"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  accordion: {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  "accordion-highlighted": {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("background"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  }
}, Fa = [
  { label: "Inline Pills (V1)", value: "inline" },
  { label: "Highlighted (V2)", value: "highlighted" },
  { label: "Accordion (V3)", value: "accordion" },
  { label: "Accordion Highlighted (V4)", value: "accordion-highlighted" },
  { label: "Custom", value: "custom" }
], Ft = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: Fa
  },
  // Title section
  { key: "showTitle", label: "Show Title", type: "toggle" },
  { key: "showSparkleIcon", label: "Show Sparkle Icon", type: "toggle" },
  { key: "collapsible", label: "Collapsible (Accordion)", type: "toggle" },
  { key: "titleText", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ae]
  },
  { key: "titleFontFamily", label: "Title Font Family", type: "font" },
  { key: "titleColor", label: "Title Color", type: "color" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Title and Pills",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 2,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...ae]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" }
], Kr = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, Ia = ({
  color: e = "currentColor"
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    style: { flexShrink: 0 },
    children: /* @__PURE__ */ t(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6375 8.97842L15.9115 8.19942C13.4152 7.49564 11.4643 5.54472 10.7605 3.04842L9.98148 0.32242C9.90136 0.12736 9.71136 0 9.50048 0C9.2896 0 9.09961 0.12736 9.01948 0.32242L8.24048 3.04842C7.5367 5.54472 5.58578 7.49564 3.08948 8.19942L0.36348 8.97842C0.14841 9.03946 0 9.23586 0 9.45942C0 9.68298 0.14841 9.87938 0.36348 9.94042L3.08948 10.7194C5.58578 11.4232 7.53671 13.3741 8.24048 15.8704L9.01948 18.5964C9.08052 18.8115 9.27692 18.9599 9.50048 18.9599C9.72404 18.9599 9.92044 18.8115 9.98148 18.5964L10.7605 15.8704C11.4642 13.3741 13.4152 11.4232 15.9115 10.7194L18.6375 9.94042C18.8526 9.87938 19.001 9.68298 19.001 9.45942C19.001 9.23586 18.8526 9.03946 18.6375 8.97842Z",
        fill: e
      }
    )
  }
), Pa = ({
  expanded: e,
  color: o = "currentColor"
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      flexShrink: 0,
      transition: "transform 0.2s ease",
      transform: e ? "rotate(180deg)" : "rotate(0deg)"
    },
    children: /* @__PURE__ */ t("polyline", { points: "6 9 12 15 18 9" })
  }
), Ta = ({ question: e, onClick: o, state: r, resolveColor: n }) => {
  const [i, l] = D(!1);
  return /* @__PURE__ */ t(
    "button",
    {
      onClick: o,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      style: {
        padding: `${r.pillPaddingY}px ${r.pillPaddingX}px`,
        borderRadius: `${r.pillBorderRadius}px`,
        border: `${r.pillBorderWidth}px solid ${n(r.pillBorderColor)}`,
        backgroundColor: n(i ? r.pillBgColorHover : r.pillBgColor),
        color: n(r.pillTextColor),
        fontSize: `${r.pillFontSize}px`,
        fontWeight: Kr[r.pillFontWeight] || 500,
        fontFamily: r.pillFontFamilyCss || "inherit",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        textAlign: "left",
        lineHeight: "32px"
      },
      children: e
    }
  );
}, $s = ({
  widgetId: e = "conversation-starters",
  displayName: o = "Conversation Starters",
  initialState: r = {},
  questions: n,
  isLoading: i = !1,
  onQuestionClick: l
}) => {
  const {
    state: s,
    isLoading: p,
    isSaving: g,
    handleEditChange: y,
    handleSave: c,
    themeColors: h,
    themeFonts: x,
    resolveColor: B,
    canSave: k
  } = U(
    e,
    { ...Ba, ...r },
    Ft
  ), [b, C] = D(!1), S = (G, H) => {
    if (G === "preset" && H !== "custom") {
      const Y = za[H];
      if (Y) {
        y("preset", H), Object.entries(Y).forEach(([q, J]) => {
          y(q, J);
        });
        return;
      }
    }
    y(G, H);
  }, T = s.pillFontFamily, m = T && T !== "inherit" ? x[T] : null, A = s.titleFontFamily, f = A && A !== "inherit" ? x[A] : null, z = m && m.format === "google" ? m.url : null, w = f && f.format === "google" ? f.url : null;
  if (Q(() => {
    z && zt(z);
  }, [z]), Q(() => {
    w && zt(w);
  }, [w]), p || !i && n.length === 0)
    return null;
  const v = m ? m.format === "system" ? m.url : `"${m.name}", sans-serif` : "inherit", P = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", W = m && m.format !== "system" && m.format !== "google", F = f && f.format !== "system" && f.format !== "google", L = `conversation-starters-${e || "default"}`, I = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    ${W ? `
      @font-face {
        font-family: "${m.name}";
        src: url("${m.url}") format("${m.format}");
        font-display: swap;
      }
    ` : ""}
    ${F ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
  `.trim(), R = {
    ...s,
    pillFontFamilyCss: v,
    titleFontFamilyCss: P
  }, j = s.collapsible ? b : !0, X = B(s.containerBgColor), M = X && X !== "transparent" && X !== "", N = /* @__PURE__ */ u(O, { children: [
    I && /* @__PURE__ */ t("style", { children: I }),
    /* @__PURE__ */ u(
      "div",
      {
        className: L,
        style: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: j ? `${s.containerGap}px` : "0px",
          marginTop: `${s.containerMarginTop}px`,
          marginBottom: `${s.containerMarginBottom}px`,
          backgroundColor: M ? X : void 0,
          padding: M || s.containerPaddingX || s.containerPaddingY ? `${s.containerPaddingY}px ${s.containerPaddingX}px` : void 0,
          borderRadius: s.containerBorderRadius > 0 ? `${s.containerBorderRadius}px` : void 0
        },
        children: [
          s.showTitle && /* @__PURE__ */ u(
            "h3",
            {
              onClick: s.collapsible ? () => C((G) => !G) : void 0,
              style: {
                fontSize: `${s.titleFontSize}px`,
                fontWeight: Kr[s.titleFontWeight] || 600,
                fontFamily: P,
                color: B(s.titleColor),
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: s.collapsible ? "pointer" : void 0,
                userSelect: s.collapsible ? "none" : void 0
              },
              children: [
                s.showSparkleIcon && /* @__PURE__ */ t(Ia, { color: B(s.titleColor) }),
                /* @__PURE__ */ t("span", { style: { flex: 1 }, children: s.titleText }),
                s.collapsible && /* @__PURE__ */ t(
                  Pa,
                  {
                    expanded: b,
                    color: B(s.titleColor)
                  }
                )
              ]
            }
          ),
          j && /* @__PURE__ */ t(O, { children: i ? /* @__PURE__ */ u(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start"
              },
              children: [
                /* @__PURE__ */ t(to, { width: 180 }),
                /* @__PURE__ */ t(to, { width: 140 }),
                /* @__PURE__ */ t(to, { width: 200 }),
                /* @__PURE__ */ t(to, { width: 160 })
              ]
            }
          ) : /* @__PURE__ */ t(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start",
                width: "100%"
              },
              children: n.map((G, H) => /* @__PURE__ */ t(
                Ta,
                {
                  question: G,
                  onClick: () => l(G),
                  state: R,
                  resolveColor: B
                },
                H
              ))
            }
          ) })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: Ft,
      editValues: s,
      onEditChange: S,
      onSave: k ? c : void 0,
      isSaving: g,
      themeColors: h,
      themeFonts: x,
      children: N
    }
  );
}, _e = 60, It = 420, Pt = ({
  showSettings: e,
  viewMode: o,
  editorMode: r = "iframe"
}) => `
  /* Reset and base styles */
  .bc-theme-editor-shell {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .bc-theme-editor-shell * {
    box-sizing: border-box;
  }

  /* Top Bar */
  .bc-theme-editor-topbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${_e}px;
    background: #f5f5f7;
    border-bottom: 1px solid ${d.border_glass};
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 16px;
    z-index: 1000001;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }

  /* Logo/Brand */
  .bc-theme-editor-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 16px;
    border-right: 1px solid ${d.border_glass};
  }

  .bc-theme-editor-logo-icon {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, ${d.blue_dark} 0%, #252b6e 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .bc-theme-editor-logo-text {
    font-size: 14px;
    font-weight: 600;
    color: ${d.primary};
    letter-spacing: -0.3px;
  }

  /* Theme ID */
  .bc-theme-editor-theme-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-theme-label {
    font-size: 12px;
    color: ${d.gray_medium};
    font-weight: 500;
  }

  .bc-theme-editor-theme-id {
    font-size: 12px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${d.primary};
    background: ${d.white};
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid ${d.border_glass};
  }

  .bc-theme-editor-live-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #4caf50;
    margin-left: 8px;
  }

  .bc-theme-editor-live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #4caf50;
  }

  /* Viewport Toggle */
  .bc-theme-editor-viewport-toggle {
    display: flex;
    background: ${d.white};
    border-radius: 10px;
    padding: 4px;
    margin-left: 16px;
    border: 1px solid ${d.border_glass};
    gap: 2px;
  }

  /* Spacer */
  .bc-theme-editor-spacer {
    flex: 1;
  }

  /* Action Buttons */
  .bc-theme-editor-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  /* Preview Area */
  .bc-theme-editor-preview {
    position: fixed;
    top: ${_e}px;
    left: 0;
    right: ${e ? It : 0}px;
    bottom: 0;
    background: #e8e8ed;
    transition: right 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
  }

  .bc-theme-editor-preview-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: ${o === "mobile" ? "24px" : "0"};
    transition: padding 0.3s ease;
  }

  .bc-theme-editor-iframe-wrapper {
    width: ${o === "desktop" ? "100%" : "375px"};
    height: ${o === "desktop" ? "100%" : "calc(100% - 48px)"};
    background: white;
    transition: all 0.3s ease;
    ${o === "mobile" ? `
      border-radius: 24px;
      box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    ` : ""}
  }

  .bc-theme-editor-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  /* Side Panel */
  @keyframes bc-slide-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes bc-slide-out {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  .bc-theme-editor-sidepanel {
    position: fixed;
    top: ${_e}px;
    right: 0;
    bottom: 0;
    width: ${It}px;
    background: #fff;
    border-left: 1px solid ${d.border_subtle};
    z-index: 1000000;
    overflow-y: auto;
    animation: bc-slide-in 0.3s ease;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.15);
  }

  .bc-theme-editor-sidepanel-header {
    position: sticky;
    top: 0;
    background: ${d.glass_bg_strong};
    backdrop-filter: blur(20px);
    padding: 20px 24px;
    border-bottom: 1px solid ${d.border_glass};
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
  }

  .bc-theme-editor-sidepanel-title {
    font-size: 16px;
    font-weight: 600;
    color: ${d.primary};
    margin: 0;
  }

  .bc-theme-editor-sidepanel-close {
    width: 32px;
    height: 32px;
    border: none;
    background: ${d.overlay_light};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: ${d.gray_medium};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-sidepanel-close:hover {
    background: ${d.gray_light};
    color: ${d.primary};
  }

  .bc-theme-editor-sidepanel-content {
    padding: 24px;
  }

  /* Messages */
  .bc-theme-editor-message {
    padding: 12px 16px;
    border-radius: 10px;
    margin-bottom: 20px;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-message-success {
    background: rgba(113, 194, 133, 0.15);
    color: ${d.green};
    border: 1px solid rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-message-error {
    background: rgba(255, 83, 74, 0.1);
    color: ${d.red};
    border: 1px solid rgba(255, 83, 74, 0.2);
  }

  /* Sections */
  .bc-theme-editor-section {
    margin-bottom: 8px;
    background: ${d.white};
    border-radius: 12px;
    border: 1px solid ${d.border_glass};
    overflow: hidden;
  }

  .bc-theme-editor-section:last-child {
    margin-bottom: 0;
  }

  .bc-theme-editor-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    user-select: none;
  }

  .bc-theme-editor-section-header:hover {
    background: ${d.bg_light};
  }

  .bc-theme-editor-section-title {
    font-size: 12px;
    font-weight: 600;
    color: ${d.primary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-section-count {
    font-size: 11px;
    font-weight: 500;
    color: ${d.gray_medium};
    background: ${d.bg_light};
    padding: 2px 8px;
    border-radius: 10px;
  }

  .bc-theme-editor-section-chevron {
    color: ${d.gray_medium};
    transition: transform 0.2s ease;
  }

  .bc-theme-editor-section-chevron.expanded {
    transform: rotate(90deg);
  }

  .bc-theme-editor-section-content {
    padding: 0 16px 16px;
  }

  /* Color/Asset Lists */
  .bc-theme-editor-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bc-theme-editor-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: ${d.overlay_light};
    border-radius: 12px;
    border: 1px solid ${d.border_glass};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-row:hover {
    background: ${d.white};
    box-shadow: 0 2px 8px ${d.shadow_soft};
  }

  .bc-theme-editor-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid ${d.border_glass};
    border-radius: 8px;
    font-size: 13px;
    background: ${d.white};
    color: ${d.primary};
    outline: none;
    transition: all 0.15s ease;
    min-width: 0;
  }

  .bc-theme-editor-input:focus {
    border-color: ${d.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .bc-theme-editor-input:disabled {
    background: transparent;
    border-color: transparent;
    padding-left: 0;
  }

  .bc-theme-editor-color-picker {
    width: 44px;
    height: 36px;
    border: 2px solid ${d.border_glass};
    border-radius: 8px;
    cursor: pointer;
    outline: none;
    padding: 2px;
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-color-picker:hover:not(:disabled) {
    border-color: ${d.gray_border};
    transform: scale(1.05);
  }

  .bc-theme-editor-color-picker:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .bc-theme-editor-color-value {
    font-size: 11px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${d.gray_medium};
    width: 85px;
    text-align: right;
    background: ${d.bg_light};
    padding: 5px 8px;
    border-radius: 4px;
    flex-shrink: 0;
    display: inline-block;
  }

  /* Buttons */
  .bc-theme-editor-btn-small {
    padding: 8px 12px;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .bc-theme-editor-btn-delete {
    background: linear-gradient(135deg, ${d.red} 0%, #e63e37 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(255, 83, 74, 0.2);
  }

  .bc-theme-editor-btn-delete:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(255, 83, 74, 0.3);
  }

  .bc-theme-editor-btn-save {
    background: linear-gradient(135deg, ${d.green} 0%, #5fb077 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(113, 194, 133, 0.2);
  }

  .bc-theme-editor-btn-save:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-btn-cancel {
    background: ${d.gray_light};
    color: ${d.gray_dark};
  }

  .bc-theme-editor-btn-cancel:hover:not(:disabled) {
    background: ${d.gray_border};
  }

  .bc-theme-editor-btn-small:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .bc-theme-editor-btn-add {
    width: fit-content;
    padding: 10px 16px;
    background: transparent;
    color: ${d.blue};
    border: 2px dashed ${d.gray_border};
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    margin-top: 4px;
  }

  .bc-theme-editor-btn-add:hover:not(:disabled) {
    background: ${d.blue_light};
    border-color: ${d.blue};
    border-style: solid;
  }

  .bc-theme-editor-btn-add:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Delete button (minimal red X) */
  .bc-theme-editor-delete-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${d.gray_medium};
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-delete-btn:hover:not(:disabled) {
    background: rgba(255, 83, 74, 0.1);
    color: ${d.red};
  }

  .bc-theme-editor-delete-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Font section specific */
  .bc-font-row {
    justify-content: space-between;
  }

  .bc-font-preview-name {
    font-size: 15px;
    color: ${d.primary};
    flex: 1;
    min-width: 0;
  }

  /* Asset specific */
  .bc-theme-editor-asset-preview {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: ${d.bg_light};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
  }

  .bc-theme-editor-asset-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .bc-theme-editor-asset-format {
    font-size: 10px;
    color: ${d.gray_medium};
    background: ${d.bg_light};
    padding: 3px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    flex-shrink: 0;
  }

  .bc-theme-editor-file-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .bc-theme-editor-file-btn {
    padding: 6px 10px;
    background: ${d.overlay_light};
    border: 1px solid ${d.border_glass};
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    color: ${d.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .bc-theme-editor-file-btn:hover:not(:disabled) {
    background: ${d.white};
    border-color: ${d.blue};
    color: ${d.blue};
  }

  .bc-theme-editor-file-name {
    font-size: 11px;
    color: ${d.gray_medium};
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bc-theme-editor-loading {
    text-align: center;
    padding: 24px;
    color: ${d.gray_medium};
    font-size: 13px;
  }

  /* Inline mode specific styles */
  ${r === "inline" ? `
  /* Push page content below the fixed top bar */
  body {
    padding-top: ${_e}px !important;
  }

  /* In inline mode, shell doesn't cover the entire viewport */
  .bc-theme-editor-shell {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
  }

  /* Hide viewport toggle in inline mode (no mobile preview available) */
  .bc-theme-editor-viewport-toggle {
    display: none;
  }
  ` : ""}
`, Tt = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, Ma = [
  { label: "Classic", value: "magnifying-glass" },
  { label: "Alternate", value: "magnifying-glass-alt" },
  { label: "Bold", value: "magnifying-glass-bold" },
  { label: "Slim", value: "magnifying-glass-slim" },
  { label: "Dot", value: "magnifying-glass-dot" }
], ko = ({
  variant: e = "magnifying-glass",
  size: o,
  color: r,
  strokeWidth: n = 2,
  style: i
}) => {
  const l = {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: r,
    strokeWidth: n,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { flexShrink: 0, ...i }
  };
  switch (e) {
    case "magnifying-glass-alt":
      return /* @__PURE__ */ u("svg", { ...l, children: [
        /* @__PURE__ */ t("path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }),
        /* @__PURE__ */ t("path", { d: "M21 21l-6-6" })
      ] });
    case "magnifying-glass-bold":
      return /* @__PURE__ */ u("svg", { ...l, strokeWidth: n + 0.75, children: [
        /* @__PURE__ */ t("circle", { cx: "11", cy: "11", r: "7" }),
        /* @__PURE__ */ t("line", { x1: "16.5", y1: "16.5", x2: "21", y2: "21" })
      ] });
    case "magnifying-glass-slim":
      return /* @__PURE__ */ u("svg", { ...l, strokeWidth: Math.max(1, n - 0.5), children: [
        /* @__PURE__ */ t("circle", { cx: "10.5", cy: "10.5", r: "8.5" }),
        /* @__PURE__ */ t("line", { x1: "21", y1: "21", x2: "17", y2: "17" })
      ] });
    case "magnifying-glass-dot":
      return /* @__PURE__ */ u("svg", { ...l, children: [
        /* @__PURE__ */ t("circle", { cx: "11", cy: "11", r: "8" }),
        /* @__PURE__ */ t("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" }),
        /* @__PURE__ */ t("circle", { cx: "11", cy: "11", r: "1.5", fill: r, stroke: "none" })
      ] });
    case "magnifying-glass":
    default:
      return /* @__PURE__ */ u("svg", { ...l, children: [
        /* @__PURE__ */ t("circle", { cx: "11", cy: "11", r: "8" }),
        /* @__PURE__ */ t("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" })
      ] });
  }
}, Ea = ({
  size: e,
  color: o
}) => /* @__PURE__ */ u(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { flexShrink: 0, cursor: "pointer" },
    children: [
      /* @__PURE__ */ t("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
      /* @__PURE__ */ t("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
    ]
  }
), Ge = {
  // Trigger icon
  triggerIconStyle: "magnifying-glass",
  triggerIconThemeIcon: "default",
  triggerIconSize: 20,
  triggerIconColor: a("textPrimary"),
  triggerIconStrokeWidth: 2,
  // Panel
  panelBgColor: a("background"),
  // Search bar
  searchBarBgColor: a("background"),
  searchBarBorderRadius: 30,
  searchBarMaxWidth: 800,
  searchBarHeight: 56,
  searchBarHeightMobile: 40,
  searchBarPlaceholder: "Search or ask concierge",
  searchBarFontSize: 14,
  searchBarFontSizeMobile: 12,
  searchBarTextColor: a("textPrimary"),
  searchBarPlaceholderColor: a("textPrimary"),
  searchBarIconSize: 24,
  searchBarIconSizeMobile: 16,
  // Ask concierge button
  askButtonBgColor: a("textPrimary"),
  askButtonTextColor: a("secondary"),
  askButtonBorderRadius: 100,
  askButtonFontSize: 14,
  askButtonFontSizeMobile: 10,
  askButtonText: "Ask concierge",
  askButtonPaddingX: 16,
  askButtonPaddingY: 4,
  // Close button
  closeIconSize: 24,
  closeIconSizeMobile: 20,
  closeIconColor: a("textPrimary"),
  // Section headers
  sectionHeaderFontSize: 16,
  sectionHeaderFontSizeMobile: 14,
  sectionHeaderFontWeight: "semibold",
  sectionHeaderColor: a("textPrimary"),
  // Body / question text
  bodyFontSize: 14,
  bodyColor: a("textPrimary"),
  bodyLineHeight: 24,
  // Products
  productImageSize: 72,
  productImageSizeMobile: 56,
  productNameFontSize: 14,
  productPriceFontSize: 14,
  productPriceFontWeight: "semibold",
  productColumns: 2,
  // Trending searches
  trendingFontSize: 14,
  trendingColor: a("textPrimary"),
  trendingLineHeight: 24,
  // Empty state
  noResultsText: "No search results found. Please try again.",
  noResultsWithSuggestionsText: "No search results found . Here's some ideas to get you started.",
  noSuggestionsText: "No suggestions found",
  noProductsText: "No products found",
  noSearchesText: "No searches found",
  // Spacing
  sectionGap: 32,
  contentPaddingX: 43,
  contentPaddingXMobile: 20,
  contentPaddingTop: 24,
  // Mobile dividers
  showMobileDividers: !0,
  dividerColor: a("background"),
  // Font
  fontFamily: "inherit"
}, en = [
  {
    key: "triggerIconThemeIcon",
    label: "Custom Icon",
    type: "icon",
    group: "Trigger Icon"
  },
  {
    key: "triggerIconStyle",
    label: "Built-in Style",
    type: "options",
    options: Ma,
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  },
  {
    key: "triggerIconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 48,
    step: 2,
    group: "Trigger Icon"
  },
  {
    key: "triggerIconColor",
    label: "Icon Color",
    type: "color",
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  },
  {
    key: "triggerIconStrokeWidth",
    label: "Stroke Width",
    type: "number",
    min: 1,
    max: 4,
    step: 0.5,
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  }
], on = [
  {
    key: "searchBarBgColor",
    label: "Background",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "searchBarBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2,
    group: "Search Bar"
  },
  {
    key: "searchBarMaxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Search Bar"
  },
  {
    key: "searchBarHeight",
    label: "Height (Desktop)",
    type: "number",
    min: 36,
    max: 72,
    step: 4,
    group: "Search Bar"
  },
  {
    key: "searchBarHeightMobile",
    label: "Height (Mobile)",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Search Bar"
  },
  {
    key: "searchBarPlaceholder",
    label: "Placeholder Text",
    type: "text",
    group: "Search Bar"
  },
  {
    key: "searchBarFontSize",
    label: "Font Size (Desktop)",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Search Bar"
  },
  {
    key: "searchBarTextColor",
    label: "Text Color",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "searchBarPlaceholderColor",
    label: "Placeholder Color",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "askButtonBgColor",
    label: "Button Background",
    type: "color",
    group: "Ask Button"
  },
  {
    key: "askButtonTextColor",
    label: "Button Text Color",
    type: "color",
    group: "Ask Button"
  },
  {
    key: "askButtonBorderRadius",
    label: "Button Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 4,
    group: "Ask Button"
  },
  {
    key: "askButtonText",
    label: "Button Text",
    type: "text",
    group: "Ask Button"
  },
  {
    key: "closeIconSize",
    label: "Close Icon Size",
    type: "number",
    min: 16,
    max: 32,
    step: 2,
    group: "Close Button"
  },
  {
    key: "closeIconColor",
    label: "Close Icon Color",
    type: "color",
    group: "Close Button"
  }
], Ro = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderFontWeight",
    label: "Header Font Weight",
    type: "options",
    options: [...ae],
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "bodyFontSize",
    label: "Body Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Body Text"
  },
  { key: "bodyColor", label: "Body Color", type: "color", group: "Body Text" }
], Ao = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "productImageSize",
    label: "Image Size (Desktop)",
    type: "number",
    min: 48,
    max: 96,
    step: 8,
    group: "Products"
  },
  {
    key: "productImageSizeMobile",
    label: "Image Size (Mobile)",
    type: "number",
    min: 40,
    max: 72,
    step: 8,
    group: "Products"
  },
  {
    key: "productColumns",
    label: "Columns (Desktop)",
    type: "number",
    min: 1,
    max: 3,
    step: 1,
    group: "Products"
  },
  {
    key: "productNameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Products"
  },
  {
    key: "productPriceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Products"
  },
  {
    key: "productPriceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [...ae],
    group: "Products"
  }
], Lo = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "trendingFontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Trending"
  },
  { key: "trendingColor", label: "Color", type: "color", group: "Trending" }
], tn = [
  {
    key: "panelBgColor",
    label: "Panel Background",
    type: "color",
    group: "Panel"
  },
  { key: "fontFamily", label: "Font Family", type: "font", group: "Panel" },
  {
    key: "sectionGap",
    label: "Section Gap",
    type: "number",
    min: 16,
    max: 64,
    step: 4,
    group: "Spacing"
  },
  {
    key: "contentPaddingX",
    label: "Padding X (Desktop)",
    type: "number",
    min: 16,
    max: 80,
    step: 4,
    group: "Spacing"
  },
  {
    key: "contentPaddingXMobile",
    label: "Padding X (Mobile)",
    type: "number",
    min: 12,
    max: 40,
    step: 4,
    group: "Spacing"
  },
  {
    key: "noResultsText",
    label: "No Results Text",
    type: "text",
    group: "Empty States"
  },
  {
    key: "noResultsWithSuggestionsText",
    label: "No Results (with suggestions)",
    type: "text",
    group: "Empty States"
  },
  {
    key: "showMobileDividers",
    label: "Show Mobile Dividers",
    type: "toggle",
    group: "Dividers"
  },
  {
    key: "dividerColor",
    label: "Divider Color",
    type: "color",
    group: "Dividers"
  }
], Wa = [
  ...en,
  ...on,
  ...Ro,
  ...Ao,
  ...Lo,
  ...tn
], We = ({ width: e }) => /* @__PURE__ */ t(
  "div",
  {
    style: {
      width: e,
      height: "18px",
      borderRadius: "3px",
      backgroundColor: "#e5e7eb",
      animation: "searchPanelPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), vo = ({ imageSize: e }) => /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: "12px" }, children: [
  /* @__PURE__ */ t(
    "div",
    {
      style: {
        width: e,
        height: e,
        borderRadius: "8px",
        backgroundColor: "#e5e7eb",
        flexShrink: 0,
        animation: "searchPanelPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
      }
    }
  ),
  /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
    /* @__PURE__ */ t(We, { width: "140px" }),
    /* @__PURE__ */ t(We, { width: "60px" })
  ] })
] }), Mt = ({
  product: e,
  imageSize: o,
  nameSize: r,
  priceSize: n,
  priceWeight: i,
  textColor: l,
  nameMaxWidth: s,
  onClick: p
}) => /* @__PURE__ */ u(
  "div",
  {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: p ? "pointer" : void 0
    },
    onClick: p,
    children: [
      /* @__PURE__ */ t(
        "img",
        {
          src: e.imageUrl,
          alt: e.name,
          style: {
            width: o,
            height: o,
            objectFit: "contain",
            flexShrink: 0,
            borderRadius: "4px"
          }
        }
      ),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            minWidth: 0,
            maxWidth: s
          },
          children: [
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: `${r}px`,
                  fontWeight: 400,
                  lineHeight: "20px",
                  color: l,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden"
                },
                children: e.name
              }
            ),
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: `${n}px`,
                  fontWeight: i,
                  lineHeight: "20px",
                  color: l
                },
                children: e.price
              }
            )
          ]
        }
      )
    ]
  }
), Ys = ({
  widgetId: e = "search-panel",
  displayName: o = "Search Panel",
  initialState: r = {},
  conciergeQuestions: n,
  popularProducts: i,
  trendingSearches: l,
  isOpen: s,
  searchQuery: p,
  isLoading: g = !1,
  hasSearched: y = !1,
  onOpen: c,
  onClose: h,
  onSearchChange: x,
  onSearchSubmit: B,
  onAskConcierge: k,
  onQuestionClick: b,
  onProductClick: C,
  onTrendingClick: S,
  brandLogo: T
}) => {
  var ot;
  const {
    state: m,
    isLoading: A,
    isSaving: f,
    handleEditChange: z,
    handleSave: w,
    themeColors: v,
    themeFonts: P,
    themeIcons: W,
    resolveColor: F,
    canSave: L
  } = U(
    e,
    { ...Ge, ...r },
    Wa
  ), I = de(null), [R, j] = D(!1), X = Zo();
  Q(() => {
    const ie = () => j(window.innerWidth < 768);
    return ie(), window.addEventListener("resize", ie), () => window.removeEventListener("resize", ie);
  }, []), Q(() => {
    if (s && I.current) {
      const ie = setTimeout(() => {
        var we;
        return (we = I.current) == null ? void 0 : we.focus();
      }, 100);
      return () => clearTimeout(ie);
    }
  }, [s]), Q(() => {
    if (!s) return;
    const ie = (we) => {
      we.key === "Escape" && h();
    };
    return document.addEventListener("keydown", ie), () => document.removeEventListener("keydown", ie);
  }, [s, h]);
  const M = ge(
    (ie) => {
      ie.key === "Enter" && B(p);
    },
    [p, B]
  );
  if (A && !s)
    return /* @__PURE__ */ t(
      "div",
      {
        onClick: c,
        style: {
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer"
        },
        children: /* @__PURE__ */ t(
          ko,
          {
            variant: Ge.triggerIconStyle,
            size: Ge.triggerIconSize,
            color: typeof Ge.triggerIconColor == "string" ? Ge.triggerIconColor : "#4f4b47",
            strokeWidth: Ge.triggerIconStrokeWidth,
            style: { cursor: "pointer" }
          }
        )
      }
    );
  if (A) return null;
  const N = F(m.triggerIconColor), G = m.triggerIconThemeIcon, H = G && G !== "default" ? (ot = W[G]) == null ? void 0 : ot.url : void 0;
  if (!s) {
    const ie = /* @__PURE__ */ t(
      "div",
      {
        onClick: c,
        style: {
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer"
        },
        children: H ? /* @__PURE__ */ t(
          "img",
          {
            src: H,
            alt: "Search",
            style: {
              width: m.triggerIconSize,
              height: m.triggerIconSize,
              objectFit: "contain",
              cursor: "pointer",
              flexShrink: 0
            }
          }
        ) : /* @__PURE__ */ t(
          ko,
          {
            variant: m.triggerIconStyle,
            size: m.triggerIconSize,
            color: N,
            strokeWidth: m.triggerIconStrokeWidth,
            style: { cursor: "pointer" }
          }
        )
      }
    );
    return /* @__PURE__ */ t(
      Z,
      {
        widgetId: e,
        displayName: "Search Icon",
        editFields: en,
        editValues: m,
        onEditChange: z,
        onSave: L ? w : void 0,
        isSaving: f,
        themeColors: v,
        themeFonts: P,
        themeIcons: W,
        wrapperStyle: { display: "inline-flex", width: "auto" },
        iconOffset: { top: -16, left: 24 },
        children: ie
      }
    );
  }
  const $ = F(m.panelBgColor), Y = F(m.searchBarBgColor), q = F(m.searchBarTextColor);
  F(m.searchBarPlaceholderColor);
  const J = F(m.askButtonBgColor), V = F(m.askButtonTextColor), ne = F(m.closeIconColor), K = F(m.sectionHeaderColor), re = F(m.bodyColor), ee = F(m.trendingColor), ye = F(m.dividerColor), Re = Tt[m.sectionHeaderFontWeight] || 600, be = Tt[m.productPriceFontWeight] || 600, ze = R ? m.searchBarHeightMobile : m.searchBarHeight, ve = R ? m.searchBarFontSizeMobile : m.searchBarFontSize, Pe = R ? m.searchBarIconSizeMobile : m.searchBarIconSize, _ = R ? m.closeIconSizeMobile : m.closeIconSize, pe = R ? m.sectionHeaderFontSizeMobile : m.sectionHeaderFontSize, fe = R ? m.productImageSizeMobile : m.productImageSize, xe = R ? m.contentPaddingXMobile : m.contentPaddingX, se = R ? m.askButtonFontSizeMobile : m.askButtonFontSize, me = n.length > 0, De = i.length > 0, Ye = l.length > 0, Qe = me || De || Ye, uo = y && !g, Ie = !y || Qe, ke = (ie) => /* @__PURE__ */ t(
    "h3",
    {
      style: {
        margin: 0,
        fontSize: `${pe}px`,
        fontWeight: Re,
        lineHeight: R ? "24px" : "32px",
        color: K
      },
      children: ie
    }
  ), Vo = () => g ? /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
    ke("Ask Concierge"),
    /* @__PURE__ */ t(We, { width: "80%" }),
    /* @__PURE__ */ t(We, { width: "70%" }),
    /* @__PURE__ */ t(We, { width: "60%" })
  ] }) : /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "12px" }, children: [
    ke("Ask Concierge"),
    me ? n.map((ie, we) => /* @__PURE__ */ t(
      "p",
      {
        onClick: () => b(ie),
        style: {
          margin: 0,
          fontSize: `${m.bodyFontSize}px`,
          fontWeight: 400,
          lineHeight: `${m.bodyLineHeight}px`,
          color: re,
          cursor: "pointer"
        },
        children: ie
      },
      we
    )) : /* @__PURE__ */ t(
      "p",
      {
        style: {
          margin: 0,
          fontSize: `${m.bodyFontSize}px`,
          fontWeight: 400,
          lineHeight: `${m.bodyLineHeight}px`,
          color: re,
          opacity: 0.7
        },
        children: m.noSuggestionsText
      }
    )
  ] }), qo = () => {
    if (g)
      return /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
        ke("Popular products"),
        /* @__PURE__ */ t(vo, { imageSize: fe }),
        /* @__PURE__ */ t(vo, { imageSize: fe }),
        /* @__PURE__ */ t(vo, { imageSize: fe })
      ] });
    const ie = R ? 1 : m.productColumns, we = [];
    if (De) {
      const Te = Math.ceil(i.length / ie);
      for (let Me = 0; Me < ie; Me++)
        we.push(
          i.slice(Me * Te, (Me + 1) * Te)
        );
    }
    return /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
      ke("Popular products"),
      De ? /* @__PURE__ */ t(
        "div",
        {
          style: {
            display: R ? "flex" : "grid",
            gridTemplateColumns: R ? void 0 : `repeat(${ie}, 1fr)`,
            flexDirection: R ? "column" : void 0,
            gap: R ? "16px" : "24px"
          },
          children: R ? i.map((Te, Me) => /* @__PURE__ */ t(
            Mt,
            {
              product: Te,
              imageSize: fe,
              nameSize: m.productNameFontSize,
              priceSize: m.productPriceFontSize,
              priceWeight: be,
              textColor: re,
              onClick: Te.onClick ?? (() => C(Te))
            },
            Me
          )) : we.map((Te, Me) => /* @__PURE__ */ t(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "20px"
              },
              children: Te.map((yo, cn) => /* @__PURE__ */ t(
                Mt,
                {
                  product: yo,
                  imageSize: fe,
                  nameSize: m.productNameFontSize,
                  priceSize: m.productPriceFontSize,
                  priceWeight: be,
                  textColor: re,
                  nameMaxWidth: 250,
                  onClick: yo.onClick ?? (() => C(yo))
                },
                cn
              ))
            },
            Me
          ))
        }
      ) : /* @__PURE__ */ t(
        "p",
        {
          style: {
            margin: 0,
            fontSize: `${m.bodyFontSize}px`,
            fontWeight: 400,
            color: re,
            opacity: 0.7
          },
          children: m.noProductsText
        }
      )
    ] });
  }, Ko = () => g ? /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
    ke("Trending searches"),
    /* @__PURE__ */ t(We, { width: "75%" }),
    /* @__PURE__ */ t(We, { width: "65%" }),
    /* @__PURE__ */ t(We, { width: "80%" })
  ] }) : /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "8px" }, children: [
    ke("Trending searches"),
    Ye ? l.map((ie, we) => /* @__PURE__ */ t(
      "p",
      {
        onClick: () => S(ie),
        style: {
          margin: 0,
          fontSize: `${m.trendingFontSize}px`,
          fontWeight: 400,
          lineHeight: `${m.trendingLineHeight}px`,
          color: ee,
          cursor: "pointer"
        },
        children: ie
      },
      we
    )) : /* @__PURE__ */ t(
      "p",
      {
        style: {
          margin: 0,
          fontSize: `${m.bodyFontSize}px`,
          fontWeight: 400,
          color: re,
          opacity: 0.7
        },
        children: m.noSearchesText
      }
    )
  ] }), et = () => !R || !m.showMobileDividers ? null : /* @__PURE__ */ t(
    "div",
    {
      style: {
        height: "1px",
        backgroundColor: ye,
        margin: `${m.sectionGap / 2}px 0`
      }
    }
  ), ho = X ? _e : 0, dn = /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: `
        @keyframes searchPanelPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        @keyframes searchPanelSlideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes searchPanelFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      ` }),
    /* @__PURE__ */ t(
      "div",
      {
        onClick: h,
        style: {
          position: "fixed",
          top: ho,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2147483645,
          backgroundColor: R ? "transparent" : "rgba(0, 0, 0, 0.15)",
          animation: "searchPanelFadeIn 0.25s ease-out"
        }
      }
    ),
    /* @__PURE__ */ u(
      "div",
      {
        style: {
          position: "fixed",
          top: ho,
          left: 0,
          right: 0,
          ...R ? { bottom: 0 } : {},
          zIndex: 2147483646,
          backgroundColor: $,
          display: "flex",
          flexDirection: "column",
          overflow: R ? "auto" : "visible",
          fontFamily: m.fontFamilyCss || "inherit",
          animation: "searchPanelSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
          ...R ? {} : {
            maxHeight: `calc(100vh - ${ho}px)`,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)"
          }
        },
        children: [
          /* @__PURE__ */ t(
            Z,
            {
              widgetId: e ? `${e}__search-bar` : void 0,
              displayName: "Search Bar",
              editFields: on,
              editValues: m,
              onEditChange: z,
              onSave: L ? w : void 0,
              isSaving: f,
              themeColors: v,
              themeFonts: P,
              wrapperStyle: { display: "flex", width: "100%" },
              children: /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: R ? "12px" : "24px",
                    padding: R ? "24px 20px 0 20px" : `36px ${xe}px 0 ${xe}px`,
                    flexShrink: 0,
                    width: "100%"
                  },
                  children: [
                    !R && T && /* @__PURE__ */ t("div", { style: { flexShrink: 0 }, children: T }),
                    /* @__PURE__ */ u(
                      "div",
                      {
                        style: {
                          flex: 1,
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: Y,
                          borderRadius: `${m.searchBarBorderRadius}px`,
                          maxWidth: `${m.searchBarMaxWidth}px`,
                          margin: "0 auto",
                          height: `${ze}px`,
                          padding: R ? "0 8px 0 12px" : "0 12px 0 16px",
                          gap: R ? "8px" : "12px"
                        },
                        children: [
                          H ? /* @__PURE__ */ t(
                            "img",
                            {
                              src: H,
                              alt: "Search",
                              style: {
                                width: Pe,
                                height: Pe,
                                objectFit: "contain",
                                flexShrink: 0
                              }
                            }
                          ) : /* @__PURE__ */ t(
                            ko,
                            {
                              variant: m.triggerIconStyle,
                              size: Pe,
                              color: q
                            }
                          ),
                          /* @__PURE__ */ t(
                            "input",
                            {
                              ref: I,
                              type: "text",
                              value: p,
                              onChange: (ie) => x(ie.target.value),
                              onKeyDown: M,
                              placeholder: m.searchBarPlaceholder,
                              style: {
                                flex: 1,
                                border: "none",
                                background: "transparent",
                                outline: "none",
                                fontSize: `${ve}px`,
                                fontWeight: 400,
                                lineHeight: R ? "16px" : "24px",
                                color: q,
                                fontFamily: "inherit"
                              }
                            }
                          ),
                          /* @__PURE__ */ t(
                            "button",
                            {
                              onClick: () => k(p),
                              style: {
                                flexShrink: 0,
                                backgroundColor: J,
                                color: V,
                                border: "none",
                                borderRadius: `${m.askButtonBorderRadius}px`,
                                padding: R ? "6px 8px" : `${m.askButtonPaddingY}px ${m.askButtonPaddingX}px`,
                                fontSize: `${se}px`,
                                fontWeight: 500,
                                lineHeight: R ? "16px" : "32px",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                fontFamily: "inherit"
                              },
                              children: m.askButtonText
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ t(
                      "div",
                      {
                        onClick: h,
                        style: { flexShrink: 0, cursor: "pointer", padding: "4px" },
                        role: "button",
                        "aria-label": "Close search panel",
                        children: /* @__PURE__ */ t(Ea, { size: _, color: ne })
                      }
                    )
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ u(
            "div",
            {
              style: {
                ...R ? { flex: 1 } : {},
                padding: `${m.contentPaddingTop}px ${xe}px ${xe}px`,
                overflow: "auto"
              },
              children: [
                uo && /* @__PURE__ */ t(
                  "p",
                  {
                    style: {
                      margin: `0 0 ${m.sectionGap}px`,
                      fontSize: `${m.sectionHeaderFontSize}px`,
                      fontWeight: Re,
                      lineHeight: "32px",
                      color: K,
                      textAlign: Qe ? "center" : void 0
                    },
                    children: Qe ? m.noResultsWithSuggestionsText : m.noResultsText
                  }
                ),
                Ie && /* @__PURE__ */ t(O, { children: R ? (
                  /* ---- Mobile: stacked single column ---- */
                  /* @__PURE__ */ u(
                    "div",
                    {
                      style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: `${m.sectionGap}px`
                      },
                      children: [
                        /* @__PURE__ */ t(
                          Z,
                          {
                            widgetId: e ? `${e}__questions` : void 0,
                            displayName: "Ask Concierge",
                            editFields: Ro,
                            editValues: m,
                            onEditChange: z,
                            onSave: L ? w : void 0,
                            isSaving: f,
                            themeColors: v,
                            themeFonts: P,
                            children: Vo()
                          }
                        ),
                        et(),
                        /* @__PURE__ */ t(
                          Z,
                          {
                            widgetId: e ? `${e}__products` : void 0,
                            displayName: "Popular Products",
                            editFields: Ao,
                            editValues: m,
                            onEditChange: z,
                            onSave: L ? w : void 0,
                            isSaving: f,
                            themeColors: v,
                            themeFonts: P,
                            children: qo()
                          }
                        ),
                        et(),
                        /* @__PURE__ */ t(
                          Z,
                          {
                            widgetId: e ? `${e}__trending` : void 0,
                            displayName: "Trending Searches",
                            editFields: Lo,
                            editValues: m,
                            onEditChange: z,
                            onSave: L ? w : void 0,
                            isSaving: f,
                            themeColors: v,
                            themeFonts: P,
                            children: Ko()
                          }
                        )
                      ]
                    }
                  )
                ) : (
                  /* ---- Desktop: 3-column layout ---- */
                  /* @__PURE__ */ u(
                    "div",
                    {
                      style: {
                        display: "grid",
                        gridTemplateColumns: "minmax(200px, 1fr) minmax(350px, 2fr) minmax(200px, 1fr)",
                        gap: `${m.sectionGap}px`
                      },
                      children: [
                        /* @__PURE__ */ t(
                          Z,
                          {
                            widgetId: e ? `${e}__questions` : void 0,
                            displayName: "Ask Concierge",
                            editFields: Ro,
                            editValues: m,
                            onEditChange: z,
                            onSave: L ? w : void 0,
                            isSaving: f,
                            themeColors: v,
                            themeFonts: P,
                            children: Vo()
                          }
                        ),
                        /* @__PURE__ */ t(
                          Z,
                          {
                            widgetId: e ? `${e}__products` : void 0,
                            displayName: "Popular Products",
                            editFields: Ao,
                            editValues: m,
                            onEditChange: z,
                            onSave: L ? w : void 0,
                            isSaving: f,
                            themeColors: v,
                            themeFonts: P,
                            children: qo()
                          }
                        ),
                        /* @__PURE__ */ t(
                          Z,
                          {
                            widgetId: e ? `${e}__trending` : void 0,
                            displayName: "Trending Searches",
                            editFields: Lo,
                            editValues: m,
                            onEditChange: z,
                            onSave: L ? w : void 0,
                            isSaving: f,
                            themeColors: v,
                            themeFonts: P,
                            children: Ko()
                          }
                        )
                      ]
                    }
                  )
                ) })
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: tn,
      editValues: m,
      onEditChange: z,
      onSave: L ? w : void 0,
      isSaving: f,
      themeColors: v,
      themeFonts: P,
      children: dn
    }
  );
}, Ra = {
  // Pill styling (matching Figma design)
  pillBgColor: a("secondary"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "500",
  pillBorderRadius: 100,
  // Pill shape
  pillPaddingX: 12,
  pillPaddingY: 12,
  // Border styling
  pillBorderWidth: 1,
  pillBorderColor: a("primary"),
  // Selected state styling
  pillBgColorSelected: a("primary"),
  pillTextColorSelected: a("secondary"),
  pillBorderColorSelected: a("primary"),
  // Container
  containerGap: 8,
  maxWidthDesktop: "100%",
  maxWidthMobile: "100%"
}, Et = [
  // Default state styling
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  // Border styling
  {
    key: "pillBorderWidth",
    label: "Border Width (px)",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Border Color", type: "color" },
  // Selected state styling
  { key: "pillBgColorSelected", label: "Selected Background", type: "color" },
  { key: "pillTextColorSelected", label: "Selected Text Color", type: "color" },
  {
    key: "pillBorderColorSelected",
    label: "Selected Border Color",
    type: "color"
  },
  // Typography
  {
    key: "pillFontSize",
    label: "Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Font Weight",
    type: "options",
    options: He
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "pillPaddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 2,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills (px)",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "maxWidthDesktop",
    label: "Max Width (Desktop)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "maxWidthMobile",
    label: "Max Width (Mobile)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" }
    ]
  }
], Qs = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    resolveColor: c,
    canSave: h
  } = U(
    o,
    { ...Ra, ...e },
    Et
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const x = n(i, c);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Et,
      editValues: i,
      onEditChange: p,
      onSave: h ? g : void 0,
      isSaving: s,
      themeColors: y,
      children: x
    }
  );
}, Aa = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, La = {
  // Background
  backgroundColor: a("transparent"),
  // Title styling
  titleColor: a("textPrimary"),
  titleFontSize: 18,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  // Icon styling (shared defaults)
  iconColor: a("textPrimary"),
  iconColorHover: a("tertiary"),
  iconSize: 20,
  // Individual icon overrides
  homeIconSize: 22,
  homeIconColor: void 0,
  sidebarIconSize: 20,
  sidebarIconColor: void 0,
  composeIconSize: 18,
  composeIconColor: void 0,
  cartIconSize: 22,
  cartIconColor: void 0,
  // Button styling
  buttonSize: 44,
  buttonBorderRadius: 8,
  buttonHoverBgColor: a("background"),
  // Badge styling (cart count)
  badgeBgColor: a("primary"),
  badgeTextColor: a("secondary"),
  badgeFontSize: 12,
  badgeMinWidth: 18,
  // Layout
  height: 56,
  paddingX: 16,
  paddingY: 8,
  maxWidth: 768
}, Wt = [
  // Layout group
  {
    key: "backgroundColor",
    label: "Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "height",
    label: "Height",
    type: "number",
    min: 40,
    max: 80,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Layout"
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Layout"
  },
  // Title group
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ae],
    group: "Title"
  },
  {
    key: "titleFontFamily",
    label: "Font Family",
    type: "font",
    group: "Title"
  },
  // Home Icon group
  {
    key: "homeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Home Icon"
  },
  {
    key: "homeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Home Icon"
  },
  // Sidebar Icon group
  {
    key: "sidebarIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Sidebar Icon"
  },
  {
    key: "sidebarIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Sidebar Icon"
  },
  // Compose Icon group
  {
    key: "composeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Compose Icon"
  },
  {
    key: "composeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Compose Icon"
  },
  // Cart Icon group
  {
    key: "cartIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Cart Icon"
  },
  {
    key: "cartIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Cart Icon"
  },
  // Shared Icons group (default color applies to all without individual override)
  {
    key: "iconColor",
    label: "Default Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  {
    key: "iconColorHover",
    label: "Hover Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  // Buttons group
  {
    key: "buttonSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Buttons"
  },
  {
    key: "buttonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Buttons"
  },
  {
    key: "buttonHoverBgColor",
    label: "Hover Background",
    type: "color",
    group: "Buttons"
  },
  // Badge group
  { key: "badgeBgColor", label: "Background", type: "color", group: "Badge" },
  { key: "badgeTextColor", label: "Text Color", type: "color", group: "Badge" },
  {
    key: "badgeFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Badge"
  },
  {
    key: "badgeMinWidth",
    label: "Min Width",
    type: "number",
    min: 14,
    max: 24,
    step: 2,
    group: "Badge"
  }
], Xs = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeFonts: c,
    resolveColor: h,
    canSave: x
  } = U(
    o,
    { ...La, ...e },
    Wt
  ), B = i.titleFontFamily, k = B && B !== "inherit" ? c[B] : null, b = k && k.format === "google" ? k.url : null;
  if (Q(() => {
    b && Aa(b);
  }, [b]), l)
    return /* @__PURE__ */ t(O, {});
  const C = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", S = k && k.format !== "system" && k.format !== "google", T = `header-${o || "default"}`, m = `
    ${S ? `
      @font-face {
        font-family: "${k.name}";
        src: url("${k.url}") format("${k.format}");
        font-display: swap;
      }
    ` : ""}
    ${C !== "inherit" ? `.${T} [data-title-text] { font-family: ${C} !important; }` : ""}
  `.trim(), A = {
    ...i,
    titleFontFamilyCss: C
  }, f = /* @__PURE__ */ u(O, { children: [
    m && /* @__PURE__ */ t("style", { children: m }),
    n(A, h)
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Wt,
      editValues: i,
      onEditChange: p,
      onSave: x ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeFonts: c,
      children: f
    }
  );
}, Ha = ({ className: e }) => /* @__PURE__ */ u(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    className: e,
    children: [
      /* @__PURE__ */ t("g", { clipPath: "url(#clip0_concierge_close)", children: /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.23815 8.00015L14.7435 2.49459C15.0855 2.15283 15.0855 1.5983 14.7435 1.25654C14.4014 0.914486 13.8475 0.914486 13.5055 1.25654L8.00015 6.7621L2.49453 1.25654C2.15249 0.914486 1.59858 0.914486 1.25653 1.25654C0.914489 1.5983 0.914489 2.15283 1.25653 2.49459L6.76215 8.00015L1.25653 13.5057C0.914489 13.8475 0.914489 14.402 1.25653 14.7438C1.42755 14.9145 1.65168 15 1.87553 15C2.09938 15 2.32351 14.9145 2.49453 14.7435L8.00015 9.2379L13.5055 14.7435C13.6765 14.9145 13.9006 15 14.1245 15C14.3483 15 14.5725 14.9145 14.7435 14.7435C15.0855 14.4017 15.0855 13.8472 14.7435 13.5054L9.23815 8.00015Z",
          fill: "currentColor",
          stroke: "currentColor",
          strokeWidth: "0.5"
        }
      ) }),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_concierge_close", children: /* @__PURE__ */ t("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), Na = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Rt = {
  // Text content
  titleContent: "CONCIERGE",
  titleFontSize: 16,
  titleFontWeight: "bold",
  titleFontFamily: "inherit",
  titleColor: a("textPrimary"),
  titleLetterSpacing: 2,
  titleTextTransform: "uppercase",
  titleTextAlign: "center",
  titleLineHeight: 1,
  // Button colors - default to textPrimary theme color
  closeButtonColor: a("textPrimary"),
  maximizeButtonColor: a("textPrimary"),
  historyButtonColor: a("textPrimary")
}, At = [
  // Text content
  { key: "titleContent", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleLetterSpacing",
    label: "Title Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "titleTextTransform",
    label: "Title Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "titleTextAlign",
    label: "Title Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 0.8,
    max: 2,
    step: 0.1
  },
  // Button colors
  { key: "closeButtonColor", label: "Close Button Color", type: "color" },
  {
    key: "maximizeButtonColor",
    label: "Maximize Button Color",
    type: "color"
  },
  {
    key: "historyButtonColor",
    label: "History Button Color",
    type: "color"
  }
], Da = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 400, Js = ({
  showMaximize: e = !0,
  isMaximized: o = !1,
  onMaximize: r,
  onMinimize: n,
  onClose: i,
  onHistoryClick: l,
  onNewConversationClick: s,
  showNewConversation: p = !0,
  newConversationIcon: g,
  title: y = "CONCIERGE",
  widgetId: c = "concierge-widget-header",
  displayName: h = "Concierge Header",
  initialState: x = {},
  // mobileBrandLogoUrl,
  // showMobileLogo = false,
  bottomContent: B
}) => {
  const {
    state: k,
    isLoading: b,
    isSaving: C,
    handleEditChange: S,
    handleSave: T,
    themeColors: m,
    themeFonts: A,
    resolveColor: f,
    canSave: z
  } = U(
    c,
    {
      ...Rt,
      titleContent: (y == null ? void 0 : y.toUpperCase()) || Rt.titleContent,
      ...x
    },
    At
  ), w = k.titleFontFamily, v = w && w !== "inherit" ? A[w] : null, P = v && v.format === "google" ? v.url : null;
  if (Q(() => {
    P && Na(P);
  }, [P]), b)
    return /* @__PURE__ */ t(
      "div",
      {
        className: "tw:flex tw:items-center tw:justify-between tw:p-4",
        "data-concierge-header": !0
      }
    );
  const W = v ? v.format === "system" ? v.url : `"${v.name}", sans-serif` : "inherit", F = v && v.format !== "system" && v.format !== "google", L = `concierge-header-${c || "default"}`, I = (j) => {
    if (j.startsWith("#")) {
      const X = j.slice(1), M = X.length === 3 ? parseInt(X[0] + X[0], 16) : parseInt(X.slice(0, 2), 16), N = X.length === 3 ? parseInt(X[1] + X[1], 16) : parseInt(X.slice(2, 4), 16), G = X.length === 3 ? parseInt(X[2] + X[2], 16) : parseInt(X.slice(4, 6), 16);
      return `rgba(${M}, ${N}, ${G}, 0.7)`;
    }
    return j.startsWith("rgba") ? j.replace(/,\s*[\d.]+\)$/, ", 0.7)") : j.startsWith("rgb") ? j.replace("rgb", "rgba").replace(")", ", 0.7)") : j;
  }, R = /* @__PURE__ */ u(
    "div",
    {
      style: {
        borderBottom: "1px solid #F3F3F3",
        boxShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
        backgroundColor: "#ffffff"
      },
      children: [
        /* @__PURE__ */ t("style", { children: `
        ${F ? `
          @font-face {
            font-family: "${v.name}";
            src: url("${v.url}") format("${v.format}");
            font-display: swap;
          }
        ` : ""}
        ${W !== "inherit" ? `.${L} [data-title-text] { font-family: ${W} !important; }` : ""}
        .${L} .concierge-maximize-icon {
          color: ${f(k.maximizeButtonColor)};
          transition: color 0.2s ease;
        }
        .${L} .concierge-maximize-icon:hover {
          color: ${I(f(k.maximizeButtonColor))};
        }
        .${L} .concierge-close-icon {
          color: ${f(k.closeButtonColor)};
          transition: color 0.2s ease;
        }
        .${L} .concierge-close-icon:hover {
          color: ${I(f(k.closeButtonColor))};
        }
        .${L} .concierge-history-icon {
          color: ${f(k.historyButtonColor)};
          transition: color 0.2s ease;
        }
        .${L} .concierge-history-icon:hover {
          color: ${I(f(k.historyButtonColor))};
        }
        .${L} .concierge-new-conversation-icon {
          color: ${f(k.historyButtonColor)};
          transition: color 0.2s ease;
        }
        .${L} .concierge-new-conversation-icon:hover {
          color: ${I(f(k.historyButtonColor))};
        }
      ` }),
        /* @__PURE__ */ u(
          "div",
          {
            className: `tw:flex tw:items-center tw:justify-between tw:min-h-[44px] ${L}`,
            style: { padding: 16 },
            "data-concierge-header": !0,
            children: [
              /* @__PURE__ */ u(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-0 tw:flex-shrink-0",
                  style: { minWidth: "80px" },
                  children: [
                    o && n && /* @__PURE__ */ t(
                      "button",
                      {
                        onClick: n,
                        className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                        style: { padding: 8 },
                        "aria-label": "Minimize to widget",
                        children: /* @__PURE__ */ t(jn, { className: "tw:w-4 tw:h-4 tw:shrink-0 concierge-maximize-icon" })
                      }
                    ),
                    !o && e && r && /* @__PURE__ */ t(
                      "button",
                      {
                        onClick: r,
                        className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                        style: { padding: 8 },
                        "aria-label": "Expand to full view",
                        children: /* @__PURE__ */ t(Hn, { className: "tw:w-4 tw:h-4 tw:shrink-0 concierge-maximize-icon" })
                      }
                    ),
                    p && s && /* @__PURE__ */ t(
                      "button",
                      {
                        onClick: s,
                        className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                        style: { padding: 8 },
                        "aria-label": "Create new conversation",
                        children: /* @__PURE__ */ t("span", { className: "tw:flex tw:items-center tw:justify-center tw:w-4 tw:h-4 concierge-new-conversation-icon [&>svg]:tw:block", children: g ?? /* @__PURE__ */ t(Dn, { className: "tw:w-4 tw:h-4 tw:shrink-0" }) })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ t(
                "span",
                {
                  "data-title-text": !0,
                  className: "tw:flex tw:items-center tw:justify-center",
                  style: {
                    fontSize: `${k.titleFontSize}px`,
                    fontWeight: Da(k.titleFontWeight),
                    fontFamily: W !== "inherit" ? W : void 0,
                    color: f(k.titleColor),
                    letterSpacing: `${k.titleLetterSpacing}px`,
                    textTransform: k.titleTextTransform,
                    textAlign: "center",
                    lineHeight: 1,
                    flex: 1
                  },
                  children: k.titleContent
                }
              ),
              /* @__PURE__ */ t(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-1 tw:justify-end tw:flex-shrink-0",
                  style: { minWidth: "80px" },
                  children: /* @__PURE__ */ t(
                    "button",
                    {
                      onClick: i,
                      className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                      style: { padding: 8 },
                      "aria-label": "Close",
                      children: /* @__PURE__ */ t(Ha, { className: "tw:w-4 tw:h-4 tw:shrink-0 concierge-close-icon" })
                    }
                  )
                }
              )
            ]
          }
        ),
        B
      ]
    }
  );
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: c,
      displayName: h,
      editFields: At,
      editValues: k,
      onEditChange: S,
      onSave: z ? T : void 0,
      isSaving: C,
      themeColors: m,
      themeFonts: A,
      children: R
    }
  );
}, Oa = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, ja = {
  // Logo / Brand Icon
  logoIcon: "default",
  logoIconSize: 22,
  // Brand Link
  brandLinkText: "example.com",
  brandLinkPrefix: "Visit ",
  brandLinkFontSize: 14,
  brandLinkColor: a("textPrimary"),
  // Layout
  expandedWidth: 248,
  collapsedWidth: 40,
  expandedBgColor: a("background"),
  collapsedBgColor: a("secondary"),
  borderColor: a("borderColor"),
  // Navigation Icons
  sidebarIconSize: 20,
  sidebarIconColor: a("textPrimary"),
  composeIconSize: 18,
  composeIconColor: a("textPrimary"),
  closeIconColor: a("textPrimary"),
  // Labels
  openSidebarLabel: "Open sidebar",
  closeSidebarLabel: "Close sidebar",
  newChatLabel: "New chat",
  signOutLabel: "Sign out",
  labelFontSize: 16,
  labelFontWeight: "medium",
  labelColor: a("textPrimary"),
  // Tooltips
  tooltipBgColor: a("textPrimary"),
  tooltipTextColor: a("secondary"),
  tooltipFontSize: 12,
  tooltipBorderRadius: 8,
  // Chat History
  chatHistoryTitle: "Chat history",
  chatHistoryTitleFontSize: 16,
  chatHistoryTitleFontWeight: "medium",
  chatHistoryTitleColor: a("textPrimary"),
  chatItemFontSize: 14,
  chatItemFontWeight: "medium",
  chatItemColor: a("textPrimary"),
  chatItemActiveBgColor: a("background"),
  chatItemHoverBgColor: a("background"),
  chatItemPaddingX: 8,
  chatItemPaddingY: 4,
  chatItemBorderRadius: 5,
  chatItemLineClamp: 1,
  // Typography
  fontFamily: "inherit",
  // Avatar
  avatarSize: 20,
  avatarBgColor: a("textPrimary"),
  avatarTextColor: a("secondary"),
  avatarFontSize: 8,
  avatarFontWeight: "semibold"
}, ro = ae.slice(0, 4), Lt = [
  // ── Logo / Brand Icon ──────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Icon", type: "icon", group: "Logo" },
  {
    key: "logoIconSize",
    label: "Icon Size",
    type: "number",
    min: 0,
    max: 100,
    step: 1,
    group: "Logo"
  },
  // ── Brand Link ─────────────────────────────────────────────────────────
  {
    key: "brandLinkPrefix",
    label: "Prefix Text",
    type: "text",
    group: "Brand Link"
  },
  {
    key: "brandLinkFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Brand Link"
  },
  {
    key: "brandLinkColor",
    label: "Color",
    type: "color",
    group: "Brand Link"
  },
  // ── Layout ─────────────────────────────────────────────────────────────
  {
    key: "expandedWidth",
    label: "Expanded Width",
    type: "number",
    min: 200,
    max: 320,
    step: 4,
    group: "Layout"
  },
  {
    key: "collapsedWidth",
    label: "Collapsed Width",
    type: "number",
    min: 36,
    max: 56,
    step: 2,
    group: "Layout"
  },
  {
    key: "expandedBgColor",
    label: "Expanded Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "collapsedBgColor",
    label: "Collapsed Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "borderColor",
    label: "Border Color",
    type: "color",
    group: "Layout"
  },
  // ── Navigation Icons ───────────────────────────────────────────────────
  {
    key: "sidebarIconSize",
    label: "Sidebar Icon Size",
    type: "number",
    min: 16,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "sidebarIconColor",
    label: "Sidebar Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "composeIconSize",
    label: "Compose Icon Size",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "composeIconColor",
    label: "Compose Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "closeIconColor",
    label: "Close Icon Color",
    type: "color",
    group: "Icons"
  },
  // ── Labels ─────────────────────────────────────────────────────────────
  {
    key: "openSidebarLabel",
    label: "Open Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "closeSidebarLabel",
    label: "Close Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "newChatLabel",
    label: "New Chat Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "signOutLabel",
    label: "Sign Out Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "labelFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Labels"
  },
  {
    key: "labelFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ro],
    group: "Labels"
  },
  { key: "labelColor", label: "Color", type: "color", group: "Labels" },
  // ── Tooltips ───────────────────────────────────────────────────────────
  {
    key: "tooltipBgColor",
    label: "Background",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipTextColor",
    label: "Text Color",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Tooltips"
  },
  {
    key: "tooltipBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Tooltips"
  },
  // ── Chat History ───────────────────────────────────────────────────────
  {
    key: "chatHistoryTitle",
    label: "Section Title",
    type: "text",
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ro],
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleColor",
    label: "Title Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemFontSize",
    label: "Item Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemFontWeight",
    label: "Item Font Weight",
    type: "options",
    options: [...ro],
    group: "Chat History"
  },
  {
    key: "chatItemColor",
    label: "Item Text Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemActiveBgColor",
    label: "Active Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemHoverBgColor",
    label: "Hover Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemPaddingX",
    label: "Item Padding X",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemPaddingY",
    label: "Item Padding Y",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemBorderRadius",
    label: "Item Border Radius",
    type: "number",
    min: 0,
    max: 12,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemLineClamp",
    label: "Item Max Lines",
    type: "number",
    min: 1,
    max: 3,
    step: 1,
    group: "Chat History"
  },
  // ── Typography ─────────────────────────────────────────────────────────
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  },
  // ── Avatar ─────────────────────────────────────────────────────────────
  {
    key: "avatarSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 2,
    group: "Avatar"
  },
  {
    key: "avatarBgColor",
    label: "Background",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarTextColor",
    label: "Text Color",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarFontSize",
    label: "Font Size",
    type: "number",
    min: 6,
    max: 14,
    step: 1,
    group: "Avatar"
  },
  {
    key: "avatarFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ro],
    group: "Avatar"
  }
], Zs = ({
  widgetId: e = "concierge-sidebar",
  displayName: o = "Concierge Sidebar",
  initialState: r = {},
  wrapperStyle: n,
  children: i
}) => {
  const {
    state: l,
    isLoading: s,
    isSaving: p,
    handleEditChange: g,
    handleSave: y,
    themeColors: c,
    themeFonts: h,
    themeIcons: x,
    resolveColor: B,
    canSave: k
  } = U(
    e,
    { ...ja, ...r },
    Lt
  ), b = l.logoIcon && l.logoIcon !== "default" ? x[l.logoIcon] : null, C = {
    logoIconUrl: b ? b.url : null
  }, S = l.fontFamily, T = S && S !== "inherit" ? h[S] : null, m = T && T.format === "google" ? T.url : null;
  if (Q(() => {
    m && Oa(m);
  }, [m]), s)
    return /* @__PURE__ */ t(O, {});
  const A = T ? T.format === "system" ? T.url : `"${T.name}", sans-serif` : "inherit", z = T && T.format !== "system" && T.format !== "google" ? `@font-face {
        font-family: "${T.name}";
        src: url("${T.url}") format("${T.format}");
        font-display: swap;
      }` : "", w = {
    ...l,
    fontFamilyCss: A
  }, v = /* @__PURE__ */ u(O, { children: [
    z && /* @__PURE__ */ t("style", { children: z }),
    i(w, C, B)
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: Lt,
      editValues: l,
      onEditChange: g,
      onSave: k ? y : void 0,
      isSaving: p,
      themeColors: c,
      themeFonts: h,
      themeIcons: x,
      wrapperStyle: n,
      children: v
    }
  );
}, Ga = {
  filled: {
    backgroundColor: a("primary"),
    backgroundColorHover: a("primary"),
    iconColor: a("secondary"),
    borderWidth: 0,
    borderColor: a("transparent"),
    shadowOpacity: 0.25,
    shadowBlur: 50,
    shadowSpread: -12,
    shadowOffsetY: 25
  },
  light: {
    backgroundColor: a("background"),
    backgroundColorHover: a("background"),
    iconColor: a("primary"),
    borderWidth: 0,
    borderColor: a("transparent"),
    shadowOpacity: 0.12,
    shadowBlur: 24,
    shadowSpread: -4,
    shadowOffsetY: 8
  },
  outlined: {
    backgroundColor: a("secondary"),
    backgroundColorHover: a("background"),
    iconColor: a("primary"),
    borderWidth: 1.5,
    borderColor: a("textPrimary"),
    shadowOpacity: 0,
    shadowBlur: 0,
    shadowSpread: 0,
    shadowOffsetY: 0
  }
}, $a = {
  "rounded-square": { borderRadius: 25 },
  circle: { borderRadius: 50 }
}, Ya = {
  // Preset selectors
  buttonShape: "circle",
  buttonStyle: "filled",
  // Position
  position: "bottom-right",
  horizontalOffset: 20,
  verticalOffset: 20,
  // Size
  size: 44,
  // Colors (using theme colors) — derived from "filled" style
  backgroundColor: a("primary"),
  backgroundColorHover: a("primary"),
  iconColor: a("secondary"),
  // Border — derived from "filled" style
  borderWidth: 0,
  borderColor: a("transparent"),
  // Shape — derived from "circle" shape
  borderRadius: 50,
  // percentage - 50 = circle
  // Shadow — derived from "filled" style
  shadowColor: a("primary"),
  shadowOpacity: 0.25,
  shadowBlur: 50,
  shadowSpread: -12,
  shadowOffsetY: 25,
  // Icon
  iconStyle: "chat-ai",
  iconSize: 22,
  // Animation
  hoverScale: 1.1,
  animationDuration: 200,
  // Suggested Messages
  showSuggestedMessages: !0,
  suggestedMessages: void 0,
  suggestedMessageRotationMs: 4e3,
  // Suggested Pills Styling
  pillBackgroundColor: "#ffffff",
  pillTextColor: "#1f2937",
  pillBorderRadius: 12,
  pillFontSize: 14,
  pillPaddingX: 16,
  pillPaddingY: 10,
  pillShadowOpacity: 0.12,
  pillsToShow: 2,
  // Header Styling
  pillHeaderText: void 0,
  pillHeaderColor: "#6b7280",
  pillHeaderFontSize: 11,
  // Feature Prompt Pill
  featurePromptBgColor: a("primary"),
  featurePromptTextColor: a("secondary"),
  featurePromptBorderRadius: 12,
  featurePromptFontSize: 14,
  featurePromptFontWeight: 500
}, Ht = [
  // --- Preset selectors ---
  {
    key: "iconStyle",
    label: "Icon",
    type: "options",
    options: [
      { label: "Chat AI", value: "chat-ai" },
      { label: "Search Sparkle", value: "search-sparkle" },
      { label: "Three Sparkles", value: "three-sparkles" },
      { label: "Diamond Sparkles", value: "diamond-sparkles" },
      { label: "Search Star", value: "search-star" },
      { label: "Search Sparkle Alt", value: "search-sparkle-alt" }
    ]
  },
  {
    key: "buttonShape",
    label: "Shape",
    type: "options",
    options: [
      { label: "Circle", value: "circle" },
      { label: "Rounded Square", value: "rounded-square" }
    ]
  },
  {
    key: "buttonStyle",
    label: "Style",
    type: "options",
    options: [
      { label: "Filled", value: "filled" },
      { label: "Light", value: "light" },
      { label: "Outlined", value: "outlined" }
    ]
  },
  // --- Size & Position ---
  {
    key: "size",
    label: "Button Size",
    type: "number",
    min: 32,
    max: 72,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Size & Position"
  },
  {
    key: "position",
    label: "Position",
    type: "options",
    options: [
      { label: "Bottom Right", value: "bottom-right" },
      { label: "Bottom Left", value: "bottom-left" },
      { label: "Top Right", value: "top-right" },
      { label: "Top Left", value: "top-left" }
    ],
    group: "Size & Position"
  },
  {
    key: "horizontalOffset",
    label: "Horizontal Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "verticalOffset",
    label: "Vertical Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  // --- Colors ---
  { key: "backgroundColor", label: "Background Color", type: "color", group: "Colors" },
  { key: "backgroundColorHover", label: "Hover Background", type: "color", group: "Colors" },
  { key: "iconColor", label: "Icon Color", type: "color", group: "Colors" },
  // --- Shape ---
  {
    key: "borderRadius",
    label: "Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shape"
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 4,
    step: 0.5,
    group: "Shape"
  },
  { key: "borderColor", label: "Border Color", type: "color", group: "Shape" },
  // --- Shadow ---
  { key: "shadowColor", label: "Shadow Color", type: "color", group: "Shadow" },
  {
    key: "shadowOpacity",
    label: "Shadow Opacity",
    type: "number",
    min: 0,
    max: 1,
    step: 0.05,
    group: "Shadow"
  },
  {
    key: "shadowBlur",
    label: "Shadow Blur",
    type: "number",
    min: 0,
    max: 100,
    step: 5,
    group: "Shadow"
  },
  {
    key: "shadowSpread",
    label: "Shadow Spread",
    type: "number",
    min: -20,
    max: 20,
    step: 2,
    group: "Shadow"
  },
  {
    key: "shadowOffsetY",
    label: "Shadow Offset Y",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shadow"
  },
  // Animation
  {
    key: "hoverScale",
    label: "Hover Scale",
    type: "number",
    min: 1,
    max: 1.3,
    step: 0.05
  },
  {
    key: "animationDuration",
    label: "Animation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  },
  // Suggested Messages
  {
    key: "showSuggestedMessages",
    label: "Show Suggested Messages",
    type: "toggle"
  },
  {
    key: "suggestedMessageRotationMs",
    label: "Message Rotation (ms)",
    type: "number",
    min: 2e3,
    max: 1e4,
    step: 500
  },
  {
    key: "pillsToShow",
    label: "Number of Pills",
    type: "number",
    min: 1,
    max: 4,
    step: 1
  },
  // Pill Styling
  { key: "pillBackgroundColor", label: "Pill Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillShadowOpacity",
    label: "Pill Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  // Header Styling
  {
    key: "pillHeaderText",
    label: "Header Text (Override)",
    type: "text"
  },
  { key: "pillHeaderColor", label: "Header Text Color", type: "color" },
  {
    key: "pillHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 9,
    max: 14,
    step: 1
  },
  // Feature Prompt Pill
  {
    key: "featurePromptBgColor",
    label: "Prompt Pill Background",
    type: "color",
    group: "Feature Prompt"
  },
  {
    key: "featurePromptTextColor",
    label: "Prompt Pill Text Color",
    type: "color",
    group: "Feature Prompt"
  },
  {
    key: "featurePromptBorderRadius",
    label: "Prompt Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Feature Prompt"
  },
  {
    key: "featurePromptFontSize",
    label: "Prompt Pill Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1,
    group: "Feature Prompt"
  },
  {
    key: "featurePromptFontWeight",
    label: "Prompt Pill Font Weight",
    type: "number",
    min: 300,
    max: 700,
    step: 100,
    group: "Feature Prompt"
  }
], Qa = (e) => {
  const { position: o, horizontalOffset: r, verticalOffset: n, size: i } = e, l = {
    position: "fixed",
    zIndex: 2147483647,
    // Max z-index to ensure it's on top
    minWidth: 0,
    minHeight: 0
  };
  return o.startsWith("bottom") ? l.bottom = n + i - 8 : l.top = n - 8, o.endsWith("left") ? l.left = r + i - 8 : l.right = r - 8, l;
}, Us = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const [i, l] = D(!1), [s, p] = D({ x: 0, y: 0 }), [g, y] = D(null), [c, h] = D(!1), [x, B] = D(!1), k = de(null), b = Zo(), {
    state: C,
    isLoading: S,
    isSaving: T,
    handleEditChange: m,
    handleSave: A,
    themeColors: f,
    resolveColor: z,
    canSave: w,
    studioLockedKeys: v
  } = U(o, { ...Ya, ...e }, Ht), P = ge(
    (M, N) => {
      if (m(M, N), M === "buttonStyle") {
        const G = Ga[N];
        G && Object.entries(G).forEach(([H, $]) => {
          m(H, $);
        });
      }
      if (M === "buttonShape") {
        const G = $a[N];
        G && m("borderRadius", G.borderRadius);
      }
    },
    [m]
  ), W = ge(() => g ? JSON.stringify(C) !== JSON.stringify(g) : !1, [C, g]);
  if (Q(() => o ? jr((N) => {
    N !== o && i && (W() ? h(!0) : l(!1));
  }) : void 0, [o, i, W]), S)
    return /* @__PURE__ */ t(O, {});
  const F = n(C, z);
  if (!b)
    return /* @__PURE__ */ t(O, { children: F });
  const L = () => {
    if (k.current) {
      const M = k.current.getBoundingClientRect(), N = window.innerWidth, G = window.innerHeight, H = 620, $ = 450, Y = 10, q = G - M.bottom, J = M.top, V = N - M.left, ne = M.right;
      let K;
      q >= $ + Y ? K = M.bottom + Y : J >= $ + Y ? K = M.top - $ - Y : q >= J ? K = Math.max(Y, G - $ - Y) : K = Math.max(Y, M.top - $ - Y);
      let re;
      V >= H ? re = M.left : ne >= H ? re = M.right - H : re = Math.max(Y, Math.min(N - H - Y, M.left)), re = Math.max(Y, Math.min(re, N - H - Y)), K = Math.max(Y, Math.min(K, G - $ - Y)), p({ x: re, y: K });
    }
    y({ ...C }), l(!0), o && Or(o);
  }, I = () => {
    g && Object.keys(g).forEach((M) => {
      P(M, g[M]);
    });
  }, R = () => {
    A && w && A(), y({ ...C });
  }, j = () => {
    h(!1), l(!1);
  }, X = () => {
    R(), h(!1), l(!1);
  };
  return /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: `
        .floating-button-edit-icon {
          width: 32px;
          height: 32px;
          background: ${d.white};
          border: 1px solid ${d.gray_border};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transition: all 0.2s;
          padding: 0;
          opacity: 0;
          pointer-events: none;
        }

        .floating-button-edit-icon.visible {
          opacity: 1;
          pointer-events: auto;
        }

        .floating-button-edit-icon:hover {
          background: ${d.blue_light};
          border-color: ${d.blue};
        }
      ` }),
    /* @__PURE__ */ u(
      "div",
      {
        onMouseEnter: () => B(!0),
        onMouseLeave: () => B(!1),
        style: { display: "contents" },
        children: [
          F,
          /* @__PURE__ */ t(
            "button",
            {
              ref: k,
              className: `floating-button-edit-icon ${x || i ? "visible" : ""}`,
              style: Qa(C),
              onMouseDown: (M) => {
                M.stopPropagation();
              },
              onClick: (M) => {
                M.stopPropagation(), M.preventDefault(), L();
              },
              "aria-label": "Edit widget",
              children: /* @__PURE__ */ t(Pr, { size: 16, color: d.gray_dark })
            }
          )
        ]
      }
    ),
    i && /* @__PURE__ */ t(
      Gr,
      {
        widgetId: o,
        displayName: r,
        fields: Ht,
        values: C,
        initialValues: g || void 0,
        onChange: P,
        onClose: () => l(!1),
        onReset: I,
        screenPosition: s,
        onSave: R,
        isSaving: T,
        themeColors: f,
        studioLockedKeys: v
      }
    ),
    c && /* @__PURE__ */ t(
      Ke,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: X,
        onCancel: j,
        isLoading: T
      }
    )
  ] });
}, Xa = {
  // Icon container
  iconContainerSize: 80,
  iconContainerBgColor: a("background"),
  iconContainerBorderRadius: 50,
  // Icon
  iconSize: 40,
  iconColor: a("textPrimary"),
  // Title
  titleFontSize: 28,
  titleFontWeight: "semibold",
  titleColor: a("textPrimary"),
  titleMarginBottom: 12,
  // Description
  descriptionFontSize: 16,
  descriptionColor: a("textPrimary"),
  descriptionMaxWidth: 500,
  descriptionLineHeight: 1.5,
  descriptionMarginBottom: 32,
  // Suggestions section title
  suggestionsTitleFontSize: 16,
  suggestionsTitleFontWeight: "medium",
  suggestionsTitleColor: a("textPrimary"),
  suggestionsTitleMarginBottom: 16,
  // Suggestion pills
  suggestionPillPaddingX: 16,
  suggestionPillPaddingY: 10,
  suggestionPillBorderRadius: 20,
  suggestionPillBorderColor: a("background"),
  suggestionPillBgColor: a("transparent"),
  suggestionPillBgColorHover: a("background"),
  suggestionPillTextColor: a("textPrimary"),
  suggestionPillFontSize: 14,
  suggestionPillGap: 8,
  // Container
  containerPadding: 20
}, Nt = [
  // Icon container
  {
    key: "iconContainerSize",
    label: "Icon Container Size",
    type: "number",
    min: 40,
    max: 120,
    step: 8
  },
  {
    key: "iconContainerBgColor",
    label: "Icon Container Background",
    type: "color"
  },
  {
    key: "iconContainerBorderRadius",
    label: "Icon Container Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Icon
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 20,
    max: 80,
    step: 4
  },
  { key: "iconColor", label: "Icon Color", type: "color" },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ae]
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleMarginBottom",
    label: "Title Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  // Description
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionMaxWidth",
    label: "Description Max Width",
    type: "number",
    min: 300,
    max: 700,
    step: 50
  },
  {
    key: "descriptionLineHeight",
    label: "Description Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "descriptionMarginBottom",
    label: "Description Margin Bottom",
    type: "number",
    min: 16,
    max: 64,
    step: 4
  },
  // Suggestions section title
  {
    key: "suggestionsTitleFontSize",
    label: "Suggestions Title Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "suggestionsTitleFontWeight",
    label: "Suggestions Title Weight",
    type: "options",
    options: [...ae]
  },
  {
    key: "suggestionsTitleColor",
    label: "Suggestions Title Color",
    type: "color"
  },
  {
    key: "suggestionsTitleMarginBottom",
    label: "Suggestions Title Margin",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Suggestion pills
  {
    key: "suggestionPillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "suggestionPillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 16,
    step: 2
  },
  {
    key: "suggestionPillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "suggestionPillBorderColor",
    label: "Pill Border Color",
    type: "color"
  },
  { key: "suggestionPillBgColor", label: "Pill Background", type: "color" },
  {
    key: "suggestionPillBgColorHover",
    label: "Pill Background (Hover)",
    type: "color"
  },
  { key: "suggestionPillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "suggestionPillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "suggestionPillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerPadding",
    label: "Container Padding",
    type: "number",
    min: 0,
    max: 40,
    step: 4
  }
], _s = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    resolveColor: c,
    canSave: h
  } = U(
    o,
    { ...Xa, ...e },
    Nt
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const x = n(i, c);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Nt,
      editValues: i,
      onEditChange: p,
      onSave: h ? g : void 0,
      isSaving: s,
      themeColors: y,
      children: x
    }
  );
}, Ja = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Za = {
  // Carousel gap
  carouselGap: 16,
  // Card container
  cardBorderRadius: 10,
  // "Explore now" pill
  pillBgColor: a("secondary"),
  pillBorderColor: a("secondary"),
  pillTextColor: a("textPrimary"),
  pillPaddingX: 12,
  pillPaddingY: 6,
  pillBorderRadius: 50,
  // Arrow button
  arrowBgColor: a("secondary"),
  arrowBorderColor: a("secondary"),
  arrowIconColor: a("textPrimary"),
  // Title
  titleColor: a("textPrimary"),
  titleFontWeight: "semibold",
  titleFontFamily: "inherit"
}, Dt = [
  // Carousel gap
  {
    key: "carouselGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Card container
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // "Explore now" pill
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 20,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 12,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 4,
    max: 50,
    step: 2
  },
  // Arrow button
  { key: "arrowBgColor", label: "Arrow Background", type: "color" },
  { key: "arrowBorderColor", label: "Arrow Border Color", type: "color" },
  { key: "arrowIconColor", label: "Arrow Icon Color", type: "color" },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ae]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  }
], Vs = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeFonts: c,
    resolveColor: h,
    canSave: x,
    getEditValues: B
  } = U(
    o,
    { ...Za, ...e },
    Dt
  ), k = i.titleFontFamily, b = k && k !== "inherit" ? c[k] : null, C = b && b.format === "google" ? b.url : null;
  if (Q(() => {
    C && Ja(C);
  }, [C]), l)
    return /* @__PURE__ */ t(O, {});
  const S = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", T = b && b.format !== "system" && b.format !== "google", m = `trending-card-${o || "default"}`, A = `
    ${T ? `
      @font-face {
        font-family: "${b.name}";
        src: url("${b.url}") format("${b.format}");
        font-display: swap;
      }
    ` : ""}
    ${S !== "inherit" ? `.${m} [data-title-text] { font-family: ${S} !important; }` : ""}
  `.trim(), f = {
    ...i,
    titleFontFamilyCss: S
  }, z = /* @__PURE__ */ u(O, { children: [
    A && /* @__PURE__ */ t("style", { children: A }),
    n(f, h)
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Dt,
      editValues: B(),
      onEditChange: p,
      onSave: x ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeFonts: c,
      children: z
    }
  );
}, Ua = {
  // Container
  backgroundColor: a("secondary"),
  borderColor: a("primary"),
  borderWidth: 1,
  borderRadius: 9999,
  // pill shape
  paddingX: 12,
  paddingY: 8,
  // Text
  textColor: a("textPrimary"),
  textColorLoading: a("textPrimary"),
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  // Product images
  imageSize: 24,
  imageBorderColor: a("borderColor"),
  imageOverlap: 12,
  imageBorderRadius: 9999,
  // circle
  // Counter (+N)
  counterTextColor: a("textPrimary"),
  counterFontSize: 14,
  // Placeholder (loading state)
  placeholderBgColor: a("background")
}, Ot = [
  // Container
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Text
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "textColorLoading", label: "Text Color (Loading)", type: "color" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: ae
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  // Product images
  {
    key: "imageSize",
    label: "Image Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2
  },
  { key: "imageBorderColor", label: "Image Border Color", type: "color" },
  {
    key: "imageOverlap",
    label: "Image Overlap",
    type: "number",
    min: 0,
    max: 20,
    step: 2
  },
  {
    key: "imageBorderRadius",
    label: "Image Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 2
  },
  // Counter
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Placeholder
  { key: "placeholderBgColor", label: "Placeholder Background", type: "color" }
], qs = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeFonts: c,
    themeIcons: h,
    resolveColor: x,
    canSave: B
  } = U(
    o,
    { ...Ua, ...e },
    Ot
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const k = n(i, x);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Ot,
      editValues: i,
      onEditChange: p,
      onSave: B ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeFonts: c,
      themeIcons: h,
      children: k
    }
  );
}, _a = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Va = {
  // Preset
  preset: "plain",
  // Layout direction
  layout: "vertical",
  // Container
  containerGap: 8,
  containerBgColor: a("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Icon
  showIcon: !1,
  // Suggestion pills
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 8,
  pillBorderColor: a("borderColor"),
  pillBorderWidth: 1,
  pillBgColor: a("secondary"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillShadowEnabled: !1,
  pillShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, qa = {
  // --- Base: transparent bg, thin light border ---
  plain: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "plain-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Highlighted: container bg, no pill border ---
  highlighted: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("transparent"),
    pillBorderWidth: 0,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "highlighted-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("transparent"),
    pillBorderWidth: 0,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Container bg with thin border on pills ---
  "container-bg": {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "container-bg-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Extras: stronger border treatment ---
  bordered: {
    showIcon: !1,
    containerGap: 6,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-icon": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-highlighted": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  }
}, Ka = [
  { label: "Plain", value: "plain" },
  { label: "Plain + Icon", value: "plain-icon" },
  { label: "Highlighted", value: "highlighted" },
  { label: "Highlighted + Icon", value: "highlighted-icon" },
  { label: "Container BG", value: "container-bg" },
  { label: "Container BG + Icon", value: "container-bg-icon" },
  { label: "Bordered", value: "bordered" },
  { label: "Bordered + Icon", value: "bordered-icon" },
  { label: "Bordered Highlighted", value: "bordered-highlighted" },
  { label: "Custom", value: "custom" }
], jt = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: Ka
  },
  // Layout direction
  {
    key: "layout",
    label: "Layout",
    type: "options",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  // Icon toggle
  { key: "showIcon", label: "Show Arrow Icon", type: "toggle" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Shadow Value (CSS)", type: "text" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...ae]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" },
  // Shadow
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Pill Shadow CSS", type: "text" }
], Ks = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeFonts: c,
    resolveColor: h,
    canSave: x
  } = U(
    o,
    { ...Va, ...e },
    jt
  ), B = (P, W) => {
    if (P === "preset" && W !== "custom") {
      const L = qa[W];
      if (L) {
        p("preset", W), Object.entries(L).forEach(([I, R]) => {
          p(I, R);
        });
        return;
      }
    }
    p(P, W);
  }, k = i.pillFontFamily, b = k && k !== "inherit" ? c[k] : null, C = b && b.format === "google" ? b.url : null;
  if (Q(() => {
    C && _a(C);
  }, [C]), l)
    return /* @__PURE__ */ t(O, {});
  const S = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", T = b && b.format !== "system" && b.format !== "google", m = `suggestion-list-${o || "default"}`, A = `
    ${T ? `
      @font-face {
        font-family: "${b.name}";
        src: url("${b.url}") format("${b.format}");
        font-display: swap;
      }
    ` : ""}
    ${S !== "inherit" ? `.${m} { font-family: ${S} !important; }` : ""}
  `.trim(), f = {
    ...i,
    pillFontFamilyCss: S
  }, z = h(i.containerBgColor), w = z && z !== "transparent" && z !== "", v = /* @__PURE__ */ u(O, { children: [
    A && /* @__PURE__ */ t("style", { children: A }),
    /* @__PURE__ */ t(
      "div",
      {
        className: m,
        style: {
          backgroundColor: w ? z : void 0,
          padding: w || i.containerPaddingX || i.containerPaddingY ? `${i.containerPaddingY}px ${i.containerPaddingX}px` : void 0,
          borderRadius: i.containerBorderRadius > 0 ? `${i.containerBorderRadius}px` : void 0
        },
        children: n(f, h)
      }
    )
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: jt,
      editValues: i,
      onEditChange: B,
      onSave: x ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeFonts: c,
      children: v
    }
  );
}, Gt = {
  "vertical-compact": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 8,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: oe("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 56
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillBorderRadius: 8,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 4,
      paddingX: 12,
      paddingY: 12,
      borderColor: oe("#F3F3F3"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 15,
      minHeight: 56
    }
  },
  "vertical-expanded": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: oe("#F3F3F3"),
      pillBorderWidth: 1,
      pillShadowEnabled: !0,
      pillShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 12,
      inputBorderColor: oe("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 116
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 12,
      containerPaddingY: 12,
      containerBorderRadius: 12,
      pillBorderRadius: 100,
      pillBorderColor: oe("#F3F3F3"),
      pillBorderWidth: 1,
      pillShadowEnabled: !0,
      pillShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 4,
      paddingX: 12,
      paddingY: 12,
      borderColor: oe("#F3F3F3"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 15,
      minHeight: 116
    }
  },
  "horizontal-compact": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: oe("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 56
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 4,
      paddingX: 12,
      paddingY: 12,
      borderColor: oe("#F3F3F3"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 15,
      minHeight: 56
    }
  },
  "horizontal-expanded": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: oe("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 116
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 4,
      paddingX: 12,
      paddingY: 12,
      borderColor: oe("#F3F3F3"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 15,
      minHeight: 116
    }
  }
}, el = [
  { label: "Vertical + Compact Input", value: "vertical-compact" },
  { label: "Vertical + Expanded Input", value: "vertical-expanded" },
  { label: "Horizontal + Compact Input", value: "horizontal-compact" },
  { label: "Horizontal + Expanded Input", value: "horizontal-expanded" },
  { label: "Custom", value: "custom" }
], $t = [
  // --- General ---
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: el
  },
  { key: "mainBgColor", label: "Background", type: "color" },
  // --- Suggestion Pills group ---
  {
    key: "pillLayout",
    label: "Layout",
    type: "options",
    group: "Suggestion Pills",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  {
    key: "pillShowIcon",
    label: "Show Icon",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderColor",
    label: "Border Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5,
    group: "Suggestion Pills"
  },
  {
    key: "pillBgColor",
    label: "Background",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillTextColor",
    label: "Text Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Suggestion Pills"
  },
  // --- Input Box group ---
  {
    key: "inputBorderColor",
    label: "Border Color",
    type: "color",
    group: "Input Box"
  },
  {
    key: "inputBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 0.5,
    group: "Input Box"
  },
  {
    key: "inputBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Input Box"
  },
  {
    key: "inputMinHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 200,
    step: 10,
    group: "Input Box"
  },
  {
    key: "inputShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Input Box"
  },
  {
    key: "inputShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Input Box"
  }
], ol = {
  preset: "vertical-expanded",
  mainBgColor: a("transparent"),
  // Pill defaults (vertical-expanded) — border 1px #F3F3F3, radius 100px, shadow per mock
  pillLayout: "vertical",
  pillShowIcon: !1,
  pillBorderRadius: 100,
  pillBorderColor: oe("#F3F3F3"),
  pillBorderWidth: 1,
  pillBgColor: a("secondary"),
  pillTextColor: a("textPrimary"),
  pillShadowEnabled: !0,
  pillShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
  pillContainerBgColor: a("transparent"),
  pillContainerBorderRadius: 12,
  // Input defaults (vertical-expanded: taller input 116px, rounded rect)
  inputBorderColor: oe("#F3F3F3"),
  inputBorderWidth: 1,
  inputBorderRadius: 20,
  inputMinHeight: 116,
  inputShadowEnabled: !1,
  inputShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)"
}, ed = ({
  widgetId: e = "concierge-panel",
  displayName: o = "Concierge Panel",
  initialState: r = {},
  suggestionListWidgetId: n = "concierge-suggestion-list",
  chatInputWidgetId: i = "concierge-chat-input",
  suppressChildEdits: l = !0,
  children: s
}) => {
  const {
    state: p,
    isLoading: g,
    isSaving: y,
    handleEditChange: c,
    handleSave: h,
    themeColors: x,
    themeFonts: B,
    resolveColor: k,
    canSave: b
  } = U(
    e,
    { ...ol, ...r },
    $t
  ), { updateWidgetConfig: C } = Wo(
    n
  ), { updateWidgetConfig: S } = Wo(i), T = de(!1);
  Q(() => {
    if (g || p.preset === "custom" || T.current) return;
    const v = Gt[p.preset];
    v && (T.current = !0, Object.entries(v.suggestionList).forEach(([P, W]) => {
      C(P, W);
    }), Object.entries(v.chatInput).forEach(([P, W]) => {
      S(P, W);
    }));
  }, [g, p.preset, C, S]);
  const m = {
    pillLayout: "layout",
    pillShowIcon: "showIcon",
    pillBorderRadius: "pillBorderRadius",
    pillBorderColor: "pillBorderColor",
    pillBorderWidth: "pillBorderWidth",
    pillBgColor: "pillBgColor",
    pillTextColor: "pillTextColor",
    pillShadowEnabled: "pillShadowEnabled",
    pillShadow: "pillShadow",
    pillContainerBgColor: "containerBgColor",
    pillContainerBorderRadius: "containerBorderRadius"
  }, A = {
    inputBorderColor: "borderColor",
    inputBorderWidth: "borderWidth",
    inputBorderRadius: "borderRadiusSingleLine",
    inputMinHeight: "minHeight",
    inputShadowEnabled: "shadowEnabled",
    inputShadow: "shadow"
  }, f = ge(
    (v, P) => {
      if (v === "preset" && P !== "custom") {
        const F = Gt[P];
        if (F) {
          c("preset", P), F.panel && Object.entries(F.panel).forEach(([L, I]) => {
            c(L, I);
          }), Object.entries(F.suggestionList).forEach(([L, I]) => {
            C(L, I);
          }), Object.entries(F.chatInput).forEach(([L, I]) => {
            S(L, I);
          });
          return;
        }
      }
      if (v in m) {
        c("preset", "custom"), c(v, P), C(m[v], P);
        return;
      }
      if (v in A) {
        c("preset", "custom"), c(v, P), S(A[v], P);
        return;
      }
      c(v, P);
    },
    [c, C, S]
  );
  if (g)
    return /* @__PURE__ */ t(O, {});
  const z = s(p, k);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: $t,
      editValues: p,
      onEditChange: f,
      onSave: b ? h : void 0,
      isSaving: y,
      themeColors: x,
      themeFonts: B,
      containerClassName: "widget-fill-height",
      children: l ? /* @__PURE__ */ t(Yi, { children: z }) : z
    }
  );
}, Yt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, tl = {
  // Card/Pill container
  borderColor: a("borderColor"),
  borderColorSelected: a("primary"),
  backgroundColor: a("secondary"),
  backgroundColorHover: a("background"),
  borderRadius: 8,
  // Rectangle card dimensions
  cardWidth: 88,
  cardGap: 12,
  cardImageSize: 72,
  // Compact pill dimensions
  pillImageSize: 32,
  pillGap: 8,
  pillPaddingY: 6,
  pillPaddingX: 12,
  // Checkmark badge
  checkmarkBgColor: a("primary"),
  checkmarkIconColor: a("secondary"),
  checkmarkSize: 16,
  // Price text
  priceColor: a("textPrimary"),
  priceFontSize: 16,
  priceFontWeightNormal: "medium",
  priceFontWeightSelected: "semibold",
  priceFontFamily: "inherit",
  // Variant name text
  nameColor: a("textPrimary"),
  nameFontSize: 14,
  nameFontSizeCompact: 14,
  nameFontWeightNormal: "medium",
  nameFontWeightSelected: "semibold",
  nameFontFamily: "inherit",
  // Divider
  dividerColor: a("background"),
  dividerColorSelected: a("primary")
}, Qt = [
  // Card/Pill container
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderColorSelected",
    label: "Border Color (Selected)",
    type: "color"
  },
  { key: "backgroundColor", label: "Background Color", type: "color" },
  {
    key: "backgroundColorHover",
    label: "Background Color (Hover)",
    type: "color"
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  // Rectangle card dimensions
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 60,
    max: 120,
    step: 4
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "cardImageSize",
    label: "Card Image Size",
    type: "number",
    min: 48,
    max: 96,
    step: 4
  },
  // Compact pill dimensions
  {
    key: "pillImageSize",
    label: "Pill Image Size",
    type: "number",
    min: 24,
    max: 48,
    step: 4
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Checkmark badge
  { key: "checkmarkBgColor", label: "Checkmark Background", type: "color" },
  { key: "checkmarkIconColor", label: "Checkmark Icon Color", type: "color" },
  {
    key: "checkmarkSize",
    label: "Checkmark Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Price text
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "priceFontWeightNormal",
    label: "Price Font Weight",
    type: "options",
    options: [...ae]
  },
  {
    key: "priceFontWeightSelected",
    label: "Price Weight (Selected)",
    type: "options",
    options: [...ae]
  },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font"
  },
  // Variant name text
  { key: "nameColor", label: "Name Color", type: "color" },
  {
    key: "nameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "nameFontSizeCompact",
    label: "Name Font Size (Compact)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "nameFontWeightNormal",
    label: "Name Font Weight",
    type: "options",
    options: [...ae]
  },
  {
    key: "nameFontWeightSelected",
    label: "Name Weight (Selected)",
    type: "options",
    options: [...ae]
  },
  {
    key: "nameFontFamily",
    label: "Name Font Family",
    type: "font"
  },
  // Divider
  { key: "dividerColor", label: "Divider Color", type: "color" },
  {
    key: "dividerColorSelected",
    label: "Divider Color (Selected)",
    type: "color"
  }
], od = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeFonts: c,
    resolveColor: h,
    canSave: x
  } = U(
    o,
    { ...tl, ...e },
    Qt
  ), B = i.priceFontFamily, k = B && B !== "inherit" ? c[B] : null, b = i.nameFontFamily, C = b && b !== "inherit" ? c[b] : null, S = k && k.format === "google" ? k.url : null, T = C && C.format === "google" ? C.url : null;
  if (Q(() => {
    S && Yt(S);
  }, [S]), Q(() => {
    T && Yt(T);
  }, [T]), l)
    return /* @__PURE__ */ t(O, {});
  const m = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", A = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", f = k && k.format !== "system" && k.format !== "google", z = C && C.format !== "system" && C.format !== "google", w = `variant-picker-${o || "default"}`, v = `
    ${f ? `
      @font-face {
        font-family: "${k.name}";
        src: url("${k.url}") format("${k.format}");
        font-display: swap;
      }
    ` : ""}
    ${z ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${m !== "inherit" ? `.${w} [data-price-text] { font-family: ${m} !important; }` : ""}
    ${A !== "inherit" ? `.${w} [data-name-text] { font-family: ${A} !important; }` : ""}
  `.trim(), P = {
    ...i,
    priceFontFamilyCss: m,
    nameFontFamilyCss: A
  }, W = /* @__PURE__ */ u(O, { children: [
    v && /* @__PURE__ */ t("style", { children: v }),
    n(P, h)
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Qt,
      editValues: i,
      onEditChange: p,
      onSave: x ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeFonts: c,
      children: W
    }
  );
}, rl = {
  overlayBgColor: oe("rgba(0, 0, 0, 0.45)"),
  dialogBgColor: a("secondary"),
  dialogBorderRadius: 12,
  titleColor: a("textPrimary"),
  messageColor: a("textPrimary"),
  cancelButtonBgColor: a("secondary"),
  cancelButtonBorderColor: a("borderColor"),
  cancelButtonTextColor: a("textPrimary"),
  confirmButtonBgColor: a("primary"),
  confirmButtonTextColor: a("primaryForeground")
}, Xt = [
  { key: "overlayBgColor", label: "Overlay Background", type: "color" },
  { key: "dialogBgColor", label: "Dialog Background", type: "color" },
  {
    key: "dialogBorderRadius",
    label: "Dialog Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  { key: "messageColor", label: "Message Color", type: "color" },
  {
    key: "cancelButtonBgColor",
    label: "Cancel Button Background",
    type: "color"
  },
  {
    key: "cancelButtonBorderColor",
    label: "Cancel Button Border",
    type: "color"
  },
  {
    key: "cancelButtonTextColor",
    label: "Cancel Button Text",
    type: "color"
  },
  {
    key: "confirmButtonBgColor",
    label: "Confirm Button Background",
    type: "color"
  },
  {
    key: "confirmButtonTextColor",
    label: "Confirm Button Text",
    type: "color"
  }
], td = ({ initialState: e = {}, widgetId: o, displayName: r, overlay: n, children: i }) => {
  const {
    state: l,
    isLoading: s,
    isSaving: p,
    handleEditChange: g,
    handleSave: y,
    themeColors: c,
    resolveColor: h,
    canSave: x
  } = U(
    o,
    { ...rl, ...e },
    Xt
  );
  if (s)
    return /* @__PURE__ */ t(O, {});
  const B = n ? n(l, h) : null, k = i(l, h);
  return /* @__PURE__ */ u(O, { children: [
    B,
    /* @__PURE__ */ t(
      Z,
      {
        widgetId: o,
        displayName: r,
        editFields: Xt,
        editValues: l,
        onEditChange: g,
        onSave: x ? y : void 0,
        isSaving: p,
        themeColors: c,
        triggerMode: "persistent",
        triggerPosition: "top-right",
        wrapperStyle: { width: "100%", maxWidth: "28rem" },
        children: k
      }
    )
  ] });
}, nl = {
  dialogBgColor: a("secondary"),
  dialogBorderRadius: 16,
  dialogPadding: 40,
  titleFontSize: 24,
  titleColor: a("textPrimary"),
  descriptionFontSize: 16,
  descriptionColor: a("textPrimary"),
  logoIcon: "default",
  logoContainerSize: 64,
  logoContainerBgColor: oe("#f5f5f5"),
  primaryButtonBgColor: a("textPrimary"),
  primaryButtonTextColor: a("secondary"),
  primaryButtonBorderRadius: 999,
  cancelTextColor: a("textPrimary")
}, Jt = [
  // ── Dialog ────────────────────────────────────────────────────────────
  { key: "dialogBgColor", label: "Background", type: "color", group: "Dialog" },
  {
    key: "dialogBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 1,
    group: "Dialog"
  },
  {
    key: "dialogPadding",
    label: "Padding",
    type: "number",
    min: 16,
    max: 60,
    step: 4,
    group: "Dialog"
  },
  // ── Logo ──────────────────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Icon", type: "icon", group: "Logo" },
  { key: "logoContainerSize", label: "Icon Size", type: "number", min: 32, max: 96, step: 4, group: "Logo" },
  { key: "logoContainerBgColor", label: "Background", type: "color", group: "Logo" },
  // ── Title ─────────────────────────────────────────────────────────────
  { key: "titleFontSize", label: "Font Size", type: "number", min: 16, max: 32, step: 1, group: "Title" },
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  // ── Description ───────────────────────────────────────────────────────
  { key: "descriptionFontSize", label: "Font Size", type: "number", min: 12, max: 20, step: 1, group: "Description" },
  { key: "descriptionColor", label: "Color", type: "color", group: "Description" },
  // ── Button ────────────────────────────────────────────────────────────
  { key: "primaryButtonBgColor", label: "Background", type: "color", group: "Button" },
  { key: "primaryButtonTextColor", label: "Text Color", type: "color", group: "Button" },
  {
    key: "primaryButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 999,
    step: 1,
    group: "Button"
  },
  { key: "cancelTextColor", label: "Cancel Text Color", type: "color", group: "Button" }
], rd = ({ initialState: e = {}, widgetId: o, displayName: r, children: n }) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeIcons: c,
    resolveColor: h,
    canSave: x
  } = U(
    o,
    { ...nl, ...e },
    Jt
  ), B = i.logoIcon && i.logoIcon !== "default" ? c[i.logoIcon] : null, k = B ? B.url : null;
  return l ? /* @__PURE__ */ t(O, {}) : /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Jt,
      editValues: i,
      onEditChange: p,
      onSave: x ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeIcons: c,
      triggerMode: "persistent",
      triggerPosition: "top-right",
      wrapperStyle: { width: "100%", maxWidth: "28rem" },
      children: n(i, h, k)
    }
  );
}, il = {
  // Dialog container
  dialogBgColor: oe("#ffffff"),
  dialogBorderRadius: 16,
  dialogPadding: 40,
  // Logo circle
  logoIcon: "default",
  logoContainerSize: 64,
  logoContainerBgColor: a("primary"),
  // Title
  titleFontSize: 24,
  titleColor: a("textPrimary"),
  // Subtitle
  subtitleFontSize: 16,
  subtitleColor: a("textPrimary"),
  // Input field
  inputBorderRadius: 6,
  inputBorderColor: oe("#dcdddc"),
  // Continue (primary) button
  primaryButtonBgColor: a("textPrimary"),
  primaryButtonDisabledBgColor: oe("#DCDCDC"),
  primaryButtonTextColor: oe("#ffffff"),
  primaryButtonBorderRadius: 999,
  // Resend (secondary/outlined) button
  secondaryButtonBorderColor: a("textPrimary"),
  secondaryButtonDisabledBorderColor: oe("#DCDCDC"),
  secondaryButtonTextColor: a("textPrimary"),
  secondaryButtonBorderRadius: 999,
  // Back / cancel text
  cancelTextColor: a("textPrimary")
}, Zt = [
  // ── Dialog ────────────────────────────────────────────────────────────
  { key: "dialogBgColor", label: "Background", type: "color", group: "Dialog" },
  {
    key: "dialogBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 1,
    group: "Dialog"
  },
  {
    key: "dialogPadding",
    label: "Padding",
    type: "number",
    min: 16,
    max: 60,
    step: 4,
    group: "Dialog"
  },
  // ── Logo ──────────────────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Image", type: "icon", group: "Logo" },
  {
    key: "logoContainerSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 96,
    step: 4,
    group: "Logo"
  },
  { key: "logoContainerBgColor", label: "Background", type: "color", group: "Logo" },
  // ── Title ─────────────────────────────────────────────────────────────
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Title"
  },
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  // ── Subtitle ──────────────────────────────────────────────────────────
  {
    key: "subtitleFontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Subtitle"
  },
  { key: "subtitleColor", label: "Color", type: "color", group: "Subtitle" },
  // ── Input ─────────────────────────────────────────────────────────────
  { key: "inputBorderColor", label: "Border Color", type: "color", group: "Input" },
  {
    key: "inputBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1,
    group: "Input"
  },
  // ── Continue Button ───────────────────────────────────────────────────
  { key: "primaryButtonBgColor", label: "Background (Active)", type: "color", group: "Continue Button" },
  { key: "primaryButtonDisabledBgColor", label: "Background (Disabled)", type: "color", group: "Continue Button" },
  { key: "primaryButtonTextColor", label: "Text Color", type: "color", group: "Continue Button" },
  {
    key: "primaryButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 999,
    step: 1,
    group: "Continue Button"
  },
  // ── Resend Button ─────────────────────────────────────────────────────
  { key: "secondaryButtonBorderColor", label: "Border (Active)", type: "color", group: "Resend Button" },
  { key: "secondaryButtonDisabledBorderColor", label: "Border (Disabled)", type: "color", group: "Resend Button" },
  { key: "secondaryButtonTextColor", label: "Text Color", type: "color", group: "Resend Button" },
  {
    key: "secondaryButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 999,
    step: 1,
    group: "Resend Button"
  },
  // ── Cancel ────────────────────────────────────────────────────────────
  { key: "cancelTextColor", label: "Back Text Color", type: "color", group: "Cancel" }
], nd = ({
  widgetId: e,
  displayName: o,
  initialState: r = {},
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeIcons: c,
    resolveColor: h,
    canSave: x
  } = U(
    e,
    { ...il, ...r },
    Zt
  ), B = i.logoIcon && i.logoIcon !== "default" ? c[i.logoIcon] : null, k = B ? B.url : null;
  return l ? /* @__PURE__ */ t(O, {}) : /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: Zt,
      editValues: i,
      onEditChange: p,
      onSave: x ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeIcons: c,
      triggerMode: "persistent",
      triggerPosition: "top-right",
      wrapperStyle: { width: "100%" },
      children: n(i, h, k)
    }
  );
}, al = {
  // ============================================
  // 1. HEADER SECTION (Search results toggle)
  // ============================================
  headerIconColor: a("textPrimary"),
  headerIconSize: 14,
  headerLabelText: "Search results",
  headerLabelColor: a("textPrimary"),
  headerLabelFontSize: 14,
  headerLabelFontWeight: "medium",
  headerLabelFontFamily: "inherit",
  headerChevronColor: a("textPrimary"),
  headerChevronSize: 16,
  headerGap: 6,
  headerMarginBottom: 16,
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  containerMarginBottom: 12,
  pillsGap: 8,
  pillsSectionMarginBottom: 24,
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  defaultExpanded: !0,
  autoCollapse: !0,
  autoCollapseDelay: 1500,
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  thinkingEnabled: !0,
  thinkingText: "Thinking...",
  thinkingTextColor: a("textPrimary"),
  thinkingTextFontSize: 14,
  thinkingBgColor: a("secondary"),
  thinkingPaddingX: 16,
  thinkingPaddingY: 12,
  thinkingBorderRadius: 18,
  thinkingBorderRadiusBottomLeft: 5,
  shimmerDuration: 1.5,
  shimmerColor: a("background"),
  // ============================================
  // 5. ANIMATION
  // ============================================
  animationsEnabled: !0,
  productAnimationDuration: 800,
  chevronRotationDuration: 200
}, Ut = [
  // ============================================
  // 1. HEADER SECTION
  // ============================================
  { key: "headerIconColor", label: "Header Icon Color", type: "color" },
  {
    key: "headerIconSize",
    label: "Header Icon Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  { key: "headerLabelText", label: "Header Label Text", type: "text" },
  { key: "headerLabelColor", label: "Header Label Color", type: "color" },
  {
    key: "headerLabelFontSize",
    label: "Header Label Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  {
    key: "headerLabelFontWeight",
    label: "Header Label Font Weight",
    type: "options",
    options: ae
  },
  {
    key: "headerLabelFontFamily",
    label: "Header Label Font Family",
    type: "font"
  },
  { key: "headerChevronColor", label: "Header Chevron Color", type: "color" },
  {
    key: "headerChevronSize",
    label: "Header Chevron Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "headerGap",
    label: "Header Gap",
    type: "number",
    min: 2,
    max: 16,
    step: 1
  },
  {
    key: "headerMarginBottom",
    label: "Header Margin Bottom",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "pillsGap",
    label: "Pills Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillsSectionMarginBottom",
    label: "Pills Section Margin Bottom",
    type: "number",
    min: 8,
    max: 48,
    step: 4
  },
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  { key: "defaultExpanded", label: "Default Expanded", type: "toggle" },
  { key: "autoCollapse", label: "Auto Collapse", type: "toggle" },
  {
    key: "autoCollapseDelay",
    label: "Auto Collapse Delay (ms)",
    type: "number",
    min: 500,
    max: 5e3,
    step: 100
  },
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  {
    key: "thinkingEnabled",
    label: "Thinking Indicator Enabled",
    type: "toggle"
  },
  { key: "thinkingText", label: "Thinking Text", type: "text" },
  { key: "thinkingTextColor", label: "Thinking Text Color", type: "color" },
  {
    key: "thinkingTextFontSize",
    label: "Thinking Text Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  { key: "thinkingBgColor", label: "Thinking Background", type: "color" },
  {
    key: "thinkingPaddingX",
    label: "Thinking Padding X",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  {
    key: "thinkingPaddingY",
    label: "Thinking Padding Y",
    type: "number",
    min: 6,
    max: 24,
    step: 2
  },
  {
    key: "thinkingBorderRadius",
    label: "Thinking Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "thinkingBorderRadiusBottomLeft",
    label: "Thinking Bottom Left Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "shimmerDuration",
    label: "Shimmer Duration (s)",
    type: "number",
    min: 0.5,
    max: 4,
    step: 0.1
  },
  { key: "shimmerColor", label: "Shimmer Color", type: "color" },
  // ============================================
  // 5. ANIMATION
  // ============================================
  { key: "animationsEnabled", label: "Animations Enabled", type: "toggle" },
  {
    key: "productAnimationDuration",
    label: "Product Animation Duration (ms)",
    type: "number",
    min: 200,
    max: 2e3,
    step: 100
  },
  {
    key: "chevronRotationDuration",
    label: "Chevron Rotation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  }
], id = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeFonts: c,
    themeIcons: h,
    resolveColor: x,
    canSave: B
  } = U(
    o,
    { ...al, ...e },
    Ut
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const k = n(i, x);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: Ut,
      editValues: i,
      onEditChange: p,
      onSave: B ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeFonts: c,
      themeIcons: h,
      children: k
    }
  );
}, ll = {
  // Container styling
  containerBgColor: a("secondary"),
  containerBorderRadius: 16,
  containerPaddingX: 24,
  containerPaddingY: 24,
  containerBorderWidth: 1,
  containerBorderColor: a("background"),
  // Icon styling
  iconBgColor: a("primary"),
  iconColor: a("secondary"),
  iconSize: 40,
  // Title styling
  titleColor: a("textPrimary"),
  titleFontSize: 16,
  titleFontWeight: "700",
  // Description styling
  descriptionColor: a("textPrimary"),
  descriptionFontSize: 14,
  // Button styling
  buttonBgColor: a("primary"),
  buttonTextColor: a("buttonText"),
  buttonFontSize: 14,
  buttonFontWeight: "600",
  buttonBorderRadius: 10,
  buttonPaddingX: 20,
  buttonPaddingY: 10
}, _t = [
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24
  },
  {
    key: "containerBorderWidth",
    label: "Container Border Width",
    type: "number",
    min: 0,
    max: 4
  },
  { key: "containerBorderColor", label: "Container Border Color", type: "color" },
  { key: "iconBgColor", label: "Icon Background", type: "color" },
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 24
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 10,
    max: 20
  },
  { key: "buttonBgColor", label: "Button Background", type: "color" },
  { key: "buttonTextColor", label: "Button Text Color", type: "color" },
  {
    key: "buttonBorderRadius",
    label: "Button Border Radius",
    type: "number",
    min: 0,
    max: 24
  }
], sl = ({ size: e, color: o }) => /* @__PURE__ */ u(
  "svg",
  {
    width: e * 0.5,
    height: e * 0.5,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ t("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2", ry: "2" }),
      /* @__PURE__ */ t("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
    ]
  }
), ad = ({
  widgetId: e,
  title: o,
  description: r,
  buttonText: n,
  onSignIn: i,
  disabled: l = !1,
  initialState: s
}) => {
  const {
    state: p,
    handleEditChange: g,
    handleSave: y,
    isSaving: c,
    getEditValues: h,
    resolveColor: x,
    themeColors: B,
    themeFonts: k,
    themeIcons: b
  } = U(
    e,
    { ...ll, ...s },
    _t
  );
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: "Prompt Login",
      editFields: _t,
      editValues: h(),
      onEditChange: g,
      onSave: y,
      isSaving: c,
      themeColors: B,
      themeFonts: k,
      themeIcons: b,
      children: /* @__PURE__ */ u(
        "div",
        {
          style: {
            backgroundColor: x(p.containerBgColor),
            borderRadius: `${p.containerBorderRadius}px`,
            padding: `${p.containerPaddingY}px ${p.containerPaddingX}px`,
            border: `${p.containerBorderWidth}px solid ${x(p.containerBorderColor)}`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "center",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)"
          },
          children: [
            /* @__PURE__ */ t(
              "div",
              {
                style: {
                  width: `${p.iconSize}px`,
                  height: `${p.iconSize}px`,
                  borderRadius: "50%",
                  backgroundColor: x(p.iconBgColor),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                },
                children: /* @__PURE__ */ t(
                  sl,
                  {
                    size: p.iconSize,
                    color: x(p.iconColor)
                  }
                )
              }
            ),
            /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    color: x(p.titleColor),
                    fontSize: `${p.titleFontSize}px`,
                    fontWeight: p.titleFontWeight,
                    lineHeight: 1.4
                  },
                  children: o
                }
              ),
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    color: x(p.descriptionColor),
                    fontSize: `${p.descriptionFontSize}px`,
                    lineHeight: 1.5
                  },
                  children: r
                }
              )
            ] }),
            i && /* @__PURE__ */ t(
              "button",
              {
                onClick: l ? void 0 : i,
                style: {
                  backgroundColor: x(p.buttonBgColor),
                  color: x(p.buttonTextColor),
                  fontSize: `${p.buttonFontSize}px`,
                  fontWeight: p.buttonFontWeight,
                  borderRadius: `${p.buttonBorderRadius}px`,
                  padding: `${p.buttonPaddingY}px ${p.buttonPaddingX}px`,
                  border: "none",
                  cursor: l ? "default" : "pointer",
                  transition: "opacity 0.15s ease",
                  opacity: l ? 0.5 : 1,
                  width: "100%",
                  maxWidth: "200px",
                  letterSpacing: "0.01em",
                  pointerEvents: l ? "none" : "auto",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center"
                },
                onMouseEnter: (C) => {
                  l || (C.currentTarget.style.opacity = "0.88");
                },
                onMouseLeave: (C) => {
                  l || (C.currentTarget.style.opacity = "1");
                },
                children: l ? "Loading ..." : n
              }
            )
          ]
        }
      )
    }
  );
}, Vt = [
  "concierge-home-greeting",
  "concierge-home-subtitle",
  "concierge-home-starters",
  "concierge-home-logo",
  "concierge-home-brand-label",
  "concierge-chat-input"
], Be = {
  "concierge-home-greeting": {
    greetingFontWeight: "semibold"
  },
  "concierge-home-subtitle": {
    fontWeight: "semibold"
  },
  "concierge-chat-input": {
    fontSize: 16,
    mobile_fontSize: 12,
    iconSize: 24,
    submitButtonSize: 24,
    iconGap: 12
  }
}, Ue = {
  preset: "expanded",
  shadowEnabled: !0,
  shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
  borderColor: a("borderColor"),
  borderColorFocus: a("borderColor"),
  borderRadiusSingleLine: 15,
  borderRadiusMultiLine: 15,
  borderWidth: 1,
  paddingX: 24,
  paddingY: 24,
  minHeight: 138,
  fontSize: 16,
  mobile_fontSize: 12,
  iconSize: 24,
  submitButtonSize: 24,
  iconGap: 12,
  mobile_minHeight: 116
}, dl = {
  // =========================================================================
  // A-Series: Minimal / brand-focused layouts
  // =========================================================================
  /** A1 - Minimal: Logo only + search bar */
  A1: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "hidden",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 32,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Be
    }
  },
  /** A2 - Logo + Subtitle: Logo with assistant intro text */
  A2: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "under-hero-logo",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 32,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Be,
      "concierge-home-subtitle": {
        fontSize: 24,
        fontWeight: "semibold",
        mobile_fontSize: 18
      },
      "concierge-home-logo": {
        marginBottom: 32,
        mobile_marginBottom: 20
      }
    }
  },
  /** A3 - Branded Logo: "CONCIERGE BY" label above logo */
  A3: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "above-hero-logo",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "hidden",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 48,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Be,
      "concierge-home-brand-label": {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 16,
        mobile_fontSize: 12,
        mobile_marginBottom: 8
      }
    }
  },
  /** A4 - Subtitle + Pills: Subtitle text with pill starters, logo in footer */
  A4: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Be,
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 24
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        marginBottom: 0
      },
      "concierge-home-starters": {
        containerMarginTop: 24
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      }
    }
  },
  /** A5 - Greeting + Pills: Personalized greeting with pill starters */
  A5: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Be,
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 24,
        mobile_greetingMarginBottom: 8
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        marginBottom: 0
      },
      "concierge-home-starters": {
        containerMarginTop: 24
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      }
    }
  },
  /** A6 - Inline Icon Greeting + Pills: Greeting with inline icon before text and pill starters */
  A6: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !0,
      greetingIconPosition: "inline",
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Be,
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 24,
        mobile_greetingMarginBottom: 8
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        marginBottom: 0
      },
      "concierge-home-starters": {
        containerMarginTop: 24
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      },
      "concierge-chat-input": {
        preset: "expanded",
        shadowEnabled: !0,
        shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
        borderColor: a("borderColor"),
        borderColorFocus: a("borderColor"),
        borderRadiusSingleLine: 15,
        borderRadiusMultiLine: 15,
        borderWidth: 1,
        paddingX: 24,
        paddingY: 24,
        minHeight: 138,
        fontSize: 16,
        mobile_fontSize: 12,
        iconSize: 24,
        submitButtonSize: 24,
        iconGap: 12,
        mobile_minHeight: 116
      }
    }
  },
  /** A7 - Icon Above Greeting + Pills: Greeting with icon above text and pill starters */
  A7: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !0,
      greetingIconPosition: "above",
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 24
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        lineHeight: 1.2,
        letterSpacing: 0.08,
        maxWidth: 830,
        marginBottom: 0
      },
      "concierge-home-starters": {
        pillPaddingX: 24,
        pillPaddingY: 12,
        pillBgColor: a("secondary"),
        pillFontWeight: "medium",
        pillShadowEnabled: !0,
        pillShadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)"
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      },
      "concierge-chat-input": {
        shadowEnabled: !0,
        shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
        borderColor: a("borderColor"),
        borderColorFocus: a("borderColor"),
        borderRadiusSingleLine: 15,
        borderRadiusMultiLine: 15,
        submitButtonIconColor: a("secondary"),
        submitButtonSize: 24,
        iconSize: 24,
        iconGap: 12,
        fontSize: 16,
        mobile_fontSize: 12,
        paddingX: 24,
        paddingY: 24,
        minHeight: 138,
        mobile_minHeight: 116
      }
    }
  },
  // =========================================================================
  // B-Series: Greeting + conversation starters focused
  // =========================================================================
  /** B1 - Card Starters Row: Greeting with 4 cards in a horizontal row */
  B1: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "cards-row",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "cards-grid"
    },
    childWidgets: {
      ...Be,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": Ue
    }
  },
  /** B2 - Icon Pills: Greeting with 3 icon-pill starters, logo after content */
  B2: {
    layout: {
      logoPosition: "after-content",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills-icons",
      maxStarters: 3,
      cardLayoutDirection: "stacked",
      footerGap: 56,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Be,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-chat-input": Ue
    }
  },
  /** B3 - Icon Pills + Branded Footer: 3 icon-pill starters with "CONCIERGE BY" footer */
  B3: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "above-footer-logo",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills-icons",
      maxStarters: 3,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Be,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": Ue
    }
  },
  /** B4 - Card Grid: Greeting with 2x2 inline-icon card grid */
  B4: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "cards-grid",
      maxStarters: 4,
      cardLayoutDirection: "inline",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "pills-icons-list"
    },
    childWidgets: {
      ...Be,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": Ue
    }
  },
  /** B5 - Pills + Branded Footer: Greeting with pills and "EMBER BY" footer */
  B5: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "above-footer-logo",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Be,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": Ue
    }
  }
}, cl = {
  A1: "A1 - Minimal (Logo only)",
  A2: "A2 - Logo + Subtitle",
  A3: "A3 - Branded Logo",
  A4: "A4 - Subtitle + Pills",
  A5: "A5 - Greeting + Pills",
  A6: "A6 - Inline Icon Greeting + Pills",
  A7: "A7 - Icon Above Greeting + Pills",
  B1: "B1 - Card Starters (Row)",
  B2: "B2 - Icon Pills",
  B3: "B3 - Icon Pills + Branded Footer",
  B4: "B4 - Card Starters (Grid)",
  B5: "B5 - Pills + Branded Footer",
  custom: "Custom"
}, pl = {
  layoutPreset: "A1",
  backgroundStyle: "colored",
  backgroundColor: a("background"),
  elementStyle: "default",
  logoPosition: "hero",
  brandLabelPosition: "hidden",
  showGreeting: !1,
  showGreetingIcon: !1,
  greetingIconPosition: "above",
  subtitlePosition: "hidden",
  startersMode: "hidden",
  maxStarters: 4,
  cardLayoutDirection: "stacked",
  footerGap: 8,
  footerPaddingBottom: 0,
  searchInputGap: 32,
  mobile_logoPosition: "hero",
  mobile_startersMode: "inherit"
}, gl = Object.entries(cl).map(([e, o]) => ({
  label: o,
  value: e
})), qt = [
  // Preset
  {
    key: "layoutPreset",
    label: "Layout Preset",
    type: "options",
    options: gl,
    group: "Preset"
  },
  // Background
  {
    key: "backgroundStyle",
    label: "Background",
    type: "options",
    options: [
      { label: "Colored", value: "colored" },
      { label: "White", value: "white" }
    ],
    group: "Background"
  },
  {
    key: "backgroundColor",
    label: "Background Color",
    type: "color",
    group: "Background",
    condition: { field: "backgroundStyle", value: "colored" }
  },
  {
    key: "elementStyle",
    label: "Element Style",
    type: "options",
    options: [
      { label: "Default", value: "default" },
      { label: "Grey Fill", value: "grey-fill" },
      { label: "Grey Fill + Stroke", value: "grey-fill-stroke" }
    ],
    group: "Background"
  },
  // Sections
  {
    key: "logoPosition",
    label: "Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "After Content", value: "after-content" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "brandLabelPosition",
    label: "Brand Label",
    type: "options",
    options: [
      { label: "Above Hero Logo", value: "above-hero-logo" },
      { label: "Above Footer Logo", value: "above-footer-logo" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "showGreeting",
    label: "Show Greeting",
    type: "toggle",
    group: "Sections"
  },
  {
    key: "showGreetingIcon",
    label: "Show Greeting Icon",
    type: "toggle",
    group: "Sections",
    condition: "showGreeting"
  },
  {
    key: "greetingIconPosition",
    label: "Icon Position",
    type: "options",
    options: [
      { label: "Above Greeting", value: "above" },
      { label: "Inline (before text)", value: "inline" }
    ],
    group: "Sections",
    condition: "showGreetingIcon"
  },
  {
    key: "subtitlePosition",
    label: "Subtitle Position",
    type: "options",
    options: [
      { label: "Under Hero Logo", value: "under-hero-logo" },
      { label: "Under Greeting", value: "under-greeting" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "startersMode",
    label: "Starters Layout",
    type: "options",
    options: [
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Sections"
  },
  {
    key: "maxStarters",
    label: "Max Starters",
    type: "number",
    min: 1,
    max: 6,
    step: 1,
    group: "Sections",
    condition: { field: "startersMode", value: "hidden", operator: "not_equals" }
  },
  {
    key: "cardLayoutDirection",
    label: "Card Layout",
    type: "options",
    options: [
      { label: "Stacked (icon above text)", value: "stacked" },
      { label: "Inline (icon beside text)", value: "inline" }
    ],
    group: "Sections",
    condition: { field: "startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "footerGap",
    label: "Footer / After-Content Gap",
    type: "number",
    min: 0,
    max: 80,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: ["footer", "after-content"], operator: "includes" }
  },
  {
    key: "footerPaddingBottom",
    label: "Footer Bottom Padding",
    type: "number",
    min: 0,
    max: 120,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: "footer" }
  },
  {
    key: "searchInputGap",
    label: "Search Input Gap",
    type: "number",
    min: 0,
    max: 64,
    step: 4,
    group: "Sections"
  },
  // Mobile overrides (responsive)
  {
    key: "mobile_logoPosition",
    label: "Mobile Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Header (top bar)", value: "header" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "Hidden", value: "hidden" },
      { label: "Inherit from Desktop", value: "inherit" }
    ],
    group: "Mobile"
  },
  {
    key: "mobile_startersMode",
    label: "Mobile Starters Layout",
    type: "options",
    options: [
      { label: "Inherit from Desktop", value: "inherit" },
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Mobile"
  }
], ld = ({
  widgetId: e = "concierge-home-layout",
  displayName: o = "Home Layout",
  initialState: r = {},
  children: n
}) => {
  const i = Yo(), l = $e(), s = de(/* @__PURE__ */ new Set()), {
    state: p,
    isLoading: g,
    isSaving: y,
    handleEditChange: c,
    handleSave: h,
    resetField: x,
    savedKeys: B,
    themeColors: k,
    resolveColor: b,
    canSave: C
  } = U(e, { ...pl, ...r }, qt), S = ge(
    (f) => {
      const z = f.childWidgets ?? {};
      Vt.forEach((w) => s.current.add(w)), i.setQueryData([...Ae, l.themeId], (w) => {
        var P;
        if (!w) return w;
        const v = {
          ...(P = w == null ? void 0 : w.config) == null ? void 0 : P.widgetConfig
        };
        for (const W of Vt)
          W in z ? v[W] = {
            ...z[W]
          } : delete v[W];
        return {
          ...w,
          config: {
            ...w == null ? void 0 : w.config,
            widgetConfig: v
          }
        };
      });
    },
    [i, l.themeId]
  ), T = ge(async () => {
    if (await h(), s.current.size > 0 && l.themeId && l.editThemeToken) {
      const f = i.getQueryData([...Ae, l.themeId]), z = Array.from(s.current).map((w) => {
        var P, W;
        const v = (W = (P = f == null ? void 0 : f.config) == null ? void 0 : P.widgetConfig) == null ? void 0 : W[w];
        return Jr({
          themeId: l.themeId,
          widgetId: w,
          widgetState: v ?? {},
          editThemeToken: l.editThemeToken
        });
      });
      try {
        await Promise.all(z), s.current.clear();
      } catch (w) {
        console.error("Failed to save child widget configs:", w);
      }
    }
  }, [h, i, l]), m = ge(
    (f, z) => {
      if (f === "layoutPreset" && z !== "custom") {
        const w = dl[z];
        w && (Object.entries(w.layout).forEach(([v, P]) => {
          c(v, P);
        }), S(w));
      }
      c(f, z);
    },
    [c, S]
  );
  if (g)
    return /* @__PURE__ */ u("div", { style: { flex: 1, display: "flex", flexDirection: "column" }, children: [
      /* @__PURE__ */ t("style", { children: "@keyframes bc-skel-pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }" }),
      /* @__PURE__ */ t("div", { style: { flex: 1 } }),
      /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 16, padding: 24 }, children: [
        /* @__PURE__ */ t("div", { style: { width: 40, height: 40, backgroundColor: "#f0f0f0", borderRadius: 20, animation: "bc-skel-pulse 1.5s ease-in-out infinite" } }),
        /* @__PURE__ */ t("div", { style: { width: 140, height: 18, backgroundColor: "#f0f0f0", borderRadius: 9, animation: "bc-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.05s" } }),
        /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }, children: [
          /* @__PURE__ */ t("div", { style: { width: 320, height: 24, backgroundColor: "#f0f0f0", borderRadius: 12, animation: "bc-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.1s" } }),
          /* @__PURE__ */ t("div", { style: { width: 260, height: 24, backgroundColor: "#f0f0f0", borderRadius: 12, animation: "bc-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.15s" } })
        ] }),
        /* @__PURE__ */ t("div", { style: { width: "100%", maxWidth: 560, height: 100, backgroundColor: "#f8f8f8", borderRadius: 16, border: "1px solid #f0f0f0", marginTop: 8, animation: "bc-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.2s" } }),
        /* @__PURE__ */ t("div", { style: { display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center", marginTop: 4 }, children: [180, 220, 160, 200].map((f, z) => /* @__PURE__ */ t("div", { style: { width: f, height: 40, backgroundColor: "#f8f8f8", borderRadius: 20, animation: "bc-skel-pulse 1.5s ease-in-out infinite", animationDelay: `${0.25 + 0.05 * z}s` } }, z)) })
      ] }),
      /* @__PURE__ */ t("div", { style: { flex: 1.2 } })
    ] });
  const A = n(p, b);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: qt,
      editValues: p,
      onEditChange: m,
      onSave: C ? T : void 0,
      isSaving: y,
      savedKeys: B,
      onResetField: x,
      themeColors: k,
      triggerMode: "persistent",
      triggerIcon: "gear",
      triggerPosition: "bottom-right",
      triggerLabel: "Edit Home Layout",
      children: A
    }
  );
}, ml = {
  logoIcon: "default",
  logoWidth: 200,
  logoMaxHeight: 80,
  logoOpacity: 1,
  marginBottom: 0,
  mobile_logoWidth: 140,
  mobile_marginBottom: 0
}, Kt = [
  {
    key: "logoIcon",
    label: "Logo Image",
    type: "icon"
  },
  {
    key: "logoWidth",
    label: "Logo Width",
    type: "number",
    min: 60,
    max: 400,
    step: 10,
    responsive: !0
  },
  {
    key: "logoMaxHeight",
    label: "Max Height",
    type: "number",
    min: 30,
    max: 200,
    step: 10
  },
  {
    key: "logoOpacity",
    label: "Opacity",
    type: "number",
    min: 0.1,
    max: 1,
    step: 0.1
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 96,
    step: 4,
    responsive: !0
  }
], sd = ({
  widgetId: e = "concierge-home-logo",
  displayName: o = "Brand Logo",
  initialState: r = {},
  logoUrl: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeIcons: c,
    canSave: h
  } = U(
    e,
    { ...ml, ...r },
    Kt
  ), x = i.logoIcon && i.logoIcon !== "default" ? c[i.logoIcon] : null, B = x ? x.url : n;
  if (l || !B)
    return /* @__PURE__ */ t(O, {});
  const k = `logo-${e || "default"}`, b = `logo-wrap-${e || "default"}`, C = i.mobile_marginBottom ?? i.marginBottom, S = i.mobile_logoWidth ?? i.logoWidth, T = `
    .${b} {
      margin-bottom: ${i.marginBottom}px;
    }
    .${k} img {
      width: ${i.logoWidth}px;
    }
    @media (max-width: 767px) {
      .${b} {
        margin-bottom: ${C}px !important;
      }
      .${k} img {
        width: ${S}px !important;
      }
    }
  `.trim(), m = /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: T }),
    /* @__PURE__ */ t(
      "div",
      {
        className: `${b} ${k}`,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        },
        children: /* @__PURE__ */ t(
          "img",
          {
            src: B,
            alt: x ? x.name : "Brand logo",
            style: {
              maxHeight: i.logoMaxHeight,
              opacity: i.logoOpacity,
              objectFit: "contain"
            }
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: Kt,
      editValues: i,
      onEditChange: p,
      onSave: h ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeIcons: c,
      children: m
    }
  );
}, ul = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, hl = {
  text: "CONCIERGE BY",
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  color: a("textPrimary"),
  letterSpacing: 2,
  textTransform: "uppercase",
  marginBottom: 8,
  mobile_fontSize: 14,
  mobile_marginBottom: 8
}, er = [
  { key: "text", label: "Label Text", type: "text" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ae]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "letterSpacing",
    label: "Letter Spacing",
    type: "number",
    min: 0,
    max: 10,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    responsive: !0
  }
], dd = ({
  widgetId: e = "concierge-home-brand-label",
  displayName: o = "Brand Label",
  initialState: r = {}
}) => {
  const {
    state: n,
    isLoading: i,
    isSaving: l,
    handleEditChange: s,
    handleSave: p,
    themeColors: g,
    themeFonts: y,
    resolveColor: c,
    canSave: h
  } = U(
    e,
    { ...hl, ...r },
    er
  ), x = n.fontFamily, B = x && x !== "inherit" ? y[x] : null, k = B && B.format === "google" ? B.url : null;
  if (Q(() => {
    k && ul(k);
  }, [k]), i)
    return /* @__PURE__ */ t(O, {});
  const b = B ? B.format === "system" ? B.url : `"${B.name}", sans-serif` : "inherit", C = B && B.format !== "system" && B.format !== "google", S = `brand-label-${e || "default"}`, T = n.mobile_fontSize ?? n.fontSize, m = n.mobile_marginBottom ?? n.marginBottom, A = `
    ${C ? `
      @font-face {
        font-family: "${B.name}";
        src: url("${B.url}") format("${B.format}");
        font-display: swap;
      }
    ` : ""}
    ${b !== "inherit" ? `.${S} { font-family: ${b} !important; }` : ""}
    .${S}-container {
      margin-bottom: ${n.marginBottom}px;
    }
    .${S}-text {
      font-size: ${n.fontSize}px;
    }
    @media (max-width: 767px) {
      .${S}-container {
        margin-bottom: ${m}px !important;
      }
      .${S}-text {
        font-size: ${T}px !important;
      }
    }
  `.trim(), f = n.fontWeight === "normal" ? 400 : n.fontWeight === "medium" ? 500 : n.fontWeight === "semibold" ? 600 : 700, z = /* @__PURE__ */ u(O, { children: [
    A && /* @__PURE__ */ t("style", { children: A }),
    /* @__PURE__ */ t(
      "div",
      {
        className: `${S}-container ${b !== "inherit" ? S : ""}`,
        style: {
          textAlign: "center"
        },
        children: /* @__PURE__ */ t(
          "span",
          {
            className: `${S}-text`,
            style: {
              fontWeight: f,
              color: c(n.color),
              letterSpacing: n.letterSpacing,
              textTransform: n.textTransform
            },
            children: n.text
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: er,
      editValues: n,
      onEditChange: s,
      onSave: h ? p : void 0,
      isSaving: l,
      themeColors: g,
      themeFonts: y,
      children: z
    }
  );
}, yl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, bl = ({
  size: e,
  color: o
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M48 22.8232H29.0836L46.1268 14.4962L45.1182 12.3764L28.0749 20.7034L39.8703 5.69848L38.0548 4.23074L26.2622 19.2357L30.4697 0.52336L28.2104 0L24 18.7123L19.7896 0L17.5274 0.52336L21.7378 19.2357L9.94236 4.23074L8.12968 5.69848L19.9222 20.7034L2.87896 12.3764L1.8732 14.4962L18.9164 22.8232H0V25.1768H18.9164L1.8732 33.5038L2.87896 35.6265L19.9222 27.2995L8.12968 42.3044L9.94236 43.7722L21.7378 28.7673L17.5274 47.4766L19.7896 48L24 29.2906L28.2104 48L30.4697 47.4766L26.2622 28.7673L38.0548 43.7722L39.8703 42.3044L28.0749 27.2995L45.1182 35.6265L46.1268 33.5038L29.0836 25.1768H48V22.8232Z",
        fill: o
      }
    )
  }
), fl = {
  greetingTemplate: "Hi, {name}.",
  greetingFontSize: 28,
  greetingFontWeight: "semibold",
  greetingFontFamily: "inherit",
  greetingColor: a("textPrimary"),
  showUserName: !0,
  iconType: "brand-icon",
  emoji: "👋",
  brandIcon: "",
  iconSize: 32,
  iconColor: a("primary"),
  iconRotationAnimation: !0,
  iconRotationDuration: 8,
  iconMarginBottom: 8,
  greetingMarginBottom: 8,
  mobile_greetingMarginBottom: 8,
  mobile_greetingFontSize: 18,
  mobile_iconSize: 28
}, or = [
  // Greeting text
  {
    key: "greetingTemplate",
    label: "Greeting Text",
    type: "text",
    group: "Greeting Text"
  },
  {
    key: "showUserName",
    label: "Show User Name",
    type: "toggle",
    group: "Greeting Text"
  },
  {
    key: "greetingFontSize",
    label: "Font Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Greeting Text",
    responsive: !0
  },
  {
    key: "greetingFontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Greeting Text"
  },
  {
    key: "greetingFontFamily",
    label: "Font Family",
    type: "font",
    group: "Greeting Text"
  },
  {
    key: "greetingColor",
    label: "Color",
    type: "color",
    group: "Greeting Text"
  },
  {
    key: "greetingMarginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Greeting Text",
    responsive: !0
  },
  // Icon
  {
    key: "iconType",
    label: "Icon Type",
    type: "options",
    options: [
      { label: "Brand Icon", value: "brand-icon" },
      { label: "Emoji", value: "emoji" }
    ],
    group: "Greeting Icon"
  },
  {
    key: "emoji",
    label: "Emoji",
    type: "text",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "emoji" }
  },
  {
    key: "brandIcon",
    label: "Icon",
    type: "icon",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 64,
    step: 4,
    group: "Greeting Icon",
    responsive: !0
  },
  {
    key: "iconColor",
    label: "Icon Color",
    type: "color",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconRotationAnimation",
    label: "Rotation Animation",
    type: "toggle",
    group: "Greeting Icon"
  },
  {
    key: "iconRotationDuration",
    label: "Rotation Speed (seconds)",
    type: "number",
    min: 1,
    max: 30,
    step: 1,
    group: "Greeting Icon",
    condition: "iconRotationAnimation"
  },
  {
    key: "iconMarginBottom",
    label: "Icon Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 4,
    group: "Greeting Icon"
  }
], cd = ({
  widgetId: e = "concierge-home-greeting",
  displayName: o = "Greeting",
  initialState: r = {},
  userName: n,
  showIcon: i = !1,
  iconPosition: l = "above"
}) => {
  const {
    state: s,
    isLoading: p,
    isSaving: g,
    handleEditChange: y,
    handleSave: c,
    resetField: h,
    savedKeys: x,
    themeColors: B,
    themeFonts: k,
    themeIcons: b,
    resolveColor: C,
    canSave: S
  } = U(
    e,
    { ...fl, ...r },
    or
  ), T = s.greetingFontFamily, m = T && T !== "inherit" ? k[T] : null, A = m && m.format === "google" ? m.url : null;
  if (Q(() => {
    A && yl(A);
  }, [A]), p)
    return /* @__PURE__ */ t(O, {});
  const f = m ? m.format === "system" ? m.url : `"${m.name}", sans-serif` : "inherit", z = m && m.format !== "system" && m.format !== "google", w = `greeting-${e || "default"}`, v = s.mobile_greetingFontSize ?? s.greetingFontSize, P = s.mobile_iconSize ?? s.iconSize, W = s.mobile_greetingMarginBottom ?? s.greetingMarginBottom, F = `
    ${z ? `
      @font-face {
        font-family: "${m.name}";
        src: url("${m.url}") format("${m.format}");
        font-display: swap;
      }
    ` : ""}
    ${f !== "inherit" ? `.${w} { font-family: ${f} !important; }` : ""}
    .${w}-wrap {
      margin-bottom: ${s.greetingMarginBottom}px;
    }
    @media (max-width: 767px) {
      .${w}-wrap {
        margin-bottom: ${W}px !important;
      }
      .${w}-text {
        font-size: ${v}px !important;
      }
      .${w}-icon {
        width: ${P}px !important;
        height: ${P}px !important;
      }
      .${w}-icon svg {
        width: ${P}px !important;
        height: ${P}px !important;
      }
    }
  `.trim();
  let L = s.greetingTemplate;
  s.showUserName && n ? L = L.replace("{name}", n) : (L = L.replace(/,?\s*\{name\}/g, "").replace(/^Hi\.$/, "Hello!"), L.trim() || (L = "Hello!"));
  const I = s.greetingFontWeight === "normal" ? 400 : s.greetingFontWeight === "medium" ? 500 : s.greetingFontWeight === "semibold" ? 600 : 700, R = C(s.iconColor), j = `greeting-icon-spin-${e || "default"}`, X = s.iconRotationAnimation ? `@keyframes ${j} { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }` : "", M = s.iconRotationAnimation ? {
    animation: `${j} ${s.iconRotationDuration}s linear infinite`
  } : {}, N = () => {
    if (!i) return null;
    let $ = null;
    return s.iconType === "emoji" ? $ = /* @__PURE__ */ t("span", { style: { fontSize: s.iconSize }, children: s.emoji }) : s.brandIcon && b[s.brandIcon] ? $ = /* @__PURE__ */ t(
      "div",
      {
        style: {
          width: s.iconSize,
          height: s.iconSize,
          backgroundColor: R,
          WebkitMaskImage: `url(${b[s.brandIcon].url})`,
          WebkitMaskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskImage: `url(${b[s.brandIcon].url})`,
          maskSize: "contain",
          maskRepeat: "no-repeat",
          maskPosition: "center"
        }
      }
    ) : $ = /* @__PURE__ */ t(bl, { size: s.iconSize, color: R }), /* @__PURE__ */ t(
      "div",
      {
        className: `${w}-icon`,
        style: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          ...M
        },
        children: $
      }
    );
  }, G = l === "inline", H = /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: F }),
    X && /* @__PURE__ */ t("style", { children: X }),
    /* @__PURE__ */ u(
      "div",
      {
        className: `${w}-wrap${f !== "inherit" ? ` ${w}` : ""}`,
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center"
        },
        children: [
          i && !G && /* @__PURE__ */ t("div", { style: { marginBottom: s.iconMarginBottom }, children: N() }),
          /* @__PURE__ */ u(
            "span",
            {
              className: `${w}-text`,
              style: {
                display: "inline-flex",
                alignItems: "center",
                gap: G && i ? 8 : 0,
                fontSize: s.greetingFontSize,
                fontWeight: I,
                color: C(s.greetingColor),
                lineHeight: 1.2
              },
              children: [
                i && G && N(),
                L
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: or,
      editValues: s,
      onEditChange: y,
      onSave: S ? c : void 0,
      isSaving: g,
      savedKeys: x,
      onResetField: h,
      themeColors: B,
      themeFonts: k,
      themeIcons: b,
      children: H
    }
  );
}, xl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Cl = {
  textTemplate: "I'm {concierge_name}, your shopping assistant for {brand}.",
  fontSize: 32,
  fontWeight: "semibold",
  fontFamily: "inherit",
  color: a("textPrimary"),
  lineHeight: 1.2,
  letterSpacing: 0.08,
  maxWidth: 830,
  marginTop: 0,
  marginBottom: 0,
  mobile_fontSize: 24
}, tr = [
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 32,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing",
    type: "number",
    min: -1,
    max: 2,
    step: 0.01
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 200,
    max: 900,
    step: 10
  },
  {
    key: "marginTop",
    label: "Spacing Above",
    type: "number",
    min: 0,
    max: 48,
    step: 4
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 48,
    step: 4
  }
], pd = ({
  widgetId: e = "concierge-home-subtitle",
  displayName: o = "Subtitle",
  initialState: r = {},
  brandName: n = "",
  conciergeName: i = "Concierge"
}) => {
  const {
    state: l,
    isLoading: s,
    isSaving: p,
    handleEditChange: g,
    handleSave: y,
    resetField: c,
    savedKeys: h,
    themeColors: x,
    themeFonts: B,
    resolveColor: k,
    canSave: b
  } = U(
    e,
    { ...Cl, ...r },
    tr
  ), C = l.fontFamily, S = C && C !== "inherit" ? B[C] : null, T = S && S.format === "google" ? S.url : null;
  if (Q(() => {
    T && xl(T);
  }, [T]), s)
    return /* @__PURE__ */ t(O, {});
  const m = S ? S.format === "system" ? S.url : `"${S.name}", sans-serif` : "inherit", A = S && S.format !== "system" && S.format !== "google", f = `subtitle-${e || "default"}`, z = l.mobile_fontSize ?? l.fontSize, w = `
    ${A ? `
      @font-face {
        font-family: "${S.name}";
        src: url("${S.url}") format("${S.format}");
        font-display: swap;
      }
    ` : ""}
    ${m !== "inherit" ? `.${f} { font-family: ${m} !important; }` : ""}
    @media (max-width: 767px) {
      .${f}-text {
        font-size: ${z}px !important;
      }
    }
  `.trim(), W = !n || n.toLowerCase() === "brandclub" ? `I'm ${i}, your Brandclub shopping assistant.` : l.textTemplate.replace("{concierge_name}", i).replace("{brand}", n), F = l.fontWeight === "normal" ? 400 : l.fontWeight === "medium" ? 500 : l.fontWeight === "semibold" ? 600 : 700, L = /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: w }),
    /* @__PURE__ */ t(
      "div",
      {
        className: m !== "inherit" ? f : void 0,
        style: {
          textAlign: "center",
          marginTop: l.marginTop,
          marginBottom: l.marginBottom,
          width: "100%"
        },
        children: /* @__PURE__ */ t(
          "p",
          {
            className: `${f}-text`,
            style: {
              fontSize: l.fontSize,
              fontWeight: F,
              color: k(l.color),
              lineHeight: l.lineHeight,
              letterSpacing: l.letterSpacing ? `${l.letterSpacing}px` : void 0,
              maxWidth: l.maxWidth,
              margin: "0 auto"
            },
            children: W
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: tr,
      editValues: l,
      onEditChange: g,
      onSave: b ? y : void 0,
      isSaving: p,
      savedKeys: h,
      onResetField: c,
      themeColors: x,
      themeFonts: B,
      children: L
    }
  );
}, kl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIxKSI+CjxwYXRoIGQ9Ik0xOC4wMDE3IDAuMDAwNjI1NjFDMjcuOTQyMyAwLjAwMDYyNTYxIDM2LjAwMjkgOC4wNTg5NSAzNi4wMDI5IDE4LjAwMTdDMzYuMDAyOSAyNy45NDQ1IDI3Ljk0NDUgMzYuMDAyOSAxOC4wMDE3IDM2LjAwMjlDOC4wNTg5NSAzNi4wMDI5IDAuMDAwNjI1NjEgMjcuOTQyMyAwLjAwMDYyNTYxIDE4LjAwMTdIMTguMDAxN1YwLjAwMDYyNTYxWiIgZmlsbD0iI0Q2OTM4QSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXIxIj4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", vl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIyKSI+CjxwYXRoIGQ9Ik0wIDM2QzAgMjYuMDU5MiA4LjA1OTIgMTggMTggMThDMjcuOTQwOCAxOCAzNiAyNi4wNTkyIDM2IDM2SDBaIiBmaWxsPSIjOEFCMkJGIi8+CjxwYXRoIGQ9Ik0zNiAwQzM2IDkuOTQwOCAyNy45NDA4IDE4IDE4IDE4QzguMDU5MiAxOCAwIDkuOTQwOCAwIDBIMzZaIiBmaWxsPSIjOEFCMkJGIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfc3RhcnRlcjIiPgo8cmVjdCB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+", Sl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIzKSI+CjxwYXRoIGQ9Ik0wIDBMMTggMThWMEgwWiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMzYgMFYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPHBhdGggZD0iTTM2IDM2TDE4IDE4VjM2SDM2WiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMCAzNlYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF9zdGFydGVyMyI+CjxyZWN0IHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=", wl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXI0KSI+CjxwYXRoIGQ9Ik0zMi41NjU4IDYuODg0NjdMMjYuNTYwOSAxNS4wODA2TDM2IDE4LjAwOUwyNi41NTg3IDIwLjkyODRMMzIuNTU2OCAyOS4xMzExTDIzLjI4NTkgMjUuNjU4NEwyMy41NTI5IDM2TDE3Ljk5NDQgMjcuNDYyMkwxMi40MjkyIDM1Ljk5NTVMMTIuNzA3MyAyNS42NTM5TDMuNDMxOTkgMjkuMTE3Nkw5LjQzOTA5IDIwLjkxOTRMMCAxNy45OTFMOS40NDEzNCAxNS4wNzE2TDMuNDQzMjEgNi44NzExN0wxMi43MTQxIDEwLjM0MzlMMTIuNDQ0OSAwTDE4LjAwMzQgOC41Mzc4TDIzLjU3MDggMC4wMDQ0OTgzMUwyMy4yOTI3IDEwLjM0ODRMMzIuNTY1OCA2Ljg4NDY3WiIgZmlsbD0iIzlBNzI2MSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXI0Ij4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", Bl = [
  kl,
  vl,
  Sl,
  wl
], zl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Fl = {
  // Pill styling
  pillPaddingX: 24,
  pillPaddingY: 12,
  pillBorderRadius: 28,
  pillBorderWidth: 1,
  pillBorderColor: a("borderColor"),
  pillBgColor: a("secondary"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillShadowEnabled: !0,
  pillShadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
  pillGap: 8,
  fontFamily: "inherit",
  // Card styling
  cardWidth: 183,
  cardHeight: 124,
  cardPadding: 16,
  cardBorderRadius: 12,
  cardBorderWidth: 0,
  cardBorderColor: a("borderColor"),
  cardBgColor: a("secondary"),
  cardBgColorHover: a("background"),
  cardTextColor: a("textPrimary"),
  cardFontSize: 14,
  cardGap: 12,
  cardIconSize: 32,
  // Default icons (will be replaced by bundled SVGs)
  starterIcon1: "",
  starterIcon2: "",
  starterIcon3: "",
  starterIcon4: "",
  // Container
  containerMaxWidth: 768,
  containerMarginTop: 16,
  // Mobile overrides
  mobile_pillFontSize: 12,
  mobile_pillPaddingX: 16,
  mobile_pillPaddingY: 12,
  mobile_cardGap: 8
}, rr = [
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    responsive: !0,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2,
    responsive: !0,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 28,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderColor",
    label: "Pill Border Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColor",
    label: "Pill Background",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColorHover",
    label: "Pill Bg (Hover)",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillTextColor",
    label: "Pill Text Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Pill Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  // Card styling
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 120,
    max: 240,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardHeight",
    label: "Card Height",
    type: "number",
    min: 80,
    max: 180,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColorHover",
    label: "Card Bg (Hover)",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardTextColor",
    label: "Card Text Color",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardFontSize",
    label: "Card Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 4,
    group: "Card Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardIconSize",
    label: "Card Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  // Icons
  {
    key: "starterIcon1",
    label: "Starter 1 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon2",
    label: "Starter 2 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon3",
    label: "Starter 3 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon4",
    label: "Starter 4 Icon",
    type: "icon",
    group: "Icons"
  },
  // Typography
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  },
  // Container
  {
    key: "containerMaxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 900,
    step: 50,
    group: "Container"
  },
  {
    key: "containerMarginTop",
    label: "Margin Top",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Container"
  }
], gd = ({
  widgetId: e = "concierge-home-starters",
  displayName: o = "Conversation Starters",
  initialState: r = {},
  mode: n,
  elementStyle: i = "default",
  cardLayoutDirection: l = "stacked",
  maxStarters: s = 4,
  queries: p,
  onSearch: g
}) => {
  const {
    state: y,
    isLoading: c,
    isSaving: h,
    handleEditChange: x,
    handleSave: B,
    resetField: k,
    savedKeys: b,
    themeColors: C,
    themeFonts: S,
    themeIcons: T,
    resolveColor: m,
    canSave: A
  } = U(
    e,
    { ...Fl, ...r, _startersMode: n },
    rr
  ), f = { ...y, _startersMode: n }, z = f.fontFamily, w = z && z !== "inherit" ? S[z] : null, v = w && w.format === "google" ? w.url : null;
  if (Q(() => {
    v && zl(v);
  }, [v]), c || n === "hidden" || p.length === 0)
    return /* @__PURE__ */ t(O, {});
  const P = w ? w.format === "system" ? w.url : `"${w.name}", sans-serif` : "inherit", W = w && w.format !== "system" && w.format !== "google", F = `starters-font-${e || "default"}`, L = `
    ${W ? `
      @font-face {
        font-family: "${w.name}";
        src: url("${w.url}") format("${w.format}");
        font-display: swap;
      }
    ` : ""}
    ${P !== "inherit" ? `.${F} { font-family: ${P} !important; }` : ""}
  `.trim(), I = p.slice(0, s), R = [
    f.starterIcon1,
    f.starterIcon2,
    f.starterIcon3,
    f.starterIcon4
  ], j = (J) => {
    const V = R[J];
    return V && T[V] ? T[V].url : Bl[J] || null;
  }, X = () => {
    if (i === "grey-fill" || i === "grey-fill-stroke")
      return "#f6f8fa";
  }, M = () => {
    if (i === "grey-fill-stroke")
      return "1px solid #e5e7eb";
    if (i === "grey-fill")
      return "none";
  }, N = (J) => J === "normal" ? 400 : J === "medium" ? 500 : J === "semibold" ? 600 : 700, G = (J, V) => {
    const ne = n === "pills-icons", K = j(V), re = X(), ee = M();
    return /* @__PURE__ */ u(
      "button",
      {
        className: "concierge-home-starters-pill",
        onClick: () => g(J),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: `${f.pillPaddingY}px ${f.pillPaddingX}px`,
          borderRadius: f.pillBorderRadius,
          border: ee ?? `${f.pillBorderWidth}px solid ${m(f.pillBorderColor)}`,
          backgroundColor: re ?? m(f.pillBgColor),
          color: m(f.pillTextColor),
          fontSize: f.pillFontSize,
          fontWeight: N(f.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          whiteSpace: "nowrap",
          boxShadow: f.pillShadowEnabled ? f.pillShadow : "none"
        },
        onMouseEnter: (ye) => {
          ye.currentTarget.style.backgroundColor = m(f.pillBgColorHover) || re || m(f.pillBgColor);
        },
        onMouseLeave: (ye) => {
          ye.currentTarget.style.backgroundColor = re ?? m(f.pillBgColor);
        },
        children: [
          ne && K && /* @__PURE__ */ t(
            "img",
            {
              src: K,
              alt: "",
              style: {
                width: 24,
                height: 24,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          J
        ]
      },
      V
    );
  }, H = (J, V) => {
    const ne = j(V), K = X(), re = M(), ee = l === "inline";
    return /* @__PURE__ */ u(
      "button",
      {
        onClick: () => g(J),
        style: {
          display: "flex",
          flexDirection: ee ? "row" : "column",
          alignItems: ee ? "center" : void 0,
          gap: ee ? "16px" : "12px",
          padding: f.cardPadding,
          borderRadius: f.cardBorderRadius,
          border: re ?? (f.cardBorderWidth > 0 ? `${f.cardBorderWidth}px solid ${m(f.cardBorderColor)}` : "none"),
          backgroundColor: K ?? m(f.cardBgColor),
          color: m(f.cardTextColor),
          fontSize: f.cardFontSize,
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          width: n === "cards-grid" ? "100%" : f.cardWidth,
          minHeight: ee ? void 0 : f.cardHeight,
          flexShrink: 0
        },
        onMouseEnter: (ye) => {
          ye.currentTarget.style.backgroundColor = m(f.cardBgColorHover) || K || m(f.cardBgColor);
        },
        onMouseLeave: (ye) => {
          ye.currentTarget.style.backgroundColor = K ?? m(f.cardBgColor);
        },
        children: [
          ne && /* @__PURE__ */ t(
            "img",
            {
              src: ne,
              alt: "",
              style: {
                width: f.cardIconSize,
                height: f.cardIconSize,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          /* @__PURE__ */ t("span", { style: { lineHeight: 1.4 }, children: J })
        ]
      },
      V
    );
  }, $ = (J, V) => {
    const ne = j(V), K = X(), re = M();
    return /* @__PURE__ */ u(
      "button",
      {
        className: "concierge-home-starters-pill",
        onClick: () => g(J),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
          padding: `${f.pillPaddingY}px ${f.pillPaddingX}px`,
          borderRadius: f.pillBorderRadius > 20 ? 10 : f.pillBorderRadius,
          border: re ?? `${f.pillBorderWidth}px solid ${m(f.pillBorderColor)}`,
          backgroundColor: K ?? m(f.pillBgColor),
          color: m(f.pillTextColor),
          fontSize: f.pillFontSize,
          fontWeight: N(f.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          boxSizing: "border-box"
        },
        onMouseEnter: (ee) => {
          ee.currentTarget.style.backgroundColor = m(f.pillBgColorHover) || K || m(f.pillBgColor);
        },
        onMouseLeave: (ee) => {
          ee.currentTarget.style.backgroundColor = K ?? m(f.pillBgColor);
        },
        children: [
          ne && /* @__PURE__ */ t(
            "img",
            {
              src: ne,
              alt: "",
              style: {
                width: 16,
                height: 16,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          J
        ]
      },
      V
    );
  }, Y = () => {
    if (n === "pills" || n === "pills-icons") {
      const J = f.pillShadowEnabled ? 16 : 0;
      return /* @__PURE__ */ t(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            gap: f.pillGap,
            justifyContent: "center",
            maxWidth: f.containerMaxWidth,
            margin: `0 auto -${J}px`,
            padding: `0 0 ${J}px`
          },
          className: "concierge-home-starters-pills",
          children: I.map((V, ne) => G(V, ne))
        }
      );
    }
    return n === "pills-icons-list" ? /* @__PURE__ */ t(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: f.pillGap,
          maxWidth: f.containerMaxWidth,
          margin: "0 auto",
          width: "100%"
        },
        className: "concierge-home-starters-pills-list",
        children: I.map((J, V) => $(J, V))
      }
    ) : n === "cards-row" ? /* @__PURE__ */ t(
      "div",
      {
        style: {
          display: "flex",
          gap: f.cardGap,
          justifyContent: "center",
          maxWidth: f.containerMaxWidth,
          margin: "0 auto",
          flexWrap: "wrap"
        },
        className: "concierge-home-starters-cards-row",
        children: I.map((J, V) => H(J, V))
      }
    ) : n === "cards-grid" ? /* @__PURE__ */ t(
      "div",
      {
        style: {
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: f.cardGap,
          maxWidth: f.containerMaxWidth,
          margin: "0 auto"
        },
        className: "concierge-home-starters-cards-grid",
        children: I.map((J, V) => H(J, V))
      }
    ) : null;
  }, q = /* @__PURE__ */ u(
    "div",
    {
      className: P !== "inherit" ? F : void 0,
      style: { marginTop: f.containerMarginTop, width: "100%" },
      children: [
        /* @__PURE__ */ t("style", { children: `
        ${L || ""}
        /* Responsive: pills become horizontally scrollable on mobile */
        @media (max-width: 767px) {
          .concierge-home-starters-pills {
            flex-wrap: nowrap !important;
            justify-content: flex-start !important;
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            padding-bottom: 4px;
          }
          .concierge-home-starters-pills::-webkit-scrollbar {
            display: none;
          }
          .concierge-home-starters-pill {
            padding: ${f.mobile_pillPaddingY ?? f.pillPaddingY}px ${f.mobile_pillPaddingX ?? f.pillPaddingX}px !important;
          }
          /* Cards row becomes 2-column grid on mobile */
          .concierge-home-starters-cards-row {
            display: grid !important;
            grid-template-columns: repeat(2, 1fr) !important;
            gap: ${f.mobile_cardGap}px !important;
          }
          .concierge-home-starters-cards-row > button {
            width: 100% !important;
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-row > button img {
            width: 16px !important;
            height: 16px !important;
          }
          /* Cards grid stays 2-column on mobile with compact sizing */
          .concierge-home-starters-cards-grid {
            gap: ${f.mobile_cardGap}px !important;
          }
          .concierge-home-starters-cards-grid > button {
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-grid > button img {
            width: 16px !important;
            height: 16px !important;
          }
        }
      ` }),
        Y()
      ]
    }
  );
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: rr,
      editValues: f,
      onEditChange: x,
      onSave: A ? B : void 0,
      isSaving: h,
      savedKeys: b,
      onResetField: k,
      themeColors: C,
      themeFonts: S,
      themeIcons: T,
      children: q
    }
  );
}, Il = {
  // Hamburger icon
  hamburgerIcon: "default",
  hamburgerIconSize: 32,
  hamburgerIconColor: a("textPrimary"),
  // Close icon
  closeIcon: "default",
  closeIconSize: 32,
  closeIconColor: a("textPrimary"),
  // Logo visibility
  showLogo: !0,
  // Layout
  navHeight: 80,
  navPaddingX: 24,
  navPaddingY: 24,
  navBgColor: a("transparent")
}, nr = [
  // Hamburger icon
  {
    key: "hamburgerIcon",
    label: "Menu Icon",
    type: "icon",
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconColor",
    label: "Color",
    type: "color",
    group: "Menu Icon"
  },
  // Close icon
  {
    key: "closeIcon",
    label: "Close Icon",
    type: "icon",
    group: "Close Icon"
  },
  {
    key: "closeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Close Icon"
  },
  {
    key: "closeIconColor",
    label: "Color",
    type: "color",
    group: "Close Icon"
  },
  // Logo visibility
  {
    key: "showLogo",
    label: "Show Logo",
    type: "toggle",
    group: "Logo"
  },
  // Layout
  {
    key: "navHeight",
    label: "Height",
    type: "number",
    min: 40,
    max: 120,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navBgColor",
    label: "Background",
    type: "color",
    group: "Layout"
  }
], md = ({
  widgetId: e = "concierge-home-mobile-nav",
  displayName: o = "Mobile Nav Header",
  initialState: r = {},
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeIcons: c,
    resolveColor: h,
    canSave: x
  } = U(
    e,
    { ...Il, ...r },
    nr
  ), B = i.hamburgerIcon && i.hamburgerIcon !== "default" ? c[i.hamburgerIcon] : null, k = i.closeIcon && i.closeIcon !== "default" ? c[i.closeIcon] : null, b = {
    hamburgerIconUrl: B ? B.url : null,
    closeIconUrl: k ? k.url : null
  };
  if (l)
    return /* @__PURE__ */ t(O, {});
  const C = n(i, b, h);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: nr,
      editValues: i,
      onEditChange: p,
      onSave: x ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeIcons: c,
      children: C
    }
  );
}, Pl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Tl = {
  // Carousel properties
  carouselGap: 15,
  itemWidth: 246,
  // Card container
  cardBorderColor: a("borderColor"),
  cardBorderRadius: 18,
  cardBgColor: a("transparent"),
  cardBgColorHover: a("background"),
  cardPaddingTop: 24,
  cardPaddingBottom: 16,
  cardPaddingSides: 12,
  // Title
  titleColor: a("textPrimary"),
  titleFontFamily: "inherit",
  titleFontSize: 18,
  titleFontWeight: 500,
  titleLineClamp: 2,
  titleLineHeight: 1.333,
  titleMarginTop: 0,
  // Price
  priceColor: a("textPrimary"),
  priceFontFamily: "inherit",
  priceFontSize: 24,
  priceFontSizeMobile: 16,
  priceFontWeight: 600,
  // Retailer icons
  retailerIconSize: 25,
  retailerIconSizeMobile: 15,
  showRetailers: !1,
  // Button
  buttonBgColor: a("textPrimary"),
  buttonTextColor: a("secondary"),
  buttonBorderRadius: 100,
  buttonFontSize: 16,
  buttonFontWeight: 600,
  buttonHeight: 42,
  // Review / Rating
  reviewColor: a("textPrimary"),
  reviewFontSize: 12,
  reviewFontWeight: 500,
  // Image container
  imageMaxWidth: 132
}, ir = [
  // Carousel properties
  {
    key: "carouselGap",
    label: "Gap Between Items (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 1,
    group: "Carousel"
  },
  {
    key: "itemWidth",
    label: "Item Width (Desktop)",
    type: "number",
    min: 150,
    max: 300,
    step: 10,
    group: "Carousel"
  },
  // Card container
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBgColorHover",
    label: "Card Hover Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardPaddingTop",
    label: "Card Padding Top (px)",
    type: "number",
    min: 0,
    max: 40,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardPaddingBottom",
    label: "Card Padding Bottom (px)",
    type: "number",
    min: 0,
    max: 40,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardPaddingSides",
    label: "Card Padding Sides (px)",
    type: "number",
    min: 0,
    max: 40,
    step: 2,
    group: "Card Container"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color", group: "Title" },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font",
    group: "Title"
  },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: He,
    group: "Title"
  },
  {
    key: "titleLineClamp",
    label: "Title Line Clamp",
    type: "number",
    min: 1,
    max: 5,
    step: 1,
    group: "Title"
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1,
    group: "Title"
  },
  {
    key: "titleMarginTop",
    label: "Title Margin Top (px)",
    type: "number",
    min: 0,
    max: 32,
    step: 2,
    group: "Title"
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color", group: "Price" },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font",
    group: "Price"
  },
  {
    key: "priceFontSize",
    label: "Price Font Size (Desktop)",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontSizeMobile",
    label: "Price Font Size (Mobile)",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: vt,
    group: "Price"
  },
  // Retailer icons
  {
    key: "showRetailers",
    label: "Show Retailer Icons",
    type: "toggle",
    group: "Retailer Icons"
  },
  {
    key: "retailerIconSize",
    label: "Retailer Icon Size (Desktop)",
    type: "number",
    min: 16,
    max: 40,
    step: 1,
    group: "Retailer Icons",
    condition: "showRetailers"
  },
  {
    key: "retailerIconSizeMobile",
    label: "Retailer Icon Size (Mobile)",
    type: "number",
    min: 12,
    max: 30,
    step: 1,
    group: "Retailer Icons",
    condition: "showRetailers"
  },
  // Button
  {
    key: "buttonBgColor",
    label: "Button Background",
    type: "color",
    group: "Button"
  },
  {
    key: "buttonTextColor",
    label: "Button Text Color",
    type: "color",
    group: "Button"
  },
  {
    key: "buttonBorderRadius",
    label: "Button Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Button"
  },
  {
    key: "buttonFontSize",
    label: "Button Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Button"
  },
  {
    key: "buttonFontWeight",
    label: "Button Font Weight",
    type: "options",
    options: vt,
    group: "Button"
  },
  {
    key: "buttonHeight",
    label: "Button Height (px)",
    type: "number",
    min: 32,
    max: 56,
    step: 2,
    group: "Button"
  },
  // Review / Rating
  {
    key: "reviewColor",
    label: "Review Color",
    type: "color",
    group: "Review"
  },
  {
    key: "reviewFontSize",
    label: "Review Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Review"
  },
  {
    key: "reviewFontWeight",
    label: "Review Font Weight",
    type: "options",
    options: He,
    group: "Review"
  },
  // Image
  {
    key: "imageMaxWidth",
    label: "Image Max Width (px)",
    type: "number",
    min: 120,
    max: 250,
    step: 10,
    group: "Image"
  }
], Ml = (e) => ({
  cardBorderColor: e.cardBorderColor,
  cardBorderRadius: e.cardBorderRadius,
  cardBgColor: e.cardBgColor,
  cardBgColorHover: e.cardBgColorHover,
  cardPaddingTop: e.cardPaddingTop,
  cardPaddingBottom: e.cardPaddingBottom,
  cardPaddingSides: e.cardPaddingSides,
  titleColor: e.titleColor,
  titleFontFamily: e.titleFontFamily,
  titleFontSize: e.titleFontSize,
  titleFontWeight: e.titleFontWeight,
  titleLineClamp: e.titleLineClamp,
  titleLineHeight: e.titleLineHeight,
  titleMarginTop: e.titleMarginTop,
  priceColor: e.priceColor,
  priceFontFamily: e.priceFontFamily,
  priceFontSize: e.priceFontSize,
  priceFontSizeMobile: e.priceFontSizeMobile,
  priceFontWeight: e.priceFontWeight,
  retailerIconSize: e.retailerIconSize,
  retailerIconSizeMobile: e.retailerIconSizeMobile,
  showRetailers: e.showRetailers,
  buttonBgColor: e.buttonBgColor,
  buttonTextColor: e.buttonTextColor,
  buttonBorderRadius: e.buttonBorderRadius,
  buttonFontSize: e.buttonFontSize,
  buttonFontWeight: e.buttonFontWeight,
  buttonHeight: e.buttonHeight,
  reviewColor: e.reviewColor,
  reviewFontSize: e.reviewFontSize,
  reviewFontWeight: e.reviewFontWeight,
  imageMaxWidth: e.imageMaxWidth
}), El = (e) => ({
  carouselGap: e.carouselGap,
  itemWidth: e.itemWidth
}), ud = ({ initialState: e = {}, widgetId: o, displayName: r, children: n }) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    resetField: y,
    savedKeys: c,
    themeColors: h,
    themeFonts: x,
    themeIcons: B,
    resolveColor: k,
    canSave: b,
    getEditValues: C
  } = U(
    o,
    { ...Tl, ...e },
    ir
  ), S = i.titleFontFamily, T = S && S !== "inherit" ? x[S] : null, m = T && T.format === "google" ? T.url : null, A = i.priceFontFamily, f = A && A !== "inherit" ? x[A] : null, z = f && f.format === "google" ? f.url : null, w = le(() => {
    const F = [];
    return m && !F.includes(m) && F.push(m), z && !F.includes(z) && F.push(z), F;
  }, [m, z]);
  if (Q(() => {
    for (const F of w)
      Pl(F);
  }, [w]), l)
    return /* @__PURE__ */ t(O, {});
  const v = Ml(i), P = El(i), W = n(
    v,
    P,
    x,
    k
  );
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: ir,
      editValues: C(),
      onEditChange: p,
      onSave: b ? g : void 0,
      isSaving: s,
      savedKeys: c,
      onResetField: y,
      themeColors: h,
      themeFonts: x,
      themeIcons: B,
      children: W
    }
  );
}, Wl = {
  // Container
  containerGap: 8,
  containerMarginTop: 8,
  // Add to Bag button (primary state)
  addButtonBgColor: a("primary"),
  addButtonTextColor: a("secondary"),
  addButtonHeight: 40,
  addButtonHeightMobile: 36,
  addButtonFontSize: 14,
  addButtonFontSizeMobile: 12,
  addButtonBorderRadius: 8,
  // Added to Bag button (success state)
  addedButtonBorderColor: a("textPrimary"),
  addedButtonBorderColorHover: a("textPrimary"),
  addedButtonTextColor: a("textPrimary"),
  addedButtonBgColorHover: a("background"),
  addedIconColor: a("textPrimary"),
  addedIconSize: 16,
  // Loading state
  loadingSpinnerColor: a("secondary"),
  loadingSpinnerSize: 14
}, ar = [
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Add to Bag button
  { key: "addButtonBgColor", label: "Add Button Background", type: "color" },
  { key: "addButtonTextColor", label: "Add Button Text", type: "color" },
  {
    key: "addButtonHeight",
    label: "Add Button Height",
    type: "number",
    min: 32,
    max: 56,
    step: 2
  },
  {
    key: "addButtonHeightMobile",
    label: "Add Button Height (Mobile)",
    type: "number",
    min: 28,
    max: 48,
    step: 2
  },
  {
    key: "addButtonFontSize",
    label: "Add Button Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "addButtonFontSizeMobile",
    label: "Add Button Font Size (Mobile)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "addButtonBorderRadius",
    label: "Add Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Added to Bag button
  {
    key: "addedButtonBorderColor",
    label: "Added Button Border",
    type: "color"
  },
  {
    key: "addedButtonBorderColorHover",
    label: "Added Button Border (Hover)",
    type: "color"
  },
  { key: "addedButtonTextColor", label: "Added Button Text", type: "color" },
  {
    key: "addedButtonBgColorHover",
    label: "Added Button Bg (Hover)",
    type: "color"
  },
  { key: "addedIconColor", label: "Added Icon Color", type: "color" },
  {
    key: "addedIconSize",
    label: "Added Icon Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Loading state
  { key: "loadingSpinnerColor", label: "Loading Spinner Color", type: "color" },
  {
    key: "loadingSpinnerSize",
    label: "Loading Spinner Size",
    type: "number",
    min: 10,
    max: 24,
    step: 2
  }
], hd = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    resolveColor: c,
    canSave: h
  } = U(
    o,
    { ...Wl, ...e },
    ar
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const x = n(i, c);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: ar,
      editValues: i,
      onEditChange: p,
      onSave: h ? g : void 0,
      isSaving: s,
      themeColors: y,
      children: x
    }
  );
}, Rl = {
  // Container
  containerBgColor: a("secondary"),
  containerGap: 16,
  // Image carousel
  imageBgColor: a("background"),
  imagePadding: 22,
  carouselArrowSize: 24,
  carouselArrowBgColor: a("secondary"),
  // Title
  titleColor: a("textPrimary"),
  titleFontSize: 24,
  titleFontWeight: "semibold",
  titleLetterSpacing: 0.08,
  // Rating
  ratingStarColor: a("primary"),
  ratingTextColor: a("textPrimary"),
  ratingFontSize: 14,
  // Price
  priceColor: a("textPrimary"),
  priceFontSize: 24,
  priceFontWeight: "semibold",
  priceLetterSpacing: 0.24,
  // Feature bullets
  featureTitleColor: a("textPrimary"),
  featureTitleFontSize: 16,
  featureBulletColor: a("textPrimary"),
  featureBulletFontSize: 12,
  // Primary CTA button
  primaryButtonBgColor: a("primary"),
  primaryButtonTextColor: a("secondary"),
  primaryButtonBorderRadius: 9999,
  primaryButtonHeight: 46,
  primaryButtonFontSize: 16,
  primaryButtonFontWeight: "semibold",
  // Secondary CTA button
  secondaryButtonBorderColor: a("primary"),
  secondaryButtonTextColor: a("primary"),
  secondaryButtonBorderRadius: 9999,
  secondaryButtonHeight: 46,
  secondaryButtonFontSize: 16,
  secondaryButtonFontWeight: "semibold",
  // Content section
  contentPadding: 0,
  contentGap: 12
}, lr = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 24,
    step: 4
  },
  // Image carousel
  { key: "imageBgColor", label: "Image Background", type: "color" },
  {
    key: "imagePadding",
    label: "Image Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "carouselArrowSize",
    label: "Carousel Arrow Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "carouselArrowBgColor",
    label: "Carousel Arrow Background",
    type: "color"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ae]
  },
  // Rating
  { key: "ratingStarColor", label: "Rating Star Color", type: "color" },
  { key: "ratingTextColor", label: "Rating Text Color", type: "color" },
  {
    key: "ratingFontSize",
    label: "Rating Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 18,
    max: 36,
    step: 2
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [...ae]
  },
  // Feature bullets
  { key: "featureTitleColor", label: "Features Title Color", type: "color" },
  {
    key: "featureTitleFontSize",
    label: "Features Title Size",
    type: "number",
    min: 14,
    max: 20,
    step: 1
  },
  { key: "featureBulletColor", label: "Feature Bullet Color", type: "color" },
  {
    key: "featureBulletFontSize",
    label: "Feature Bullet Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Primary CTA button
  {
    key: "primaryButtonBgColor",
    label: "Primary Button Background",
    type: "color"
  },
  {
    key: "primaryButtonTextColor",
    label: "Primary Button Text",
    type: "color"
  },
  {
    key: "primaryButtonBorderRadius",
    label: "Primary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "primaryButtonHeight",
    label: "Primary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "primaryButtonFontSize",
    label: "Primary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Secondary CTA button
  {
    key: "secondaryButtonBorderColor",
    label: "Secondary Button Border",
    type: "color"
  },
  {
    key: "secondaryButtonTextColor",
    label: "Secondary Button Text",
    type: "color"
  },
  {
    key: "secondaryButtonBorderRadius",
    label: "Secondary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "secondaryButtonHeight",
    label: "Secondary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "secondaryButtonFontSize",
    label: "Secondary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Content section
  {
    key: "contentPadding",
    label: "Content Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "contentGap",
    label: "Content Gap",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  }
], yd = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    resolveColor: c,
    canSave: h
  } = U(
    o,
    { ...Rl, ...e },
    lr
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const x = n(i, c);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: lr,
      editValues: i,
      onEditChange: p,
      onSave: h ? g : void 0,
      isSaving: s,
      themeColors: y,
      children: x
    }
  );
}, Al = {
  // Card styling
  cardBgColor: a("secondary"),
  cardBorderColor: a("borderColor"),
  cardBorderRadius: 8,
  cardShadowColor: a("primary"),
  cardShadowOpacity: 0.08,
  cardPadding: 12,
  // Retailer logo
  logoContainerSize: 40,
  logoContainerBgColor: a("background"),
  logoContainerBorderRadius: 50,
  // Card text
  cardTitleFontSize: 14,
  cardTitleFontWeight: "semibold",
  cardTitleColor: a("textPrimary"),
  cardSubtitleFontSize: 12,
  cardSubtitleColor: a("textPrimary"),
  // Card button
  cardButtonBgColor: a("background"),
  cardButtonTextColor: a("textPrimary"),
  cardButtonFontSize: 12,
  cardButtonBorderRadius: 18,
  cardButtonPaddingX: 14,
  cardButtonPaddingY: 4,
  // Search bar
  searchBgColor: a("secondary"),
  searchBorderColor: a("borderColor"),
  searchBorderRadius: 100,
  searchHeight: 44,
  searchPlaceholderColor: a("textPrimary"),
  searchTextColor: a("textPrimary"),
  searchIconColor: a("textPrimary"),
  // Detail panel
  panelBgColor: a("secondary"),
  panelWidth: 300,
  panelBorderRadius: 10,
  panelImageHeight: 164,
  // Status colors
  statusOpenColor: a("success"),
  statusClosedColor: a("error"),
  // Section titles
  sectionTitleFontSize: 12,
  sectionTitleFontWeight: "bold",
  sectionTitleColor: a("textPrimary"),
  // Loading/empty states
  loadingBgColor: a("background"),
  emptyStateTextColor: a("textPrimary"),
  emptyStateFontSize: 14
}, sr = [
  // Card styling
  { key: "cardBgColor", label: "Card Background", type: "color" },
  { key: "cardBorderColor", label: "Card Border Color", type: "color" },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  { key: "cardShadowColor", label: "Card Shadow Color", type: "color" },
  {
    key: "cardShadowOpacity",
    label: "Card Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Retailer logo
  {
    key: "logoContainerSize",
    label: "Logo Container Size",
    type: "number",
    min: 24,
    max: 56,
    step: 4
  },
  {
    key: "logoContainerBgColor",
    label: "Logo Container Background",
    type: "color"
  },
  {
    key: "logoContainerBorderRadius",
    label: "Logo Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Card text
  {
    key: "cardTitleFontSize",
    label: "Card Title Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "cardTitleFontWeight",
    label: "Card Title Weight",
    type: "options",
    options: [...ae]
  },
  { key: "cardTitleColor", label: "Card Title Color", type: "color" },
  {
    key: "cardSubtitleFontSize",
    label: "Card Subtitle Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  { key: "cardSubtitleColor", label: "Card Subtitle Color", type: "color" },
  // Card button
  { key: "cardButtonBgColor", label: "Card Button Background", type: "color" },
  { key: "cardButtonTextColor", label: "Card Button Text", type: "color" },
  {
    key: "cardButtonFontSize",
    label: "Card Button Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "cardButtonBorderRadius",
    label: "Card Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingX",
    label: "Card Button Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingY",
    label: "Card Button Padding Y",
    type: "number",
    min: 2,
    max: 12,
    step: 2
  },
  // Search bar
  { key: "searchBgColor", label: "Search Background", type: "color" },
  { key: "searchBorderColor", label: "Search Border Color", type: "color" },
  {
    key: "searchBorderRadius",
    label: "Search Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "searchHeight",
    label: "Search Height",
    type: "number",
    min: 36,
    max: 56,
    step: 2
  },
  {
    key: "searchPlaceholderColor",
    label: "Search Placeholder Color",
    type: "color"
  },
  { key: "searchTextColor", label: "Search Text Color", type: "color" },
  { key: "searchIconColor", label: "Search Icon Color", type: "color" },
  // Detail panel
  { key: "panelBgColor", label: "Panel Background", type: "color" },
  {
    key: "panelWidth",
    label: "Panel Width",
    type: "number",
    min: 240,
    max: 400,
    step: 20
  },
  {
    key: "panelBorderRadius",
    label: "Panel Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "panelImageHeight",
    label: "Panel Image Height",
    type: "number",
    min: 100,
    max: 240,
    step: 10
  },
  // Status colors
  { key: "statusOpenColor", label: "Status Open Color", type: "color" },
  { key: "statusClosedColor", label: "Status Closed Color", type: "color" },
  // Section titles
  {
    key: "sectionTitleFontSize",
    label: "Section Title Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "sectionTitleFontWeight",
    label: "Section Title Weight",
    type: "options",
    options: [...ae]
  },
  { key: "sectionTitleColor", label: "Section Title Color", type: "color" },
  // Loading/empty states
  { key: "loadingBgColor", label: "Loading Background", type: "color" },
  { key: "emptyStateTextColor", label: "Empty State Text", type: "color" },
  {
    key: "emptyStateFontSize",
    label: "Empty State Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  }
], bd = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    resolveColor: c,
    canSave: h
  } = U(
    o,
    { ...Al, ...e },
    sr
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const x = n(i, c);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: sr,
      editValues: i,
      onEditChange: p,
      onSave: h ? g : void 0,
      isSaving: s,
      themeColors: y,
      children: x
    }
  );
}, Ll = {
  // Container
  maxWidth: 600,
  paddingX: 16,
  paddingY: 16,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 18,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 16,
  // Order card
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Order info
  orderIdFontSize: 14,
  orderIdFontWeight: "semibold",
  orderIdColor: "#1a1a1a",
  orderDateFontSize: 13,
  orderDateColor: "#6b7280",
  orderStatusFontSize: 12,
  // Item styling
  itemImageSize: 48,
  itemTitleFontSize: 14,
  itemTitleColor: "#1a1a1a",
  itemPriceFontSize: 14,
  itemPriceColor: "#374151",
  // Total
  totalFontSize: 15,
  totalFontWeight: "semibold",
  totalColor: "#1a1a1a",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Ho = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, rn = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, Hl = (e) => new Date(e).toLocaleDateString("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric"
}), Nl = ({ size: e, color: o }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "2", children: [
  /* @__PURE__ */ t("path", { d: "M16.5 9.4L7.5 4.21M21 16V8C20.9996 7.6481 20.9071 7.3024 20.7315 6.99847C20.556 6.69454 20.3037 6.44327 20 6.27L13 2.27C12.696 2.09674 12.3511 2.0053 12 2.0053C11.6489 2.0053 11.304 2.09674 11 2.27L4 6.27C3.69626 6.44327 3.44398 6.69454 3.26846 6.99847C3.09294 7.3024 3.00036 7.6481 3 8V16C3.00036 16.3519 3.09294 16.6976 3.26846 17.0015C3.44398 17.3055 3.69626 17.5567 4 17.73L11 21.73C11.304 21.9033 11.6489 21.9947 12 21.9947C12.3511 21.9947 12.696 21.9033 13 21.73L20 17.73C20.3037 17.5567 20.556 17.3055 20.7315 17.0015C20.9071 16.6976 20.9996 16.3519 21 16Z", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M3.27002 6.96L12 12.01L20.73 6.96", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M12 22.08V12", strokeLinecap: "round", strokeLinejoin: "round" })
] }), dr = ({ size: e, color: o }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "2", children: [
  /* @__PURE__ */ t("path", { d: "M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M3 6H21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Dl = ({ item: e, state: o, onClick: r }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: r,
    style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      cursor: r ? "pointer" : "default"
    },
    children: [
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.itemImageSize,
            height: o.itemImageSize,
            borderRadius: 8,
            overflow: "hidden",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: e.imageUrl ? /* @__PURE__ */ t(
            "img",
            {
              src: e.imageUrl,
              alt: e.title || e.retailerSku,
              style: { width: "100%", height: "100%", objectFit: "cover" }
            }
          ) : /* @__PURE__ */ t(Nl, { size: o.itemImageSize * 0.5, color: "#9ca3af" })
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.itemTitleFontSize,
              color: o.itemTitleColor,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: e.title || e.retailerSku
          }
        ),
        /* @__PURE__ */ u(
          "div",
          {
            style: {
              display: "flex",
              gap: 8,
              fontSize: o.itemPriceFontSize,
              color: o.itemPriceColor
            },
            children: [
              /* @__PURE__ */ t("span", { children: rn(e.price) }),
              /* @__PURE__ */ u("span", { children: [
                "× ",
                e.quantity
              ] })
            ]
          }
        )
      ] })
    ]
  }
), Ol = ({ order: e, state: o, onOrderClick: r, onItemClick: n }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: r,
    style: {
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      cursor: r ? "pointer" : "default"
    },
    children: [
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 12
          },
          children: [
            /* @__PURE__ */ u("div", { children: [
              /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    fontSize: o.orderIdFontSize,
                    fontWeight: Ho(o.orderIdFontWeight),
                    color: o.orderIdColor
                  },
                  children: [
                    "Order #",
                    e.orderId.slice(-8).toUpperCase()
                  ]
                }
              ),
              e.retailerName && /* @__PURE__ */ t("div", { style: { fontSize: o.orderDateFontSize, color: o.orderDateColor, marginTop: 2 }, children: e.retailerName })
            ] }),
            /* @__PURE__ */ u("div", { style: { textAlign: "right" }, children: [
              /* @__PURE__ */ t("div", { style: { fontSize: o.orderDateFontSize, color: o.orderDateColor }, children: Hl(e.orderDate) }),
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    fontSize: o.orderStatusFontSize,
                    color: e.status === "delivered" ? "#10b981" : "#f59e0b",
                    marginTop: 2,
                    textTransform: "capitalize"
                  },
                  children: e.status
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: 10 }, children: [
        e.items.slice(0, 2).map((i, l) => /* @__PURE__ */ t(
          Dl,
          {
            item: i,
            state: o,
            onClick: n ? () => n(i) : void 0
          },
          l
        )),
        e.items.length > 2 && /* @__PURE__ */ u("div", { style: { fontSize: o.itemTitleFontSize, color: o.orderDateColor }, children: [
          "+",
          e.items.length - 2,
          " more item",
          e.items.length - 2 !== 1 ? "s" : ""
        ] })
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: 12,
            paddingTop: 12,
            borderTop: `1px solid ${o.cardBorderColor}`
          },
          children: [
            /* @__PURE__ */ t("span", { style: { fontSize: o.totalFontSize, color: o.orderDateColor }, children: "Total" }),
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: o.totalFontSize,
                  fontWeight: Ho(o.totalFontWeight),
                  color: o.totalColor
                },
                children: rn(e.totalAmount)
              }
            )
          ]
        }
      )
    ]
  }
), fd = ({
  widgetId: e,
  orders: o,
  isAuthenticated: r = !0,
  isLoading: n = !1,
  error: i,
  onOrderClick: l,
  onItemClick: s,
  emptyMessage: p = "No orders yet",
  className: g,
  children: y
}) => {
  const { state: c } = U(
    e,
    Ll,
    []
    // No edit fields for now
  );
  return y ? /* @__PURE__ */ t(O, { children: y(c, o) }) : n ? /* @__PURE__ */ t(
    "div",
    {
      className: g,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        textAlign: "center"
      },
      children: /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor }, children: "Loading orders..." })
    }
  ) : i ? /* @__PURE__ */ t(
    "div",
    {
      className: g,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        textAlign: "center"
      },
      children: /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: "#ef4444" }, children: i })
    }
  ) : r ? o.length === 0 ? /* @__PURE__ */ u(
    "div",
    {
      className: g,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ t(dr, { size: c.emptyIconSize, color: c.emptyTextColor }),
        /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor, marginTop: 12 }, children: p })
      ]
    }
  ) : /* @__PURE__ */ u(
    "div",
    {
      className: g,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        backgroundColor: c.backgroundColor,
        borderRadius: c.borderRadius
      },
      children: [
        /* @__PURE__ */ u(
          "h3",
          {
            style: {
              fontSize: c.headerFontSize,
              fontWeight: Ho(c.headerFontWeight),
              color: c.headerColor,
              marginBottom: c.headerMarginBottom,
              margin: 0,
              marginBlockEnd: c.headerMarginBottom
            },
            children: [
              o.length,
              " Order",
              o.length !== 1 ? "s" : ""
            ]
          }
        ),
        /* @__PURE__ */ t("div", { style: { display: "flex", flexDirection: "column", gap: c.cardGap }, children: o.map((h) => /* @__PURE__ */ t(
          Ol,
          {
            order: h,
            state: c,
            onOrderClick: l ? () => l(h) : void 0,
            onItemClick: s ? (x) => s(x, h) : void 0
          },
          h.orderId
        )) })
      ]
    }
  ) : /* @__PURE__ */ u(
    "div",
    {
      className: g,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ t(dr, { size: c.emptyIconSize, color: c.emptyTextColor }),
        /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor, marginTop: 12 }, children: "Please login to view your order history" })
      ]
    }
  );
}, jl = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 12,
  cardGap: 12,
  // Product image
  imageSize: 64,
  imageBorderRadius: 8,
  // Content
  titleFontSize: 14,
  titleFontWeight: "medium",
  titleColor: "#1a1a1a",
  brandNameFontSize: 12,
  brandNameColor: "#6b7280",
  // Price
  priceFontSize: 14,
  priceColor: "#1a1a1a",
  // Reward badge
  rewardFontSize: 13,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Urgency badge
  urgencyFontSize: 11,
  urgencyColor: "#dc2626",
  urgencyBgColor: "#fef2f2",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Gl = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], cr = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Image
  {
    key: "imageSize",
    label: "Image Size",
    type: "number",
    min: 48,
    max: 120,
    step: 8,
    group: "Image"
  },
  {
    key: "imageBorderRadius",
    label: "Image Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Image"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Gl,
    group: "Title"
  },
  // Brand
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  }
], No = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, Do = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, $l = ({
  size: e,
  color: o
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Yl = ({ deal: e, state: o, onClick: r }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: r,
    style: {
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      cursor: r ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      r && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.imageUrl && /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.imageSize,
            height: o.imageSize,
            borderRadius: o.imageBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ t(
            "img",
            {
              src: e.imageUrl,
              alt: e.title,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.brandNameFontSize,
              color: o.brandNameColor,
              marginBottom: 2
            },
            children: e.brandName
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.titleFontSize,
              fontWeight: No(o.titleFontWeight),
              color: o.titleColor,
              marginBottom: 4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.title
          }
        ),
        e.price && /* @__PURE__ */ t("div", { style: { fontSize: o.priceFontSize, color: o.priceColor }, children: Do(e.price) }),
        e.retailerName && /* @__PURE__ */ u(
          "div",
          {
            style: {
              fontSize: o.brandNameFontSize,
              color: o.brandNameColor,
              marginTop: 4
            },
            children: [
              "at ",
              e.retailerName
            ]
          }
        )
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 6,
            flexShrink: 0
          },
          children: [
            /* @__PURE__ */ u(
              "div",
              {
                style: {
                  fontSize: o.rewardFontSize,
                  fontWeight: No(o.rewardFontWeight),
                  color: o.rewardColor,
                  backgroundColor: o.rewardBgColor,
                  padding: "6px 10px",
                  borderRadius: o.rewardBorderRadius,
                  whiteSpace: "nowrap"
                },
                children: [
                  "+",
                  Do(e.rewardAmount)
                ]
              }
            ),
            (e.isLimitedQuantity || e.expiresAt) && /* @__PURE__ */ t(
              "div",
              {
                style: {
                  fontSize: o.urgencyFontSize,
                  color: o.urgencyColor,
                  backgroundColor: o.urgencyBgColor,
                  padding: "3px 8px",
                  borderRadius: 4,
                  whiteSpace: "nowrap"
                },
                children: e.isLimitedQuantity ? "🔥 Limited" : "⏰ Limited Time"
              }
            )
          ]
        }
      )
    ]
  }
), xd = ({
  widgetId: e,
  displayName: o = "Daily Deals",
  deals: r,
  isLoading: n = !1,
  error: i,
  onDealClick: l,
  headerText: s,
  showHeader: p = !0,
  emptyMessage: g = "No daily deals available right now",
  className: y,
  children: c
}) => {
  const {
    state: h,
    handleEditChange: x,
    handleSave: B,
    isSaving: k,
    themeColors: b,
    themeFonts: C,
    canSave: S
  } = U(
    e,
    jl,
    cr
  );
  if (c)
    return /* @__PURE__ */ t(O, { children: c(h, r) });
  if (n)
    return /* @__PURE__ */ t(
      "div",
      {
        className: y,
        style: {
          maxWidth: h.maxWidth,
          padding: `${h.paddingY}px ${h.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: h.emptyTextFontSize,
              color: h.emptyTextColor
            },
            children: "Finding today's deals..."
          }
        )
      }
    );
  if (i)
    return /* @__PURE__ */ t(
      "div",
      {
        className: y,
        style: {
          maxWidth: h.maxWidth,
          padding: `${h.paddingY}px ${h.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: h.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (r.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: y,
        style: {
          maxWidth: h.maxWidth,
          padding: `${h.paddingY}px ${h.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ t($l, { size: h.emptyIconSize, color: h.emptyTextColor }),
          /* @__PURE__ */ t(
            "div",
            {
              style: {
                fontSize: h.emptyTextFontSize,
                color: h.emptyTextColor,
                marginTop: 12
              },
              children: g
            }
          )
        ]
      }
    );
  const T = r.reduce((f, z) => f + z.rewardAmount, 0), m = s || `${r.length} Daily Deal${r.length !== 1 ? "s" : ""} (${Do(T)} cashback)`, A = /* @__PURE__ */ u(
    "div",
    {
      className: y,
      style: {
        maxWidth: h.maxWidth,
        padding: `${h.paddingY}px ${h.paddingX}px`,
        backgroundColor: h.backgroundColor,
        borderRadius: h.borderRadius
      },
      children: [
        p && /* @__PURE__ */ t(
          "h3",
          {
            style: {
              fontSize: h.headerFontSize,
              fontWeight: No(h.headerFontWeight),
              color: h.headerColor,
              marginBottom: h.headerMarginBottom,
              margin: 0,
              marginBlockEnd: h.headerMarginBottom
            },
            children: m
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            style: { display: "flex", flexDirection: "column", gap: h.cardGap },
            children: r.map((f) => /* @__PURE__ */ t(
              Yl,
              {
                deal: f,
                state: h,
                onClick: l ? () => l(f) : void 0
              },
              f.stacklineSku
            ))
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: cr,
      editValues: h,
      onEditChange: x,
      onSave: S ? B : void 0,
      isSaving: k,
      themeColors: b,
      themeFonts: C,
      children: A
    }
  );
}, nn = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Brand logo
  brandLogoSize: 48,
  brandLogoBorderRadius: 8,
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#181d56",
  // Brandclub primary color
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Meta info
  metaFontSize: 12,
  metaColor: "#9ca3af",
  // Reward badge
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Survey badge
  surveyBadgeFontSize: 11,
  surveyBadgeColor: "#1d4ed8",
  surveyBadgeBgColor: "#dbeafe",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Ql = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], pr = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Brand logo
  {
    key: "brandLogoSize",
    label: "Logo Size",
    type: "number",
    min: 32,
    max: 80,
    step: 4,
    group: "Logo"
  },
  {
    key: "brandLogoBorderRadius",
    label: "Logo Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Logo"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Ql,
    group: "Title"
  },
  // Brand name
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  },
  // Survey badge
  {
    key: "surveyBadgeColor",
    label: "Badge Text Color",
    type: "color",
    group: "Badge"
  },
  {
    key: "surveyBadgeBgColor",
    label: "Badge Background",
    type: "color",
    group: "Badge"
  }
], Oo = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, an = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, Xl = ({ size: e, color: o }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "2", children: [
  /* @__PURE__ */ t("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("rect", { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M9 12h6", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M9 16h6", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Jl = ({ survey: e, state: o, onClick: r }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: r,
    style: {
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      cursor: r ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      r && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      (e.previewImageUrl || e.brandLogoUrl) && /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.brandLogoSize,
            height: o.brandLogoSize,
            borderRadius: o.brandLogoBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ t(
            "img",
            {
              src: e.previewImageUrl || e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }, children: [
          /* @__PURE__ */ t(
            "span",
            {
              style: {
                fontSize: o.surveyBadgeFontSize,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: 4,
                backgroundColor: o.surveyBadgeBgColor,
                color: o.surveyBadgeColor,
                whiteSpace: "nowrap"
              },
              children: "📋 Survey"
            }
          ),
          /* @__PURE__ */ t("span", { style: { fontSize: o.brandNameFontSize, color: o.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.titleFontSize,
              fontWeight: Oo(o.titleFontWeight),
              color: o.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.descriptionFontSize,
              color: o.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        /* @__PURE__ */ u("div", { style: { display: "flex", gap: 12, marginTop: 6 }, children: [
          e.estimatedMinutes && /* @__PURE__ */ u("span", { style: { fontSize: o.metaFontSize, color: o.metaColor }, children: [
            "~",
            e.estimatedMinutes,
            " min"
          ] }),
          e.questionCount && /* @__PURE__ */ u("span", { style: { fontSize: o.metaFontSize, color: o.metaColor }, children: [
            e.questionCount,
            " questions"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: o.rewardFontSize,
            fontWeight: Oo(o.rewardFontWeight),
            color: o.rewardColor,
            backgroundColor: o.rewardBgColor,
            padding: "6px 10px",
            borderRadius: o.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            an(e.rewardAmount)
          ]
        }
      )
    ]
  }
), Cd = ({
  widgetId: e,
  displayName: o = "Surveys",
  surveys: r,
  isLoading: n = !1,
  error: i,
  onSurveyClick: l,
  headerText: s,
  showHeader: p = !0,
  emptyMessage: g = "No surveys available right now",
  className: y,
  children: c
}) => {
  const {
    state: h,
    handleEditChange: x,
    handleSave: B,
    isSaving: k,
    themeColors: b,
    themeFonts: C,
    canSave: S
  } = U(
    e,
    nn,
    pr
  );
  if (c)
    return /* @__PURE__ */ t(O, { children: c(h, r) });
  if (n)
    return /* @__PURE__ */ t(
      "div",
      {
        className: y,
        style: {
          maxWidth: h.maxWidth,
          padding: `${h.paddingY}px ${h.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: h.emptyTextFontSize, color: h.emptyTextColor }, children: "Finding available surveys..." })
      }
    );
  if (i)
    return /* @__PURE__ */ t(
      "div",
      {
        className: y,
        style: {
          maxWidth: h.maxWidth,
          padding: `${h.paddingY}px ${h.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: h.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (r.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: y,
        style: {
          maxWidth: h.maxWidth,
          padding: `${h.paddingY}px ${h.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ t(Xl, { size: h.emptyIconSize, color: h.emptyTextColor }),
          /* @__PURE__ */ t("div", { style: { fontSize: h.emptyTextFontSize, color: h.emptyTextColor, marginTop: 12 }, children: g })
        ]
      }
    );
  const T = r.reduce((f, z) => f + z.rewardAmount, 0), m = s || `${r.length} Survey${r.length !== 1 ? "s" : ""} (${an(T)} potential)`, A = /* @__PURE__ */ u(
    "div",
    {
      className: y,
      style: {
        maxWidth: h.maxWidth,
        padding: `${h.paddingY}px ${h.paddingX}px`,
        backgroundColor: h.backgroundColor,
        borderRadius: h.borderRadius
      },
      children: [
        p && /* @__PURE__ */ t(
          "h3",
          {
            style: {
              fontSize: h.headerFontSize,
              fontWeight: Oo(h.headerFontWeight),
              color: h.headerColor,
              marginBottom: h.headerMarginBottom,
              margin: 0,
              marginBlockEnd: h.headerMarginBottom
            },
            children: m
          }
        ),
        /* @__PURE__ */ t("div", { style: { display: "flex", flexDirection: "column", gap: h.cardGap }, children: r.map((f) => /* @__PURE__ */ t(
          Jl,
          {
            survey: f,
            state: h,
            onClick: l ? () => l(f) : void 0
          },
          f.campaignId
        )) })
      ]
    }
  );
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: e,
      displayName: o,
      editFields: pr,
      editValues: h,
      onEditChange: x,
      onSave: S ? B : void 0,
      isSaving: k,
      themeColors: b,
      themeFonts: C,
      children: A
    }
  );
}, Zl = "#181d56", gr = {
  bg: "rgba(162, 34, 114, 0.3)",
  text: "rgb(162, 34, 114)"
}, Ul = "https://media.brandclub.com/brandclub/image_asset/survey-reward-icon.webp", _l = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, Vl = (e) => `https://media.brandclub.com/b/428x428/${e}.jpg`, ql = ({
  size: e = 40,
  color: o = "#9ca3af"
}) => /* @__PURE__ */ u(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9 12H15",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9 16H13",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), kd = ({
  survey: e,
  state: o,
  onClick: r,
  className: n,
  width: i = 280
}) => {
  const [l, s] = D(!1);
  ({ ...nn, ...o });
  const p = () => {
    r ? r() : window.location.href = `/survey/${e.campaignId}`;
  }, g = e.brandLogoUrl || (e.brandId ? Vl(e.brandId) : void 0), y = !!g;
  return /* @__PURE__ */ u(
    "div",
    {
      className: n,
      onClick: p,
      onMouseEnter: () => s(!0),
      onMouseLeave: () => s(!1),
      style: {
        width: typeof i == "number" ? `${i}px` : i,
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: l ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
        display: "flex",
        flexDirection: "column"
      },
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              height: 160,
              backgroundColor: "#ffffff",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20
            },
            children: y ? /* @__PURE__ */ t(
              "img",
              {
                src: g,
                alt: e.brandName,
                style: {
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain"
                }
              }
            ) : /* @__PURE__ */ t(ql, { size: 48, color: "#d1d5db" })
          }
        ),
        /* @__PURE__ */ u(
          "div",
          {
            style: {
              padding: 16,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f9fafb"
            },
            children: [
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    fontSize: 15,
                    fontWeight: 600,
                    color: Zl,
                    lineHeight: 1.4,
                    marginBottom: 6,
                    height: 42,
                    // Fixed height for 2 lines (15px * 1.4 * 2)
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.title
                }
              ),
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    fontSize: 13,
                    color: "#6b7280",
                    lineHeight: 1.5,
                    marginBottom: 12,
                    height: 20,
                    // Fixed height for 1 line
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.description || `Share your feedback with ${e.brandName}.`
                }
              ),
              /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 7
                  },
                  children: [
                    /* @__PURE__ */ u(
                      "div",
                      {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          backgroundColor: gr.bg,
                          color: gr.text,
                          borderRadius: 25,
                          padding: "5px 13px",
                          fontSize: 14,
                          fontWeight: 600
                        },
                        children: [
                          /* @__PURE__ */ t(
                            "img",
                            {
                              src: Ul,
                              alt: "survey-reward-icon",
                              style: {
                                width: 14,
                                height: 14,
                                objectFit: "contain"
                              }
                            }
                          ),
                          /* @__PURE__ */ t("span", { children: _l(e.rewardAmount) })
                        ]
                      }
                    ),
                    /* @__PURE__ */ t(
                      "span",
                      {
                        style: {
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#181d56"
                        },
                        children: "survey reward"
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Kl = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Type badge
  typeBadgeFontSize: 11,
  typeBadgePaddingX: 8,
  typeBadgePaddingY: 4,
  typeBadgeBorderRadius: 4,
  surveyBadgeBgColor: "#dbeafe",
  surveyBadgeTextColor: "#1d4ed8",
  contentBadgeBgColor: "#fce7f3",
  contentBadgeTextColor: "#be185d",
  membershipBadgeBgColor: "#d1fae5",
  membershipBadgeTextColor: "#047857",
  reviewBadgeBgColor: "#fef3c7",
  reviewBadgeTextColor: "#b45309",
  referralBadgeBgColor: "#e0e7ff",
  referralBadgeTextColor: "#4338ca",
  affiliateBadgeBgColor: "#f3e8ff",
  affiliateBadgeTextColor: "#7c3aed",
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Reward amount
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Brand logo
  brandLogoSize: 40,
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, jo = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, ln = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, es = {
  survey: "📋 Survey",
  content: "🎬 Content",
  membership: "🏆 Club",
  review: "⭐ Review",
  referral: "👥 Referral",
  affiliate: "🔗 Affiliate"
}, os = ({ size: e, color: o }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "2", children: [
  /* @__PURE__ */ t("rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M12 8V21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M19 12V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V12", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M7.5 8C6.67157 8 6 7.32843 6 6.5C6 5.67157 6.67157 5 7.5 5C9.5 5 12 8 12 8C12 8 14.5 5 16.5 5C17.3284 5 18 5.67157 18 6.5C18 7.32843 17.3284 8 16.5 8", strokeLinecap: "round", strokeLinejoin: "round" })
] }), ts = ({ type: e, state: o }) => {
  const n = ((i) => {
    switch (i) {
      case "survey":
        return { bg: o.surveyBadgeBgColor, text: o.surveyBadgeTextColor };
      case "content":
        return { bg: o.contentBadgeBgColor, text: o.contentBadgeTextColor };
      case "membership":
        return { bg: o.membershipBadgeBgColor, text: o.membershipBadgeTextColor };
      case "review":
        return { bg: o.reviewBadgeBgColor, text: o.reviewBadgeTextColor };
      case "referral":
        return { bg: o.referralBadgeBgColor, text: o.referralBadgeTextColor };
      case "affiliate":
        return { bg: o.affiliateBadgeBgColor, text: o.affiliateBadgeTextColor };
      default:
        return { bg: "#f3f4f6", text: "#374151" };
    }
  })(e);
  return /* @__PURE__ */ t(
    "span",
    {
      style: {
        fontSize: o.typeBadgeFontSize,
        fontWeight: 600,
        padding: `${o.typeBadgePaddingY}px ${o.typeBadgePaddingX}px`,
        borderRadius: o.typeBadgeBorderRadius,
        backgroundColor: n.bg,
        color: n.text,
        whiteSpace: "nowrap"
      },
      children: es[e] || e
    }
  );
}, rs = ({ opportunity: e, state: o, onClick: r }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: r,
    style: {
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      cursor: r ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      r && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.brandLogoUrl && /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.brandLogoSize,
            height: o.brandLogoSize,
            borderRadius: 8,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ t(
            "img",
            {
              src: e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }, children: [
          /* @__PURE__ */ t(ts, { type: e.type, state: o }),
          /* @__PURE__ */ t("span", { style: { fontSize: o.brandNameFontSize, color: o.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.titleFontSize,
              fontWeight: jo(o.titleFontWeight),
              color: o.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.descriptionFontSize,
              color: o.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        e.estimatedMinutes && /* @__PURE__ */ u(
          "div",
          {
            style: {
              fontSize: o.descriptionFontSize,
              color: o.descriptionColor,
              marginTop: 4
            },
            children: [
              "~",
              e.estimatedMinutes,
              " min"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: o.rewardFontSize,
            fontWeight: jo(o.rewardFontWeight),
            color: o.rewardColor,
            backgroundColor: o.rewardBgColor,
            padding: "6px 10px",
            borderRadius: o.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            ln(e.rewardAmount)
          ]
        }
      )
    ]
  }
), vd = ({
  widgetId: e,
  opportunities: o,
  isLoading: r = !1,
  error: n,
  onOpportunityClick: i,
  headerText: l,
  showHeader: s = !0,
  emptyMessage: p = "No reward opportunities available",
  className: g,
  children: y
}) => {
  const { state: c } = U(
    e,
    Kl,
    []
    // No edit fields for now
  );
  if (y)
    return /* @__PURE__ */ t(O, { children: y(c, o) });
  if (r)
    return /* @__PURE__ */ t(
      "div",
      {
        className: g,
        style: {
          maxWidth: c.maxWidth,
          padding: `${c.paddingY}px ${c.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor }, children: "Finding reward opportunities..." })
      }
    );
  if (n)
    return /* @__PURE__ */ t(
      "div",
      {
        className: g,
        style: {
          maxWidth: c.maxWidth,
          padding: `${c.paddingY}px ${c.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: "#ef4444" }, children: n })
      }
    );
  if (o.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: g,
        style: {
          maxWidth: c.maxWidth,
          padding: `${c.paddingY}px ${c.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ t(os, { size: c.emptyIconSize, color: c.emptyTextColor }),
          /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor, marginTop: 12 }, children: p })
        ]
      }
    );
  const h = o.reduce((B, k) => B + k.rewardAmount, 0), x = l || `${o.length} Reward Opportunity${o.length !== 1 ? "s" : ""} (${ln(h)} potential)`;
  return /* @__PURE__ */ u(
    "div",
    {
      className: g,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        backgroundColor: c.backgroundColor,
        borderRadius: c.borderRadius
      },
      children: [
        s && /* @__PURE__ */ t(
          "h3",
          {
            style: {
              fontSize: c.headerFontSize,
              fontWeight: jo(c.headerFontWeight),
              color: c.headerColor,
              marginBottom: c.headerMarginBottom,
              margin: 0,
              marginBlockEnd: c.headerMarginBottom
            },
            children: x
          }
        ),
        /* @__PURE__ */ t("div", { style: { display: "flex", flexDirection: "column", gap: c.cardGap }, children: o.map((B) => /* @__PURE__ */ t(
          rs,
          {
            opportunity: B,
            state: c,
            onClick: i ? () => i(B) : void 0
          },
          B.id || B.campaignId || `${B.type}-${B.title}`
        )) })
      ]
    }
  );
}, ns = {
  // Container
  maxWidth: 900,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 18,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 16,
  // Product card
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 12,
  cardGap: 12,
  // Product image
  imageSize: 120,
  imageBorderRadius: 8,
  // Product title
  titleFontSize: 14,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  titleMaxLines: 2,
  // Brand name
  brandFontSize: 12,
  brandColor: "#6b7280",
  // Price
  priceFontSize: 16,
  priceFontWeight: "bold",
  priceColor: "#1a1a1a",
  // Reward
  rewardFontSize: 12,
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  // Rating
  ratingStarSize: 14,
  ratingStarColor: "#f59e0b",
  ratingStarEmptyColor: "#d1d5db",
  ratingTextFontSize: 12,
  ratingTextColor: "#6b7280",
  // Comparison table
  rowBgColor: "#ffffff",
  rowBgColorAlt: "#f9fafb",
  rowBorderColor: "#e5e7eb",
  labelFontSize: 13,
  labelFontWeight: "medium",
  labelColor: "#374151",
  valueFontSize: 13,
  valueColor: "#1a1a1a",
  // Highlight
  highlightBgColor: "#ecfdf5",
  highlightBorderColor: "#10b981",
  // Empty state
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, ao = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, Go = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, is = ({ rating: e, maxRating: o = 5, starSize: r, starColor: n, emptyColor: i }) => {
  const l = [];
  for (let s = 1; s <= o; s++) {
    const p = Math.min(Math.max(e - s + 1, 0), 1) * 100;
    l.push(
      /* @__PURE__ */ u("svg", { width: r, height: r, viewBox: "0 0 24 24", children: [
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ u("linearGradient", { id: `star-fill-${s}-${e}`, children: [
          /* @__PURE__ */ t("stop", { offset: `${p}%`, stopColor: n }),
          /* @__PURE__ */ t("stop", { offset: `${p}%`, stopColor: i })
        ] }) }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: `url(#star-fill-${s}-${e})`,
            d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          }
        )
      ] }, s)
    );
  }
  return /* @__PURE__ */ t("div", { style: { display: "flex", gap: 2 }, children: l });
}, as = ({ size: e, color: o }) => /* @__PURE__ */ t("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "1.5", children: /* @__PURE__ */ t("path", { d: "M16.5 9.4L7.5 4.21M21 16V8C20.9996 7.6481 20.9071 7.3024 20.7315 6.99847C20.556 6.69454 20.3037 6.44327 20 6.27L13 2.27C12.696 2.09674 12.3511 2.0053 12 2.0053C11.6489 2.0053 11.304 2.09674 11 2.27L4 6.27C3.69626 6.44327 3.44398 6.69454 3.26846 6.99847C3.09294 7.3024 3.00036 7.6481 3 8V16C3.00036 16.3519 3.09294 16.6976 3.26846 17.0015C3.44398 17.3055 3.69626 17.5567 4 17.73L11 21.73C11.304 21.9033 11.6489 21.9947 12 21.9947C12.3511 21.9947 12.696 21.9033 13 21.73L20 17.73C20.3037 17.5567 20.556 17.3055 20.7315 17.0015C20.9071 16.6976 20.9996 16.3519 21 16Z", strokeLinecap: "round", strokeLinejoin: "round" }) }), ls = ({
  product: e,
  state: o,
  onClick: r,
  onAddToCart: n,
  showAddToCart: i
}) => /* @__PURE__ */ u(
  "div",
  {
    style: {
      flex: 1,
      minWidth: 150,
      maxWidth: 220,
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 8,
      cursor: r ? "pointer" : "default"
    },
    onClick: r,
    children: [
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.imageSize,
            height: o.imageSize,
            borderRadius: o.imageBorderRadius,
            overflow: "hidden",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          children: e.imageUrl ? /* @__PURE__ */ t(
            "img",
            {
              src: e.imageUrl,
              alt: e.title,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          ) : /* @__PURE__ */ t(as, { size: o.imageSize * 0.4, color: "#9ca3af" })
        }
      ),
      e.brand && /* @__PURE__ */ t("div", { style: { fontSize: o.brandFontSize, color: o.brandColor }, children: e.brand }),
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            fontSize: o.titleFontSize,
            fontWeight: ao(o.titleFontWeight),
            color: o.titleColor,
            textAlign: "center",
            display: "-webkit-box",
            WebkitLineClamp: o.titleMaxLines,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            lineHeight: 1.3
          },
          children: e.title
        }
      ),
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            fontSize: o.priceFontSize,
            fontWeight: ao(o.priceFontWeight),
            color: o.priceColor
          },
          children: Go(e.price)
        }
      ),
      e.rewardAmount && e.rewardAmount > 0 && /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: o.rewardFontSize,
            color: o.rewardColor,
            backgroundColor: o.rewardBgColor,
            padding: "4px 8px",
            borderRadius: 4
          },
          children: [
            "+",
            Go(e.rewardAmount),
            " reward"
          ]
        }
      ),
      e.reviewsRating !== void 0 && /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 4 }, children: [
        /* @__PURE__ */ t(
          is,
          {
            rating: e.reviewsRating,
            starSize: o.ratingStarSize,
            starColor: o.ratingStarColor,
            emptyColor: o.ratingStarEmptyColor
          }
        ),
        e.reviewsCount !== void 0 && /* @__PURE__ */ u("span", { style: { fontSize: o.ratingTextFontSize, color: o.ratingTextColor }, children: [
          "(",
          e.reviewsCount,
          ")"
        ] })
      ] }),
      i && n && /* @__PURE__ */ t(
        "button",
        {
          onClick: (l) => {
            l.stopPropagation(), n();
          },
          style: {
            marginTop: 8,
            padding: "8px 16px",
            fontSize: 13,
            fontWeight: 600,
            color: "#ffffff",
            backgroundColor: "#1a1a1a",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
            width: "100%"
          },
          children: "Add to Cart"
        }
      )
    ]
  }
), ss = (e) => {
  const o = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    r.attributes && Object.keys(r.attributes).forEach((n) => o.add(n));
  }), Array.from(o).map((r) => ({
    key: r,
    label: r.charAt(0).toUpperCase() + r.slice(1).replace(/([A-Z])/g, " $1"),
    format: "text"
  }));
}, Sd = ({
  widgetId: e,
  products: o,
  attributes: r,
  isLoading: n = !1,
  error: i,
  onProductClick: l,
  onAddToCart: s,
  showAddToCart: p = !1,
  headerText: g,
  showHeader: y = !0,
  className: c,
  children: h
}) => {
  const { state: x } = U(
    e,
    ns,
    []
    // No edit fields for now
  );
  if (h)
    return /* @__PURE__ */ t(O, { children: h(x, o) });
  if (n)
    return /* @__PURE__ */ t(
      "div",
      {
        className: c,
        style: {
          maxWidth: x.maxWidth,
          padding: `${x.paddingY}px ${x.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: x.emptyTextFontSize, color: x.emptyTextColor }, children: "Comparing products..." })
      }
    );
  if (i)
    return /* @__PURE__ */ t(
      "div",
      {
        className: c,
        style: {
          maxWidth: x.maxWidth,
          padding: `${x.paddingY}px ${x.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: x.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (o.length < 2)
    return /* @__PURE__ */ t(
      "div",
      {
        className: c,
        style: {
          maxWidth: x.maxWidth,
          padding: `${x.paddingY}px ${x.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: x.emptyTextFontSize, color: x.emptyTextColor }, children: "At least 2 products are needed for comparison" })
      }
    );
  const B = r || ss(o), k = g || `Comparing ${o.length} Products`;
  return /* @__PURE__ */ u(
    "div",
    {
      className: c,
      style: {
        maxWidth: x.maxWidth,
        padding: `${x.paddingY}px ${x.paddingX}px`,
        backgroundColor: x.backgroundColor,
        borderRadius: x.borderRadius,
        overflowX: "auto"
      },
      children: [
        y && /* @__PURE__ */ t(
          "h3",
          {
            style: {
              fontSize: x.headerFontSize,
              fontWeight: ao(x.headerFontWeight),
              color: x.headerColor,
              marginBottom: x.headerMarginBottom,
              margin: 0,
              marginBlockEnd: x.headerMarginBottom
            },
            children: k
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              display: "flex",
              gap: x.cardGap,
              marginBottom: B.length > 0 ? 16 : 0
            },
            children: o.map((b) => /* @__PURE__ */ t(
              ls,
              {
                product: b,
                state: x,
                onClick: l ? () => l(b) : void 0,
                onAddToCart: s ? () => s(b) : void 0,
                showAddToCart: p
              },
              b.stacklineSku
            ))
          }
        ),
        B.length > 0 && /* @__PURE__ */ t(
          "div",
          {
            style: {
              border: `1px solid ${x.rowBorderColor}`,
              borderRadius: 8,
              overflow: "hidden"
            },
            children: B.map((b, C) => /* @__PURE__ */ u(
              "div",
              {
                style: {
                  display: "flex",
                  backgroundColor: C % 2 === 0 ? x.rowBgColor : x.rowBgColorAlt,
                  borderBottom: C < B.length - 1 ? `1px solid ${x.rowBorderColor}` : "none"
                },
                children: [
                  /* @__PURE__ */ t(
                    "div",
                    {
                      style: {
                        width: 120,
                        flexShrink: 0,
                        padding: "10px 12px",
                        fontSize: x.labelFontSize,
                        fontWeight: ao(x.labelFontWeight),
                        color: x.labelColor,
                        borderRight: `1px solid ${x.rowBorderColor}`
                      },
                      children: b.label
                    }
                  ),
                  o.map((S) => {
                    var A;
                    const T = (A = S.attributes) == null ? void 0 : A[b.key];
                    let m = "-";
                    return T != null && (b.format === "currency" && typeof T == "number" ? m = Go(T) : b.format === "boolean" ? m = T ? "✓" : "✗" : m = String(T)), /* @__PURE__ */ t(
                      "div",
                      {
                        style: {
                          flex: 1,
                          minWidth: 150,
                          maxWidth: 220,
                          padding: "10px 12px",
                          fontSize: x.valueFontSize,
                          color: x.valueColor,
                          textAlign: "center",
                          borderRight: `1px solid ${x.rowBorderColor}`
                        },
                        children: m
                      },
                      S.stacklineSku
                    );
                  })
                ]
              },
              b.key
            ))
          }
        )
      ]
    }
  );
}, ds = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, cs = {
  content: "Default Text",
  fontFamily: "inherit",
  fontSize: 16,
  fontWeight: "medium",
  color: {
    type: "theme",
    value: "textPrimary"
  },
  textAlign: "left",
  lineHeight: 1.5,
  letterSpacing: 0,
  textTransform: "none"
}, mr = [
  { key: "content", label: "Text Content", type: "text" },
  { key: "fontFamily", label: "Font Family", type: "font" },
  {
    key: "fontSize",
    label: "Font Size (px)",
    type: "number",
    min: 12,
    max: 72,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: ae
  },
  { key: "color", label: "Text Color", type: "color" },
  {
    key: "textAlign",
    label: "Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 3,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  }
], wd = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  excludeEditFields: n
}) => {
  const i = n ? mr.filter((w) => !n.includes(w.key)) : mr, {
    state: l,
    isLoading: s,
    isSaving: p,
    handleEditChange: g,
    handleSave: y,
    themeColors: c,
    themeFonts: h,
    resolveColor: x,
    canSave: B
  } = U(
    o,
    { ...cs, ...e },
    i
  ), k = l.fontFamily, b = k && k !== "inherit" ? h[k] : null, C = b && b.format === "google" ? b.url : null;
  if (Q(() => {
    C && ds(C);
  }, [C]), s)
    return /* @__PURE__ */ t(O, {});
  const S = (w) => {
    const v = {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }, P = parseInt(w, 10);
    return isNaN(P) ? v[w] || 500 : P;
  }, T = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", m = `textbox-${o || "default"}`, f = `
    ${b && b.format !== "system" && b.format !== "google" ? `
      @font-face {
        font-family: "${b.name}";
        src: url("${b.url}") format("${b.format}");
        font-display: swap;
      }
    ` : ""}
    ${T !== "inherit" ? `.${m} { font-family: ${T} !important; }` : ""}
  `.trim(), z = /* @__PURE__ */ u(O, { children: [
    f && /* @__PURE__ */ t("style", { children: f }),
    /* @__PURE__ */ t(
      "span",
      {
        className: `textbox-content ${m}`,
        style: {
          // font-family is set via CSS class with !important, only use inline for inherit
          ...T === "inherit" ? { fontFamily: "inherit" } : {},
          fontSize: `${l.fontSize}px`,
          fontWeight: S(l.fontWeight),
          color: x(l.color),
          textAlign: l.textAlign,
          lineHeight: l.lineHeight,
          letterSpacing: `${l.letterSpacing}px`,
          textTransform: l.textTransform,
          display: "inline-block",
          width: "100%"
        },
        children: l.content
      }
    )
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: i,
      editValues: l,
      onEditChange: g,
      onSave: B ? y : void 0,
      isSaving: p,
      themeColors: c,
      themeFonts: h,
      children: z
    }
  );
}, ur = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, ps = {
  // Instant reward (DailyDeals) - orange
  instantBgColor: oe("rgba(236, 121, 46, 0.3)"),
  instantTextColor: oe("rgb(236, 121, 46)"),
  // Purchase reward - magenta
  purchaseBgColor: oe("rgba(162, 34, 114, 0.3)"),
  purchaseTextColor: oe("rgb(162, 34, 114)"),
  // Affiliate reward - teal
  affiliateBgColor: oe("rgba(22, 148, 155, 0.2)"),
  affiliateTextColor: oe("rgb(22, 148, 155)"),
  // Content/Survey reward - magenta
  contentBgColor: oe("rgba(162, 34, 114, 0.3)"),
  contentTextColor: oe("rgb(162, 34, 114)"),
  // Pill styling
  pillBorderRadius: 25,
  pillPaddingMultiplier: 0.95,
  // Icon
  iconSizeMultiplier: 1,
  iconMarginMultiplier: 0.416,
  // Text
  pillFontWeight: "semibold",
  pillFontFamily: "inherit",
  subfixTextColor: a("textPrimary"),
  subfixFontWeight: "semibold",
  subfixFontFamily: "inherit",
  // Container
  containerGap: 7
}, hr = [
  // Instant reward
  { key: "instantBgColor", label: "Instant Reward Background", type: "color" },
  { key: "instantTextColor", label: "Instant Reward Text", type: "color" },
  // Purchase reward
  {
    key: "purchaseBgColor",
    label: "Purchase Reward Background",
    type: "color"
  },
  { key: "purchaseTextColor", label: "Purchase Reward Text", type: "color" },
  // Affiliate reward
  {
    key: "affiliateBgColor",
    label: "Affiliate Reward Background",
    type: "color"
  },
  { key: "affiliateTextColor", label: "Affiliate Reward Text", type: "color" },
  // Content/Survey reward
  { key: "contentBgColor", label: "Content Reward Background", type: "color" },
  { key: "contentTextColor", label: "Content Reward Text", type: "color" },
  // Pill styling
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillPaddingMultiplier",
    label: "Pill Padding Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.05
  },
  // Icon
  {
    key: "iconSizeMultiplier",
    label: "Icon Size Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.1
  },
  {
    key: "iconMarginMultiplier",
    label: "Icon Margin Multiplier",
    type: "number",
    min: 0.2,
    max: 0.8,
    step: 0.05
  },
  // Text
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...ae]
  },
  {
    key: "pillFontFamily",
    label: "Pill Font Family",
    type: "font"
  },
  { key: "subfixTextColor", label: "Subfix Text Color", type: "color" },
  {
    key: "subfixFontWeight",
    label: "Subfix Font Weight",
    type: "options",
    options: [...ae]
  },
  {
    key: "subfixFontFamily",
    label: "Subfix Font Family",
    type: "font"
  },
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  }
], Bd = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    themeFonts: c,
    resolveColor: h,
    canSave: x
  } = U(
    o,
    { ...ps, ...e },
    hr
  ), B = i.pillFontFamily, k = B && B !== "inherit" ? c[B] : null, b = i.subfixFontFamily, C = b && b !== "inherit" ? c[b] : null, S = k && k.format === "google" ? k.url : null, T = C && C.format === "google" ? C.url : null;
  if (Q(() => {
    S && ur(S);
  }, [S]), Q(() => {
    T && ur(T);
  }, [T]), l)
    return /* @__PURE__ */ t(O, {});
  const m = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", A = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", f = k && k.format !== "system" && k.format !== "google", z = C && C.format !== "system" && C.format !== "google", w = `reward-pill-${o || "default"}`, v = `
    ${f ? `
      @font-face {
        font-family: "${k.name}";
        src: url("${k.url}") format("${k.format}");
        font-display: swap;
      }
    ` : ""}
    ${z ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${m !== "inherit" ? `.${w} [data-pill-text] { font-family: ${m} !important; }` : ""}
    ${A !== "inherit" ? `.${w} [data-subfix-text] { font-family: ${A} !important; }` : ""}
  `.trim(), P = {
    ...i,
    pillFontFamilyCss: m,
    subfixFontFamilyCss: A
  }, W = /* @__PURE__ */ u(O, { children: [
    v && /* @__PURE__ */ t("style", { children: v }),
    n(P, h)
  ] });
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: hr,
      editValues: i,
      onEditChange: p,
      onSave: x ? g : void 0,
      isSaving: s,
      themeColors: y,
      themeFonts: c,
      children: W
    }
  );
}, gs = {
  // Icon size
  iconSize: 18,
  iconSizeMobile: 15,
  // Overlap and spacing
  overlapRatio: 0.46,
  counterMarginLeft: 7,
  // Border styling
  iconBorderRadius: 50,
  // percentage - 50 = circle
  // Counter text
  counterTextColor: a("textPrimary"),
  counterFontSize: 11,
  counterFontWeight: "semibold",
  // Display limits
  maxVisibleIcons: 4
}, yr = [
  // Icon size
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 32,
    step: 2
  },
  {
    key: "iconSizeMobile",
    label: "Icon Size (Mobile)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  // Overlap and spacing
  {
    key: "overlapRatio",
    label: "Overlap Ratio",
    type: "number",
    min: 0,
    max: 0.7,
    step: 0.05
  },
  {
    key: "counterMarginLeft",
    label: "Counter Margin Left",
    type: "number",
    min: 0,
    max: 16,
    step: 1
  },
  // Border styling
  {
    key: "iconBorderRadius",
    label: "Icon Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Counter text
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 8,
    max: 16,
    step: 1
  },
  {
    key: "counterFontWeight",
    label: "Counter Font Weight",
    type: "options",
    options: [...ae]
  },
  // Display limits
  {
    key: "maxVisibleIcons",
    label: "Max Visible Icons",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  }
], zd = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: s,
    handleEditChange: p,
    handleSave: g,
    themeColors: y,
    resolveColor: c,
    canSave: h
  } = U(
    o,
    { ...gs, ...e },
    yr
  );
  if (l)
    return /* @__PURE__ */ t(O, {});
  const x = n(i, c);
  return /* @__PURE__ */ t(
    Z,
    {
      widgetId: o,
      displayName: r,
      editFields: yr,
      editValues: i,
      onEditChange: p,
      onSave: h ? g : void 0,
      isSaving: s,
      themeColors: y,
      children: x
    }
  );
}, ms = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black"
}, E = (e) => e.map((o) => ({
  weight: o,
  label: ms[o] || `Weight ${o}`
})), lo = [
  // === SANS-SERIF ===
  {
    name: "Inter",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Roboto",
    category: "sans-serif",
    variants: E([100, 300, 400, 500, 700, 900]),
    popular: !0
  },
  {
    name: "Open Sans",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Lato",
    category: "sans-serif",
    variants: E([100, 300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Montserrat",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Poppins",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito Sans",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Sans 3",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Raleway",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Work Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Oswald",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Rubik",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Quicksand",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Mulish",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow Condensed",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Kanit",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Manrope",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "DM Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Outfit",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Plus Jakarta Sans",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Figtree",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cabin",
    category: "sans-serif",
    variants: E([400, 500, 600, 700])
  },
  {
    name: "Karla",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Archivo",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Josefin Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Lexend",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Exo 2",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Titillium Web",
    category: "sans-serif",
    variants: E([200, 300, 400, 600, 700, 900])
  },
  {
    name: "Sora",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Space Grotesk",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Albert Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Be Vietnam Pro",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Asap",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu",
    category: "sans-serif",
    variants: E([300, 400, 500, 700]),
    popular: !0
  },
  {
    name: "Dosis",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Noto Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Noto Sans Display",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fira Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "PT Sans",
    category: "sans-serif",
    variants: E([400, 700])
  },
  {
    name: "PT Sans Narrow",
    category: "sans-serif",
    variants: E([400, 700])
  },
  {
    name: "Mukta",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Hind",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Rajdhani",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Varela Round",
    category: "sans-serif",
    variants: E([400])
  },
  {
    name: "Comic Neue",
    category: "sans-serif",
    variants: E([300, 400, 700])
  },
  // === SERIF ===
  {
    name: "Playfair Display",
    category: "serif",
    variants: E([400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Merriweather",
    category: "serif",
    variants: E([300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Lora",
    category: "serif",
    variants: E([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "PT Serif",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Noto Serif",
    category: "serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Serif 4",
    category: "serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Libre Baskerville",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Crimson Text",
    category: "serif",
    variants: E([400, 600, 700])
  },
  {
    name: "Crimson Pro",
    category: "serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Bitter",
    category: "serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant Garamond",
    category: "serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "EB Garamond",
    category: "serif",
    variants: E([400, 500, 600, 700, 800])
  },
  {
    name: "DM Serif Display",
    category: "serif",
    variants: E([400])
  },
  {
    name: "Spectral",
    category: "serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Cardo",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Libre Caslon Text",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Bodoni Moda",
    category: "serif",
    variants: E([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fraunces",
    category: "serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant",
    category: "serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Cinzel",
    category: "serif",
    variants: E([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Playfair Display SC",
    category: "serif",
    variants: E([400, 700, 900])
  },
  // === DISPLAY ===
  {
    name: "Bebas Neue",
    category: "display",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Abril Fatface",
    category: "display",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Righteous",
    category: "display",
    variants: E([400])
  },
  {
    name: "Alfa Slab One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Fredoka",
    category: "display",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Comfortaa",
    category: "display",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Lobster",
    category: "display",
    variants: E([400])
  },
  {
    name: "Staatliches",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bungee",
    category: "display",
    variants: E([400])
  },
  {
    name: "Monoton",
    category: "display",
    variants: E([400])
  },
  {
    name: "Black Ops One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Permanent Marker",
    category: "display",
    variants: E([400])
  },
  {
    name: "Russo One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Fugaz One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bangers",
    category: "display",
    variants: E([400])
  },
  {
    name: "Anton",
    category: "display",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Creepster",
    category: "display",
    variants: E([400])
  },
  {
    name: "Orbitron",
    category: "display",
    variants: E([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Audiowide",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bungee Inline",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bungee Shade",
    category: "display",
    variants: E([400])
  },
  {
    name: "Faster One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Press Start 2P",
    category: "display",
    variants: E([400])
  },
  // === HANDWRITING ===
  {
    name: "Dancing Script",
    category: "handwriting",
    variants: E([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Pacifico",
    category: "handwriting",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Caveat",
    category: "handwriting",
    variants: E([400, 500, 600, 700])
  },
  {
    name: "Great Vibes",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Satisfy",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Sacramento",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Kalam",
    category: "handwriting",
    variants: E([300, 400, 700])
  },
  {
    name: "Shadows Into Light",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Indie Flower",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Amatic SC",
    category: "handwriting",
    variants: E([400, 700])
  },
  {
    name: "Patrick Hand",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Courgette",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Shadows Into Light Two",
    category: "handwriting",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Caveat Brush",
    category: "handwriting",
    variants: E([400])
  },
  // === MONOSPACE ===
  {
    name: "Fira Code",
    category: "monospace",
    variants: E([300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "JetBrains Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Source Code Pro",
    category: "monospace",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Roboto Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "IBM Plex Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Space Mono",
    category: "monospace",
    variants: E([400, 700])
  },
  {
    name: "Inconsolata",
    category: "monospace",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu Mono",
    category: "monospace",
    variants: E([400, 700])
  },
  {
    name: "Noto Sans Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Courier Prime",
    category: "monospace",
    variants: E([400, 700])
  },
  {
    name: "Fira Mono",
    category: "monospace",
    variants: E([400, 500, 700])
  }
], us = (e, o = [500]) => {
  const r = e.replace(/ /g, "+"), n = o.join(";");
  return `https://fonts.googleapis.com/css2?family=${r}:wght@${n}&display=swap`;
}, hs = (e) => `https://fonts.googleapis.com/css2?${e.map((r) => {
  const n = r.name.replace(/ /g, "+"), i = r.weights.join(";");
  return `family=${n}:wght@${i}`;
}).join("&")}&display=swap`, ys = (e) => {
  const o = lo.find(
    (r) => r.name.toLowerCase() === e.toLowerCase()
  );
  return (o == null ? void 0 : o.variants) || [{ weight: 500, label: "Medium" }];
};
let no = null;
const sn = () => no || (no = new Promise((e) => {
  const o = lo.map((i) => ({
    name: i.name,
    weights: [400, 500]
  })), r = hs(o), n = document.createElement("link");
  n.href = r, n.rel = "stylesheet", n.onload = () => {
    e();
  }, n.onerror = () => {
    console.warn("Failed to preload Google Fonts"), e();
  }, document.head.appendChild(n);
}), no), bs = (e) => {
  if (!e) return "#000000ff";
  const o = e.startsWith("#") ? e : `#${e}`;
  return o.length === 9 ? o : o.length === 7 ? `${o}ff` : o.padEnd(9, "f").slice(0, 9);
}, br = (e) => {
  const o = bs(e);
  return o.length === 9 && o.slice(7, 9).toLowerCase() === "ff" ? o.slice(0, 7) : o;
}, Ee = (e, o, r) => {
  var i;
  const n = {
    type: Zr,
    payload: { updateType: o, themeId: r }
  };
  (i = e == null ? void 0 : e.current) != null && i.contentWindow ? e.current.contentWindow.postMessage(
    n,
    window.location.origin
  ) : window.postMessage(n, window.location.origin);
}, fs = (e) => {
  var r;
  switch ((r = e.split(".").pop()) == null ? void 0 : r.toLowerCase()) {
    case "woff2":
      return "woff2";
    case "woff":
      return "woff";
    case "ttf":
      return "truetype";
    case "otf":
      return "opentype";
    default:
      return "woff2";
  }
}, xs = ({
  themeId: e,
  editThemeToken: o,
  iframeRef: r,
  refreshThemeColors: n,
  refreshThemeFonts: i,
  refreshThemeIcons: l
}) => {
  const [s, p] = D(!1), [g, y] = D(null), [c, h] = D(null), [x, B] = D(!1), [k, b] = D(""), [C, S] = D("#000000ff"), [T, m] = D(
    null
  ), A = async () => {
    if (!k.trim()) {
      y("Color name is required");
      return;
    }
    if (!o || !e) {
      y("Theme ID and edit token are required");
      return;
    }
    p(!0), y(null), h(null);
    try {
      await ft({
        themeId: e,
        colorKey: k.trim(),
        colorValue: br(C),
        editThemeToken: o
      }), await n(), Ee(r, "colors", e), b(""), S("#000000ff"), B(!1), h("Color added successfully"), setTimeout(() => h(null), 2e3);
    } catch (M) {
      y(M.message || "Failed to add color");
    } finally {
      p(!1);
    }
  }, f = async (M, N) => {
    if (!(!o || !e)) {
      p(!0), y(null), h(null);
      try {
        await ft({
          themeId: e,
          colorKey: M,
          colorValue: br(N),
          editThemeToken: o
        }), await n(), Ee(r, "colors", e), h("Color updated successfully"), setTimeout(() => h(null), 2e3);
      } catch (G) {
        y(G.message || "Failed to update color");
      } finally {
        p(!1);
      }
    }
  }, z = async (M, N) => {
    if (!(!o || !e)) {
      if (!N.trim()) {
        y("Color name is required");
        return;
      }
      if (M !== N.trim()) {
        p(!0), y(null), h(null);
        try {
          await ea({
            themeId: e,
            oldColorKey: M,
            newColorKey: N.trim(),
            editThemeToken: o
          }), await n(), Ee(r, "colors", e), h("Color renamed successfully"), setTimeout(() => h(null), 2e3);
        } catch (G) {
          y(G.message || "Failed to rename color");
        } finally {
          p(!1);
        }
      }
    }
  }, w = (M) => {
    !o || !e || m({ type: "color", key: M });
  }, v = async (M) => {
    if (!(!o || !e)) {
      p(!0), y(null), h(null);
      try {
        await Ki({
          themeId: e,
          colorKey: M,
          editThemeToken: o
        }), await n(), Ee(r, "colors", e), h("Color deleted successfully"), setTimeout(() => h(null), 2e3);
      } catch (N) {
        y(N.message || "Failed to delete color");
      } finally {
        p(!1);
      }
    }
  }, P = async (M) => {
    if (!o || !e) {
      y("Theme ID and edit token are required");
      return;
    }
    p(!0), y(null), h(null);
    try {
      let N, G;
      switch (M.type) {
        case "system":
          N = M.value || M.name, G = "system";
          break;
        case "google":
          const $ = ys(M.name).map((J) => J.weight);
          $.includes(800) || $.push(800), $.includes(900) || $.push(900), N = us(M.name, $), G = "google";
          break;
        case "upload":
          if (!M.file)
            throw new Error("No font file provided");
          const { signedUploadUrl: Y, objectPublicUrl: q } = await xt({
            themeId: e,
            fileName: M.file.name,
            contentType: M.file.type || "font/woff2",
            assetType: "font",
            editThemeToken: o
          });
          await Ct({
            file: M.file,
            signedUploadUrl: Y
          }), N = q, G = fs(M.file.name);
          break;
        default:
          throw new Error("Unknown font type");
      }
      await oa({
        themeId: e,
        fontKey: M.name.toLowerCase().replace(/\s+/g, "-"),
        fontValue: {
          name: M.name,
          url: N,
          format: G
        },
        editThemeToken: o
      }), await i(), Ee(r, "fonts", e), h("Font added successfully"), setTimeout(() => h(null), 2e3);
    } catch (N) {
      y(N.message || "Failed to add font");
    } finally {
      p(!1);
    }
  }, W = (M) => {
    !o || !e || m({ type: "font", key: M });
  }, F = async (M) => {
    if (!(!o || !e)) {
      p(!0), y(null), h(null);
      try {
        await ta({
          themeId: e,
          fontKey: M,
          editThemeToken: o
        }), await i(), Ee(r, "fonts", e), h("Font deleted successfully"), setTimeout(() => h(null), 2e3);
      } catch (N) {
        y(N.message || "Failed to delete font");
      } finally {
        p(!1);
      }
    }
  }, L = async (M) => {
    if (!o || !e) {
      y("Theme ID and edit token are required");
      return;
    }
    p(!0), y(null), h(null);
    try {
      let N;
      switch (M.type) {
        case "lucide":
          if (N = M.url || "", !N)
            throw new Error("No icon URL provided");
          break;
        case "upload":
          if (!M.file)
            throw new Error("No icon file provided");
          const { signedUploadUrl: G, objectPublicUrl: H } = await xt({
            themeId: e,
            fileName: M.file.name,
            contentType: M.file.type || (M.file.name.endsWith(".svg") ? "image/svg+xml" : "application/octet-stream"),
            assetType: "icon",
            editThemeToken: o
          });
          await Ct({
            file: M.file,
            signedUploadUrl: G
          }), N = H;
          break;
        default:
          throw new Error("Unknown icon type");
      }
      await ra({
        themeId: e,
        iconKey: M.name.toLowerCase().replace(/\s+/g, "-"),
        iconValue: {
          name: M.name,
          url: N
        },
        editThemeToken: o
      }), await l(), Ee(r, "icons", e), h("Icon added successfully"), setTimeout(() => h(null), 2e3);
    } catch (N) {
      y(N.message || "Failed to add icon");
    } finally {
      p(!1);
    }
  }, I = (M) => {
    !o || !e || m({ type: "icon", key: M });
  }, R = async (M) => {
    if (!(!o || !e)) {
      p(!0), y(null), h(null);
      try {
        await na({
          themeId: e,
          iconKey: M,
          editThemeToken: o
        }), await l(), Ee(r, "icons", e), h("Icon deleted successfully"), setTimeout(() => h(null), 2e3);
      } catch (N) {
        y(N.message || "Failed to delete icon");
      } finally {
        p(!1);
      }
    }
  };
  return {
    // Loading and messages
    isLoading: s,
    error: g,
    successMessage: c,
    // Color state
    isAddingColor: x,
    setIsAddingColor: B,
    newColorKey: k,
    setNewColorKey: b,
    newColorValue: C,
    setNewColorValue: S,
    // Color Handlers
    handleAddColor: A,
    handleUpdateColor: f,
    handleRenameColor: z,
    handleDeleteColor: w,
    // Font Handlers
    handleAddFont: P,
    handleDeleteFont: W,
    // Icon Handlers
    handleAddIcon: L,
    handleDeleteIcon: I,
    // Delete confirmation
    pendingDelete: T,
    confirmDelete: async () => {
      if (!T) return;
      const { type: M, key: N } = T;
      switch (m(null), M) {
        case "color":
          await v(N);
          break;
        case "font":
          await F(N);
          break;
        case "icon":
          await R(N);
          break;
      }
    },
    cancelDelete: () => {
      m(null);
    }
  };
}, fr = ({
  onClose: e,
  successMessage: o,
  error: r,
  children: n
}) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel", children: [
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel-header", children: [
    /* @__PURE__ */ t("h2", { className: "bc-theme-editor-sidepanel-title", children: "Theme Settings" }),
    /* @__PURE__ */ t(
      te,
      {
        variant: "icon",
        size: "sm",
        onClick: e,
        "aria-label": "Close settings",
        children: /* @__PURE__ */ t(Ne, { size: 16 })
      }
    )
  ] }),
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel-content", children: [
    o && /* @__PURE__ */ u("div", { className: "bc-theme-editor-message bc-theme-editor-message-success", children: [
      /* @__PURE__ */ t(Bn, { size: 14 }),
      " ",
      o
    ] }),
    r && /* @__PURE__ */ u("div", { className: "bc-theme-editor-message bc-theme-editor-message-error", children: [
      /* @__PURE__ */ t(Fn, { size: 14 }),
      " ",
      r
    ] }),
    n
  ] })
] }), xr = ({
  themeFonts: e,
  isExpanded: o,
  onToggle: r,
  isLoading: n,
  onDeleteFont: i,
  onOpenFontPicker: l,
  studioLockedFontKeys: s
}) => {
  const [p, g] = D(!1);
  Q(() => {
    o && !p && sn().then(() => g(!0));
  }, [o, p]);
  const y = (c) => {
    switch (c) {
      case "google":
        return "Google Fonts";
      case "system":
        return "System";
      case "woff2":
      case "woff":
      case "truetype":
      case "opentype":
        return "Uploaded";
      default:
        return c;
    }
  };
  return /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: r, children: [
      /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
        "Fonts",
        /* @__PURE__ */ t("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ t(
        co,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${o ? "expanded" : ""}`
        }
      )
    ] }),
    o && /* @__PURE__ */ t("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([c, h]) => {
        const x = (s == null ? void 0 : s.has(c)) ?? !1;
        return /* @__PURE__ */ u("div", { className: "bc-theme-editor-row bc-font-row", children: [
          /* @__PURE__ */ t(
            "span",
            {
              className: "bc-font-preview-name",
              style: {
                fontFamily: p ? `'${h.name}', sans-serif` : "inherit"
              },
              children: h.name
            }
          ),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-asset-format", children: x ? "Concierge Studio" : y(h.format) }),
          x ? /* @__PURE__ */ t(
            "span",
            {
              title: "Edit this font from Concierge Studio",
              style: {
                display: "inline-flex",
                alignItems: "center",
                color: d.blue,
                padding: "4px",
                cursor: "help"
              },
              children: /* @__PURE__ */ t(Qo, { size: 14 })
            }
          ) : /* @__PURE__ */ t(
            "button",
            {
              className: "bc-theme-editor-delete-btn",
              onClick: () => i(c),
              disabled: n,
              "aria-label": "Delete font",
              children: /* @__PURE__ */ t(Ne, { size: 16 })
            }
          )
        ] }, c);
      }),
      /* @__PURE__ */ t(
        te,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ t(Xo, { size: 12 }),
          onClick: l,
          disabled: n,
          children: "Add Font"
        }
      )
    ] }) })
  ] });
}, Cr = ({
  themeIcons: e,
  isExpanded: o,
  onToggle: r,
  isLoading: n,
  onDeleteIcon: i,
  onOpenIconPicker: l
}) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: r, children: [
    /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
      "Images and Icons",
      /* @__PURE__ */ t("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
    ] }),
    /* @__PURE__ */ t(
      co,
      {
        size: 16,
        className: `bc-theme-editor-section-chevron ${o ? "expanded" : ""}`
      }
    )
  ] }),
  o && /* @__PURE__ */ t("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
    Object.entries(e).map(([s, p]) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
      /* @__PURE__ */ t("div", { className: "bc-theme-editor-asset-preview", children: /* @__PURE__ */ t("img", { src: p.url, alt: p.name }) }),
      /* @__PURE__ */ t(
        "input",
        {
          type: "text",
          className: "bc-theme-editor-input",
          value: p.name,
          disabled: !0
        }
      ),
      /* @__PURE__ */ t(
        "button",
        {
          className: "bc-theme-editor-delete-btn",
          onClick: () => i(s),
          disabled: n,
          "aria-label": "Delete icon",
          children: /* @__PURE__ */ t(Ne, { size: 16 })
        }
      )
    ] }, s)),
    /* @__PURE__ */ t(
      te,
      {
        variant: "ghost",
        size: "sm",
        leftIcon: /* @__PURE__ */ t(Xo, { size: 12 }),
        onClick: l,
        disabled: n,
        children: "Add Image"
      }
    )
  ] }) })
] }), kr = [
  // Sans-serif
  {
    name: "System UI",
    value: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    category: "sans-serif"
  },
  {
    name: "SF Pro",
    value: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
    category: "sans-serif"
  },
  {
    name: "Helvetica",
    value: "Helvetica, Arial, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Arial",
    value: "Arial, Helvetica, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Segoe UI",
    value: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Verdana",
    value: "Verdana, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Tahoma",
    value: "Tahoma, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Trebuchet MS",
    value: "'Trebuchet MS', sans-serif",
    category: "sans-serif"
  },
  // Serif
  {
    name: "New York",
    value: "'New York', 'Iowan Old Style', Georgia, serif",
    category: "serif"
  },
  {
    name: "Georgia",
    value: "Georgia, 'Times New Roman', serif",
    category: "serif"
  },
  {
    name: "Times New Roman",
    value: "'Times New Roman', Times, serif",
    category: "serif"
  },
  {
    name: "Palatino",
    value: "'Palatino Linotype', Palatino, 'Book Antiqua', serif",
    category: "serif"
  },
  {
    name: "Garamond",
    value: "Garamond, 'Times New Roman', serif",
    category: "serif"
  },
  // Monospace
  {
    name: "SF Mono",
    value: "'SF Mono', Menlo, Monaco, monospace",
    category: "monospace"
  },
  {
    name: "Menlo",
    value: "Menlo, Monaco, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Monaco",
    value: "Monaco, Menlo, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Consolas",
    value: "Consolas, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Courier New",
    value: "'Courier New', Courier, monospace",
    category: "monospace"
  }
], Cs = () => `
  /* Overlay */
  .font-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: font-picker-fade-in 0.2s ease;
  }

  @keyframes font-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .font-picker-modal {
    background: ${d.white};
    border-radius: 16px;
    width: 90%;
    max-width: 560px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: font-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes font-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .font-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .font-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${d.primary};
    margin: 0;
  }

  /* Search */
  .font-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${d.border_glass};
    position: relative;
  }

  .font-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${d.gray_medium};
  }

  .font-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${d.primary};
    background: ${d.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-search-input:focus {
    border-color: ${d.blue};
    background: ${d.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .font-picker-search-input::placeholder {
    color: ${d.gray_medium};
  }

  /* Tabs */
  .font-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .font-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${d.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .font-picker-tab:hover {
    color: ${d.primary};
  }

  .font-picker-tab.active {
    color: ${d.primary};
  }

  .font-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${d.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .font-picker-content {
    flex: 1;
    overflow-y: auto;
    padding: 0;
  }

  .font-picker-description {
    font-size: 13px;
    color: ${d.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Font List */
  .font-picker-list {
    padding-bottom: 16px;
  }

  .font-picker-category {
    margin-bottom: 8px;
  }

  .font-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${d.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
  }

  .font-picker-item {
    display: flex;
    align-items: center;
    padding: 14px 24px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${d.border_glass};
  }

  .font-picker-item:hover {
    background: ${d.bg_light};
  }

  .font-picker-item.selected {
    background: rgba(85, 114, 183, 0.08);
  }

  .font-picker-item-name {
    flex: 1;
    font-size: 16px;
    color: ${d.primary};
  }

  .font-picker-popular {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${d.blue};
    background: rgba(85, 114, 183, 0.1);
    padding: 3px 8px;
    border-radius: 4px;
    margin-right: 12px;
  }

  .font-picker-check {
    color: ${d.blue};
    flex-shrink: 0;
  }

  /* Variant Selector */
  .font-picker-variant-selector {
    padding: 8px 24px 8px 48px;
    background: ${d.bg_light};
    border-bottom: 1px solid ${d.border_glass};
  }

  .font-picker-variant-select {
    padding: 8px 32px 8px 12px;
    border: 1px solid ${d.border_glass};
    border-radius: 8px;
    font-size: 13px;
    color: ${d.primary};
    background: ${d.white};
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    transition: all 0.15s ease;
  }

  .font-picker-variant-select:focus {
    border-color: ${d.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Upload Tab */
  .font-picker-upload {
    padding: 16px 24px;
  }

  .font-picker-upload-zone {
    border: 2px dashed ${d.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .font-picker-upload-zone:hover {
    border-color: ${d.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .font-picker-upload-icon {
    color: ${d.gray_medium};
  }

  .font-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
  }

  .font-picker-upload-hint {
    font-size: 12px;
    color: ${d.gray_medium};
  }

  .font-picker-upload-preview {
    margin-top: 16px;
  }

  .font-picker-upload-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: ${d.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .font-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .font-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .font-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${d.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .font-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${d.primary};
    background: ${d.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-upload-input:focus {
    border-color: ${d.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .font-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${d.border_glass};
    background: ${d.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, vr = ({
  isOpen: e,
  onClose: o,
  onSelect: r,
  isLoading: n = !1
}) => {
  const [i, l] = D("system"), [s, p] = D(""), [g, y] = D(null), [c, h] = D(null), [x, B] = D(""), k = de(null), [b, C] = D(!1);
  Q(() => {
    e && (p(""), y(null), h(null), B(""));
  }, [e]), Q(() => {
    i === "google" && !b && sn().then(() => {
      C(!0);
    });
  }, [i, b]);
  const S = le(() => {
    if (!s) return kr;
    const I = s.toLowerCase();
    return kr.filter(
      (R) => R.name.toLowerCase().includes(I) || R.category.toLowerCase().includes(I)
    );
  }, [s]), T = le(() => {
    if (!s) return lo;
    const I = s.toLowerCase();
    return lo.filter(
      (R) => R.name.toLowerCase().includes(I) || R.category.toLowerCase().includes(I)
    );
  }, [s]), m = (I) => {
    y({
      type: "system",
      name: I.name,
      value: I.value
    });
  }, A = (I) => {
    y({
      type: "google",
      name: I.name
    });
  }, f = (I) => {
    var j;
    const R = (j = I.target.files) == null ? void 0 : j[0];
    if (R) {
      h(R);
      const X = R.name.replace(/\.[^/.]+$/, "");
      B(X), y({
        type: "upload",
        name: X,
        file: R,
        format: z(R.name)
      });
    }
  }, z = (I) => {
    var j;
    switch ((j = I.split(".").pop()) == null ? void 0 : j.toLowerCase()) {
      case "woff2":
        return "woff2";
      case "woff":
        return "woff";
      case "ttf":
        return "truetype";
      case "otf":
        return "opentype";
      default:
        return "woff2";
    }
  }, w = (I) => {
    B(I), (g == null ? void 0 : g.type) === "upload" && c && y({
      ...g,
      name: I
    });
  }, v = () => {
    g && (r(g), o());
  }, P = n || !g || g.type === "upload" && (!c || !x.trim()), W = le(() => {
    const I = {};
    return T.forEach((R) => {
      I[R.category] || (I[R.category] = []), I[R.category].push(R);
    }), I;
  }, [T]), F = le(() => {
    const I = {};
    return S.forEach((R) => {
      I[R.category] || (I[R.category] = []), I[R.category].push(R);
    }), I;
  }, [S]);
  if (!e) return null;
  const L = /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: Cs() }),
    /* @__PURE__ */ t("div", { className: "font-picker-overlay", onClick: o, children: /* @__PURE__ */ u("div", { className: "font-picker-modal", onClick: (I) => I.stopPropagation(), children: [
      /* @__PURE__ */ u("div", { className: "font-picker-header", children: [
        /* @__PURE__ */ t("h2", { className: "font-picker-title", children: "Select font" }),
        /* @__PURE__ */ t(
          te,
          {
            variant: "icon",
            size: "sm",
            onClick: o,
            "aria-label": "Close",
            children: /* @__PURE__ */ t(Ne, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-search", children: [
        /* @__PURE__ */ t(po, { size: 16, className: "font-picker-search-icon" }),
        /* @__PURE__ */ t(
          "input",
          {
            type: "text",
            placeholder: "Search",
            value: s,
            onChange: (I) => p(I.target.value),
            className: "font-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-tabs", children: [
        /* @__PURE__ */ t(
          "button",
          {
            className: `font-picker-tab ${i === "system" ? "active" : ""}`,
            onClick: () => l("system"),
            children: "System Fonts"
          }
        ),
        /* @__PURE__ */ t(
          "button",
          {
            className: `font-picker-tab ${i === "google" ? "active" : ""}`,
            onClick: () => l("google"),
            children: "Google Fonts"
          }
        ),
        /* @__PURE__ */ t(
          "button",
          {
            className: `font-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => l("upload"),
            children: "Upload"
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-content", children: [
        i === "system" && /* @__PURE__ */ u("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ t("p", { className: "font-picker-description", children: "These fonts load faster and might appear differently on various devices." }),
          Object.entries(F).map(
            ([I, R]) => /* @__PURE__ */ u("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ t("h4", { className: "font-picker-category-title", children: I.charAt(0).toUpperCase() + I.slice(1) }),
              R.map((j) => /* @__PURE__ */ u(
                "div",
                {
                  className: `font-picker-item ${(g == null ? void 0 : g.type) === "system" && (g == null ? void 0 : g.name) === j.name ? "selected" : ""}`,
                  onClick: () => m(j),
                  children: [
                    /* @__PURE__ */ t(
                      "span",
                      {
                        className: "font-picker-item-name",
                        style: { fontFamily: j.value },
                        children: j.name
                      }
                    ),
                    (g == null ? void 0 : g.type) === "system" && (g == null ? void 0 : g.name) === j.name && /* @__PURE__ */ t(qe, { size: 16, className: "font-picker-check" })
                  ]
                },
                j.name
              ))
            ] }, I)
          )
        ] }),
        i === "google" && /* @__PURE__ */ u("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ t("p", { className: "font-picker-description", children: "These fonts are downloaded onto a visitor's computer and might cause slower load times." }),
          Object.entries(W).map(
            ([I, R]) => /* @__PURE__ */ u("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ t("h4", { className: "font-picker-category-title", children: I.charAt(0).toUpperCase() + I.slice(1) }),
              R.map((j) => {
                const X = (g == null ? void 0 : g.type) === "google" && (g == null ? void 0 : g.name) === j.name;
                return /* @__PURE__ */ t("div", { children: /* @__PURE__ */ u(
                  "div",
                  {
                    className: `font-picker-item ${X ? "selected" : ""}`,
                    onClick: () => A(j),
                    children: [
                      /* @__PURE__ */ t(
                        "span",
                        {
                          className: "font-picker-item-name",
                          style: {
                            fontFamily: b ? `'${j.name}', sans-serif` : "inherit"
                          },
                          children: j.name
                        }
                      ),
                      X && /* @__PURE__ */ t(
                        qe,
                        {
                          size: 16,
                          className: "font-picker-check"
                        }
                      )
                    ]
                  }
                ) }, j.name);
              })
            ] }, I)
          )
        ] }),
        i === "upload" && /* @__PURE__ */ u("div", { className: "font-picker-upload", children: [
          /* @__PURE__ */ t("p", { className: "font-picker-description", children: "Upload your own font file. Supported formats: WOFF2, WOFF, TTF, OTF." }),
          /* @__PURE__ */ t(
            "input",
            {
              ref: k,
              type: "file",
              accept: ".woff2,.woff,.ttf,.otf",
              onChange: f,
              style: { display: "none" }
            }
          ),
          c ? /* @__PURE__ */ u("div", { className: "font-picker-upload-preview", children: [
            /* @__PURE__ */ u("div", { className: "font-picker-upload-file", children: [
              /* @__PURE__ */ t("span", { className: "font-picker-upload-filename", children: c.name }),
              /* @__PURE__ */ t(
                te,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => {
                    var I;
                    return (I = k.current) == null ? void 0 : I.click();
                  },
                  children: "Change"
                }
              )
            ] }),
            /* @__PURE__ */ u("div", { className: "font-picker-upload-name", children: [
              /* @__PURE__ */ t("label", { className: "font-picker-upload-label", children: "Font name" }),
              /* @__PURE__ */ t(
                "input",
                {
                  type: "text",
                  value: x,
                  onChange: (I) => w(I.target.value),
                  placeholder: "Enter font name",
                  className: "font-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ u(
            "div",
            {
              className: "font-picker-upload-zone",
              onClick: () => {
                var I;
                return (I = k.current) == null ? void 0 : I.click();
              },
              children: [
                /* @__PURE__ */ t(Er, { size: 32, className: "font-picker-upload-icon" }),
                /* @__PURE__ */ t("span", { className: "font-picker-upload-text", children: "Click to upload font file" }),
                /* @__PURE__ */ t("span", { className: "font-picker-upload-hint", children: "WOFF2, WOFF, TTF, or OTF" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-footer", children: [
        /* @__PURE__ */ t(te, { variant: "outline", onClick: o, disabled: n, children: "Cancel" }),
        /* @__PURE__ */ t(
          te,
          {
            variant: "primary",
            onClick: v,
            disabled: P,
            children: n ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return Le.createPortal(L, go());
}, Sr = [
  "arrows",
  "commerce",
  "communication",
  "devices",
  "files",
  "layout",
  "media",
  "navigation",
  "social",
  "symbols",
  "text",
  "weather"
], so = [
  // === ARROWS ===
  { name: "arrow-up", tags: ["up", "direction"], category: "arrows" },
  { name: "arrow-down", tags: ["down", "direction"], category: "arrows" },
  {
    name: "arrow-left",
    tags: ["left", "direction", "back"],
    category: "arrows"
  },
  {
    name: "arrow-right",
    tags: ["right", "direction", "forward"],
    category: "arrows"
  },
  {
    name: "arrow-up-right",
    tags: ["diagonal", "external"],
    category: "arrows"
  },
  { name: "arrow-down-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-up-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-down-right", tags: ["diagonal"], category: "arrows" },
  { name: "chevron-up", tags: ["up", "expand"], category: "arrows" },
  { name: "chevron-down", tags: ["down", "collapse"], category: "arrows" },
  { name: "chevron-left", tags: ["left", "back"], category: "arrows" },
  { name: "chevron-right", tags: ["right", "forward"], category: "arrows" },
  { name: "chevrons-up", tags: ["up", "double"], category: "arrows" },
  { name: "chevrons-down", tags: ["down", "double"], category: "arrows" },
  { name: "chevrons-left", tags: ["left", "double"], category: "arrows" },
  { name: "chevrons-right", tags: ["right", "double"], category: "arrows" },
  { name: "move", tags: ["drag", "reorder"], category: "arrows" },
  { name: "move-horizontal", tags: ["drag", "resize"], category: "arrows" },
  { name: "move-vertical", tags: ["drag", "resize"], category: "arrows" },
  {
    name: "refresh-cw",
    tags: ["reload", "sync", "refresh"],
    category: "arrows"
  },
  { name: "refresh-ccw", tags: ["reload", "undo"], category: "arrows" },
  { name: "rotate-cw", tags: ["rotate", "clockwise"], category: "arrows" },
  { name: "rotate-ccw", tags: ["rotate", "counter"], category: "arrows" },
  { name: "undo", tags: ["back", "reverse"], category: "arrows" },
  { name: "redo", tags: ["forward"], category: "arrows" },
  { name: "repeat", tags: ["loop", "cycle"], category: "arrows" },
  { name: "corner-down-left", tags: ["enter", "return"], category: "arrows" },
  { name: "corner-down-right", tags: ["turn"], category: "arrows" },
  { name: "corner-up-left", tags: ["turn"], category: "arrows" },
  { name: "corner-up-right", tags: ["turn"], category: "arrows" },
  // === COMMERCE ===
  {
    name: "shopping-cart",
    tags: ["cart", "buy", "ecommerce"],
    category: "commerce"
  },
  { name: "shopping-bag", tags: ["bag", "buy", "store"], category: "commerce" },
  {
    name: "credit-card",
    tags: ["payment", "card", "money"],
    category: "commerce"
  },
  { name: "wallet", tags: ["money", "payment"], category: "commerce" },
  { name: "receipt", tags: ["invoice", "bill"], category: "commerce" },
  { name: "tag", tags: ["label", "price"], category: "commerce" },
  { name: "tags", tags: ["labels", "prices"], category: "commerce" },
  { name: "percent", tags: ["discount", "sale"], category: "commerce" },
  {
    name: "dollar-sign",
    tags: ["money", "currency", "price"],
    category: "commerce"
  },
  {
    name: "banknote",
    tags: ["money", "cash", "payment"],
    category: "commerce"
  },
  { name: "coins", tags: ["money", "currency"], category: "commerce" },
  { name: "gift", tags: ["present", "reward"], category: "commerce" },
  {
    name: "package",
    tags: ["box", "shipping", "delivery"],
    category: "commerce"
  },
  { name: "truck", tags: ["delivery", "shipping"], category: "commerce" },
  { name: "store", tags: ["shop", "retail"], category: "commerce" },
  { name: "barcode", tags: ["scan", "product"], category: "commerce" },
  { name: "qr-code", tags: ["scan", "code"], category: "commerce" },
  // === COMMUNICATION ===
  {
    name: "mail",
    tags: ["email", "message", "envelope"],
    category: "communication"
  },
  { name: "mail-open", tags: ["email", "read"], category: "communication" },
  { name: "inbox", tags: ["email", "messages"], category: "communication" },
  {
    name: "send",
    tags: ["email", "message", "submit"],
    category: "communication"
  },
  {
    name: "message-circle",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "message-square",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "messages-square",
    tags: ["chat", "conversation"],
    category: "communication"
  },
  { name: "phone", tags: ["call", "contact"], category: "communication" },
  { name: "phone-call", tags: ["calling", "ring"], category: "communication" },
  {
    name: "phone-incoming",
    tags: ["call", "receive"],
    category: "communication"
  },
  { name: "phone-outgoing", tags: ["call", "dial"], category: "communication" },
  { name: "phone-missed", tags: ["call", "missed"], category: "communication" },
  {
    name: "video",
    tags: ["camera", "call", "meeting"],
    category: "communication"
  },
  {
    name: "video-off",
    tags: ["camera", "disabled"],
    category: "communication"
  },
  {
    name: "mic",
    tags: ["microphone", "audio", "voice"],
    category: "communication"
  },
  { name: "mic-off", tags: ["mute", "silent"], category: "communication" },
  { name: "bell", tags: ["notification", "alert"], category: "communication" },
  {
    name: "bell-off",
    tags: ["notification", "mute"],
    category: "communication"
  },
  {
    name: "bell-ring",
    tags: ["notification", "alert"],
    category: "communication"
  },
  { name: "at-sign", tags: ["email", "mention"], category: "communication" },
  // === DEVICES ===
  {
    name: "smartphone",
    tags: ["phone", "mobile", "device"],
    category: "devices"
  },
  { name: "tablet", tags: ["ipad", "device"], category: "devices" },
  { name: "laptop", tags: ["computer", "device"], category: "devices" },
  {
    name: "monitor",
    tags: ["screen", "display", "desktop"],
    category: "devices"
  },
  { name: "tv", tags: ["television", "screen"], category: "devices" },
  { name: "watch", tags: ["time", "wearable"], category: "devices" },
  { name: "headphones", tags: ["audio", "music"], category: "devices" },
  { name: "speaker", tags: ["audio", "sound"], category: "devices" },
  { name: "camera", tags: ["photo", "picture"], category: "devices" },
  { name: "printer", tags: ["print", "document"], category: "devices" },
  { name: "keyboard", tags: ["input", "type"], category: "devices" },
  { name: "mouse", tags: ["input", "click"], category: "devices" },
  { name: "gamepad", tags: ["game", "controller"], category: "devices" },
  { name: "cpu", tags: ["processor", "chip"], category: "devices" },
  { name: "hard-drive", tags: ["storage", "disk"], category: "devices" },
  { name: "usb", tags: ["cable", "port"], category: "devices" },
  {
    name: "wifi",
    tags: ["internet", "network", "wireless"],
    category: "devices"
  },
  { name: "bluetooth", tags: ["wireless", "connect"], category: "devices" },
  { name: "battery", tags: ["power", "charge"], category: "devices" },
  { name: "battery-charging", tags: ["power", "charge"], category: "devices" },
  { name: "plug", tags: ["power", "electric"], category: "devices" },
  // === FILES ===
  { name: "file", tags: ["document", "page"], category: "files" },
  { name: "file-text", tags: ["document", "text"], category: "files" },
  { name: "file-image", tags: ["picture", "photo"], category: "files" },
  { name: "file-video", tags: ["movie", "media"], category: "files" },
  { name: "file-audio", tags: ["music", "sound"], category: "files" },
  { name: "file-code", tags: ["code", "programming"], category: "files" },
  { name: "file-json", tags: ["data", "code"], category: "files" },
  { name: "file-spreadsheet", tags: ["excel", "data"], category: "files" },
  { name: "file-archive", tags: ["zip", "compress"], category: "files" },
  { name: "file-plus", tags: ["add", "new"], category: "files" },
  { name: "file-minus", tags: ["remove", "delete"], category: "files" },
  { name: "file-check", tags: ["done", "complete"], category: "files" },
  { name: "file-x", tags: ["delete", "remove"], category: "files" },
  { name: "folder", tags: ["directory"], category: "files" },
  { name: "folder-open", tags: ["directory", "open"], category: "files" },
  { name: "folder-plus", tags: ["add", "new"], category: "files" },
  { name: "folder-minus", tags: ["remove"], category: "files" },
  { name: "clipboard", tags: ["copy", "paste"], category: "files" },
  { name: "clipboard-check", tags: ["done", "complete"], category: "files" },
  { name: "copy", tags: ["duplicate", "clipboard"], category: "files" },
  { name: "scissors", tags: ["cut"], category: "files" },
  { name: "download", tags: ["save", "get"], category: "files" },
  { name: "upload", tags: ["send", "share"], category: "files" },
  { name: "cloud", tags: ["storage", "online"], category: "files" },
  { name: "cloud-download", tags: ["download", "sync"], category: "files" },
  { name: "cloud-upload", tags: ["upload", "sync"], category: "files" },
  { name: "archive", tags: ["box", "storage"], category: "files" },
  { name: "trash", tags: ["delete", "remove"], category: "files" },
  { name: "trash-2", tags: ["delete", "remove"], category: "files" },
  // === LAYOUT ===
  { name: "layout", tags: ["template", "design"], category: "layout" },
  { name: "layout-grid", tags: ["grid", "template"], category: "layout" },
  { name: "layout-list", tags: ["list", "rows"], category: "layout" },
  {
    name: "layout-dashboard",
    tags: ["dashboard", "widgets"],
    category: "layout"
  },
  { name: "grid-2x2", tags: ["grid", "squares"], category: "layout" },
  { name: "grid-3x3", tags: ["grid", "squares"], category: "layout" },
  { name: "list", tags: ["items", "menu"], category: "layout" },
  { name: "list-ordered", tags: ["numbers", "ol"], category: "layout" },
  { name: "list-checks", tags: ["todo", "tasks"], category: "layout" },
  { name: "table", tags: ["data", "spreadsheet"], category: "layout" },
  { name: "columns", tags: ["layout", "split"], category: "layout" },
  { name: "rows", tags: ["layout", "split"], category: "layout" },
  { name: "sidebar", tags: ["panel", "nav"], category: "layout" },
  { name: "panel-left", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-right", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-top", tags: ["header", "layout"], category: "layout" },
  { name: "panel-bottom", tags: ["footer", "layout"], category: "layout" },
  { name: "maximize", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "maximize-2", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "minimize", tags: ["exit", "shrink"], category: "layout" },
  { name: "minimize-2", tags: ["exit", "shrink"], category: "layout" },
  { name: "split", tags: ["divide", "separate"], category: "layout" },
  { name: "merge", tags: ["combine", "join"], category: "layout" },
  // === MEDIA ===
  { name: "play", tags: ["start", "video", "audio"], category: "media" },
  { name: "pause", tags: ["stop", "wait"], category: "media" },
  { name: "stop-circle", tags: ["end", "halt"], category: "media" },
  { name: "skip-back", tags: ["previous", "rewind"], category: "media" },
  { name: "skip-forward", tags: ["next", "forward"], category: "media" },
  { name: "rewind", tags: ["backward", "reverse"], category: "media" },
  { name: "fast-forward", tags: ["forward", "speed"], category: "media" },
  { name: "volume", tags: ["sound", "audio"], category: "media" },
  { name: "volume-1", tags: ["sound", "low"], category: "media" },
  { name: "volume-2", tags: ["sound", "high"], category: "media" },
  { name: "volume-x", tags: ["mute", "silent"], category: "media" },
  { name: "music", tags: ["audio", "song"], category: "media" },
  { name: "music-2", tags: ["audio", "notes"], category: "media" },
  { name: "music-3", tags: ["audio", "notes"], category: "media" },
  { name: "music-4", tags: ["audio", "notes"], category: "media" },
  { name: "image", tags: ["picture", "photo"], category: "media" },
  { name: "images", tags: ["pictures", "gallery"], category: "media" },
  { name: "film", tags: ["movie", "video"], category: "media" },
  { name: "clapperboard", tags: ["movie", "film"], category: "media" },
  { name: "disc", tags: ["cd", "dvd", "music"], category: "media" },
  { name: "radio", tags: ["music", "broadcast"], category: "media" },
  { name: "podcast", tags: ["audio", "broadcast"], category: "media" },
  { name: "cast", tags: ["stream", "broadcast"], category: "media" },
  { name: "airplay", tags: ["stream", "mirror"], category: "media" },
  { name: "screen-share", tags: ["present", "stream"], category: "media" },
  { name: "screen-share-off", tags: ["stop", "stream"], category: "media" },
  // === NAVIGATION ===
  { name: "home", tags: ["house", "main"], category: "navigation" },
  { name: "menu", tags: ["hamburger", "nav"], category: "navigation" },
  {
    name: "more-horizontal",
    tags: ["dots", "options"],
    category: "navigation"
  },
  { name: "more-vertical", tags: ["dots", "options"], category: "navigation" },
  { name: "grip-horizontal", tags: ["drag", "handle"], category: "navigation" },
  { name: "grip-vertical", tags: ["drag", "handle"], category: "navigation" },
  { name: "search", tags: ["find", "magnify"], category: "navigation" },
  { name: "zoom-in", tags: ["magnify", "enlarge"], category: "navigation" },
  { name: "zoom-out", tags: ["shrink", "reduce"], category: "navigation" },
  { name: "filter", tags: ["sort", "funnel"], category: "navigation" },
  {
    name: "settings",
    tags: ["gear", "config", "preferences"],
    category: "navigation"
  },
  { name: "settings-2", tags: ["sliders", "config"], category: "navigation" },
  {
    name: "sliders-horizontal",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  {
    name: "sliders-vertical",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  { name: "map", tags: ["location", "navigation"], category: "navigation" },
  { name: "map-pin", tags: ["location", "marker"], category: "navigation" },
  { name: "navigation", tags: ["direction", "arrow"], category: "navigation" },
  {
    name: "compass",
    tags: ["direction", "navigation"],
    category: "navigation"
  },
  { name: "globe", tags: ["world", "earth", "web"], category: "navigation" },
  { name: "locate", tags: ["gps", "position"], category: "navigation" },
  { name: "crosshair", tags: ["target", "aim"], category: "navigation" },
  { name: "bookmark", tags: ["save", "favorite"], category: "navigation" },
  { name: "flag", tags: ["mark", "report"], category: "navigation" },
  { name: "hash", tags: ["tag", "number"], category: "navigation" },
  { name: "link", tags: ["url", "chain"], category: "navigation" },
  { name: "link-2", tags: ["url", "chain"], category: "navigation" },
  { name: "unlink", tags: ["break", "disconnect"], category: "navigation" },
  {
    name: "external-link",
    tags: ["open", "new window"],
    category: "navigation"
  },
  { name: "log-in", tags: ["sign in", "enter"], category: "navigation" },
  { name: "log-out", tags: ["sign out", "exit"], category: "navigation" },
  // === SOCIAL ===
  { name: "user", tags: ["person", "account", "profile"], category: "social" },
  { name: "user-plus", tags: ["add", "follow"], category: "social" },
  { name: "user-minus", tags: ["remove", "unfollow"], category: "social" },
  { name: "user-check", tags: ["verified", "approved"], category: "social" },
  { name: "user-x", tags: ["delete", "remove"], category: "social" },
  { name: "users", tags: ["people", "team", "group"], category: "social" },
  { name: "user-circle", tags: ["avatar", "profile"], category: "social" },
  { name: "contact", tags: ["person", "card"], category: "social" },
  { name: "heart", tags: ["like", "love", "favorite"], category: "social" },
  { name: "thumbs-up", tags: ["like", "approve"], category: "social" },
  { name: "thumbs-down", tags: ["dislike", "disapprove"], category: "social" },
  { name: "star", tags: ["favorite", "rating"], category: "social" },
  { name: "award", tags: ["achievement", "badge"], category: "social" },
  { name: "trophy", tags: ["winner", "achievement"], category: "social" },
  { name: "medal", tags: ["achievement", "award"], category: "social" },
  { name: "share", tags: ["social", "send"], category: "social" },
  { name: "share-2", tags: ["social", "network"], category: "social" },
  { name: "rss", tags: ["feed", "subscribe"], category: "social" },
  { name: "smile", tags: ["emoji", "happy"], category: "social" },
  { name: "frown", tags: ["emoji", "sad"], category: "social" },
  { name: "meh", tags: ["emoji", "neutral"], category: "social" },
  { name: "laugh", tags: ["emoji", "happy"], category: "social" },
  { name: "angry", tags: ["emoji", "mad"], category: "social" },
  // === SYMBOLS ===
  { name: "check", tags: ["done", "complete", "yes"], category: "symbols" },
  { name: "check-circle", tags: ["done", "success"], category: "symbols" },
  { name: "check-square", tags: ["done", "checkbox"], category: "symbols" },
  { name: "x", tags: ["close", "cancel", "no"], category: "symbols" },
  { name: "x-circle", tags: ["close", "error"], category: "symbols" },
  { name: "x-square", tags: ["close", "cancel"], category: "symbols" },
  { name: "plus", tags: ["add", "new", "create"], category: "symbols" },
  { name: "plus-circle", tags: ["add", "new"], category: "symbols" },
  { name: "plus-square", tags: ["add", "new"], category: "symbols" },
  { name: "minus", tags: ["remove", "subtract"], category: "symbols" },
  { name: "minus-circle", tags: ["remove"], category: "symbols" },
  { name: "minus-square", tags: ["remove"], category: "symbols" },
  { name: "circle", tags: ["shape", "dot"], category: "symbols" },
  { name: "square", tags: ["shape", "box"], category: "symbols" },
  { name: "triangle", tags: ["shape", "warning"], category: "symbols" },
  { name: "octagon", tags: ["stop", "shape"], category: "symbols" },
  { name: "info", tags: ["information", "help"], category: "symbols" },
  { name: "alert-circle", tags: ["warning", "error"], category: "symbols" },
  { name: "alert-triangle", tags: ["warning", "caution"], category: "symbols" },
  { name: "help-circle", tags: ["question", "support"], category: "symbols" },
  { name: "ban", tags: ["block", "forbidden"], category: "symbols" },
  { name: "shield", tags: ["security", "protect"], category: "symbols" },
  { name: "shield-check", tags: ["secure", "verified"], category: "symbols" },
  { name: "lock", tags: ["secure", "private"], category: "symbols" },
  { name: "unlock", tags: ["open", "public"], category: "symbols" },
  { name: "key", tags: ["password", "access"], category: "symbols" },
  { name: "eye", tags: ["view", "visible", "show"], category: "symbols" },
  { name: "eye-off", tags: ["hide", "invisible"], category: "symbols" },
  { name: "zap", tags: ["lightning", "fast", "power"], category: "symbols" },
  { name: "flame", tags: ["fire", "hot", "trending"], category: "symbols" },
  { name: "sparkles", tags: ["magic", "new", "ai"], category: "symbols" },
  { name: "wand", tags: ["magic", "transform"], category: "symbols" },
  { name: "target", tags: ["goal", "aim"], category: "symbols" },
  { name: "clock", tags: ["time", "schedule"], category: "symbols" },
  { name: "timer", tags: ["countdown", "stopwatch"], category: "symbols" },
  {
    name: "calendar",
    tags: ["date", "schedule", "event"],
    category: "symbols"
  },
  { name: "hourglass", tags: ["time", "wait"], category: "symbols" },
  { name: "infinity", tags: ["endless", "loop"], category: "symbols" },
  // === TEXT ===
  { name: "type", tags: ["text", "font"], category: "text" },
  { name: "bold", tags: ["text", "strong"], category: "text" },
  { name: "italic", tags: ["text", "emphasis"], category: "text" },
  { name: "underline", tags: ["text", "format"], category: "text" },
  { name: "strikethrough", tags: ["text", "delete"], category: "text" },
  { name: "align-left", tags: ["text", "paragraph"], category: "text" },
  { name: "align-center", tags: ["text", "paragraph"], category: "text" },
  { name: "align-right", tags: ["text", "paragraph"], category: "text" },
  { name: "align-justify", tags: ["text", "paragraph"], category: "text" },
  { name: "indent", tags: ["text", "tab"], category: "text" },
  { name: "outdent", tags: ["text", "tab"], category: "text" },
  { name: "heading-1", tags: ["text", "h1"], category: "text" },
  { name: "heading-2", tags: ["text", "h2"], category: "text" },
  { name: "heading-3", tags: ["text", "h3"], category: "text" },
  { name: "heading-4", tags: ["text", "h4"], category: "text" },
  { name: "heading-5", tags: ["text", "h5"], category: "text" },
  { name: "heading-6", tags: ["text", "h6"], category: "text" },
  { name: "pilcrow", tags: ["paragraph", "text"], category: "text" },
  { name: "quote", tags: ["blockquote", "cite"], category: "text" },
  { name: "code", tags: ["programming", "syntax"], category: "text" },
  { name: "braces", tags: ["code", "curly"], category: "text" },
  { name: "brackets", tags: ["code", "square"], category: "text" },
  { name: "parentheses", tags: ["code", "round"], category: "text" },
  { name: "terminal", tags: ["code", "command"], category: "text" },
  { name: "pencil", tags: ["edit", "write"], category: "text" },
  { name: "pen", tags: ["edit", "write"], category: "text" },
  { name: "highlighter", tags: ["mark", "highlight"], category: "text" },
  { name: "eraser", tags: ["delete", "remove"], category: "text" },
  { name: "text-cursor", tags: ["input", "caret"], category: "text" },
  { name: "text-cursor-input", tags: ["input", "field"], category: "text" },
  { name: "spell-check", tags: ["grammar", "correct"], category: "text" },
  { name: "languages", tags: ["translate", "i18n"], category: "text" },
  // === WEATHER ===
  { name: "sun", tags: ["day", "bright", "light"], category: "weather" },
  { name: "moon", tags: ["night", "dark"], category: "weather" },
  { name: "cloud", tags: ["weather", "overcast"], category: "weather" },
  { name: "cloud-sun", tags: ["partly cloudy"], category: "weather" },
  { name: "cloud-moon", tags: ["night", "cloudy"], category: "weather" },
  { name: "cloud-rain", tags: ["rain", "weather"], category: "weather" },
  { name: "cloud-drizzle", tags: ["light rain"], category: "weather" },
  { name: "cloud-snow", tags: ["snow", "winter"], category: "weather" },
  { name: "cloud-lightning", tags: ["storm", "thunder"], category: "weather" },
  { name: "cloud-fog", tags: ["mist", "haze"], category: "weather" },
  { name: "snowflake", tags: ["snow", "winter", "cold"], category: "weather" },
  { name: "wind", tags: ["breeze", "air"], category: "weather" },
  { name: "droplet", tags: ["water", "rain"], category: "weather" },
  { name: "droplets", tags: ["water", "humidity"], category: "weather" },
  { name: "thermometer", tags: ["temperature", "heat"], category: "weather" },
  { name: "rainbow", tags: ["weather", "colors"], category: "weather" },
  { name: "umbrella", tags: ["rain", "protection"], category: "weather" },
  { name: "sunrise", tags: ["morning", "dawn"], category: "weather" },
  { name: "sunset", tags: ["evening", "dusk"], category: "weather" }
], wr = (e) => `https://unpkg.com/lucide-static@latest/icons/${e}.svg`, ks = (e) => {
  const o = e.toLowerCase().trim();
  return o ? so.filter(
    (r) => r.name.toLowerCase().includes(o) || r.tags.some((n) => n.toLowerCase().includes(o)) || r.category.toLowerCase().includes(o)
  ) : so;
}, Br = (e) => so.filter((o) => o.category === e), vs = () => `
  /* Overlay */
  .icon-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: icon-picker-fade-in 0.2s ease;
  }

  @keyframes icon-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .icon-picker-modal {
    background: ${d.white};
    border-radius: 16px;
    width: 90%;
    max-width: 680px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: icon-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes icon-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .icon-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .icon-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${d.primary};
    margin: 0;
  }

  /* Search */
  .icon-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${d.border_glass};
    position: relative;
  }

  .icon-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${d.gray_medium};
  }

  .icon-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${d.primary};
    background: ${d.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-search-input:focus {
    border-color: ${d.blue};
    background: ${d.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .icon-picker-search-input::placeholder {
    color: ${d.gray_medium};
  }

  /* Tabs */
  .icon-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .icon-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${d.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .icon-picker-tab:hover {
    color: ${d.primary};
  }

  .icon-picker-tab.active {
    color: ${d.primary};
  }

  .icon-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${d.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .icon-picker-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .icon-picker-description {
    font-size: 13px;
    color: ${d.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Category Filter */
  .icon-picker-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .icon-picker-category-btn {
    padding: 6px 14px;
    border: 1px solid ${d.border_glass};
    border-radius: 20px;
    background: ${d.white};
    font-size: 12px;
    font-weight: 500;
    color: ${d.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .icon-picker-category-btn:hover {
    border-color: ${d.blue};
    color: ${d.blue};
  }

  .icon-picker-category-btn.active {
    background: ${d.primary};
    border-color: ${d.primary};
    color: ${d.white};
  }

  /* Icons Container */
  .icon-picker-icons-container {
    padding: 16px 24px;
  }

  .icon-picker-category-section {
    margin-bottom: 24px;
  }

  .icon-picker-category-section:last-child {
    margin-bottom: 0;
  }

  .icon-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${d.gray_medium};
    margin: 0 0 12px 0;
  }

  /* Icons Grid */
  .icon-picker-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
    gap: 8px;
  }

  .icon-picker-icon-item {
    position: relative;
    width: 52px;
    height: 52px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
    background: ${d.white};
  }

  .icon-picker-icon-item:hover {
    border-color: ${d.blue};
    background: rgba(85, 114, 183, 0.04);
    transform: scale(1.05);
  }

  .icon-picker-icon-item.selected {
    border-color: ${d.blue};
    background: rgba(85, 114, 183, 0.08);
    box-shadow: 0 0 0 2px rgba(85, 114, 183, 0.2);
  }

  .icon-picker-icon-preview {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .icon-picker-icon-check {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    background: ${d.blue};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${d.white};
  }

  .icon-picker-empty {
    text-align: center;
    padding: 48px 24px;
    color: ${d.gray_medium};
  }

  /* Selected Icon Info */
  .icon-picker-selected-info {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    background: ${d.bg_light};
    border-top: 1px solid ${d.border_glass};
  }

  .icon-picker-selected-preview {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .icon-picker-selected-name {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  /* Upload Tab */
  .icon-picker-upload {
    padding: 16px 24px;
  }

  .icon-picker-upload-zone {
    border: 2px dashed ${d.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .icon-picker-upload-zone:hover {
    border-color: ${d.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .icon-picker-upload-icon {
    color: ${d.gray_medium};
  }

  .icon-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
  }

  .icon-picker-upload-hint {
    font-size: 12px;
    color: ${d.gray_medium};
  }

  .icon-picker-upload-preview {
    margin-top: 16px;
  }

  .icon-picker-upload-file {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: ${d.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .icon-picker-image-preview {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon-picker-image-preview svg {
    max-width: 100%;
    max-height: 100%;
  }

  .icon-picker-image-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 4px;
  }

  .icon-picker-upload-file-info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .icon-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .icon-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .icon-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${d.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .icon-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${d.primary};
    background: ${d.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-upload-input:focus {
    border-color: ${d.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .icon-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${d.border_glass};
    background: ${d.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, zr = ({
  isOpen: e,
  onClose: o,
  onSelect: r,
  isLoading: n = !1
}) => {
  const [i, l] = D("upload"), [s, p] = D(""), [g, y] = D(null), [c, h] = D("all"), [x, B] = D(null), [k, b] = D(""), [C, S] = D(null), [T, m] = D(null), A = de(null);
  Q(() => {
    e && (l("upload"), p(""), y(null), h("all"), B(null), b(""), S(null), m(null));
  }, [e]);
  const f = le(() => {
    let I;
    return s ? I = ks(s) : c === "all" ? I = so : I = Br(c), I;
  }, [s, c]), z = le(() => {
    if (s || c !== "all")
      return {
        [c === "all" ? "results" : c]: f
      };
    const I = {};
    return Sr.forEach((R) => {
      I[R] = Br(R);
    }), I;
  }, [f, s, c]), w = (I) => {
    y({
      type: "lucide",
      name: I.name,
      url: wr(I.name)
    });
  }, v = async (I) => {
    var j;
    const R = (j = I.target.files) == null ? void 0 : j[0];
    if (R) {
      B(R);
      const X = R.name.replace(/\.[^/.]+$/, "");
      if (b(X), T && (URL.revokeObjectURL(T), m(null)), S(null), R.type === "image/svg+xml" || R.name.endsWith(".svg")) {
        const N = new FileReader();
        N.onload = (G) => {
          var H;
          S((H = G.target) == null ? void 0 : H.result);
        }, N.readAsText(R);
      } else
        m(URL.createObjectURL(R));
      y({
        type: "upload",
        name: X,
        file: R
      });
    }
  }, P = (I) => {
    b(I), (g == null ? void 0 : g.type) === "upload" && x && y({
      ...g,
      name: I
    });
  }, W = () => {
    g && (r(g), o());
  }, F = n || !g || g.type === "upload" && (!x || !k.trim());
  if (!e) return null;
  const L = /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: vs() }),
    /* @__PURE__ */ t("div", { className: "icon-picker-overlay", onClick: o, children: /* @__PURE__ */ u("div", { className: "icon-picker-modal", onClick: (I) => I.stopPropagation(), children: [
      /* @__PURE__ */ u("div", { className: "icon-picker-header", children: [
        /* @__PURE__ */ t("h2", { className: "icon-picker-title", children: "Select icon" }),
        /* @__PURE__ */ t(
          te,
          {
            variant: "icon",
            size: "sm",
            onClick: o,
            "aria-label": "Close",
            children: /* @__PURE__ */ t(Ne, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-search", children: [
        /* @__PURE__ */ t(po, { size: 16, className: "icon-picker-search-icon" }),
        /* @__PURE__ */ t(
          "input",
          {
            type: "text",
            placeholder: "Search icons...",
            value: s,
            onChange: (I) => p(I.target.value),
            className: "icon-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-tabs", children: [
        /* @__PURE__ */ t(
          "button",
          {
            className: `icon-picker-tab ${i === "lucide" ? "active" : ""}`,
            onClick: () => l("lucide"),
            children: "Lucide Icons"
          }
        ),
        /* @__PURE__ */ t(
          "button",
          {
            className: `icon-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => l("upload"),
            children: "Upload Image"
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-content", children: [
        i === "lucide" && /* @__PURE__ */ u(O, { children: [
          /* @__PURE__ */ u("div", { className: "icon-picker-categories", children: [
            /* @__PURE__ */ t(
              "button",
              {
                className: `icon-picker-category-btn ${c === "all" ? "active" : ""}`,
                onClick: () => h("all"),
                children: "All"
              }
            ),
            Sr.map((I) => /* @__PURE__ */ t(
              "button",
              {
                className: `icon-picker-category-btn ${c === I ? "active" : ""}`,
                onClick: () => h(I),
                children: I.charAt(0).toUpperCase() + I.slice(1)
              },
              I
            ))
          ] }),
          /* @__PURE__ */ u("div", { className: "icon-picker-icons-container", children: [
            Object.entries(z).map(([I, R]) => /* @__PURE__ */ u(
              "div",
              {
                className: "icon-picker-category-section",
                children: [
                  !s && c === "all" && /* @__PURE__ */ t("h4", { className: "icon-picker-category-title", children: I.charAt(0).toUpperCase() + I.slice(1) }),
                  /* @__PURE__ */ t("div", { className: "icon-picker-grid", children: R.map((j) => /* @__PURE__ */ u(
                    "div",
                    {
                      className: `icon-picker-icon-item ${(g == null ? void 0 : g.type) === "lucide" && (g == null ? void 0 : g.name) === j.name ? "selected" : ""}`,
                      onClick: () => w(j),
                      title: j.name,
                      children: [
                        /* @__PURE__ */ t(
                          "img",
                          {
                            src: wr(j.name),
                            alt: j.name,
                            className: "icon-picker-icon-preview"
                          }
                        ),
                        (g == null ? void 0 : g.type) === "lucide" && (g == null ? void 0 : g.name) === j.name && /* @__PURE__ */ t("div", { className: "icon-picker-icon-check", children: /* @__PURE__ */ t(qe, { size: 12 }) })
                      ]
                    },
                    j.name
                  )) })
                ]
              },
              I
            )),
            f.length === 0 && /* @__PURE__ */ t("div", { className: "icon-picker-empty", children: /* @__PURE__ */ u("p", { children: [
              'No icons found for "',
              s,
              '"'
            ] }) })
          ] }),
          (g == null ? void 0 : g.type) === "lucide" && /* @__PURE__ */ u("div", { className: "icon-picker-selected-info", children: [
            /* @__PURE__ */ t(
              "img",
              {
                src: g.url,
                alt: g.name,
                className: "icon-picker-selected-preview"
              }
            ),
            /* @__PURE__ */ t("span", { className: "icon-picker-selected-name", children: g.name })
          ] })
        ] }),
        i === "upload" && /* @__PURE__ */ u("div", { className: "icon-picker-upload", children: [
          /* @__PURE__ */ t("p", { className: "icon-picker-description", children: "Upload your own image or icon file." }),
          /* @__PURE__ */ t(
            "input",
            {
              ref: A,
              type: "file",
              accept: ".png,.jpg,.jpeg,.gif,.webp,.svg,image/*",
              onChange: v,
              style: { display: "none" }
            }
          ),
          x ? /* @__PURE__ */ u("div", { className: "icon-picker-upload-preview", children: [
            /* @__PURE__ */ u("div", { className: "icon-picker-upload-file", children: [
              C && /* @__PURE__ */ t(
                "div",
                {
                  className: "icon-picker-image-preview",
                  dangerouslySetInnerHTML: { __html: C }
                }
              ),
              T && /* @__PURE__ */ t("div", { className: "icon-picker-image-preview", children: /* @__PURE__ */ t("img", { src: T, alt: k }) }),
              /* @__PURE__ */ u("div", { className: "icon-picker-upload-file-info", children: [
                /* @__PURE__ */ t("span", { className: "icon-picker-upload-filename", children: x.name }),
                /* @__PURE__ */ t(
                  te,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: () => {
                      var I;
                      return (I = A.current) == null ? void 0 : I.click();
                    },
                    children: "Change"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ u("div", { className: "icon-picker-upload-name", children: [
              /* @__PURE__ */ t("label", { className: "icon-picker-upload-label", children: "Image name" }),
              /* @__PURE__ */ t(
                "input",
                {
                  type: "text",
                  value: k,
                  onChange: (I) => P(I.target.value),
                  placeholder: "Enter image name",
                  className: "icon-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ u(
            "div",
            {
              className: "icon-picker-upload-zone",
              onClick: () => {
                var I;
                return (I = A.current) == null ? void 0 : I.click();
              },
              children: [
                /* @__PURE__ */ t(Er, { size: 32, className: "icon-picker-upload-icon" }),
                /* @__PURE__ */ t("span", { className: "icon-picker-upload-text", children: "Click to upload image" }),
                /* @__PURE__ */ t("span", { className: "icon-picker-upload-hint", children: "PNG, JPG, GIF, WEBP, SVG" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-footer", children: [
        /* @__PURE__ */ t(te, { variant: "outline", onClick: o, disabled: n, children: "Cancel" }),
        /* @__PURE__ */ t(
          te,
          {
            variant: "primary",
            onClick: W,
            disabled: F,
            children: n ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return Le.createPortal(L, go());
}, Fd = () => {
  const e = $e(), o = Wr(), [r, n] = D("checking"), [i, l] = D("desktop"), s = de(null), [p, g] = D(!1), { data: y } = Fe(), c = (y == null ? void 0 : y.themeName) || e.themeId, { themeColors: h, refreshThemeColors: x } = _o(), { themeFonts: B, refreshThemeFonts: k } = Ur(), { themeIcons: b, refreshThemeIcons: C } = _r(), { data: S } = Fe(), T = le(() => {
    var N;
    const M = (N = S == null ? void 0 : S.studioControlledKeys) == null ? void 0 : N.colors;
    return M != null && M.length ? new Set(M) : void 0;
  }, [S]), m = le(() => {
    var N;
    const M = (N = S == null ? void 0 : S.studioControlledKeys) == null ? void 0 : N.fonts;
    return M != null && M.length ? new Set(M) : void 0;
  }, [S]), [A, f] = D(null), [z, w] = D(!1), [v, P] = D(!1), W = (M) => {
    f((N) => N === M ? null : M);
  }, F = xs({
    themeId: e.themeId,
    editThemeToken: e.editThemeToken,
    iframeRef: r === "iframe" ? s : null,
    refreshThemeColors: x,
    refreshThemeFonts: k,
    refreshThemeIcons: C
  });
  Q(() => {
    o || $i();
  }, [o]), Q(() => Li(() => {
    P(!0);
  }), []), Q(() => {
    if (o || !e.themeId) return;
    (async () => {
      const N = await qn();
      n(N ? "iframe" : "inline");
    })();
  }, [o, e.themeId]), Q(() => {
    if (o || e.previewMode || !e.themeId || !e.editThemeToken) return;
    let M = !1;
    return qi({
      themeId: e.themeId,
      editThemeToken: e.editThemeToken
    }).then((N) => {
      M || N || (fo(), xo(), window.location.reload());
    }), () => {
      M = !0;
    };
  }, [o, e.themeId, e.editThemeToken, e.previewMode, e.origin]);
  const L = ge(() => {
    var M;
    if (s.current)
      try {
        const N = new URL(
          ((M = s.current.contentWindow) == null ? void 0 : M.location.href) || ""
        ), G = new URL(window.location.href);
        G.pathname = N.pathname;
        const H = new URLSearchParams(N.search), $ = new URLSearchParams();
        e.themeId && $.set("themeId", e.themeId), e.editMode && $.set("editMode", "true"), e.editThemeToken && $.set("editThemeToken", e.editThemeToken), H.forEach((Y, q) => {
          q !== "frameMode" && q !== "themeId" && q !== "editMode" && q !== "editThemeToken" && $.set(q, Y);
        }), G.search = $.toString(), window.history.replaceState({}, "", G.toString());
      } catch (N) {
        console.debug("Could not access iframe URL (cross-origin):", N);
      }
  }, [e]);
  if (!e.themeId || o)
    return null;
  if (e.previewMode) {
    const M = () => {
      fo(), xo();
      const N = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
      window.location.href = N;
    };
    return /* @__PURE__ */ u(O, { children: [
      /* @__PURE__ */ t("style", { children: `
          body { padding-top: 60px !important; }
        ` }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            height: 60,
            background: "#f5f5f7",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            padding: "0 20px",
            gap: 16,
            zIndex: 1000001,
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
          },
          children: [
            /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 10 }, children: [
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  children: /* @__PURE__ */ t(Mn, { size: 18, color: "white" })
                }
              ),
              /* @__PURE__ */ t("span", { style: { fontWeight: 600, fontSize: 15, color: "#1a1a2e" }, children: "Theme Preview" })
            ] }),
            /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [
              /* @__PURE__ */ t("span", { style: { fontSize: 12, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px" }, children: "Theme:" }),
              /* @__PURE__ */ t("span", { style: { fontSize: 14, fontWeight: 500, color: "#1a1a2e" }, children: c }),
              (y == null ? void 0 : y.isPublished) && /* @__PURE__ */ u(
                "span",
                {
                  style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 11,
                    fontWeight: 600,
                    color: "#22c55e",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  },
                  children: [
                    /* @__PURE__ */ t(
                      "span",
                      {
                        style: {
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: "#22c55e"
                        }
                      }
                    ),
                    "Live"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ t("div", { style: { flex: 1 } }),
            /* @__PURE__ */ t(
              te,
              {
                variant: "ghost",
                size: "sm",
                leftIcon: /* @__PURE__ */ t(bo, { size: 14 }),
                onClick: M,
                children: "Exit Preview"
              }
            )
          ]
        }
      )
    ] });
  }
  if (r === "checking")
    return /* @__PURE__ */ u(
      "div",
      {
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 60,
          background: "#f5f5f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          zIndex: 999999,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: 14,
          color: "#666"
        },
        children: [
          /* @__PURE__ */ t(Rn, { size: 16, className: "bc-theme-editor-spinner" }),
          /* @__PURE__ */ t("span", { children: "Initializing Theme Editor..." }),
          /* @__PURE__ */ t("style", { children: `
          @keyframes bc-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .bc-theme-editor-spinner {
            animation: bc-spin 1s linear infinite;
          }
        ` })
        ]
      }
    );
  const I = () => {
    fo(), xo();
    const M = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
    window.location.href = M;
  }, R = () => {
    g(!p);
  }, j = async (M) => {
    await F.handleAddFont(M);
  }, X = async (M) => {
    await F.handleAddIcon(M);
  };
  return r === "inline" ? /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: Pt({ showSettings: p, viewMode: i, editorMode: r }) }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ u("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ t("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ t(rt, { size: 18 }) }),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-theme-id", children: c }),
          (y == null ? void 0 : y.isPublished) && /* @__PURE__ */ u("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ t("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ t(
            te,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ t(wo, { size: 14 }),
              onClick: R,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ t(
            te,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ t(bo, { size: 14 }),
              onClick: I,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      p && /* @__PURE__ */ u(
        fr,
        {
          onClose: () => g(!1),
          successMessage: F.successMessage,
          error: F.error,
          children: [
            /* @__PURE__ */ t(
              bt,
              {
                themeColors: h,
                isExpanded: A === "colors",
                onToggle: () => W("colors"),
                isLoading: F.isLoading,
                isAddingColor: F.isAddingColor,
                setIsAddingColor: F.setIsAddingColor,
                newColorKey: F.newColorKey,
                setNewColorKey: F.setNewColorKey,
                newColorValue: F.newColorValue,
                setNewColorValue: F.setNewColorValue,
                onAddColor: F.handleAddColor,
                onUpdateColor: F.handleUpdateColor,
                onRenameColor: F.handleRenameColor,
                onDeleteColor: F.handleDeleteColor,
                studioLockedColorKeys: T
              }
            ),
            /* @__PURE__ */ t(
              xr,
              {
                themeFonts: B,
                isExpanded: A === "fonts",
                onToggle: () => W("fonts"),
                isLoading: F.isLoading,
                onDeleteFont: F.handleDeleteFont,
                onOpenFontPicker: () => w(!0),
                studioLockedFontKeys: m
              }
            ),
            /* @__PURE__ */ t(
              Cr,
              {
                themeIcons: b,
                isExpanded: A === "icons",
                onToggle: () => W("icons"),
                isLoading: F.isLoading,
                onDeleteIcon: F.handleDeleteIcon,
                onOpenIconPicker: () => P(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ t(
        vr,
        {
          isOpen: z,
          onClose: () => w(!1),
          onSelect: j,
          isLoading: F.isLoading
        }
      ),
      /* @__PURE__ */ t(
        zr,
        {
          isOpen: v,
          onClose: () => P(!1),
          onSelect: X,
          isLoading: F.isLoading
        }
      ),
      F.pendingDelete && /* @__PURE__ */ t(
        Ke,
        {
          title: `Delete ${F.pendingDelete.type}`,
          message: `Are you sure you want to delete "${F.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: F.confirmDelete,
          onCancel: F.cancelDelete,
          isLoading: F.isLoading
        }
      )
    ] })
  ] }) : /* @__PURE__ */ u(O, { children: [
    /* @__PURE__ */ t("style", { children: Pt({ showSettings: p, viewMode: i, editorMode: r }) }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ u("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ t("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ t(rt, { size: 18 }) }),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-theme-id", children: c }),
          (y == null ? void 0 : y.isPublished) && /* @__PURE__ */ u("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ t("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-viewport-toggle", children: [
          /* @__PURE__ */ t(
            te,
            {
              variant: i === "desktop" ? "primary" : "icon",
              size: "sm",
              onClick: () => l("desktop"),
              "aria-label": "Desktop view",
              children: /* @__PURE__ */ t(Ir, { size: 16 })
            }
          ),
          /* @__PURE__ */ t(
            te,
            {
              variant: i === "mobile" ? "primary" : "icon",
              size: "sm",
              onClick: () => l("mobile"),
              "aria-label": "Mobile view",
              children: /* @__PURE__ */ t(Mr, { size: 16 })
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ t(
            te,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ t(wo, { size: 14 }),
              onClick: R,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ t(
            te,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ t(bo, { size: 14 }),
              onClick: I,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ t("div", { className: "bc-theme-editor-preview", children: /* @__PURE__ */ t("div", { className: "bc-theme-editor-preview-container", children: /* @__PURE__ */ t("div", { className: "bc-theme-editor-iframe-wrapper", children: /* @__PURE__ */ t(
        "iframe",
        {
          ref: s,
          className: "bc-theme-editor-iframe",
          src: window.location.href,
          onLoad: L,
          title: "Theme Preview"
        }
      ) }) }) }),
      p && /* @__PURE__ */ u(
        fr,
        {
          onClose: () => g(!1),
          successMessage: F.successMessage,
          error: F.error,
          children: [
            /* @__PURE__ */ t(
              bt,
              {
                themeColors: h,
                isExpanded: A === "colors",
                onToggle: () => W("colors"),
                isLoading: F.isLoading,
                isAddingColor: F.isAddingColor,
                setIsAddingColor: F.setIsAddingColor,
                newColorKey: F.newColorKey,
                setNewColorKey: F.setNewColorKey,
                newColorValue: F.newColorValue,
                setNewColorValue: F.setNewColorValue,
                onAddColor: F.handleAddColor,
                onUpdateColor: F.handleUpdateColor,
                onRenameColor: F.handleRenameColor,
                onDeleteColor: F.handleDeleteColor
              }
            ),
            /* @__PURE__ */ t(
              xr,
              {
                themeFonts: B,
                isExpanded: A === "fonts",
                onToggle: () => W("fonts"),
                isLoading: F.isLoading,
                onDeleteFont: F.handleDeleteFont,
                onOpenFontPicker: () => w(!0)
              }
            ),
            /* @__PURE__ */ t(
              Cr,
              {
                themeIcons: b,
                isExpanded: A === "icons",
                onToggle: () => W("icons"),
                isLoading: F.isLoading,
                onDeleteIcon: F.handleDeleteIcon,
                onOpenIconPicker: () => P(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ t(
        vr,
        {
          isOpen: z,
          onClose: () => w(!1),
          onSelect: j,
          isLoading: F.isLoading
        }
      ),
      /* @__PURE__ */ t(
        zr,
        {
          isOpen: v,
          onClose: () => P(!1),
          onSelect: X,
          isLoading: F.isLoading
        }
      ),
      F.pendingDelete && /* @__PURE__ */ t(
        Ke,
        {
          title: `Delete ${F.pendingDelete.type}`,
          message: `Are you sure you want to delete "${F.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: F.confirmDelete,
          onCancel: F.cancelDelete,
          isLoading: F.isLoading
        }
      )
    ] })
  ] });
};
export {
  te as Button,
  hd as BuyBoxWidget,
  id as ChainOfThoughtWidget,
  Ds as ChatInput,
  Js as ConciergeHeaderWidget,
  dd as ConciergeHomeBrandLabelWidget,
  cd as ConciergeHomeGreetingWidget,
  ld as ConciergeHomeLayoutWidget,
  sd as ConciergeHomeLogoWidget,
  md as ConciergeHomeMobileNavWidget,
  gd as ConciergeHomeStartersWidget,
  pd as ConciergeHomeSubtitleWidget,
  ed as ConciergePanelWidget,
  Zs as ConciergeSidebarWidget,
  td as ConfirmActionDialogWidget,
  $s as ConversationStartersWidget,
  xd as DailyDealsWidget,
  js as ELEMENT_GROUPS,
  Gr as EditPanel,
  yd as FeaturedProductWidget,
  Us as FloatingButtonWidget,
  Qs as FollowUpQueriesWidget,
  Xs as HeaderWidget,
  dl as LAYOUT_PRESETS,
  nd as LoginDialogWidget,
  Os as MessageBubbleWidget,
  cl as PRESET_LABELS,
  ud as ProductCardCarouselWidget,
  Sd as ProductComparisonWidget,
  ad as PromptLoginWidget,
  fd as PurchaseHistoryWidget,
  zd as RetailerIconWidget,
  vd as RewardOpportunitiesWidget,
  Bd as RewardPillWidget,
  Ys as SearchPanelWidget,
  qs as SearchQueryPillWidget,
  rd as ShareConversationDialogWidget,
  bd as StoreLocatorWidget,
  Ks as SuggestionListWidget,
  kd as SurveyCard,
  Cd as SurveysWidget,
  wd as TextBox,
  Fd as ThemeManager,
  Vs as TrendingCardWidget,
  Gs as TypingIndicatorWidget,
  od as VariantPickerWidget,
  Ae as WIDGET_THEME_QUERY_KEY,
  _s as WelcomeScreenWidget,
  Yi as WidgetEditSuppressProvider,
  As as WidgetEditUnsuppressProvider,
  Z as WidgetWrapper,
  Ts as calculateRewardPercent,
  fo as clearThemeParams,
  xo as clearUrlParams,
  d as colors,
  oe as customColor,
  ll as defaultPromptLoginState,
  Is as formatDate,
  Fs as formatMoney,
  Ps as formatRelativeTime,
  Es as getFontWeightValue,
  Gi as getThemeParams,
  Ti as isColorValue,
  ji as saveThemeParams,
  Ms as slugify,
  $i as syncUrlToStorage,
  a as themeColor,
  Ws as truncateText,
  Rs as updateUrlParams,
  Zo as useEditMode,
  Ns as useResolveColor,
  Hs as useStudioAgentName,
  Ls as useStudioAvailability,
  _o as useThemeColors,
  Ur as useThemeFonts,
  _r as useThemeIcons,
  aa as useWidgetConfig,
  Wo as useWidgetEdit,
  Qi as useWidgetEditSuppressed,
  U as useWidgetEditable,
  Fe as useWidgetTheme,
  $e as useWidgetThemeParams
};
//# sourceMappingURL=index.js.map
